export const districts = [
  {
    id: '1101010',
    regencyId: '1101',
    name: 'Teupah Selatan',
  },
  {
    id: '1101020',
    regencyId: '1101',
    name: 'Simeulue Timur',
  },
  {
    id: '1101021',
    regencyId: '1101',
    name: 'Teupah Barat',
  },
  {
    id: '1101022',
    regencyId: '1101',
    name: 'Teupah Tengah',
  },
  {
    id: '1101030',
    regencyId: '1101',
    name: 'Simeulue Tengah',
  },
  {
    id: '1101031',
    regencyId: '1101',
    name: 'Teluk Dalam',
  },
  {
    id: '1101032',
    regencyId: '1101',
    name: 'Simeulue Cut',
  },
  {
    id: '1101040',
    regencyId: '1101',
    name: 'Salang',
  },
  {
    id: '1101050',
    regencyId: '1101',
    name: 'Simeulue Barat',
  },
  {
    id: '1101051',
    regencyId: '1101',
    name: 'Alafan',
  },
  {
    id: '1102010',
    regencyId: '1102',
    name: 'Pulau Banyak',
  },
  {
    id: '1102011',
    regencyId: '1102',
    name: 'Pulau Banyak Barat',
  },
  {
    id: '1102020',
    regencyId: '1102',
    name: 'Singkil',
  },
  {
    id: '1102021',
    regencyId: '1102',
    name: 'Singkil Utara',
  },
  {
    id: '1102022',
    regencyId: '1102',
    name: 'Kuala Baru',
  },
  {
    id: '1102030',
    regencyId: '1102',
    name: 'Simpang Kanan',
  },
  {
    id: '1102031',
    regencyId: '1102',
    name: 'Gunung Meriah',
  },
  {
    id: '1102032',
    regencyId: '1102',
    name: 'Danau Paris',
  },
  {
    id: '1102033',
    regencyId: '1102',
    name: 'Suro',
  },
  {
    id: '1102042',
    regencyId: '1102',
    name: 'Singkohor',
  },
  {
    id: '1102043',
    regencyId: '1102',
    name: 'Kota Baharu',
  },
  {
    id: '1103010',
    regencyId: '1103',
    name: 'Trumon',
  },
  {
    id: '1103011',
    regencyId: '1103',
    name: 'Trumon Timur',
  },
  {
    id: '1103012',
    regencyId: '1103',
    name: 'Trumon Tengah',
  },
  {
    id: '1103020',
    regencyId: '1103',
    name: 'Bakongan',
  },
  {
    id: '1103021',
    regencyId: '1103',
    name: 'Bakongan Timur',
  },
  {
    id: '1103022',
    regencyId: '1103',
    name: 'Kota Bahagia',
  },
  {
    id: '1103030',
    regencyId: '1103',
    name: 'Kluet Selatan',
  },
  {
    id: '1103031',
    regencyId: '1103',
    name: 'Kluet Timur',
  },
  {
    id: '1103040',
    regencyId: '1103',
    name: 'Kluet Utara',
  },
  {
    id: '1103041',
    regencyId: '1103',
    name: 'Pasie Raja',
  },
  {
    id: '1103042',
    regencyId: '1103',
    name: 'Kluet Tengah',
  },
  {
    id: '1103050',
    regencyId: '1103',
    name: 'Tapak Tuan',
  },
  {
    id: '1103060',
    regencyId: '1103',
    name: 'Sama Dua',
  },
  {
    id: '1103070',
    regencyId: '1103',
    name: 'Sawang',
  },
  {
    id: '1103080',
    regencyId: '1103',
    name: 'Meukek',
  },
  {
    id: '1103090',
    regencyId: '1103',
    name: 'Labuhan Haji',
  },
  {
    id: '1103091',
    regencyId: '1103',
    name: 'Labuhan Haji Timur',
  },
  {
    id: '1103092',
    regencyId: '1103',
    name: 'Labuhan Haji Barat',
  },
  {
    id: '1104010',
    regencyId: '1104',
    name: 'Lawe Alas',
  },
  {
    id: '1104011',
    regencyId: '1104',
    name: 'Babul Rahmah',
  },
  {
    id: '1104012',
    regencyId: '1104',
    name: 'Tanoh Alas',
  },
  {
    id: '1104020',
    regencyId: '1104',
    name: 'Lawe Sigala-Gala',
  },
  {
    id: '1104021',
    regencyId: '1104',
    name: 'Babul Makmur',
  },
  {
    id: '1104022',
    regencyId: '1104',
    name: 'Semadam',
  },
  {
    id: '1104023',
    regencyId: '1104',
    name: 'Leuser',
  },
  {
    id: '1104030',
    regencyId: '1104',
    name: 'Bambel',
  },
  {
    id: '1104031',
    regencyId: '1104',
    name: 'Bukit Tusam',
  },
  {
    id: '1104032',
    regencyId: '1104',
    name: 'Lawe Sumur',
  },
  {
    id: '1104040',
    regencyId: '1104',
    name: 'Babussalam',
  },
  {
    id: '1104041',
    regencyId: '1104',
    name: 'Lawe Bulan',
  },
  {
    id: '1104050',
    regencyId: '1104',
    name: 'Badar',
  },
  {
    id: '1104051',
    regencyId: '1104',
    name: 'Darul Hasanah',
  },
  {
    id: '1104052',
    regencyId: '1104',
    name: 'Ketambe',
  },
  {
    id: '1104053',
    regencyId: '1104',
    name: 'Deleng Pokhkisen',
  },
  {
    id: '1105080',
    regencyId: '1105',
    name: 'Serba Jadi',
  },
  {
    id: '1105081',
    regencyId: '1105',
    name: 'Simpang Jernih',
  },
  {
    id: '1105082',
    regencyId: '1105',
    name: 'Peunaron',
  },
  {
    id: '1105090',
    regencyId: '1105',
    name: 'Birem Bayeun',
  },
  {
    id: '1105100',
    regencyId: '1105',
    name: 'Rantau Selamat',
  },
  {
    id: '1105101',
    regencyId: '1105',
    name: 'Sungai Raya',
  },
  {
    id: '1105110',
    regencyId: '1105',
    name: 'Peureulak',
  },
  {
    id: '1105111',
    regencyId: '1105',
    name: 'Peureulak Timur',
  },
  {
    id: '1105112',
    regencyId: '1105',
    name: 'Peureulak Barat',
  },
  {
    id: '1105120',
    regencyId: '1105',
    name: 'Ranto Peureulak',
  },
  {
    id: '1105130',
    regencyId: '1105',
    name: 'Idi Rayeuk',
  },
  {
    id: '1105131',
    regencyId: '1105',
    name: 'Peudawa',
  },
  {
    id: '1105132',
    regencyId: '1105',
    name: 'Banda Alam',
  },
  {
    id: '1105133',
    regencyId: '1105',
    name: 'Idi Tunong',
  },
  {
    id: '1105134',
    regencyId: '1105',
    name: 'Darul Ihsan',
  },
  {
    id: '1105135',
    regencyId: '1105',
    name: 'Idi Timur',
  },
  {
    id: '1105140',
    regencyId: '1105',
    name: 'Darul Aman',
  },
  {
    id: '1105150',
    regencyId: '1105',
    name: 'Nurussalam',
  },
  {
    id: '1105151',
    regencyId: '1105',
    name: 'Darul Falah',
  },
  {
    id: '1105160',
    regencyId: '1105',
    name: 'Julok',
  },
  {
    id: '1105161',
    regencyId: '1105',
    name: 'Indra Makmur',
  },
  {
    id: '1105170',
    regencyId: '1105',
    name: 'Pante Bidari',
  },
  {
    id: '1105180',
    regencyId: '1105',
    name: 'Simpang Ulim',
  },
  {
    id: '1105181',
    regencyId: '1105',
    name: 'Madat',
  },
  {
    id: '1106010',
    regencyId: '1106',
    name: 'Linge',
  },
  {
    id: '1106011',
    regencyId: '1106',
    name: 'Atu Lintang',
  },
  {
    id: '1106012',
    regencyId: '1106',
    name: 'Jagong Jeget',
  },
  {
    id: '1106020',
    regencyId: '1106',
    name: 'Bintang',
  },
  {
    id: '1106031',
    regencyId: '1106',
    name: 'Lut Tawar',
  },
  {
    id: '1106032',
    regencyId: '1106',
    name: 'Kebayakan',
  },
  {
    id: '1106040',
    regencyId: '1106',
    name: 'Pegasing',
  },
  {
    id: '1106041',
    regencyId: '1106',
    name: 'Bies',
  },
  {
    id: '1106050',
    regencyId: '1106',
    name: 'Bebesen',
  },
  {
    id: '1106051',
    regencyId: '1106',
    name: 'Kute Panang',
  },
  {
    id: '1106060',
    regencyId: '1106',
    name: 'Silih Nara',
  },
  {
    id: '1106061',
    regencyId: '1106',
    name: 'Ketol',
  },
  {
    id: '1106062',
    regencyId: '1106',
    name: 'Celala',
  },
  {
    id: '1106063',
    regencyId: '1106',
    name: 'Rusip Antara',
  },
  {
    id: '1107050',
    regencyId: '1107',
    name: 'Johan Pahlawan',
  },
  {
    id: '1107060',
    regencyId: '1107',
    name: 'Samatiga',
  },
  {
    id: '1107061',
    regencyId: '1107',
    name: 'Bubon',
  },
  {
    id: '1107062',
    regencyId: '1107',
    name: 'Arongan Lambalek',
  },
  {
    id: '1107070',
    regencyId: '1107',
    name: 'Woyla',
  },
  {
    id: '1107071',
    regencyId: '1107',
    name: 'Woyla Barat',
  },
  {
    id: '1107072',
    regencyId: '1107',
    name: 'Woyla Timur',
  },
  {
    id: '1107080',
    regencyId: '1107',
    name: 'Kaway Xvi',
  },
  {
    id: '1107081',
    regencyId: '1107',
    name: 'Meureubo',
  },
  {
    id: '1107082',
    regencyId: '1107',
    name: 'Pantai Ceuremen',
  },
  {
    id: '1107083',
    regencyId: '1107',
    name: 'Panton Reu',
  },
  {
    id: '1107090',
    regencyId: '1107',
    name: 'Sungai Mas',
  },
  {
    id: '1108010',
    regencyId: '1108',
    name: 'Lhoong',
  },
  {
    id: '1108020',
    regencyId: '1108',
    name: 'Lhoknga',
  },
  {
    id: '1108021',
    regencyId: '1108',
    name: 'Leupung',
  },
  {
    id: '1108030',
    regencyId: '1108',
    name: 'Indrapuri',
  },
  {
    id: '1108031',
    regencyId: '1108',
    name: 'Kuta Cot Glie',
  },
  {
    id: '1108040',
    regencyId: '1108',
    name: 'Seulimeum',
  },
  {
    id: '1108041',
    regencyId: '1108',
    name: 'Kota Jantho',
  },
  {
    id: '1108042',
    regencyId: '1108',
    name: 'Lembah Seulawah',
  },
  {
    id: '1108050',
    regencyId: '1108',
    name: 'Mesjid Raya',
  },
  {
    id: '1108060',
    regencyId: '1108',
    name: 'Darussalam',
  },
  {
    id: '1108061',
    regencyId: '1108',
    name: 'Baitussalam',
  },
  {
    id: '1108070',
    regencyId: '1108',
    name: 'Kuta Baro',
  },
  {
    id: '1108080',
    regencyId: '1108',
    name: 'Montasik',
  },
  {
    id: '1108081',
    regencyId: '1108',
    name: 'Blang Bintang',
  },
  {
    id: '1108090',
    regencyId: '1108',
    name: 'Ingin Jaya',
  },
  {
    id: '1108091',
    regencyId: '1108',
    name: 'Krueng Barona Jaya',
  },
  {
    id: '1108100',
    regencyId: '1108',
    name: 'Suka Makmur',
  },
  {
    id: '1108101',
    regencyId: '1108',
    name: 'Kuta Malaka',
  },
  {
    id: '1108102',
    regencyId: '1108',
    name: 'Simpang Tiga',
  },
  {
    id: '1108110',
    regencyId: '1108',
    name: 'Darul Imarah',
  },
  {
    id: '1108111',
    regencyId: '1108',
    name: 'Darul Kamal',
  },
  {
    id: '1108120',
    regencyId: '1108',
    name: 'Peukan Bada',
  },
  {
    id: '1108130',
    regencyId: '1108',
    name: 'Pulo Aceh',
  },
  {
    id: '1109010',
    regencyId: '1109',
    name: 'Geumpang',
  },
  {
    id: '1109011',
    regencyId: '1109',
    name: 'Mane',
  },
  {
    id: '1109070',
    regencyId: '1109',
    name: 'Glumpang Tiga',
  },
  {
    id: '1109071',
    regencyId: '1109',
    name: 'Glumpang Baro',
  },
  {
    id: '1109080',
    regencyId: '1109',
    name: 'Mutiara',
  },
  {
    id: '1109081',
    regencyId: '1109',
    name: 'Mutiara Timur',
  },
  {
    id: '1109090',
    regencyId: '1109',
    name: 'Tiro/Truseb',
  },
  {
    id: '1109100',
    regencyId: '1109',
    name: 'Tangse',
  },
  {
    id: '1109111',
    regencyId: '1109',
    name: 'Keumala',
  },
  {
    id: '1109112',
    regencyId: '1109',
    name: 'Titeue',
  },
  {
    id: '1109120',
    regencyId: '1109',
    name: 'Sakti',
  },
  {
    id: '1109130',
    regencyId: '1109',
    name: 'Mila',
  },
  {
    id: '1109140',
    regencyId: '1109',
    name: 'Padang Tiji',
  },
  {
    id: '1109150',
    regencyId: '1109',
    name: 'Delima',
  },
  {
    id: '1109151',
    regencyId: '1109',
    name: 'Grong Grong',
  },
  {
    id: '1109160',
    regencyId: '1109',
    name: 'Indrajaya',
  },
  {
    id: '1109170',
    regencyId: '1109',
    name: 'Peukan Baro',
  },
  {
    id: '1109180',
    regencyId: '1109',
    name: 'Kembang Tanjong',
  },
  {
    id: '1109190',
    regencyId: '1109',
    name: 'Simpang Tiga',
  },
  {
    id: '1109200',
    regencyId: '1109',
    name: 'Kota Sigli',
  },
  {
    id: '1109210',
    regencyId: '1109',
    name: 'Pidie',
  },
  {
    id: '1109220',
    regencyId: '1109',
    name: 'Batee',
  },
  {
    id: '1109230',
    regencyId: '1109',
    name: 'Muara Tiga',
  },
  {
    id: '1110010',
    regencyId: '1110',
    name: 'Samalanga',
  },
  {
    id: '1110011',
    regencyId: '1110',
    name: 'Simpang Mamplam',
  },
  {
    id: '1110020',
    regencyId: '1110',
    name: 'Pandrah',
  },
  {
    id: '1110030',
    regencyId: '1110',
    name: 'Jeunieb',
  },
  {
    id: '1110031',
    regencyId: '1110',
    name: 'Peulimbang',
  },
  {
    id: '1110040',
    regencyId: '1110',
    name: 'Peudada',
  },
  {
    id: '1110050',
    regencyId: '1110',
    name: 'Juli',
  },
  {
    id: '1110060',
    regencyId: '1110',
    name: 'Jeumpa',
  },
  {
    id: '1110061',
    regencyId: '1110',
    name: 'Kota Juang',
  },
  {
    id: '1110062',
    regencyId: '1110',
    name: 'Kuala',
  },
  {
    id: '1110070',
    regencyId: '1110',
    name: 'Jangka',
  },
  {
    id: '1110080',
    regencyId: '1110',
    name: 'Peusangan',
  },
  {
    id: '1110081',
    regencyId: '1110',
    name: 'Peusangan Selatan',
  },
  {
    id: '1110082',
    regencyId: '1110',
    name: 'Peusangan Siblah Krueng',
  },
  {
    id: '1110090',
    regencyId: '1110',
    name: 'Makmur',
  },
  {
    id: '1110100',
    regencyId: '1110',
    name: 'Ganda Pura',
  },
  {
    id: '1110101',
    regencyId: '1110',
    name: 'Kuta Blang',
  },
  {
    id: '1111010',
    regencyId: '1111',
    name: 'Sawang',
  },
  {
    id: '1111020',
    regencyId: '1111',
    name: 'Nisam',
  },
  {
    id: '1111021',
    regencyId: '1111',
    name: 'Nisam Antara',
  },
  {
    id: '1111022',
    regencyId: '1111',
    name: 'Banda Baro',
  },
  {
    id: '1111030',
    regencyId: '1111',
    name: 'Kuta Makmur',
  },
  {
    id: '1111031',
    regencyId: '1111',
    name: 'Simpang Keramat',
  },
  {
    id: '1111040',
    regencyId: '1111',
    name: 'Syamtalira Bayu',
  },
  {
    id: '1111041',
    regencyId: '1111',
    name: 'Geureudong Pase',
  },
  {
    id: '1111050',
    regencyId: '1111',
    name: 'Meurah Mulia',
  },
  {
    id: '1111060',
    regencyId: '1111',
    name: 'Matangkuli',
  },
  {
    id: '1111061',
    regencyId: '1111',
    name: 'Paya Bakong',
  },
  {
    id: '1111062',
    regencyId: '1111',
    name: 'Pirak Timu',
  },
  {
    id: '1111070',
    regencyId: '1111',
    name: 'Cot Girek',
  },
  {
    id: '1111080',
    regencyId: '1111',
    name: 'Tanah Jambo Aye',
  },
  {
    id: '1111081',
    regencyId: '1111',
    name: 'Langkahan',
  },
  {
    id: '1111090',
    regencyId: '1111',
    name: 'Seunuddon',
  },
  {
    id: '1111100',
    regencyId: '1111',
    name: 'Baktiya',
  },
  {
    id: '1111101',
    regencyId: '1111',
    name: 'Baktiya Barat',
  },
  {
    id: '1111110',
    regencyId: '1111',
    name: 'Lhoksukon',
  },
  {
    id: '1111120',
    regencyId: '1111',
    name: 'Tanah Luas',
  },
  {
    id: '1111121',
    regencyId: '1111',
    name: 'Nibong',
  },
  {
    id: '1111130',
    regencyId: '1111',
    name: 'Samudera',
  },
  {
    id: '1111140',
    regencyId: '1111',
    name: 'Syamtalira Aron',
  },
  {
    id: '1111150',
    regencyId: '1111',
    name: 'Tanah Pasir',
  },
  {
    id: '1111151',
    regencyId: '1111',
    name: 'Lapang',
  },
  {
    id: '1111160',
    regencyId: '1111',
    name: 'Muara Batu',
  },
  {
    id: '1111170',
    regencyId: '1111',
    name: 'Dewantara',
  },
  {
    id: '1112010',
    regencyId: '1112',
    name: 'Manggeng',
  },
  {
    id: '1112011',
    regencyId: '1112',
    name: 'Lembah Sabil',
  },
  {
    id: '1112020',
    regencyId: '1112',
    name: 'Tangan-Tangan',
  },
  {
    id: '1112021',
    regencyId: '1112',
    name: 'Setia',
  },
  {
    id: '1112030',
    regencyId: '1112',
    name: 'Blang Pidie',
  },
  {
    id: '1112031',
    regencyId: '1112',
    name: 'Jeumpa',
  },
  {
    id: '1112040',
    regencyId: '1112',
    name: 'Susoh',
  },
  {
    id: '1112050',
    regencyId: '1112',
    name: 'Kuala Batee',
  },
  {
    id: '1112060',
    regencyId: '1112',
    name: 'Babah Rot',
  },
  {
    id: '1113010',
    regencyId: '1113',
    name: 'Kuta Panjang',
  },
  {
    id: '1113011',
    regencyId: '1113',
    name: 'Blang Jerango',
  },
  {
    id: '1113020',
    regencyId: '1113',
    name: 'Blangkejeren',
  },
  {
    id: '1113021',
    regencyId: '1113',
    name: 'Putri Betung',
  },
  {
    id: '1113022',
    regencyId: '1113',
    name: 'Dabun Gelang',
  },
  {
    id: '1113023',
    regencyId: '1113',
    name: 'Blang Pegayon',
  },
  {
    id: '1113030',
    regencyId: '1113',
    name: 'Pining',
  },
  {
    id: '1113040',
    regencyId: '1113',
    name: 'Rikit Gaib',
  },
  {
    id: '1113041',
    regencyId: '1113',
    name: 'Pantan Cuaca',
  },
  {
    id: '1113050',
    regencyId: '1113',
    name: 'Terangun',
  },
  {
    id: '1113051',
    regencyId: '1113',
    name: 'Tripe Jaya',
  },
  {
    id: '1114010',
    regencyId: '1114',
    name: 'Tamiang Hulu',
  },
  {
    id: '1114011',
    regencyId: '1114',
    name: 'Bandar Pusaka',
  },
  {
    id: '1114020',
    regencyId: '1114',
    name: 'Kejuruan Muda',
  },
  {
    id: '1114021',
    regencyId: '1114',
    name: 'Tenggulun',
  },
  {
    id: '1114030',
    regencyId: '1114',
    name: 'Rantau',
  },
  {
    id: '1114040',
    regencyId: '1114',
    name: 'Kota Kuala Simpang',
  },
  {
    id: '1114050',
    regencyId: '1114',
    name: 'Seruway',
  },
  {
    id: '1114060',
    regencyId: '1114',
    name: 'Bendahara',
  },
  {
    id: '1114061',
    regencyId: '1114',
    name: 'Banda Mulia',
  },
  {
    id: '1114070',
    regencyId: '1114',
    name: 'Karang Baru',
  },
  {
    id: '1114071',
    regencyId: '1114',
    name: 'Sekerak',
  },
  {
    id: '1114080',
    regencyId: '1114',
    name: 'Manyak Payed',
  },
  {
    id: '1115010',
    regencyId: '1115',
    name: 'Darul Makmur',
  },
  {
    id: '1115011',
    regencyId: '1115',
    name: 'Tripa Makmur',
  },
  {
    id: '1115020',
    regencyId: '1115',
    name: 'Kuala',
  },
  {
    id: '1115021',
    regencyId: '1115',
    name: 'Kuala Pesisir',
  },
  {
    id: '1115022',
    regencyId: '1115',
    name: 'Tadu Raya',
  },
  {
    id: '1115030',
    regencyId: '1115',
    name: 'Beutong',
  },
  {
    id: '1115031',
    regencyId: '1115',
    name: 'Beutong Ateuh Banggalang',
  },
  {
    id: '1115040',
    regencyId: '1115',
    name: 'Seunagan',
  },
  {
    id: '1115041',
    regencyId: '1115',
    name: 'Suka Makmue',
  },
  {
    id: '1115050',
    regencyId: '1115',
    name: 'Seunagan Timur',
  },
  {
    id: '1116010',
    regencyId: '1116',
    name: 'Teunom',
  },
  {
    id: '1116011',
    regencyId: '1116',
    name: 'Pasie Raya',
  },
  {
    id: '1116020',
    regencyId: '1116',
    name: 'Panga',
  },
  {
    id: '1116030',
    regencyId: '1116',
    name: 'Krueng Sabee',
  },
  {
    id: '1116040',
    regencyId: '1116',
    name: 'Setia Bakti',
  },
  {
    id: '1116050',
    regencyId: '1116',
    name: 'Sampoiniet',
  },
  {
    id: '1116051',
    regencyId: '1116',
    name: 'Darul Hikmah',
  },
  {
    id: '1116060',
    regencyId: '1116',
    name: 'Jaya',
  },
  {
    id: '1116061',
    regencyId: '1116',
    name: 'Indra Jaya',
  },
  {
    id: '1117010',
    regencyId: '1117',
    name: 'Timang Gajah',
  },
  {
    id: '1117011',
    regencyId: '1117',
    name: 'Gajah Putih',
  },
  {
    id: '1117020',
    regencyId: '1117',
    name: 'Pintu Rime Gayo',
  },
  {
    id: '1117030',
    regencyId: '1117',
    name: 'Bukit',
  },
  {
    id: '1117040',
    regencyId: '1117',
    name: 'Wih Pesam',
  },
  {
    id: '1117050',
    regencyId: '1117',
    name: 'Bandar',
  },
  {
    id: '1117051',
    regencyId: '1117',
    name: 'Bener Kelipah',
  },
  {
    id: '1117060',
    regencyId: '1117',
    name: 'Syiah Utama',
  },
  {
    id: '1117061',
    regencyId: '1117',
    name: 'Mesidah',
  },
  {
    id: '1117070',
    regencyId: '1117',
    name: 'Permata',
  },
  {
    id: '1118010',
    regencyId: '1118',
    name: 'Meureudu',
  },
  {
    id: '1118020',
    regencyId: '1118',
    name: 'Meurah Dua',
  },
  {
    id: '1118030',
    regencyId: '1118',
    name: 'Bandar Dua',
  },
  {
    id: '1118040',
    regencyId: '1118',
    name: 'Jangka Buya',
  },
  {
    id: '1118050',
    regencyId: '1118',
    name: 'Ulim',
  },
  {
    id: '1118060',
    regencyId: '1118',
    name: 'Trienggadeng',
  },
  {
    id: '1118070',
    regencyId: '1118',
    name: 'Panteraja',
  },
  {
    id: '1118080',
    regencyId: '1118',
    name: 'Bandar Baru',
  },
  {
    id: '1171010',
    regencyId: '1171',
    name: 'Meuraxa',
  },
  {
    id: '1171011',
    regencyId: '1171',
    name: 'Jaya Baru',
  },
  {
    id: '1171012',
    regencyId: '1171',
    name: 'Banda Raya',
  },
  {
    id: '1171020',
    regencyId: '1171',
    name: 'Baiturrahman',
  },
  {
    id: '1171021',
    regencyId: '1171',
    name: 'Lueng Bata',
  },
  {
    id: '1171030',
    regencyId: '1171',
    name: 'Kuta Alam',
  },
  {
    id: '1171031',
    regencyId: '1171',
    name: 'Kuta Raja',
  },
  {
    id: '1171040',
    regencyId: '1171',
    name: 'Syiah Kuala',
  },
  {
    id: '1171041',
    regencyId: '1171',
    name: 'Ulee Kareng',
  },
  {
    id: '1172010',
    regencyId: '1172',
    name: 'Sukajaya',
  },
  {
    id: '1172020',
    regencyId: '1172',
    name: 'Sukakarya',
  },
  {
    id: '1173010',
    regencyId: '1173',
    name: 'Langsa Timur',
  },
  {
    id: '1173011',
    regencyId: '1173',
    name: 'Langsa Lama',
  },
  {
    id: '1173020',
    regencyId: '1173',
    name: 'Langsa Barat',
  },
  {
    id: '1173021',
    regencyId: '1173',
    name: 'Langsa Baro',
  },
  {
    id: '1173030',
    regencyId: '1173',
    name: 'Langsa Kota',
  },
  {
    id: '1174010',
    regencyId: '1174',
    name: 'Blang Mangat',
  },
  {
    id: '1174020',
    regencyId: '1174',
    name: 'Muara Dua',
  },
  {
    id: '1174021',
    regencyId: '1174',
    name: 'Muara Satu',
  },
  {
    id: '1174030',
    regencyId: '1174',
    name: 'Banda Sakti',
  },
  {
    id: '1175010',
    regencyId: '1175',
    name: 'Simpang Kiri',
  },
  {
    id: '1175020',
    regencyId: '1175',
    name: 'Penanggalan',
  },
  {
    id: '1175030',
    regencyId: '1175',
    name: 'Rundeng',
  },
  {
    id: '1175040',
    regencyId: '1175',
    name: 'Sultan Daulat',
  },
  {
    id: '1175050',
    regencyId: '1175',
    name: 'Longkib',
  },
  {
    id: '1201060',
    regencyId: '1201',
    name: 'Idano Gawo',
  },
  {
    id: '1201061',
    regencyId: '1201',
    name: 'Bawolato',
  },
  {
    id: '1201062',
    regencyId: '1201',
    name: 'Ulugawo',
  },
  {
    id: '1201070',
    regencyId: '1201',
    name: 'Gido',
  },
  {
    id: '1201071',
    regencyId: '1201',
    name: 'Sogaeadu',
  },
  {
    id: '1201081',
    regencyId: '1201',
    name: 'Ma U',
  },
  {
    id: '1201082',
    regencyId: '1201',
    name: 'Somolo - Molo',
  },
  {
    id: '1201130',
    regencyId: '1201',
    name: 'Hiliduho',
  },
  {
    id: '1201131',
    regencyId: '1201',
    name: 'Hili Serangkai',
  },
  {
    id: '1201132',
    regencyId: '1201',
    name: 'Botomuzoi',
  },
  {
    id: '1202010',
    regencyId: '1202',
    name: 'Batahan',
  },
  {
    id: '1202011',
    regencyId: '1202',
    name: 'Sinunukan',
  },
  {
    id: '1202020',
    regencyId: '1202',
    name: 'Batang Natal',
  },
  {
    id: '1202021',
    regencyId: '1202',
    name: 'Lingga Bayu',
  },
  {
    id: '1202022',
    regencyId: '1202',
    name: 'Ranto Baek',
  },
  {
    id: '1202030',
    regencyId: '1202',
    name: 'Kotanopan',
  },
  {
    id: '1202031',
    regencyId: '1202',
    name: 'Ulu Pungkut',
  },
  {
    id: '1202032',
    regencyId: '1202',
    name: 'Tambangan',
  },
  {
    id: '1202033',
    regencyId: '1202',
    name: 'Lembah Sorik Marapi',
  },
  {
    id: '1202034',
    regencyId: '1202',
    name: 'Puncak Sorik Marapi',
  },
  {
    id: '1202040',
    regencyId: '1202',
    name: 'Muara Sipongi',
  },
  {
    id: '1202041',
    regencyId: '1202',
    name: 'Pakantan',
  },
  {
    id: '1202050',
    regencyId: '1202',
    name: 'Panyabungan',
  },
  {
    id: '1202051',
    regencyId: '1202',
    name: 'Panyabungan Selatan',
  },
  {
    id: '1202052',
    regencyId: '1202',
    name: 'Panyabungan Barat',
  },
  {
    id: '1202053',
    regencyId: '1202',
    name: 'Panyabungan Utara',
  },
  {
    id: '1202054',
    regencyId: '1202',
    name: 'Panyabungan Timur',
  },
  {
    id: '1202055',
    regencyId: '1202',
    name: 'Huta Bargot',
  },
  {
    id: '1202060',
    regencyId: '1202',
    name: 'Natal',
  },
  {
    id: '1202070',
    regencyId: '1202',
    name: 'Muara Batang Gadis',
  },
  {
    id: '1202080',
    regencyId: '1202',
    name: 'Siabu',
  },
  {
    id: '1202081',
    regencyId: '1202',
    name: 'Bukit Malintang',
  },
  {
    id: '1202082',
    regencyId: '1202',
    name: 'Naga Juang',
  },
  {
    id: '1203010',
    regencyId: '1203',
    name: 'Batang Angkola',
  },
  {
    id: '1203011',
    regencyId: '1203',
    name: 'Sayur Matinggi',
  },
  {
    id: '1203012',
    regencyId: '1203',
    name: 'Tano Tombangan Angkola',
  },
  {
    id: '1203070',
    regencyId: '1203',
    name: 'Angkola Timur',
  },
  {
    id: '1203080',
    regencyId: '1203',
    name: 'Angkola Selatan',
  },
  {
    id: '1203090',
    regencyId: '1203',
    name: 'Angkola  Barat',
  },
  {
    id: '1203091',
    regencyId: '1203',
    name: 'Angkola Sangkunur',
  },
  {
    id: '1203100',
    regencyId: '1203',
    name: 'Batang Toru',
  },
  {
    id: '1203101',
    regencyId: '1203',
    name: 'Marancar',
  },
  {
    id: '1203102',
    regencyId: '1203',
    name: 'Muara Batang Toru',
  },
  {
    id: '1203110',
    regencyId: '1203',
    name: 'Sipirok',
  },
  {
    id: '1203120',
    regencyId: '1203',
    name: 'Arse',
  },
  {
    id: '1203160',
    regencyId: '1203',
    name: 'Saipar Dolok Hole',
  },
  {
    id: '1203161',
    regencyId: '1203',
    name: 'Aek Bilah',
  },
  {
    id: '1204010',
    regencyId: '1204',
    name: 'Pinang Sori',
  },
  {
    id: '1204011',
    regencyId: '1204',
    name: 'Badiri',
  },
  {
    id: '1204020',
    regencyId: '1204',
    name: 'Sibabangun',
  },
  {
    id: '1204021',
    regencyId: '1204',
    name: 'Lumut',
  },
  {
    id: '1204022',
    regencyId: '1204',
    name: 'Sukabangun',
  },
  {
    id: '1204030',
    regencyId: '1204',
    name: 'Pandan',
  },
  {
    id: '1204031',
    regencyId: '1204',
    name: 'Tukka',
  },
  {
    id: '1204032',
    regencyId: '1204',
    name: 'Sarudik',
  },
  {
    id: '1204040',
    regencyId: '1204',
    name: 'Tapian Nauli',
  },
  {
    id: '1204041',
    regencyId: '1204',
    name: 'Sitahuis',
  },
  {
    id: '1204050',
    regencyId: '1204',
    name: 'Kolang',
  },
  {
    id: '1204060',
    regencyId: '1204',
    name: 'Sorkam',
  },
  {
    id: '1204061',
    regencyId: '1204',
    name: 'Sorkam Barat',
  },
  {
    id: '1204062',
    regencyId: '1204',
    name: 'Pasaribu Tobing',
  },
  {
    id: '1204070',
    regencyId: '1204',
    name: 'Barus',
  },
  {
    id: '1204071',
    regencyId: '1204',
    name: 'Sosor Gadong',
  },
  {
    id: '1204072',
    regencyId: '1204',
    name: 'Andam Dewi',
  },
  {
    id: '1204073',
    regencyId: '1204',
    name: 'Barus Utara',
  },
  {
    id: '1204080',
    regencyId: '1204',
    name: 'Manduamas',
  },
  {
    id: '1204081',
    regencyId: '1204',
    name: 'Sirandorung',
  },
  {
    id: '1205030',
    regencyId: '1205',
    name: 'Parmonangan',
  },
  {
    id: '1205040',
    regencyId: '1205',
    name: 'Adiankoting',
  },
  {
    id: '1205050',
    regencyId: '1205',
    name: 'Sipoholon',
  },
  {
    id: '1205060',
    regencyId: '1205',
    name: 'Tarutung',
  },
  {
    id: '1205061',
    regencyId: '1205',
    name: 'Siatas Barita',
  },
  {
    id: '1205070',
    regencyId: '1205',
    name: 'Pahae Julu',
  },
  {
    id: '1205080',
    regencyId: '1205',
    name: 'Pahae Jae',
  },
  {
    id: '1205081',
    regencyId: '1205',
    name: 'Purbatua',
  },
  {
    id: '1205082',
    regencyId: '1205',
    name: 'Simangumban',
  },
  {
    id: '1205090',
    regencyId: '1205',
    name: 'Pangaribuan',
  },
  {
    id: '1205100',
    regencyId: '1205',
    name: 'Garoga',
  },
  {
    id: '1205110',
    regencyId: '1205',
    name: 'Sipahutar',
  },
  {
    id: '1205120',
    regencyId: '1205',
    name: 'Siborongborong',
  },
  {
    id: '1205130',
    regencyId: '1205',
    name: 'Pagaran',
  },
  {
    id: '1205180',
    regencyId: '1205',
    name: 'Muara',
  },
  {
    id: '1206030',
    regencyId: '1206',
    name: 'Balige',
  },
  {
    id: '1206031',
    regencyId: '1206',
    name: 'Tampahan',
  },
  {
    id: '1206040',
    regencyId: '1206',
    name: 'Laguboti',
  },
  {
    id: '1206050',
    regencyId: '1206',
    name: 'Habinsaran',
  },
  {
    id: '1206051',
    regencyId: '1206',
    name: 'Borbor',
  },
  {
    id: '1206052',
    regencyId: '1206',
    name: 'Nassau',
  },
  {
    id: '1206060',
    regencyId: '1206',
    name: 'Silaen',
  },
  {
    id: '1206061',
    regencyId: '1206',
    name: 'Sigumpar',
  },
  {
    id: '1206070',
    regencyId: '1206',
    name: 'Porsea',
  },
  {
    id: '1206071',
    regencyId: '1206',
    name: 'Pintu Pohan Meranti',
  },
  {
    id: '1206072',
    regencyId: '1206',
    name: 'Siantar Narumonda',
  },
  {
    id: '1206073',
    regencyId: '1206',
    name: 'Parmaksian',
  },
  {
    id: '1206080',
    regencyId: '1206',
    name: 'Lumban Julu',
  },
  {
    id: '1206081',
    regencyId: '1206',
    name: 'Uluan',
  },
  {
    id: '1206082',
    regencyId: '1206',
    name: 'Ajibata',
  },
  {
    id: '1206083',
    regencyId: '1206',
    name: 'Bonatua Lunasi',
  },
  {
    id: '1207050',
    regencyId: '1207',
    name: 'Bilah Hulu',
  },
  {
    id: '1207070',
    regencyId: '1207',
    name: 'Pangkatan',
  },
  {
    id: '1207080',
    regencyId: '1207',
    name: 'Bilah Barat',
  },
  {
    id: '1207130',
    regencyId: '1207',
    name: 'Bilah Hilir',
  },
  {
    id: '1207140',
    regencyId: '1207',
    name: 'Panai Hulu',
  },
  {
    id: '1207150',
    regencyId: '1207',
    name: 'Panai Tengah',
  },
  {
    id: '1207160',
    regencyId: '1207',
    name: 'Panai Hilir',
  },
  {
    id: '1207210',
    regencyId: '1207',
    name: 'Rantau Selatan',
  },
  {
    id: '1207220',
    regencyId: '1207',
    name: 'Rantau Utara',
  },
  {
    id: '1208010',
    regencyId: '1208',
    name: 'Bandar Pasir Mandoge',
  },
  {
    id: '1208020',
    regencyId: '1208',
    name: 'Bandar Pulau',
  },
  {
    id: '1208021',
    regencyId: '1208',
    name: 'Aek Songsongan',
  },
  {
    id: '1208022',
    regencyId: '1208',
    name: 'Rahuning',
  },
  {
    id: '1208030',
    regencyId: '1208',
    name: 'Pulau Rakyat',
  },
  {
    id: '1208031',
    regencyId: '1208',
    name: 'Aek Kuasan',
  },
  {
    id: '1208032',
    regencyId: '1208',
    name: 'Aek Ledong',
  },
  {
    id: '1208040',
    regencyId: '1208',
    name: 'Sei Kepayang',
  },
  {
    id: '1208041',
    regencyId: '1208',
    name: 'Sei Kepayang Barat',
  },
  {
    id: '1208042',
    regencyId: '1208',
    name: 'Sei Kepayang Timur',
  },
  {
    id: '1208050',
    regencyId: '1208',
    name: 'Tanjung Balai',
  },
  {
    id: '1208060',
    regencyId: '1208',
    name: 'Simpang Empat',
  },
  {
    id: '1208061',
    regencyId: '1208',
    name: 'Teluk Dalam',
  },
  {
    id: '1208070',
    regencyId: '1208',
    name: 'Air Batu',
  },
  {
    id: '1208071',
    regencyId: '1208',
    name: 'Sei Dadap',
  },
  {
    id: '1208080',
    regencyId: '1208',
    name: 'Buntu Pane',
  },
  {
    id: '1208081',
    regencyId: '1208',
    name: 'Tinggi Raja',
  },
  {
    id: '1208082',
    regencyId: '1208',
    name: 'Setia Janji',
  },
  {
    id: '1208090',
    regencyId: '1208',
    name: 'Meranti',
  },
  {
    id: '1208091',
    regencyId: '1208',
    name: 'Pulo Bandring',
  },
  {
    id: '1208092',
    regencyId: '1208',
    name: 'Rawang Panca Arga',
  },
  {
    id: '1208100',
    regencyId: '1208',
    name: 'Air Joman',
  },
  {
    id: '1208101',
    regencyId: '1208',
    name: 'Silau Laut',
  },
  {
    id: '1208160',
    regencyId: '1208',
    name: 'Kisaran Barat',
  },
  {
    id: '1208170',
    regencyId: '1208',
    name: 'Kisaran Timur',
  },
  {
    id: '1209010',
    regencyId: '1209',
    name: 'Silimakuta',
  },
  {
    id: '1209011',
    regencyId: '1209',
    name: 'Pematang Silimahuta',
  },
  {
    id: '1209020',
    regencyId: '1209',
    name: 'Purba',
  },
  {
    id: '1209021',
    regencyId: '1209',
    name: 'Haranggaol Horison',
  },
  {
    id: '1209040',
    regencyId: '1209',
    name: 'Sidamanik',
  },
  {
    id: '1209041',
    regencyId: '1209',
    name: 'Pematang Sidamanik',
  },
  {
    id: '1209050',
    regencyId: '1209',
    name: 'Girsang Sipangan Bolon',
  },
  {
    id: '1209060',
    regencyId: '1209',
    name: 'Tanah Jawa',
  },
  {
    id: '1209061',
    regencyId: '1209',
    name: 'Hatonduhan',
  },
  {
    id: '1209070',
    regencyId: '1209',
    name: 'Dolok Panribuan',
  },
  {
    id: '1209080',
    regencyId: '1209',
    name: 'Jorlang Hataran',
  },
  {
    id: '1209090',
    regencyId: '1209',
    name: 'Panei',
  },
  {
    id: '1209091',
    regencyId: '1209',
    name: 'Panombean Panei',
  },
  {
    id: '1209100',
    regencyId: '1209',
    name: 'Raya',
  },
  {
    id: '1209101',
    regencyId: '1209',
    name: 'Dolog Masagal',
  },
  {
    id: '1209110',
    regencyId: '1209',
    name: 'Dolok Silau',
  },
  {
    id: '1209120',
    regencyId: '1209',
    name: 'Silau Kahean',
  },
  {
    id: '1209130',
    regencyId: '1209',
    name: 'Raya Kahean',
  },
  {
    id: '1209140',
    regencyId: '1209',
    name: 'Tapian Dolok',
  },
  {
    id: '1209150',
    regencyId: '1209',
    name: 'Dolok Batu Nanggar',
  },
  {
    id: '1209160',
    regencyId: '1209',
    name: 'Siantar',
  },
  {
    id: '1209161',
    regencyId: '1209',
    name: 'Gunung Malela',
  },
  {
    id: '1209162',
    regencyId: '1209',
    name: 'Gunung Maligas',
  },
  {
    id: '1209170',
    regencyId: '1209',
    name: 'Hutabayu Raja',
  },
  {
    id: '1209171',
    regencyId: '1209',
    name: 'Jawa Maraja Bah Jambi',
  },
  {
    id: '1209180',
    regencyId: '1209',
    name: 'Pematang Bandar',
  },
  {
    id: '1209181',
    regencyId: '1209',
    name: 'Bandar Huluan',
  },
  {
    id: '1209190',
    regencyId: '1209',
    name: 'Bandar',
  },
  {
    id: '1209191',
    regencyId: '1209',
    name: 'Bandar Masilam',
  },
  {
    id: '1209200',
    regencyId: '1209',
    name: 'Bosar Maligas',
  },
  {
    id: '1209210',
    regencyId: '1209',
    name: 'Ujung Padang',
  },
  {
    id: '1210030',
    regencyId: '1210',
    name: 'Sidikalang',
  },
  {
    id: '1210031',
    regencyId: '1210',
    name: 'Berampu',
  },
  {
    id: '1210032',
    regencyId: '1210',
    name: 'Sitinjo',
  },
  {
    id: '1210040',
    regencyId: '1210',
    name: 'Parbuluan',
  },
  {
    id: '1210050',
    regencyId: '1210',
    name: 'Sumbul',
  },
  {
    id: '1210051',
    regencyId: '1210',
    name: 'Silahisabungan',
  },
  {
    id: '1210060',
    regencyId: '1210',
    name: 'Silima Pungga-Pungga',
  },
  {
    id: '1210061',
    regencyId: '1210',
    name: 'Lae Parira',
  },
  {
    id: '1210070',
    regencyId: '1210',
    name: 'Siempat Nempu',
  },
  {
    id: '1210080',
    regencyId: '1210',
    name: 'Siempat Nempu Hulu',
  },
  {
    id: '1210090',
    regencyId: '1210',
    name: 'Siempat Nempu Hilir',
  },
  {
    id: '1210100',
    regencyId: '1210',
    name: 'Tiga Lingga',
  },
  {
    id: '1210101',
    regencyId: '1210',
    name: 'Gunung Sitember',
  },
  {
    id: '1210110',
    regencyId: '1210',
    name: 'Pegagan Hilir',
  },
  {
    id: '1210120',
    regencyId: '1210',
    name: 'Tanah Pinem',
  },
  {
    id: '1211010',
    regencyId: '1211',
    name: 'Mardingding',
  },
  {
    id: '1211020',
    regencyId: '1211',
    name: 'Laubaleng',
  },
  {
    id: '1211030',
    regencyId: '1211',
    name: 'Tiga Binanga',
  },
  {
    id: '1211040',
    regencyId: '1211',
    name: 'Juhar',
  },
  {
    id: '1211050',
    regencyId: '1211',
    name: 'Munte',
  },
  {
    id: '1211060',
    regencyId: '1211',
    name: 'Kuta Buluh',
  },
  {
    id: '1211070',
    regencyId: '1211',
    name: 'Payung',
  },
  {
    id: '1211071',
    regencyId: '1211',
    name: 'Tiganderket',
  },
  {
    id: '1211080',
    regencyId: '1211',
    name: 'Simpang Empat',
  },
  {
    id: '1211081',
    regencyId: '1211',
    name: 'Naman Teran',
  },
  {
    id: '1211082',
    regencyId: '1211',
    name: 'Merdeka',
  },
  {
    id: '1211090',
    regencyId: '1211',
    name: 'Kabanjahe',
  },
  {
    id: '1211100',
    regencyId: '1211',
    name: 'Berastagi',
  },
  {
    id: '1211110',
    regencyId: '1211',
    name: 'Tigapanah',
  },
  {
    id: '1211111',
    regencyId: '1211',
    name: 'Dolat Rayat',
  },
  {
    id: '1211120',
    regencyId: '1211',
    name: 'Merek',
  },
  {
    id: '1211130',
    regencyId: '1211',
    name: 'Barusjahe',
  },
  {
    id: '1212010',
    regencyId: '1212',
    name: 'Gunung Meriah',
  },
  {
    id: '1212020',
    regencyId: '1212',
    name: 'Sinembah Tanjung Muda Hulu',
  },
  {
    id: '1212030',
    regencyId: '1212',
    name: 'Sibolangit',
  },
  {
    id: '1212040',
    regencyId: '1212',
    name: 'Kutalimbaru',
  },
  {
    id: '1212050',
    regencyId: '1212',
    name: 'Pancur Batu',
  },
  {
    id: '1212060',
    regencyId: '1212',
    name: 'Namo Rambe',
  },
  {
    id: '1212070',
    regencyId: '1212',
    name: 'Biru-Biru',
  },
  {
    id: '1212080',
    regencyId: '1212',
    name: 'Sinembah Tanjung Muda Hilir',
  },
  {
    id: '1212090',
    regencyId: '1212',
    name: 'Bangun Purba',
  },
  {
    id: '1212190',
    regencyId: '1212',
    name: 'Galang',
  },
  {
    id: '1212200',
    regencyId: '1212',
    name: 'Tanjung Morawa',
  },
  {
    id: '1212210',
    regencyId: '1212',
    name: 'Patumbak',
  },
  {
    id: '1212220',
    regencyId: '1212',
    name: 'Deli Tua',
  },
  {
    id: '1212230',
    regencyId: '1212',
    name: 'Sunggal',
  },
  {
    id: '1212240',
    regencyId: '1212',
    name: 'Hamparan Perak',
  },
  {
    id: '1212250',
    regencyId: '1212',
    name: 'Labuhan Deli',
  },
  {
    id: '1212260',
    regencyId: '1212',
    name: 'Percut Sei Tuan',
  },
  {
    id: '1212270',
    regencyId: '1212',
    name: 'Batang Kuis',
  },
  {
    id: '1212280',
    regencyId: '1212',
    name: 'Pantai Labu',
  },
  {
    id: '1212290',
    regencyId: '1212',
    name: 'Beringin',
  },
  {
    id: '1212300',
    regencyId: '1212',
    name: 'Lubuk Pakam',
  },
  {
    id: '1212310',
    regencyId: '1212',
    name: 'Pagar Merbau',
  },
  {
    id: '1213010',
    regencyId: '1213',
    name: 'Bohorok',
  },
  {
    id: '1213011',
    regencyId: '1213',
    name: 'Sirapit',
  },
  {
    id: '1213020',
    regencyId: '1213',
    name: 'Salapian',
  },
  {
    id: '1213021',
    regencyId: '1213',
    name: 'Kutambaru',
  },
  {
    id: '1213030',
    regencyId: '1213',
    name: 'Sei Bingai',
  },
  {
    id: '1213040',
    regencyId: '1213',
    name: 'Kuala',
  },
  {
    id: '1213050',
    regencyId: '1213',
    name: 'Selesai',
  },
  {
    id: '1213060',
    regencyId: '1213',
    name: 'Binjai',
  },
  {
    id: '1213070',
    regencyId: '1213',
    name: 'Stabat',
  },
  {
    id: '1213080',
    regencyId: '1213',
    name: 'Wampu',
  },
  {
    id: '1213090',
    regencyId: '1213',
    name: 'Batang Serangan',
  },
  {
    id: '1213100',
    regencyId: '1213',
    name: 'Sawit Seberang',
  },
  {
    id: '1213110',
    regencyId: '1213',
    name: 'Padang Tualang',
  },
  {
    id: '1213120',
    regencyId: '1213',
    name: 'Hinai',
  },
  {
    id: '1213130',
    regencyId: '1213',
    name: 'Secanggang',
  },
  {
    id: '1213140',
    regencyId: '1213',
    name: 'Tanjung Pura',
  },
  {
    id: '1213150',
    regencyId: '1213',
    name: 'Gebang',
  },
  {
    id: '1213160',
    regencyId: '1213',
    name: 'Babalan',
  },
  {
    id: '1213170',
    regencyId: '1213',
    name: 'Sei Lepan',
  },
  {
    id: '1213180',
    regencyId: '1213',
    name: 'Brandan Barat',
  },
  {
    id: '1213190',
    regencyId: '1213',
    name: 'Besitang',
  },
  {
    id: '1213200',
    regencyId: '1213',
    name: 'Pangkalan Susu',
  },
  {
    id: '1213201',
    regencyId: '1213',
    name: 'Pematang Jaya',
  },
  {
    id: '1214010',
    regencyId: '1214',
    name: 'Hibala',
  },
  {
    id: '1214011',
    regencyId: '1214',
    name: 'Tanah Masa',
  },
  {
    id: '1214020',
    regencyId: '1214',
    name: 'Pulau-Pulau Batu',
  },
  {
    id: '1214021',
    regencyId: '1214',
    name: 'Pulau-Pulau Batu Timur',
  },
  {
    id: '1214022',
    regencyId: '1214',
    name: 'Simuk',
  },
  {
    id: '1214023',
    regencyId: '1214',
    name: 'Pulau-Pulau Batu Barat',
  },
  {
    id: '1214024',
    regencyId: '1214',
    name: 'Pulau-Pulau Batu Utara',
  },
  {
    id: '1214030',
    regencyId: '1214',
    name: 'Teluk Dalam',
  },
  {
    id: '1214031',
    regencyId: '1214',
    name: 'Fanayama',
  },
  {
    id: '1214032',
    regencyId: '1214',
    name: 'Toma',
  },
  {
    id: '1214033',
    regencyId: '1214',
    name: 'Maniamolo',
  },
  {
    id: '1214034',
    regencyId: '1214',
    name: 'Mazino',
  },
  {
    id: '1214035',
    regencyId: '1214',
    name: 'Luahagundre Maniamolo',
  },
  {
    id: '1214036',
    regencyId: '1214',
    name: 'Onolalu',
  },
  {
    id: '1214040',
    regencyId: '1214',
    name: 'Amandraya',
  },
  {
    id: '1214041',
    regencyId: '1214',
    name: 'Aramo',
  },
  {
    id: '1214042',
    regencyId: '1214',
    name: 'Ulususua',
  },
  {
    id: '1214050',
    regencyId: '1214',
    name: 'Lahusa',
  },
  {
    id: '1214051',
    regencyId: '1214',
    name: 'Siduaori',
  },
  {
    id: '1214052',
    regencyId: '1214',
    name: 'Somambawa',
  },
  {
    id: '1214060',
    regencyId: '1214',
    name: 'Gomo',
  },
  {
    id: '1214061',
    regencyId: '1214',
    name: 'Susua',
  },
  {
    id: '1214062',
    regencyId: '1214',
    name: 'Mazo',
  },
  {
    id: '1214063',
    regencyId: '1214',
    name: 'Umbunasi',
  },
  {
    id: '1214064',
    regencyId: '1214',
    name: 'Idanotae',
  },
  {
    id: '1214065',
    regencyId: '1214',
    name: 'Uluidanotae',
  },
  {
    id: '1214066',
    regencyId: '1214',
    name: 'Boronadu',
  },
  {
    id: '1214070',
    regencyId: '1214',
    name: 'Lolomatua',
  },
  {
    id: '1214071',
    regencyId: '1214',
    name: 'Ulunoyo',
  },
  {
    id: '1214072',
    regencyId: '1214',
    name: 'Huruna',
  },
  {
    id: '1214080',
    regencyId: '1214',
    name: "Lolowa'U",
  },
  {
    id: '1214081',
    regencyId: '1214',
    name: 'Hilimegai',
  },
  {
    id: '1214082',
    regencyId: '1214',
    name: 'Oou',
  },
  {
    id: '1214083',
    regencyId: '1214',
    name: 'Onohazumba',
  },
  {
    id: '1214084',
    regencyId: '1214',
    name: 'Hilisalawaahe',
  },
  {
    id: '1215010',
    regencyId: '1215',
    name: 'Pakkat',
  },
  {
    id: '1215020',
    regencyId: '1215',
    name: 'Onan Ganjang',
  },
  {
    id: '1215030',
    regencyId: '1215',
    name: 'Sijama Polang',
  },
  {
    id: '1215040',
    regencyId: '1215',
    name: 'Dolok Sanggul',
  },
  {
    id: '1215050',
    regencyId: '1215',
    name: 'Lintong Nihuta',
  },
  {
    id: '1215060',
    regencyId: '1215',
    name: 'Paranginan',
  },
  {
    id: '1215070',
    regencyId: '1215',
    name: 'Bakti Raja',
  },
  {
    id: '1215080',
    regencyId: '1215',
    name: 'Pollung',
  },
  {
    id: '1215090',
    regencyId: '1215',
    name: 'Parlilitan',
  },
  {
    id: '1215100',
    regencyId: '1215',
    name: 'Tara Bintang',
  },
  {
    id: '1216010',
    regencyId: '1216',
    name: 'Salak',
  },
  {
    id: '1216011',
    regencyId: '1216',
    name: 'Sitellu Tali Urang Jehe',
  },
  {
    id: '1216012',
    regencyId: '1216',
    name: 'Pagindar',
  },
  {
    id: '1216013',
    regencyId: '1216',
    name: 'Sitellu Tali Urang Julu',
  },
  {
    id: '1216014',
    regencyId: '1216',
    name: 'Pergetteng-Getteng Sengkut',
  },
  {
    id: '1216020',
    regencyId: '1216',
    name: 'Kerajaan',
  },
  {
    id: '1216021',
    regencyId: '1216',
    name: 'Tinada',
  },
  {
    id: '1216022',
    regencyId: '1216',
    name: 'Siempat Rube',
  },
  {
    id: '1217010',
    regencyId: '1217',
    name: 'Sianjur Mula Mula',
  },
  {
    id: '1217020',
    regencyId: '1217',
    name: 'Harian',
  },
  {
    id: '1217030',
    regencyId: '1217',
    name: 'Sitio-Tio',
  },
  {
    id: '1217040',
    regencyId: '1217',
    name: 'Onan Runggu',
  },
  {
    id: '1217050',
    regencyId: '1217',
    name: 'Nainggolan',
  },
  {
    id: '1217060',
    regencyId: '1217',
    name: 'Palipi',
  },
  {
    id: '1217070',
    regencyId: '1217',
    name: 'Ronggur Nihuta',
  },
  {
    id: '1217080',
    regencyId: '1217',
    name: 'Pangururan',
  },
  {
    id: '1217090',
    regencyId: '1217',
    name: 'Simanindo',
  },
  {
    id: '1218010',
    regencyId: '1218',
    name: 'Kotarih',
  },
  {
    id: '1218011',
    regencyId: '1218',
    name: 'Silinda',
  },
  {
    id: '1218012',
    regencyId: '1218',
    name: 'Bintang Bayu',
  },
  {
    id: '1218020',
    regencyId: '1218',
    name: 'Dolok Masihul',
  },
  {
    id: '1218021',
    regencyId: '1218',
    name: 'Serbajadi',
  },
  {
    id: '1218030',
    regencyId: '1218',
    name: 'Sipispis',
  },
  {
    id: '1218040',
    regencyId: '1218',
    name: 'Dolok Merawan',
  },
  {
    id: '1218050',
    regencyId: '1218',
    name: 'Tebingtinggi',
  },
  {
    id: '1218051',
    regencyId: '1218',
    name: 'Tebing Syahbandar',
  },
  {
    id: '1218060',
    regencyId: '1218',
    name: 'Bandar Khalipah',
  },
  {
    id: '1218070',
    regencyId: '1218',
    name: 'Tanjung Beringin',
  },
  {
    id: '1218080',
    regencyId: '1218',
    name: 'Sei Rampah',
  },
  {
    id: '1218081',
    regencyId: '1218',
    name: 'Sei Bamban',
  },
  {
    id: '1218090',
    regencyId: '1218',
    name: 'Teluk Mengkudu',
  },
  {
    id: '1218100',
    regencyId: '1218',
    name: 'Perbaungan',
  },
  {
    id: '1218101',
    regencyId: '1218',
    name: 'Pegajahan',
  },
  {
    id: '1218110',
    regencyId: '1218',
    name: 'Pantai Cermin',
  },
  {
    id: '1219010',
    regencyId: '1219',
    name: 'Sei Balai',
  },
  {
    id: '1219020',
    regencyId: '1219',
    name: 'Tanjung Tiram',
  },
  {
    id: '1219021',
    regencyId: '1219',
    name: 'Nibung Hangus',
  },
  {
    id: '1219030',
    regencyId: '1219',
    name: 'Talawi',
  },
  {
    id: '1219031',
    regencyId: '1219',
    name: 'Datuk Tanah Datar',
  },
  {
    id: '1219040',
    regencyId: '1219',
    name: 'Limapuluh',
  },
  {
    id: '1219041',
    regencyId: '1219',
    name: 'Lima Puluh Pesisir',
  },
  {
    id: '1219042',
    regencyId: '1219',
    name: 'Datuk Lima Puluh',
  },
  {
    id: '1219050',
    regencyId: '1219',
    name: 'Air Putih',
  },
  {
    id: '1219060',
    regencyId: '1219',
    name: 'Sei Suka',
  },
  {
    id: '1219061',
    regencyId: '1219',
    name: 'Laut Tador',
  },
  {
    id: '1219070',
    regencyId: '1219',
    name: 'Medang Deras',
  },
  {
    id: '1220010',
    regencyId: '1220',
    name: 'Batang Onang',
  },
  {
    id: '1220020',
    regencyId: '1220',
    name: 'Padang Bolak Julu',
  },
  {
    id: '1220030',
    regencyId: '1220',
    name: 'Portibi',
  },
  {
    id: '1220040',
    regencyId: '1220',
    name: 'Padang Bolak',
  },
  {
    id: '1220041',
    regencyId: '1220',
    name: 'Padang Bolak Tenggara',
  },
  {
    id: '1220050',
    regencyId: '1220',
    name: 'Simangambat',
  },
  {
    id: '1220051',
    regencyId: '1220',
    name: 'Ujung Batu',
  },
  {
    id: '1220060',
    regencyId: '1220',
    name: 'Halongonan',
  },
  {
    id: '1220061',
    regencyId: '1220',
    name: 'Halongonan Timur',
  },
  {
    id: '1220070',
    regencyId: '1220',
    name: 'Dolok',
  },
  {
    id: '1220080',
    regencyId: '1220',
    name: 'Dolok Sigompulon',
  },
  {
    id: '1220090',
    regencyId: '1220',
    name: 'Hulu Sihapas',
  },
  {
    id: '1221010',
    regencyId: '1221',
    name: 'Sosopan',
  },
  {
    id: '1221020',
    regencyId: '1221',
    name: 'Ulu Barumun',
  },
  {
    id: '1221030',
    regencyId: '1221',
    name: 'Barumun',
  },
  {
    id: '1221031',
    regencyId: '1221',
    name: 'Barumun Selatan',
  },
  {
    id: '1221040',
    regencyId: '1221',
    name: 'Lubuk Barumun',
  },
  {
    id: '1221050',
    regencyId: '1221',
    name: 'Sosa',
  },
  {
    id: '1221060',
    regencyId: '1221',
    name: 'Batang Lubu Sutam',
  },
  {
    id: '1221070',
    regencyId: '1221',
    name: 'Huta Raja Tinggi',
  },
  {
    id: '1221080',
    regencyId: '1221',
    name: 'Huristak',
  },
  {
    id: '1221090',
    regencyId: '1221',
    name: 'Barumun Tengah',
  },
  {
    id: '1221091',
    regencyId: '1221',
    name: 'Aek Nabara Barumun',
  },
  {
    id: '1221092',
    regencyId: '1221',
    name: 'Sihapas Barumun',
  },
  {
    id: '1222010',
    regencyId: '1222',
    name: 'Sungai Kanan',
  },
  {
    id: '1222020',
    regencyId: '1222',
    name: 'Torgamba',
  },
  {
    id: '1222030',
    regencyId: '1222',
    name: 'Kota Pinang',
  },
  {
    id: '1222040',
    regencyId: '1222',
    name: 'Silangkitang',
  },
  {
    id: '1222050',
    regencyId: '1222',
    name: 'Kampung Rakyat',
  },
  {
    id: '1223010',
    regencyId: '1223',
    name: 'Na IX-X',
  },
  {
    id: '1223020',
    regencyId: '1223',
    name: 'Marbau',
  },
  {
    id: '1223030',
    regencyId: '1223',
    name: 'Aek Kuo',
  },
  {
    id: '1223040',
    regencyId: '1223',
    name: 'Aek Natas',
  },
  {
    id: '1223050',
    regencyId: '1223',
    name: 'Kualuh Selatan',
  },
  {
    id: '1223060',
    regencyId: '1223',
    name: 'Kualuh Hilir',
  },
  {
    id: '1223070',
    regencyId: '1223',
    name: 'Kualuh Hulu',
  },
  {
    id: '1223080',
    regencyId: '1223',
    name: 'Kualuh Leidong',
  },
  {
    id: '1224010',
    regencyId: '1224',
    name: 'Tugala Oyo',
  },
  {
    id: '1224020',
    regencyId: '1224',
    name: 'Alasa',
  },
  {
    id: '1224030',
    regencyId: '1224',
    name: 'Alasa Talu Muzoi',
  },
  {
    id: '1224040',
    regencyId: '1224',
    name: 'Namohalu Esiwa',
  },
  {
    id: '1224050',
    regencyId: '1224',
    name: 'Sitolu Ori',
  },
  {
    id: '1224060',
    regencyId: '1224',
    name: 'Tuhemberua',
  },
  {
    id: '1224070',
    regencyId: '1224',
    name: 'Sawo',
  },
  {
    id: '1224080',
    regencyId: '1224',
    name: 'Lotu',
  },
  {
    id: '1224090',
    regencyId: '1224',
    name: 'Lahewa Timur',
  },
  {
    id: '1224100',
    regencyId: '1224',
    name: 'Afulu',
  },
  {
    id: '1224110',
    regencyId: '1224',
    name: 'Lahewa',
  },
  {
    id: '1225010',
    regencyId: '1225',
    name: 'Sirombu',
  },
  {
    id: '1225020',
    regencyId: '1225',
    name: 'Lahomi',
  },
  {
    id: '1225030',
    regencyId: '1225',
    name: 'Ulu Moro O',
  },
  {
    id: '1225040',
    regencyId: '1225',
    name: 'Lolofitu Moi',
  },
  {
    id: '1225050',
    regencyId: '1225',
    name: 'Mandrehe Utara',
  },
  {
    id: '1225060',
    regencyId: '1225',
    name: 'Mandrehe',
  },
  {
    id: '1225070',
    regencyId: '1225',
    name: 'Mandrehe Barat',
  },
  {
    id: '1225080',
    regencyId: '1225',
    name: 'Moro O',
  },
  {
    id: '1271010',
    regencyId: '1271',
    name: 'Sibolga Utara',
  },
  {
    id: '1271020',
    regencyId: '1271',
    name: 'Sibolga Kota',
  },
  {
    id: '1271030',
    regencyId: '1271',
    name: 'Sibolga Selatan',
  },
  {
    id: '1271031',
    regencyId: '1271',
    name: 'Sibolga Sambas',
  },
  {
    id: '1272010',
    regencyId: '1272',
    name: 'Datuk Bandar',
  },
  {
    id: '1272011',
    regencyId: '1272',
    name: 'Datuk Bandar Timur',
  },
  {
    id: '1272020',
    regencyId: '1272',
    name: 'Tanjung Balai Selatan',
  },
  {
    id: '1272030',
    regencyId: '1272',
    name: 'Tanjung Balai Utara',
  },
  {
    id: '1272040',
    regencyId: '1272',
    name: 'Sei Tualang Raso',
  },
  {
    id: '1272050',
    regencyId: '1272',
    name: 'Teluk Nibung',
  },
  {
    id: '1273010',
    regencyId: '1273',
    name: 'Siantar Marihat',
  },
  {
    id: '1273011',
    regencyId: '1273',
    name: 'Siantar Marimbun',
  },
  {
    id: '1273020',
    regencyId: '1273',
    name: 'Siantar Selatan',
  },
  {
    id: '1273030',
    regencyId: '1273',
    name: 'Siantar Barat',
  },
  {
    id: '1273040',
    regencyId: '1273',
    name: 'Siantar Utara',
  },
  {
    id: '1273050',
    regencyId: '1273',
    name: 'Siantar Timur',
  },
  {
    id: '1273060',
    regencyId: '1273',
    name: 'Siantar Martoba',
  },
  {
    id: '1273061',
    regencyId: '1273',
    name: 'Siantar Sitalasari',
  },
  {
    id: '1274010',
    regencyId: '1274',
    name: 'Padang Hulu',
  },
  {
    id: '1274011',
    regencyId: '1274',
    name: 'Tebing Tinggi Kota',
  },
  {
    id: '1274020',
    regencyId: '1274',
    name: 'Rambutan',
  },
  {
    id: '1274021',
    regencyId: '1274',
    name: 'Bajenis',
  },
  {
    id: '1274030',
    regencyId: '1274',
    name: 'Padang Hilir',
  },
  {
    id: '1275010',
    regencyId: '1275',
    name: 'Medan Tuntungan',
  },
  {
    id: '1275020',
    regencyId: '1275',
    name: 'Medan Johor',
  },
  {
    id: '1275030',
    regencyId: '1275',
    name: 'Medan Amplas',
  },
  {
    id: '1275040',
    regencyId: '1275',
    name: 'Medan Denai',
  },
  {
    id: '1275050',
    regencyId: '1275',
    name: 'Medan Area',
  },
  {
    id: '1275060',
    regencyId: '1275',
    name: 'Medan Kota',
  },
  {
    id: '1275070',
    regencyId: '1275',
    name: 'Medan Maimun',
  },
  {
    id: '1275080',
    regencyId: '1275',
    name: 'Medan Polonia',
  },
  {
    id: '1275090',
    regencyId: '1275',
    name: 'Medan Baru',
  },
  {
    id: '1275100',
    regencyId: '1275',
    name: 'Medan Selayang',
  },
  {
    id: '1275110',
    regencyId: '1275',
    name: 'Medan Sunggal',
  },
  {
    id: '1275120',
    regencyId: '1275',
    name: 'Medan Helvetia',
  },
  {
    id: '1275130',
    regencyId: '1275',
    name: 'Medan Petisah',
  },
  {
    id: '1275140',
    regencyId: '1275',
    name: 'Medan Barat',
  },
  {
    id: '1275150',
    regencyId: '1275',
    name: 'Medan Timur',
  },
  {
    id: '1275160',
    regencyId: '1275',
    name: 'Medan Perjuangan',
  },
  {
    id: '1275170',
    regencyId: '1275',
    name: 'Medan Tembung',
  },
  {
    id: '1275180',
    regencyId: '1275',
    name: 'Medan Deli',
  },
  {
    id: '1275190',
    regencyId: '1275',
    name: 'Medan Labuhan',
  },
  {
    id: '1275200',
    regencyId: '1275',
    name: 'Medan Marelan',
  },
  {
    id: '1275210',
    regencyId: '1275',
    name: 'Medan Belawan',
  },
  {
    id: '1276010',
    regencyId: '1276',
    name: 'Binjai Selatan',
  },
  {
    id: '1276020',
    regencyId: '1276',
    name: 'Binjai Kota',
  },
  {
    id: '1276030',
    regencyId: '1276',
    name: 'Binjai Timur',
  },
  {
    id: '1276040',
    regencyId: '1276',
    name: 'Binjai Utara',
  },
  {
    id: '1276050',
    regencyId: '1276',
    name: 'Binjai Barat',
  },
  {
    id: '1277010',
    regencyId: '1277',
    name: 'Padangsidimpuan Tenggara',
  },
  {
    id: '1277020',
    regencyId: '1277',
    name: 'Padangsidimpuan Selatan',
  },
  {
    id: '1277030',
    regencyId: '1277',
    name: 'Padangsidimpuan Batunadua',
  },
  {
    id: '1277040',
    regencyId: '1277',
    name: 'Padangsidimpuan Utara',
  },
  {
    id: '1277050',
    regencyId: '1277',
    name: 'Padangsidimpuan Hutaimbaru',
  },
  {
    id: '1277051',
    regencyId: '1277',
    name: 'Padangsidimpuan Angkola Julu',
  },
  {
    id: '1278010',
    regencyId: '1278',
    name: 'Gunungsitoli Idanoi',
  },
  {
    id: '1278020',
    regencyId: '1278',
    name: 'Gunungsitoli Selatan',
  },
  {
    id: '1278030',
    regencyId: '1278',
    name: 'Gunungsitoli Barat',
  },
  {
    id: '1278040',
    regencyId: '1278',
    name: 'Gunung Sitoli',
  },
  {
    id: '1278050',
    regencyId: '1278',
    name: 'Gunungsitoli Alo Oa',
  },
  {
    id: '1278060',
    regencyId: '1278',
    name: 'Gunungsitoli Utara',
  },
  {
    id: '1301011',
    regencyId: '1301',
    name: 'Pagai Selatan',
  },
  {
    id: '1301012',
    regencyId: '1301',
    name: 'Sikakap',
  },
  {
    id: '1301013',
    regencyId: '1301',
    name: 'Pagai Utara',
  },
  {
    id: '1301021',
    regencyId: '1301',
    name: 'Sipora Selatan',
  },
  {
    id: '1301022',
    regencyId: '1301',
    name: 'Sipora Utara',
  },
  {
    id: '1301030',
    regencyId: '1301',
    name: 'Siberut Selatan',
  },
  {
    id: '1301031',
    regencyId: '1301',
    name: 'Seberut Barat Daya',
  },
  {
    id: '1301032',
    regencyId: '1301',
    name: 'Siberut Tengah',
  },
  {
    id: '1301040',
    regencyId: '1301',
    name: 'Siberut Utara',
  },
  {
    id: '1301041',
    regencyId: '1301',
    name: 'Siberut Barat',
  },
  {
    id: '1302011',
    regencyId: '1302',
    name: 'Silaut',
  },
  {
    id: '1302012',
    regencyId: '1302',
    name: 'Lunang',
  },
  {
    id: '1302020',
    regencyId: '1302',
    name: 'Basa Ampek Balai Tapan',
  },
  {
    id: '1302021',
    regencyId: '1302',
    name: 'Ranah Ampek Hulu Tapan',
  },
  {
    id: '1302030',
    regencyId: '1302',
    name: 'Pancung Soal',
  },
  {
    id: '1302031',
    regencyId: '1302',
    name: 'Airpura',
  },
  {
    id: '1302040',
    regencyId: '1302',
    name: 'Linggo Sari Baganti',
  },
  {
    id: '1302050',
    regencyId: '1302',
    name: 'Ranah Pesisir',
  },
  {
    id: '1302060',
    regencyId: '1302',
    name: 'Lengayang',
  },
  {
    id: '1302070',
    regencyId: '1302',
    name: 'Sutera',
  },
  {
    id: '1302080',
    regencyId: '1302',
    name: 'Batang Kapas',
  },
  {
    id: '1302090',
    regencyId: '1302',
    name: 'IV Jurai',
  },
  {
    id: '1302100',
    regencyId: '1302',
    name: 'Bayang',
  },
  {
    id: '1302101',
    regencyId: '1302',
    name: 'IV  Nagari Bayang Utara',
  },
  {
    id: '1302110',
    regencyId: '1302',
    name: 'Koto XI Tarusan',
  },
  {
    id: '1303040',
    regencyId: '1303',
    name: 'Pantai Cermin',
  },
  {
    id: '1303050',
    regencyId: '1303',
    name: 'Lembah Gumanti',
  },
  {
    id: '1303051',
    regencyId: '1303',
    name: 'Hiliran Gumanti',
  },
  {
    id: '1303060',
    regencyId: '1303',
    name: 'Payung Sekaki',
  },
  {
    id: '1303061',
    regencyId: '1303',
    name: 'Tigo Lurah',
  },
  {
    id: '1303070',
    regencyId: '1303',
    name: 'Lembang Jaya',
  },
  {
    id: '1303071',
    regencyId: '1303',
    name: 'Danau Kembar',
  },
  {
    id: '1303080',
    regencyId: '1303',
    name: 'Gunung Talang',
  },
  {
    id: '1303090',
    regencyId: '1303',
    name: 'Bukit Sundi',
  },
  {
    id: '1303100',
    regencyId: '1303',
    name: 'IX Koto Sungai Lasi',
  },
  {
    id: '1303110',
    regencyId: '1303',
    name: 'Kubung',
  },
  {
    id: '1303120',
    regencyId: '1303',
    name: 'X Koto Diatas',
  },
  {
    id: '1303130',
    regencyId: '1303',
    name: 'X Koto Singkarak',
  },
  {
    id: '1303140',
    regencyId: '1303',
    name: 'Junjung Sirih',
  },
  {
    id: '1304050',
    regencyId: '1304',
    name: 'Kamang Baru',
  },
  {
    id: '1304060',
    regencyId: '1304',
    name: 'Tanjung Gadang',
  },
  {
    id: '1304070',
    regencyId: '1304',
    name: 'Sijunjung',
  },
  {
    id: '1304071',
    regencyId: '1304',
    name: 'Lubuk Tarok',
  },
  {
    id: '1304080',
    regencyId: '1304',
    name: 'IV Nagari',
  },
  {
    id: '1304090',
    regencyId: '1304',
    name: 'Kupitan',
  },
  {
    id: '1304100',
    regencyId: '1304',
    name: 'Koto Tujuh',
  },
  {
    id: '1304110',
    regencyId: '1304',
    name: 'Sumpur Kudus',
  },
  {
    id: '1305010',
    regencyId: '1305',
    name: 'Sepuluh Koto',
  },
  {
    id: '1305020',
    regencyId: '1305',
    name: 'Batipuh',
  },
  {
    id: '1305021',
    regencyId: '1305',
    name: 'Batipuh Selatan',
  },
  {
    id: '1305030',
    regencyId: '1305',
    name: 'Pariangan',
  },
  {
    id: '1305040',
    regencyId: '1305',
    name: 'Rambatan',
  },
  {
    id: '1305050',
    regencyId: '1305',
    name: 'Lima Kaum',
  },
  {
    id: '1305060',
    regencyId: '1305',
    name: 'Tanjung Emas',
  },
  {
    id: '1305070',
    regencyId: '1305',
    name: 'Padang Ganting',
  },
  {
    id: '1305080',
    regencyId: '1305',
    name: 'Lintau Buo',
  },
  {
    id: '1305081',
    regencyId: '1305',
    name: 'Lintau Buo Utara',
  },
  {
    id: '1305090',
    regencyId: '1305',
    name: 'Sungayang',
  },
  {
    id: '1305100',
    regencyId: '1305',
    name: 'Sungai Tarab',
  },
  {
    id: '1305110',
    regencyId: '1305',
    name: 'Salimpaung',
  },
  {
    id: '1305111',
    regencyId: '1305',
    name: 'Tanjung Baru',
  },
  {
    id: '1306010',
    regencyId: '1306',
    name: 'Batang Anai',
  },
  {
    id: '1306020',
    regencyId: '1306',
    name: 'Lubuk Alung',
  },
  {
    id: '1306021',
    regencyId: '1306',
    name: 'Sintuk Toboh Gadang',
  },
  {
    id: '1306030',
    regencyId: '1306',
    name: 'Ulakan Tapakis',
  },
  {
    id: '1306040',
    regencyId: '1306',
    name: 'Nan Sabaris',
  },
  {
    id: '1306050',
    regencyId: '1306',
    name: '2 X 11 Enam Lingkung',
  },
  {
    id: '1306051',
    regencyId: '1306',
    name: 'Enam Lingkung',
  },
  {
    id: '1306052',
    regencyId: '1306',
    name: '2 X 11 Kayu Tanam',
  },
  {
    id: '1306060',
    regencyId: '1306',
    name: 'VII Koto Sungai Sariak',
  },
  {
    id: '1306061',
    regencyId: '1306',
    name: 'Patamuan',
  },
  {
    id: '1306062',
    regencyId: '1306',
    name: 'Padang Sago',
  },
  {
    id: '1306070',
    regencyId: '1306',
    name: 'V Koto Kp Dalam',
  },
  {
    id: '1306071',
    regencyId: '1306',
    name: 'V Koto Timur',
  },
  {
    id: '1306080',
    regencyId: '1306',
    name: 'Sungai Limau',
  },
  {
    id: '1306081',
    regencyId: '1306',
    name: 'Batang Gasan',
  },
  {
    id: '1306090',
    regencyId: '1306',
    name: 'Sungai Geringging',
  },
  {
    id: '1306100',
    regencyId: '1306',
    name: 'IV Koto Aur Malintang',
  },
  {
    id: '1307010',
    regencyId: '1307',
    name: 'Tanjung Mutiara',
  },
  {
    id: '1307020',
    regencyId: '1307',
    name: 'Lubuk Basung',
  },
  {
    id: '1307021',
    regencyId: '1307',
    name: 'Ampek Nagari',
  },
  {
    id: '1307030',
    regencyId: '1307',
    name: 'Tanjung Raya',
  },
  {
    id: '1307040',
    regencyId: '1307',
    name: 'Matur',
  },
  {
    id: '1307050',
    regencyId: '1307',
    name: 'IV Koto',
  },
  {
    id: '1307051',
    regencyId: '1307',
    name: 'Malalak',
  },
  {
    id: '1307061',
    regencyId: '1307',
    name: 'Banuhampu',
  },
  {
    id: '1307062',
    regencyId: '1307',
    name: 'Sungai Pua',
  },
  {
    id: '1307070',
    regencyId: '1307',
    name: 'Ampek Angkek',
  },
  {
    id: '1307071',
    regencyId: '1307',
    name: 'Canduang',
  },
  {
    id: '1307080',
    regencyId: '1307',
    name: 'Baso',
  },
  {
    id: '1307090',
    regencyId: '1307',
    name: 'Tilatang Kamang',
  },
  {
    id: '1307091',
    regencyId: '1307',
    name: 'Kamang Magek',
  },
  {
    id: '1307100',
    regencyId: '1307',
    name: 'Palembayan',
  },
  {
    id: '1307110',
    regencyId: '1307',
    name: 'Palupuh',
  },
  {
    id: '1308010',
    regencyId: '1308',
    name: 'Payakumbuh',
  },
  {
    id: '1308011',
    regencyId: '1308',
    name: 'Akabiluru',
  },
  {
    id: '1308020',
    regencyId: '1308',
    name: 'Luak',
  },
  {
    id: '1308021',
    regencyId: '1308',
    name: 'Lareh Sago Halaban',
  },
  {
    id: '1308022',
    regencyId: '1308',
    name: 'Situjuah Limo Nagari',
  },
  {
    id: '1308030',
    regencyId: '1308',
    name: 'Harau',
  },
  {
    id: '1308040',
    regencyId: '1308',
    name: 'Guguak',
  },
  {
    id: '1308041',
    regencyId: '1308',
    name: 'Mungka',
  },
  {
    id: '1308050',
    regencyId: '1308',
    name: 'Suliki',
  },
  {
    id: '1308051',
    regencyId: '1308',
    name: 'Bukik Barisan',
  },
  {
    id: '1308060',
    regencyId: '1308',
    name: 'Gunuang Omeh',
  },
  {
    id: '1308070',
    regencyId: '1308',
    name: 'Kapur IX',
  },
  {
    id: '1308080',
    regencyId: '1308',
    name: 'Pangkalan Koto Baru',
  },
  {
    id: '1309070',
    regencyId: '1309',
    name: 'Bonjol',
  },
  {
    id: '1309071',
    regencyId: '1309',
    name: 'Tigo Nagari',
  },
  {
    id: '1309072',
    regencyId: '1309',
    name: 'Simpang Alahan Mati',
  },
  {
    id: '1309080',
    regencyId: '1309',
    name: 'Lubuk Sikaping',
  },
  {
    id: '1309100',
    regencyId: '1309',
    name: 'Dua Koto',
  },
  {
    id: '1309110',
    regencyId: '1309',
    name: 'Panti',
  },
  {
    id: '1309111',
    regencyId: '1309',
    name: 'Padang Gelugur',
  },
  {
    id: '1309121',
    regencyId: '1309',
    name: 'Rao',
  },
  {
    id: '1309122',
    regencyId: '1309',
    name: 'Mapat Tunggul',
  },
  {
    id: '1309123',
    regencyId: '1309',
    name: 'Mapat Tunggul Selatan',
  },
  {
    id: '1309124',
    regencyId: '1309',
    name: 'Rao Selatan',
  },
  {
    id: '1309125',
    regencyId: '1309',
    name: 'Rao Utara',
  },
  {
    id: '1310010',
    regencyId: '1310',
    name: 'Sangir',
  },
  {
    id: '1310020',
    regencyId: '1310',
    name: 'Sangir Jujuan',
  },
  {
    id: '1310021',
    regencyId: '1310',
    name: 'Sangir Balai Janggo',
  },
  {
    id: '1310030',
    regencyId: '1310',
    name: 'Sangir Batang Hari',
  },
  {
    id: '1310040',
    regencyId: '1310',
    name: 'Sungai Pagu',
  },
  {
    id: '1310041',
    regencyId: '1310',
    name: 'Pauah Duo',
  },
  {
    id: '1310050',
    regencyId: '1310',
    name: 'Koto Parik Gadang Diateh',
  },
  {
    id: '1311010',
    regencyId: '1311',
    name: 'Sungai Rumbai',
  },
  {
    id: '1311011',
    regencyId: '1311',
    name: 'Koto Besar',
  },
  {
    id: '1311012',
    regencyId: '1311',
    name: 'Asam Jujuhan',
  },
  {
    id: '1311020',
    regencyId: '1311',
    name: 'Koto Baru',
  },
  {
    id: '1311021',
    regencyId: '1311',
    name: 'Koto Salak',
  },
  {
    id: '1311022',
    regencyId: '1311',
    name: 'Tiumang',
  },
  {
    id: '1311023',
    regencyId: '1311',
    name: 'Padang Laweh',
  },
  {
    id: '1311030',
    regencyId: '1311',
    name: 'Sitiung',
  },
  {
    id: '1311031',
    regencyId: '1311',
    name: 'Timpeh',
  },
  {
    id: '1311040',
    regencyId: '1311',
    name: 'Pulau Punjung',
  },
  {
    id: '1311041',
    regencyId: '1311',
    name: 'IX Koto',
  },
  {
    id: '1312010',
    regencyId: '1312',
    name: 'Sungai Beremas',
  },
  {
    id: '1312020',
    regencyId: '1312',
    name: 'Ranah Batahan',
  },
  {
    id: '1312030',
    regencyId: '1312',
    name: 'Koto Balingka',
  },
  {
    id: '1312040',
    regencyId: '1312',
    name: 'Sungai Aur',
  },
  {
    id: '1312050',
    regencyId: '1312',
    name: 'Lembah Malintang',
  },
  {
    id: '1312060',
    regencyId: '1312',
    name: 'Gunung Tuleh',
  },
  {
    id: '1312070',
    regencyId: '1312',
    name: 'Talamau',
  },
  {
    id: '1312080',
    regencyId: '1312',
    name: 'Pasaman',
  },
  {
    id: '1312090',
    regencyId: '1312',
    name: 'Luhak Nan Duo',
  },
  {
    id: '1312100',
    regencyId: '1312',
    name: 'Sasak Ranah Pasisie',
  },
  {
    id: '1312110',
    regencyId: '1312',
    name: 'Kinali',
  },
  {
    id: '1371010',
    regencyId: '1371',
    name: 'Bungus Teluk Kabung',
  },
  {
    id: '1371020',
    regencyId: '1371',
    name: 'Lubuk Kilangan',
  },
  {
    id: '1371030',
    regencyId: '1371',
    name: 'Lubuk Begalung',
  },
  {
    id: '1371040',
    regencyId: '1371',
    name: 'Padang Selatan',
  },
  {
    id: '1371050',
    regencyId: '1371',
    name: 'Padang Timur',
  },
  {
    id: '1371060',
    regencyId: '1371',
    name: 'Padang Barat',
  },
  {
    id: '1371070',
    regencyId: '1371',
    name: 'Padang Utara',
  },
  {
    id: '1371080',
    regencyId: '1371',
    name: 'Nanggalo',
  },
  {
    id: '1371090',
    regencyId: '1371',
    name: 'Kuranji',
  },
  {
    id: '1371100',
    regencyId: '1371',
    name: 'Pauh',
  },
  {
    id: '1371110',
    regencyId: '1371',
    name: 'Koto Tangah',
  },
  {
    id: '1372010',
    regencyId: '1372',
    name: 'Lubuk Sikarah',
  },
  {
    id: '1372020',
    regencyId: '1372',
    name: 'Tanjung Harapan',
  },
  {
    id: '1373010',
    regencyId: '1373',
    name: 'Silungkang',
  },
  {
    id: '1373020',
    regencyId: '1373',
    name: 'Lembah Segar',
  },
  {
    id: '1373030',
    regencyId: '1373',
    name: 'Barangin',
  },
  {
    id: '1373040',
    regencyId: '1373',
    name: 'Talawi',
  },
  {
    id: '1374010',
    regencyId: '1374',
    name: 'Padang Panjang Barat',
  },
  {
    id: '1374020',
    regencyId: '1374',
    name: 'Padang Panjang Timur',
  },
  {
    id: '1375010',
    regencyId: '1375',
    name: 'Guguk Panjang',
  },
  {
    id: '1375020',
    regencyId: '1375',
    name: 'Mandiangin Koto Selayan',
  },
  {
    id: '1375030',
    regencyId: '1375',
    name: 'Aur Birugo Tigo Baleh',
  },
  {
    id: '1376010',
    regencyId: '1376',
    name: 'Payakumbuh Barat',
  },
  {
    id: '1376011',
    regencyId: '1376',
    name: 'Payakumbuh Selatan',
  },
  {
    id: '1376020',
    regencyId: '1376',
    name: 'Payakumbuh Timur',
  },
  {
    id: '1376030',
    regencyId: '1376',
    name: 'Payakumbuh Utara',
  },
  {
    id: '1376031',
    regencyId: '1376',
    name: 'Lamposi Tigo Nagori',
  },
  {
    id: '1377010',
    regencyId: '1377',
    name: 'Pariaman Selatan',
  },
  {
    id: '1377020',
    regencyId: '1377',
    name: 'Pariaman Tengah',
  },
  {
    id: '1377021',
    regencyId: '1377',
    name: 'Pariaman Timur',
  },
  {
    id: '1377030',
    regencyId: '1377',
    name: 'Pariaman Utara',
  },
  {
    id: '1401010',
    regencyId: '1401',
    name: 'Kuantan Mudik',
  },
  {
    id: '1401011',
    regencyId: '1401',
    name: 'Hulu Kuantan',
  },
  {
    id: '1401012',
    regencyId: '1401',
    name: 'Gunung Toar',
  },
  {
    id: '1401013',
    regencyId: '1401',
    name: 'Pucuk Rantau',
  },
  {
    id: '1401020',
    regencyId: '1401',
    name: 'Singingi',
  },
  {
    id: '1401021',
    regencyId: '1401',
    name: 'Singingi Hilir',
  },
  {
    id: '1401030',
    regencyId: '1401',
    name: 'Kuantan Tengah',
  },
  {
    id: '1401031',
    regencyId: '1401',
    name: 'Sentajo Raya',
  },
  {
    id: '1401040',
    regencyId: '1401',
    name: 'Benai',
  },
  {
    id: '1401050',
    regencyId: '1401',
    name: 'Kuantan Hilir',
  },
  {
    id: '1401051',
    regencyId: '1401',
    name: 'Pangean',
  },
  {
    id: '1401052',
    regencyId: '1401',
    name: 'Logas Tanah Darat',
  },
  {
    id: '1401053',
    regencyId: '1401',
    name: 'Kuantan Hilir Seberang',
  },
  {
    id: '1401060',
    regencyId: '1401',
    name: 'Cerenti',
  },
  {
    id: '1401061',
    regencyId: '1401',
    name: 'Inuman',
  },
  {
    id: '1402010',
    regencyId: '1402',
    name: 'Peranap',
  },
  {
    id: '1402011',
    regencyId: '1402',
    name: 'Batang Peranap',
  },
  {
    id: '1402020',
    regencyId: '1402',
    name: 'Seberida',
  },
  {
    id: '1402021',
    regencyId: '1402',
    name: 'Batang Cenaku',
  },
  {
    id: '1402022',
    regencyId: '1402',
    name: 'Batang Gansal',
  },
  {
    id: '1402030',
    regencyId: '1402',
    name: 'Kelayang',
  },
  {
    id: '1402031',
    regencyId: '1402',
    name: 'Rakit Kulim',
  },
  {
    id: '1402040',
    regencyId: '1402',
    name: 'Pasir Penyu',
  },
  {
    id: '1402041',
    regencyId: '1402',
    name: 'Lirik',
  },
  {
    id: '1402042',
    regencyId: '1402',
    name: 'Sungai Lala',
  },
  {
    id: '1402043',
    regencyId: '1402',
    name: 'Lubuk Batu Jaya',
  },
  {
    id: '1402050',
    regencyId: '1402',
    name: 'Rengat Barat',
  },
  {
    id: '1402060',
    regencyId: '1402',
    name: 'Rengat',
  },
  {
    id: '1402061',
    regencyId: '1402',
    name: 'Kuala Cenaku',
  },
  {
    id: '1403010',
    regencyId: '1403',
    name: 'Keritang',
  },
  {
    id: '1403011',
    regencyId: '1403',
    name: 'Kemuning',
  },
  {
    id: '1403020',
    regencyId: '1403',
    name: 'Reteh',
  },
  {
    id: '1403021',
    regencyId: '1403',
    name: 'Sungai Batang',
  },
  {
    id: '1403030',
    regencyId: '1403',
    name: 'Enok',
  },
  {
    id: '1403040',
    regencyId: '1403',
    name: 'Tanah Merah',
  },
  {
    id: '1403050',
    regencyId: '1403',
    name: 'Kuala Indragiri',
  },
  {
    id: '1403051',
    regencyId: '1403',
    name: 'Concong',
  },
  {
    id: '1403060',
    regencyId: '1403',
    name: 'Tembilahan',
  },
  {
    id: '1403061',
    regencyId: '1403',
    name: 'Tembilahan Hulu',
  },
  {
    id: '1403070',
    regencyId: '1403',
    name: 'Tempuling',
  },
  {
    id: '1403071',
    regencyId: '1403',
    name: 'Kempas',
  },
  {
    id: '1403080',
    regencyId: '1403',
    name: 'Batang Tuaka',
  },
  {
    id: '1403090',
    regencyId: '1403',
    name: 'Gaung Anak Serka',
  },
  {
    id: '1403100',
    regencyId: '1403',
    name: 'Gaung',
  },
  {
    id: '1403110',
    regencyId: '1403',
    name: 'Mandah',
  },
  {
    id: '1403120',
    regencyId: '1403',
    name: 'Kateman',
  },
  {
    id: '1403121',
    regencyId: '1403',
    name: 'Pelangiran',
  },
  {
    id: '1403122',
    regencyId: '1403',
    name: 'Teluk Belengkong',
  },
  {
    id: '1403123',
    regencyId: '1403',
    name: 'Pulau Burung',
  },
  {
    id: '1404010',
    regencyId: '1404',
    name: 'Langgam',
  },
  {
    id: '1404011',
    regencyId: '1404',
    name: 'Pangkalan Kerinci',
  },
  {
    id: '1404012',
    regencyId: '1404',
    name: 'Bandar Seikijang',
  },
  {
    id: '1404020',
    regencyId: '1404',
    name: 'Pangkalan Kuras',
  },
  {
    id: '1404021',
    regencyId: '1404',
    name: 'Ukui',
  },
  {
    id: '1404022',
    regencyId: '1404',
    name: 'Pangkalan Lesung',
  },
  {
    id: '1404030',
    regencyId: '1404',
    name: 'Bunut',
  },
  {
    id: '1404031',
    regencyId: '1404',
    name: 'Pelalawan',
  },
  {
    id: '1404032',
    regencyId: '1404',
    name: 'Bandar Petalangan',
  },
  {
    id: '1404040',
    regencyId: '1404',
    name: 'Kuala Kampar',
  },
  {
    id: '1404041',
    regencyId: '1404',
    name: 'Kerumutan',
  },
  {
    id: '1404042',
    regencyId: '1404',
    name: 'Teluk Meranti',
  },
  {
    id: '1405010',
    regencyId: '1405',
    name: 'Minas',
  },
  {
    id: '1405011',
    regencyId: '1405',
    name: 'Sungai Mandau',
  },
  {
    id: '1405012',
    regencyId: '1405',
    name: 'Kandis',
  },
  {
    id: '1405020',
    regencyId: '1405',
    name: 'Siak',
  },
  {
    id: '1405021',
    regencyId: '1405',
    name: 'Kerinci Kanan',
  },
  {
    id: '1405022',
    regencyId: '1405',
    name: 'Tualang',
  },
  {
    id: '1405023',
    regencyId: '1405',
    name: 'Dayun',
  },
  {
    id: '1405024',
    regencyId: '1405',
    name: 'Lubuk Dalam',
  },
  {
    id: '1405025',
    regencyId: '1405',
    name: 'Koto Gasib',
  },
  {
    id: '1405026',
    regencyId: '1405',
    name: 'Mempura',
  },
  {
    id: '1405030',
    regencyId: '1405',
    name: 'Sungai Apit',
  },
  {
    id: '1405031',
    regencyId: '1405',
    name: 'Bunga Raya',
  },
  {
    id: '1405032',
    regencyId: '1405',
    name: 'Sabak Auh',
  },
  {
    id: '1405033',
    regencyId: '1405',
    name: 'Pusako',
  },
  {
    id: '1406010',
    regencyId: '1406',
    name: 'Kampar Kiri',
  },
  {
    id: '1406011',
    regencyId: '1406',
    name: 'Kampar Kiri Hulu',
  },
  {
    id: '1406012',
    regencyId: '1406',
    name: 'Kampar Kiri Hilir',
  },
  {
    id: '1406013',
    regencyId: '1406',
    name: 'Gunung Sahilan',
  },
  {
    id: '1406014',
    regencyId: '1406',
    name: 'Kampar Kiri Tengah',
  },
  {
    id: '1406020',
    regencyId: '1406',
    name: 'Xiii Koto Kampar',
  },
  {
    id: '1406021',
    regencyId: '1406',
    name: 'Koto Kampar Hulu',
  },
  {
    id: '1406030',
    regencyId: '1406',
    name: 'Kuok',
  },
  {
    id: '1406031',
    regencyId: '1406',
    name: 'Salo',
  },
  {
    id: '1406040',
    regencyId: '1406',
    name: 'Tapung',
  },
  {
    id: '1406041',
    regencyId: '1406',
    name: 'Tapung Hulu',
  },
  {
    id: '1406042',
    regencyId: '1406',
    name: 'Tapung Hilir',
  },
  {
    id: '1406050',
    regencyId: '1406',
    name: 'Bangkinang Kota',
  },
  {
    id: '1406051',
    regencyId: '1406',
    name: 'Bangkinang',
  },
  {
    id: '1406060',
    regencyId: '1406',
    name: 'Kampar',
  },
  {
    id: '1406061',
    regencyId: '1406',
    name: 'Kampa',
  },
  {
    id: '1406062',
    regencyId: '1406',
    name: 'Rumbio Jaya',
  },
  {
    id: '1406063',
    regencyId: '1406',
    name: 'Kampar Utara',
  },
  {
    id: '1406070',
    regencyId: '1406',
    name: 'Tambang',
  },
  {
    id: '1406080',
    regencyId: '1406',
    name: 'Siak Hulu',
  },
  {
    id: '1406081',
    regencyId: '1406',
    name: 'Perhentian Raja',
  },
  {
    id: '1407010',
    regencyId: '1407',
    name: 'Rokan IV Koto',
  },
  {
    id: '1407011',
    regencyId: '1407',
    name: 'Pendalian IV Koto',
  },
  {
    id: '1407020',
    regencyId: '1407',
    name: 'Tandun',
  },
  {
    id: '1407021',
    regencyId: '1407',
    name: 'Kabun',
  },
  {
    id: '1407022',
    regencyId: '1407',
    name: 'Ujung Batu',
  },
  {
    id: '1407030',
    regencyId: '1407',
    name: 'Rambah Samo',
  },
  {
    id: '1407040',
    regencyId: '1407',
    name: 'Rambah',
  },
  {
    id: '1407041',
    regencyId: '1407',
    name: 'Rambah Hilir',
  },
  {
    id: '1407042',
    regencyId: '1407',
    name: 'Bangun Purba',
  },
  {
    id: '1407050',
    regencyId: '1407',
    name: 'Tambusai',
  },
  {
    id: '1407051',
    regencyId: '1407',
    name: 'Tambusai Utara',
  },
  {
    id: '1407060',
    regencyId: '1407',
    name: 'Kepenuhan',
  },
  {
    id: '1407061',
    regencyId: '1407',
    name: 'Kepenuhan Hulu',
  },
  {
    id: '1407070',
    regencyId: '1407',
    name: 'Kunto Darussalam',
  },
  {
    id: '1407071',
    regencyId: '1407',
    name: 'Pagaran Tapah Darussalam',
  },
  {
    id: '1407072',
    regencyId: '1407',
    name: 'Bonai Darussalam',
  },
  {
    id: '1408010',
    regencyId: '1408',
    name: 'Mandau',
  },
  {
    id: '1408011',
    regencyId: '1408',
    name: 'Pinggir',
  },
  {
    id: '1408012',
    regencyId: '1408',
    name: 'Bathin Solapan',
  },
  {
    id: '1408013',
    regencyId: '1408',
    name: 'Talang Muandau',
  },
  {
    id: '1408020',
    regencyId: '1408',
    name: 'Bukit Batu',
  },
  {
    id: '1408021',
    regencyId: '1408',
    name: 'Siak Kecil',
  },
  {
    id: '1408022',
    regencyId: '1408',
    name: 'Bandar Laksamana',
  },
  {
    id: '1408030',
    regencyId: '1408',
    name: 'Rupat',
  },
  {
    id: '1408031',
    regencyId: '1408',
    name: 'Rupat Utara',
  },
  {
    id: '1408040',
    regencyId: '1408',
    name: 'Bengkalis',
  },
  {
    id: '1408050',
    regencyId: '1408',
    name: 'Bantan',
  },
  {
    id: '1409010',
    regencyId: '1409',
    name: 'Tanah Putih',
  },
  {
    id: '1409011',
    regencyId: '1409',
    name: 'Pujud',
  },
  {
    id: '1409012',
    regencyId: '1409',
    name: 'Tanah Putih Tanjung Melawan',
  },
  {
    id: '1409013',
    regencyId: '1409',
    name: 'Rantau Kopar',
  },
  {
    id: '1409014',
    regencyId: '1409',
    name: 'Tanjung Medan',
  },
  {
    id: '1409020',
    regencyId: '1409',
    name: 'Bagan Sinembah',
  },
  {
    id: '1409021',
    regencyId: '1409',
    name: 'Simpang Kanan',
  },
  {
    id: '1409022',
    regencyId: '1409',
    name: 'Bagan Sinembah Raya',
  },
  {
    id: '1409023',
    regencyId: '1409',
    name: 'Balai Jaya',
  },
  {
    id: '1409030',
    regencyId: '1409',
    name: 'Kubu',
  },
  {
    id: '1409031',
    regencyId: '1409',
    name: 'Pasir Limau Kapas',
  },
  {
    id: '1409032',
    regencyId: '1409',
    name: 'Kubu Babussalam',
  },
  {
    id: '1409040',
    regencyId: '1409',
    name: 'Bangko',
  },
  {
    id: '1409041',
    regencyId: '1409',
    name: 'Sinaboi',
  },
  {
    id: '1409042',
    regencyId: '1409',
    name: 'Batu Hampar',
  },
  {
    id: '1409043',
    regencyId: '1409',
    name: 'Pekaitan',
  },
  {
    id: '1409050',
    regencyId: '1409',
    name: 'Rimba Melintang',
  },
  {
    id: '1409051',
    regencyId: '1409',
    name: 'Bangko Pusako',
  },
  {
    id: '1410010',
    regencyId: '1410',
    name: 'Tebing Tinggi Barat',
  },
  {
    id: '1410020',
    regencyId: '1410',
    name: 'Tebing Tinggi',
  },
  {
    id: '1410021',
    regencyId: '1410',
    name: 'Tebing Tinggi Timur',
  },
  {
    id: '1410030',
    regencyId: '1410',
    name: 'Rangsang',
  },
  {
    id: '1410031',
    regencyId: '1410',
    name: 'Rangsang Pesisir',
  },
  {
    id: '1410040',
    regencyId: '1410',
    name: 'Rangsang Barat',
  },
  {
    id: '1410050',
    regencyId: '1410',
    name: 'Merbau',
  },
  {
    id: '1410051',
    regencyId: '1410',
    name: 'Pulau Merbau',
  },
  {
    id: '1410052',
    regencyId: '1410',
    name: 'Tasik Putri Puyu',
  },
  {
    id: '1471010',
    regencyId: '1471',
    name: 'Tampan',
  },
  {
    id: '1471011',
    regencyId: '1471',
    name: 'Payung Sekaki',
  },
  {
    id: '1471020',
    regencyId: '1471',
    name: 'Bukit Raya',
  },
  {
    id: '1471021',
    regencyId: '1471',
    name: 'Marpoyan Damai',
  },
  {
    id: '1471022',
    regencyId: '1471',
    name: 'Tenayan Raya',
  },
  {
    id: '1471030',
    regencyId: '1471',
    name: 'Limapuluh',
  },
  {
    id: '1471040',
    regencyId: '1471',
    name: 'Sail',
  },
  {
    id: '1471050',
    regencyId: '1471',
    name: 'Pekanbaru Kota',
  },
  {
    id: '1471060',
    regencyId: '1471',
    name: 'Sukajadi',
  },
  {
    id: '1471070',
    regencyId: '1471',
    name: 'Senapelan',
  },
  {
    id: '1471080',
    regencyId: '1471',
    name: 'Rumbai',
  },
  {
    id: '1471081',
    regencyId: '1471',
    name: 'Rumbai Pesisir',
  },
  {
    id: '1473010',
    regencyId: '1473',
    name: 'Bukit Kapur',
  },
  {
    id: '1473011',
    regencyId: '1473',
    name: 'Medang Kampai',
  },
  {
    id: '1473012',
    regencyId: '1473',
    name: 'Sungai Sembilan',
  },
  {
    id: '1473020',
    regencyId: '1473',
    name: 'Dumai Barat',
  },
  {
    id: '1473021',
    regencyId: '1473',
    name: 'Dumai Selatan',
  },
  {
    id: '1473030',
    regencyId: '1473',
    name: 'Dumai Timur',
  },
  {
    id: '1473031',
    regencyId: '1473',
    name: 'Dumai Kota',
  },
  {
    id: '1501010',
    regencyId: '1501',
    name: 'Gunung Raya',
  },
  {
    id: '1501011',
    regencyId: '1501',
    name: 'Bukit Kerman',
  },
  {
    id: '1501020',
    regencyId: '1501',
    name: 'Batang Merangin',
  },
  {
    id: '1501030',
    regencyId: '1501',
    name: 'Keliling Danau',
  },
  {
    id: '1501040',
    regencyId: '1501',
    name: 'Danau Kerinci',
  },
  {
    id: '1501050',
    regencyId: '1501',
    name: 'Sitinjau Laut',
  },
  {
    id: '1501070',
    regencyId: '1501',
    name: 'Air Hangat',
  },
  {
    id: '1501071',
    regencyId: '1501',
    name: 'Air Hangat Timur',
  },
  {
    id: '1501072',
    regencyId: '1501',
    name: 'Depati VII',
  },
  {
    id: '1501073',
    regencyId: '1501',
    name: 'Air Hangat Barat',
  },
  {
    id: '1501080',
    regencyId: '1501',
    name: 'Gunung Kerinci',
  },
  {
    id: '1501081',
    regencyId: '1501',
    name: 'Siulak',
  },
  {
    id: '1501082',
    regencyId: '1501',
    name: 'Siulak Mukai',
  },
  {
    id: '1501090',
    regencyId: '1501',
    name: 'Kayu Aro',
  },
  {
    id: '1501091',
    regencyId: '1501',
    name: 'Gunung Tujuh',
  },
  {
    id: '1501092',
    regencyId: '1501',
    name: 'Kayu Aro Barat',
  },
  {
    id: '1502010',
    regencyId: '1502',
    name: 'Jangkat',
  },
  {
    id: '1502011',
    regencyId: '1502',
    name: 'Sungai Tenang',
  },
  {
    id: '1502020',
    regencyId: '1502',
    name: 'Muara Siau',
  },
  {
    id: '1502021',
    regencyId: '1502',
    name: 'Lembah Masurai',
  },
  {
    id: '1502022',
    regencyId: '1502',
    name: 'Tiang Pumpung',
  },
  {
    id: '1502030',
    regencyId: '1502',
    name: 'Pamenang',
  },
  {
    id: '1502031',
    regencyId: '1502',
    name: 'Pamenang Barat',
  },
  {
    id: '1502032',
    regencyId: '1502',
    name: 'Renah Pamenang',
  },
  {
    id: '1502033',
    regencyId: '1502',
    name: 'Pamenang Selatan',
  },
  {
    id: '1502040',
    regencyId: '1502',
    name: 'Bangko',
  },
  {
    id: '1502041',
    regencyId: '1502',
    name: 'Bangko Barat',
  },
  {
    id: '1502042',
    regencyId: '1502',
    name: 'Nalo Tantan',
  },
  {
    id: '1502043',
    regencyId: '1502',
    name: 'Batang Masumai',
  },
  {
    id: '1502050',
    regencyId: '1502',
    name: 'Sungai Manau',
  },
  {
    id: '1502051',
    regencyId: '1502',
    name: 'Renah Pembarap',
  },
  {
    id: '1502052',
    regencyId: '1502',
    name: 'Pangkalan Jambu',
  },
  {
    id: '1502060',
    regencyId: '1502',
    name: 'Tabir',
  },
  {
    id: '1502061',
    regencyId: '1502',
    name: 'Tabir Ulu',
  },
  {
    id: '1502062',
    regencyId: '1502',
    name: 'Tabir Selatan',
  },
  {
    id: '1502063',
    regencyId: '1502',
    name: 'Tabir Ilir',
  },
  {
    id: '1502064',
    regencyId: '1502',
    name: 'Tabir Timur',
  },
  {
    id: '1502065',
    regencyId: '1502',
    name: 'Tabir Lintas',
  },
  {
    id: '1502066',
    regencyId: '1502',
    name: 'Margo Tabir',
  },
  {
    id: '1502067',
    regencyId: '1502',
    name: 'Tabir Barat',
  },
  {
    id: '1503010',
    regencyId: '1503',
    name: 'Batang Asai',
  },
  {
    id: '1503020',
    regencyId: '1503',
    name: 'Limun',
  },
  {
    id: '1503021',
    regencyId: '1503',
    name: 'Cermin Nan Gedang',
  },
  {
    id: '1503030',
    regencyId: '1503',
    name: 'Pelawan',
  },
  {
    id: '1503031',
    regencyId: '1503',
    name: 'Singkut',
  },
  {
    id: '1503040',
    regencyId: '1503',
    name: 'Sarolangun',
  },
  {
    id: '1503041',
    regencyId: '1503',
    name: 'Bathin VIII',
  },
  {
    id: '1503050',
    regencyId: '1503',
    name: 'Pauh',
  },
  {
    id: '1503051',
    regencyId: '1503',
    name: 'Air Hitam',
  },
  {
    id: '1503060',
    regencyId: '1503',
    name: 'Mandiangin',
  },
  {
    id: '1504010',
    regencyId: '1504',
    name: 'Mersam',
  },
  {
    id: '1504011',
    regencyId: '1504',
    name: 'Maro Sebo Ulu',
  },
  {
    id: '1504020',
    regencyId: '1504',
    name: 'Batin Xxiv',
  },
  {
    id: '1504030',
    regencyId: '1504',
    name: 'Muara Tembesi',
  },
  {
    id: '1504040',
    regencyId: '1504',
    name: 'Muara Bulian',
  },
  {
    id: '1504041',
    regencyId: '1504',
    name: 'Bajubang',
  },
  {
    id: '1504042',
    regencyId: '1504',
    name: 'Maro Sebo Ilir',
  },
  {
    id: '1504050',
    regencyId: '1504',
    name: 'Pemayung',
  },
  {
    id: '1505010',
    regencyId: '1505',
    name: 'Mestong',
  },
  {
    id: '1505011',
    regencyId: '1505',
    name: 'Sungai Bahar',
  },
  {
    id: '1505012',
    regencyId: '1505',
    name: 'Bahar Selatan',
  },
  {
    id: '1505013',
    regencyId: '1505',
    name: 'Bahar Utara',
  },
  {
    id: '1505020',
    regencyId: '1505',
    name: 'Kumpeh Ulu',
  },
  {
    id: '1505021',
    regencyId: '1505',
    name: 'Sungai Gelam',
  },
  {
    id: '1505030',
    regencyId: '1505',
    name: 'Kumpeh',
  },
  {
    id: '1505040',
    regencyId: '1505',
    name: 'Maro Sebo',
  },
  {
    id: '1505041',
    regencyId: '1505',
    name: 'Taman Rajo',
  },
  {
    id: '1505050',
    regencyId: '1505',
    name: 'Jambi Luar Kota',
  },
  {
    id: '1505060',
    regencyId: '1505',
    name: 'Sekernan',
  },
  {
    id: '1506010',
    regencyId: '1506',
    name: 'Mendahara',
  },
  {
    id: '1506011',
    regencyId: '1506',
    name: 'Mendahara Ulu',
  },
  {
    id: '1506012',
    regencyId: '1506',
    name: 'Geragai',
  },
  {
    id: '1506020',
    regencyId: '1506',
    name: 'Dendang',
  },
  {
    id: '1506031',
    regencyId: '1506',
    name: 'Muara Sabak Barat',
  },
  {
    id: '1506032',
    regencyId: '1506',
    name: 'Muara Sabak Timur',
  },
  {
    id: '1506033',
    regencyId: '1506',
    name: 'Kuala Jambi',
  },
  {
    id: '1506040',
    regencyId: '1506',
    name: 'Rantau Rasau',
  },
  {
    id: '1506041',
    regencyId: '1506',
    name: 'Berbak',
  },
  {
    id: '1506050',
    regencyId: '1506',
    name: 'Nipah Panjang',
  },
  {
    id: '1506060',
    regencyId: '1506',
    name: 'Sadu',
  },
  {
    id: '1507010',
    regencyId: '1507',
    name: 'Tungkal Ulu',
  },
  {
    id: '1507011',
    regencyId: '1507',
    name: 'Merlung',
  },
  {
    id: '1507012',
    regencyId: '1507',
    name: 'Batang Asam',
  },
  {
    id: '1507013',
    regencyId: '1507',
    name: 'Tebing Tinggi',
  },
  {
    id: '1507014',
    regencyId: '1507',
    name: 'Renah Mendaluh',
  },
  {
    id: '1507015',
    regencyId: '1507',
    name: 'Muara Papalik',
  },
  {
    id: '1507020',
    regencyId: '1507',
    name: 'Pengabuan',
  },
  {
    id: '1507021',
    regencyId: '1507',
    name: 'Senyerang',
  },
  {
    id: '1507030',
    regencyId: '1507',
    name: 'Tungkal Ilir',
  },
  {
    id: '1507031',
    regencyId: '1507',
    name: 'Bram Itam',
  },
  {
    id: '1507032',
    regencyId: '1507',
    name: 'Seberang Kota',
  },
  {
    id: '1507040',
    regencyId: '1507',
    name: 'Betara',
  },
  {
    id: '1507041',
    regencyId: '1507',
    name: 'Kuala Betara',
  },
  {
    id: '1508010',
    regencyId: '1508',
    name: 'Tebo Ilir',
  },
  {
    id: '1508011',
    regencyId: '1508',
    name: 'Muara Tabir',
  },
  {
    id: '1508020',
    regencyId: '1508',
    name: 'Tebo Tengah',
  },
  {
    id: '1508021',
    regencyId: '1508',
    name: 'Sumay',
  },
  {
    id: '1508022',
    regencyId: '1508',
    name: 'Tengah Ilir',
  },
  {
    id: '1508030',
    regencyId: '1508',
    name: 'Rimbo Bujang',
  },
  {
    id: '1508031',
    regencyId: '1508',
    name: 'Rimbo Ulu',
  },
  {
    id: '1508032',
    regencyId: '1508',
    name: 'Rimbo Ilir',
  },
  {
    id: '1508040',
    regencyId: '1508',
    name: 'Tebo Ulu',
  },
  {
    id: '1508041',
    regencyId: '1508',
    name: 'VII Koto',
  },
  {
    id: '1508042',
    regencyId: '1508',
    name: 'Serai Serumpun',
  },
  {
    id: '1508043',
    regencyId: '1508',
    name: 'VII Koto Ilir',
  },
  {
    id: '1509010',
    regencyId: '1509',
    name: 'Pelepat',
  },
  {
    id: '1509011',
    regencyId: '1509',
    name: 'Pelepat Ilir',
  },
  {
    id: '1509021',
    regencyId: '1509',
    name: 'Bathin II Babeko',
  },
  {
    id: '1509022',
    regencyId: '1509',
    name: 'Rimbo Tengah',
  },
  {
    id: '1509023',
    regencyId: '1509',
    name: 'Bungo Dani',
  },
  {
    id: '1509024',
    regencyId: '1509',
    name: 'Pasar Muara Bungo',
  },
  {
    id: '1509025',
    regencyId: '1509',
    name: 'Bathin III',
  },
  {
    id: '1509030',
    regencyId: '1509',
    name: 'Rantau Pandan',
  },
  {
    id: '1509031',
    regencyId: '1509',
    name: 'Muko-Muko Bathin VII',
  },
  {
    id: '1509032',
    regencyId: '1509',
    name: 'Bathin III Ulu',
  },
  {
    id: '1509040',
    regencyId: '1509',
    name: 'Tanah Sepenggal',
  },
  {
    id: '1509041',
    regencyId: '1509',
    name: 'Tanah Sepenggal Lintas',
  },
  {
    id: '1509050',
    regencyId: '1509',
    name: 'Tanah Tumbuh',
  },
  {
    id: '1509051',
    regencyId: '1509',
    name: 'Limbur Lubuk Mengkuang',
  },
  {
    id: '1509052',
    regencyId: '1509',
    name: 'Bathin II Pelayang',
  },
  {
    id: '1509060',
    regencyId: '1509',
    name: 'Jujuhan',
  },
  {
    id: '1509061',
    regencyId: '1509',
    name: 'Jujuhan Ilir',
  },
  {
    id: '1571010',
    regencyId: '1571',
    name: 'Kota Baru',
  },
  {
    id: '1571011',
    regencyId: '1571',
    name: 'Alam Barajo',
  },
  {
    id: '1571020',
    regencyId: '1571',
    name: 'Jambi Selatan',
  },
  {
    id: '1571021',
    regencyId: '1571',
    name: 'Paal Merah',
  },
  {
    id: '1571030',
    regencyId: '1571',
    name: 'Jelutung',
  },
  {
    id: '1571040',
    regencyId: '1571',
    name: 'Pasar Jambi',
  },
  {
    id: '1571050',
    regencyId: '1571',
    name: 'Telanaipura',
  },
  {
    id: '1571051',
    regencyId: '1571',
    name: 'Danau Sipin',
  },
  {
    id: '1571060',
    regencyId: '1571',
    name: 'Danau Teluk',
  },
  {
    id: '1571070',
    regencyId: '1571',
    name: 'Pelayangan',
  },
  {
    id: '1571080',
    regencyId: '1571',
    name: 'Jambi Timur',
  },
  {
    id: '1572010',
    regencyId: '1572',
    name: 'Tanah Kampung',
  },
  {
    id: '1572020',
    regencyId: '1572',
    name: 'Kumun Debai',
  },
  {
    id: '1572030',
    regencyId: '1572',
    name: 'Sungai Penuh',
  },
  {
    id: '1572031',
    regencyId: '1572',
    name: 'Pondok Tinggi',
  },
  {
    id: '1572032',
    regencyId: '1572',
    name: 'Sungai Bungkal',
  },
  {
    id: '1572040',
    regencyId: '1572',
    name: 'Hamparan Rawang',
  },
  {
    id: '1572050',
    regencyId: '1572',
    name: 'Pesisir Bukit',
  },
  {
    id: '1572051',
    regencyId: '1572',
    name: 'Koto Baru',
  },
  {
    id: '1601052',
    regencyId: '1601',
    name: 'Lengkiti',
  },
  {
    id: '1601070',
    regencyId: '1601',
    name: 'Sosoh Buay Rayap',
  },
  {
    id: '1601080',
    regencyId: '1601',
    name: 'Pengandonan',
  },
  {
    id: '1601081',
    regencyId: '1601',
    name: 'Semidang Aji',
  },
  {
    id: '1601082',
    regencyId: '1601',
    name: 'Ulu Ogan',
  },
  {
    id: '1601083',
    regencyId: '1601',
    name: 'Muara Jaya',
  },
  {
    id: '1601090',
    regencyId: '1601',
    name: 'Peninjauan',
  },
  {
    id: '1601091',
    regencyId: '1601',
    name: 'Lubuk Batang',
  },
  {
    id: '1601092',
    regencyId: '1601',
    name: 'Sinar Peninjauan',
  },
  {
    id: '1601093',
    regencyId: '1601',
    name: 'Kedaton Peninjauan Raya',
  },
  {
    id: '1601130',
    regencyId: '1601',
    name: 'Batu Raja Timur',
  },
  {
    id: '1601131',
    regencyId: '1601',
    name: 'Lubuk Raja',
  },
  {
    id: '1601140',
    regencyId: '1601',
    name: 'Batu Raja Barat',
  },
  {
    id: '1602010',
    regencyId: '1602',
    name: 'Lempuing',
  },
  {
    id: '1602011',
    regencyId: '1602',
    name: 'Lempuing Jaya',
  },
  {
    id: '1602020',
    regencyId: '1602',
    name: 'Mesuji',
  },
  {
    id: '1602021',
    regencyId: '1602',
    name: 'Sungai Menang',
  },
  {
    id: '1602022',
    regencyId: '1602',
    name: 'Mesuji Makmur',
  },
  {
    id: '1602023',
    regencyId: '1602',
    name: 'Mesuji Raya',
  },
  {
    id: '1602030',
    regencyId: '1602',
    name: 'Tulung Selapan',
  },
  {
    id: '1602031',
    regencyId: '1602',
    name: 'Cengal',
  },
  {
    id: '1602040',
    regencyId: '1602',
    name: 'Pedamaran',
  },
  {
    id: '1602041',
    regencyId: '1602',
    name: 'Pedamaran Timur',
  },
  {
    id: '1602050',
    regencyId: '1602',
    name: 'Tanjung Lubuk',
  },
  {
    id: '1602051',
    regencyId: '1602',
    name: 'Teluk Gelam',
  },
  {
    id: '1602060',
    regencyId: '1602',
    name: 'Kota Kayu Agung',
  },
  {
    id: '1602120',
    regencyId: '1602',
    name: 'Sirah Pulau Padang',
  },
  {
    id: '1602121',
    regencyId: '1602',
    name: 'Jejawi',
  },
  {
    id: '1602130',
    regencyId: '1602',
    name: 'Pampangan',
  },
  {
    id: '1602131',
    regencyId: '1602',
    name: 'Pangkalan Lapam',
  },
  {
    id: '1602140',
    regencyId: '1602',
    name: 'Air Sugihan',
  },
  {
    id: '1603010',
    regencyId: '1603',
    name: 'Semendo Darat Laut',
  },
  {
    id: '1603011',
    regencyId: '1603',
    name: 'Semendo Darat Ulu',
  },
  {
    id: '1603012',
    regencyId: '1603',
    name: 'Semendo Darat Tengah',
  },
  {
    id: '1603020',
    regencyId: '1603',
    name: 'Tanjung Agung',
  },
  {
    id: '1603031',
    regencyId: '1603',
    name: 'Rambang',
  },
  {
    id: '1603032',
    regencyId: '1603',
    name: 'Lubai',
  },
  {
    id: '1603033',
    regencyId: '1603',
    name: 'Lubai Ulu',
  },
  {
    id: '1603040',
    regencyId: '1603',
    name: 'Lawang Kidul',
  },
  {
    id: '1603050',
    regencyId: '1603',
    name: 'Muara Enim',
  },
  {
    id: '1603051',
    regencyId: '1603',
    name: 'Ujan Mas',
  },
  {
    id: '1603060',
    regencyId: '1603',
    name: 'Gunung Megang',
  },
  {
    id: '1603061',
    regencyId: '1603',
    name: 'Benakat',
  },
  {
    id: '1603062',
    regencyId: '1603',
    name: 'Belimbing',
  },
  {
    id: '1603070',
    regencyId: '1603',
    name: 'Rambang Dangku',
  },
  {
    id: '1603090',
    regencyId: '1603',
    name: 'Gelumbang',
  },
  {
    id: '1603091',
    regencyId: '1603',
    name: 'Lembak',
  },
  {
    id: '1603092',
    regencyId: '1603',
    name: 'Sungai Rotan',
  },
  {
    id: '1603093',
    regencyId: '1603',
    name: 'Muara Belida',
  },
  {
    id: '1603094',
    regencyId: '1603',
    name: 'Kelekar',
  },
  {
    id: '1603095',
    regencyId: '1603',
    name: 'Belida Darat',
  },
  {
    id: '1604011',
    regencyId: '1604',
    name: 'Tanjung Sakti Pumi',
  },
  {
    id: '1604012',
    regencyId: '1604',
    name: 'Tanjung Sakti Pumu',
  },
  {
    id: '1604040',
    regencyId: '1604',
    name: 'Kota Agung',
  },
  {
    id: '1604041',
    regencyId: '1604',
    name: 'Mulak Ulu',
  },
  {
    id: '1604042',
    regencyId: '1604',
    name: 'Tanjung Tebat',
  },
  {
    id: '1604043',
    regencyId: '1604',
    name: 'Mulak Sebingkai',
  },
  {
    id: '1604050',
    regencyId: '1604',
    name: 'Pulau Pinang',
  },
  {
    id: '1604051',
    regencyId: '1604',
    name: 'Pagar Gunung',
  },
  {
    id: '1604052',
    regencyId: '1604',
    name: 'Gumay Ulu',
  },
  {
    id: '1604060',
    regencyId: '1604',
    name: 'Jarai',
  },
  {
    id: '1604061',
    regencyId: '1604',
    name: 'Pajar Bulan',
  },
  {
    id: '1604062',
    regencyId: '1604',
    name: 'Muara Payang',
  },
  {
    id: '1604063',
    regencyId: '1604',
    name: 'Sukamerindu',
  },
  {
    id: '1604111',
    regencyId: '1604',
    name: 'Kikim Barat',
  },
  {
    id: '1604112',
    regencyId: '1604',
    name: 'Kikim Timur',
  },
  {
    id: '1604113',
    regencyId: '1604',
    name: 'Kikim Selatan',
  },
  {
    id: '1604114',
    regencyId: '1604',
    name: 'Kikim Tengah',
  },
  {
    id: '1604120',
    regencyId: '1604',
    name: 'Lahat',
  },
  {
    id: '1604121',
    regencyId: '1604',
    name: 'Gumay Talang',
  },
  {
    id: '1604122',
    regencyId: '1604',
    name: 'Pseksu',
  },
  {
    id: '1604123',
    regencyId: '1604',
    name: 'Lahat Selatan',
  },
  {
    id: '1604131',
    regencyId: '1604',
    name: 'Merapi Barat',
  },
  {
    id: '1604132',
    regencyId: '1604',
    name: 'Merapi Timur',
  },
  {
    id: '1604133',
    regencyId: '1604',
    name: 'Merapi Selatan',
  },
  {
    id: '1605030',
    regencyId: '1605',
    name: 'Suku Tengah Lakitan Ulu',
  },
  {
    id: '1605031',
    regencyId: '1605',
    name: 'Selangit',
  },
  {
    id: '1605032',
    regencyId: '1605',
    name: 'Sumber Harta',
  },
  {
    id: '1605040',
    regencyId: '1605',
    name: 'Tugumulyo',
  },
  {
    id: '1605041',
    regencyId: '1605',
    name: 'Purwodadi',
  },
  {
    id: '1605050',
    regencyId: '1605',
    name: 'Muara Beliti',
  },
  {
    id: '1605051',
    regencyId: '1605',
    name: 'Tiang Pumpung Kepungut',
  },
  {
    id: '1605060',
    regencyId: '1605',
    name: 'Jayaloka',
  },
  {
    id: '1605061',
    regencyId: '1605',
    name: 'Suka Karya',
  },
  {
    id: '1605070',
    regencyId: '1605',
    name: 'Muara Kelingi',
  },
  {
    id: '1605071',
    regencyId: '1605',
    name: 'Bulang Tengah Suku Ulu',
  },
  {
    id: '1605072',
    regencyId: '1605',
    name: 'Tuah Negeri',
  },
  {
    id: '1605080',
    regencyId: '1605',
    name: 'Muara Lakitan',
  },
  {
    id: '1605090',
    regencyId: '1605',
    name: 'Megang Sakti',
  },
  {
    id: '1606010',
    regencyId: '1606',
    name: 'Sanga Desa',
  },
  {
    id: '1606020',
    regencyId: '1606',
    name: 'Babat Toman',
  },
  {
    id: '1606021',
    regencyId: '1606',
    name: 'Batanghari Leko',
  },
  {
    id: '1606022',
    regencyId: '1606',
    name: 'Plakat Tinggi',
  },
  {
    id: '1606023',
    regencyId: '1606',
    name: 'Lawang Wetan',
  },
  {
    id: '1606030',
    regencyId: '1606',
    name: 'Sungai Keruh',
  },
  {
    id: '1606040',
    regencyId: '1606',
    name: 'Sekayu',
  },
  {
    id: '1606041',
    regencyId: '1606',
    name: 'Lais',
  },
  {
    id: '1606090',
    regencyId: '1606',
    name: 'Sungai Lilin',
  },
  {
    id: '1606091',
    regencyId: '1606',
    name: 'Keluang',
  },
  {
    id: '1606092',
    regencyId: '1606',
    name: 'Babat Supat',
  },
  {
    id: '1606100',
    regencyId: '1606',
    name: 'Bayung Lencir',
  },
  {
    id: '1606101',
    regencyId: '1606',
    name: 'Lalan',
  },
  {
    id: '1606102',
    regencyId: '1606',
    name: 'Tungkal Jaya',
  },
  {
    id: '1607010',
    regencyId: '1607',
    name: 'Rantau Bayur',
  },
  {
    id: '1607020',
    regencyId: '1607',
    name: 'Betung',
  },
  {
    id: '1607021',
    regencyId: '1607',
    name: 'Suak Tapeh',
  },
  {
    id: '1607030',
    regencyId: '1607',
    name: 'Pulau Rimau',
  },
  {
    id: '1607031',
    regencyId: '1607',
    name: 'Tungkal Ilir',
  },
  {
    id: '1607040',
    regencyId: '1607',
    name: 'Banyuasin III',
  },
  {
    id: '1607041',
    regencyId: '1607',
    name: 'Sembawa',
  },
  {
    id: '1607050',
    regencyId: '1607',
    name: 'Talang Kelapa',
  },
  {
    id: '1607051',
    regencyId: '1607',
    name: 'Tanjung Lago',
  },
  {
    id: '1607060',
    regencyId: '1607',
    name: 'Banyuasin I',
  },
  {
    id: '1607061',
    regencyId: '1607',
    name: 'Air Kumbang',
  },
  {
    id: '1607070',
    regencyId: '1607',
    name: 'Rambutan',
  },
  {
    id: '1607080',
    regencyId: '1607',
    name: 'Muara Padang',
  },
  {
    id: '1607081',
    regencyId: '1607',
    name: 'Muara Sugihan',
  },
  {
    id: '1607090',
    regencyId: '1607',
    name: 'Makarti Jaya',
  },
  {
    id: '1607091',
    regencyId: '1607',
    name: 'Air Saleh',
  },
  {
    id: '1607100',
    regencyId: '1607',
    name: 'Banyuasin II',
  },
  {
    id: '1607110',
    regencyId: '1607',
    name: 'Muara Telang',
  },
  {
    id: '1607111',
    regencyId: '1607',
    name: 'Sumber Marga Telang',
  },
  {
    id: '1608010',
    regencyId: '1608',
    name: 'Mekakau Ilir',
  },
  {
    id: '1608020',
    regencyId: '1608',
    name: 'Banding Agung',
  },
  {
    id: '1608021',
    regencyId: '1608',
    name: 'Warkuk Ranau Selatan',
  },
  {
    id: '1608022',
    regencyId: '1608',
    name: 'Buay Pematang Ribu Ranau Tengah',
  },
  {
    id: '1608030',
    regencyId: '1608',
    name: 'Buay Pemaca',
  },
  {
    id: '1608040',
    regencyId: '1608',
    name: 'Simpang',
  },
  {
    id: '1608041',
    regencyId: '1608',
    name: 'Buana Pemaca',
  },
  {
    id: '1608050',
    regencyId: '1608',
    name: 'Muaradua',
  },
  {
    id: '1608051',
    regencyId: '1608',
    name: 'Buay Rawan',
  },
  {
    id: '1608060',
    regencyId: '1608',
    name: 'Buay Sandang Aji',
  },
  {
    id: '1608061',
    regencyId: '1608',
    name: 'Tiga Dihaji',
  },
  {
    id: '1608070',
    regencyId: '1608',
    name: 'Buay Runjung',
  },
  {
    id: '1608071',
    regencyId: '1608',
    name: 'Runjung Agung',
  },
  {
    id: '1608080',
    regencyId: '1608',
    name: 'Kisam Tinggi',
  },
  {
    id: '1608090',
    regencyId: '1608',
    name: 'Muaradua Kisam',
  },
  {
    id: '1608091',
    regencyId: '1608',
    name: 'Kisam Ilir',
  },
  {
    id: '1608100',
    regencyId: '1608',
    name: 'Pulau Beringin',
  },
  {
    id: '1608101',
    regencyId: '1608',
    name: 'Sindang Danau',
  },
  {
    id: '1608102',
    regencyId: '1608',
    name: 'Sungai Are',
  },
  {
    id: '1609010',
    regencyId: '1609',
    name: 'Martapura',
  },
  {
    id: '1609011',
    regencyId: '1609',
    name: 'Bunga Mayang',
  },
  {
    id: '1609012',
    regencyId: '1609',
    name: 'Jaya Pura',
  },
  {
    id: '1609020',
    regencyId: '1609',
    name: 'Buay Pemuka Peliung',
  },
  {
    id: '1609030',
    regencyId: '1609',
    name: 'Buay Madang',
  },
  {
    id: '1609031',
    regencyId: '1609',
    name: 'Buay Madang Timur',
  },
  {
    id: '1609032',
    regencyId: '1609',
    name: 'Buay Pemuka Bangsa Raja',
  },
  {
    id: '1609040',
    regencyId: '1609',
    name: 'Madang Suku II',
  },
  {
    id: '1609041',
    regencyId: '1609',
    name: 'Madang Suku III',
  },
  {
    id: '1609050',
    regencyId: '1609',
    name: 'Madang Suku I',
  },
  {
    id: '1609051',
    regencyId: '1609',
    name: 'Belitang Madang Raya',
  },
  {
    id: '1609060',
    regencyId: '1609',
    name: 'Belitang',
  },
  {
    id: '1609061',
    regencyId: '1609',
    name: 'Belitang Jaya',
  },
  {
    id: '1609070',
    regencyId: '1609',
    name: 'Belitang III',
  },
  {
    id: '1609080',
    regencyId: '1609',
    name: 'Belitang II',
  },
  {
    id: '1609081',
    regencyId: '1609',
    name: 'Belitang Mulya',
  },
  {
    id: '1609090',
    regencyId: '1609',
    name: 'Semendawai Suku III',
  },
  {
    id: '1609091',
    regencyId: '1609',
    name: 'Semendawai Timur',
  },
  {
    id: '1609100',
    regencyId: '1609',
    name: 'Cempaka',
  },
  {
    id: '1609101',
    regencyId: '1609',
    name: 'Semendawai Barat',
  },
  {
    id: '1610010',
    regencyId: '1610',
    name: 'Muara Kuang',
  },
  {
    id: '1610011',
    regencyId: '1610',
    name: 'Rambang Kuang',
  },
  {
    id: '1610012',
    regencyId: '1610',
    name: 'Lubuk Keliat',
  },
  {
    id: '1610020',
    regencyId: '1610',
    name: 'Tanjung Batu',
  },
  {
    id: '1610021',
    regencyId: '1610',
    name: 'Payaraman',
  },
  {
    id: '1610030',
    regencyId: '1610',
    name: 'Rantau Alai',
  },
  {
    id: '1610031',
    regencyId: '1610',
    name: 'Kandis',
  },
  {
    id: '1610040',
    regencyId: '1610',
    name: 'Tanjung Raja',
  },
  {
    id: '1610041',
    regencyId: '1610',
    name: 'Rantau Panjang',
  },
  {
    id: '1610042',
    regencyId: '1610',
    name: 'Sungai Pinang',
  },
  {
    id: '1610050',
    regencyId: '1610',
    name: 'Pemulutan',
  },
  {
    id: '1610051',
    regencyId: '1610',
    name: 'Pemulutan Selatan',
  },
  {
    id: '1610052',
    regencyId: '1610',
    name: 'Pemulutan Barat',
  },
  {
    id: '1610060',
    regencyId: '1610',
    name: 'Indralaya',
  },
  {
    id: '1610061',
    regencyId: '1610',
    name: 'Indralaya Utara',
  },
  {
    id: '1610062',
    regencyId: '1610',
    name: 'Indralaya Selatan',
  },
  {
    id: '1611010',
    regencyId: '1611',
    name: 'Muara Pinang',
  },
  {
    id: '1611020',
    regencyId: '1611',
    name: 'Lintang Kanan',
  },
  {
    id: '1611030',
    regencyId: '1611',
    name: 'Pendopo',
  },
  {
    id: '1611031',
    regencyId: '1611',
    name: 'Pendopo Barat',
  },
  {
    id: '1611040',
    regencyId: '1611',
    name: 'Pasemah Air Keruh',
  },
  {
    id: '1611050',
    regencyId: '1611',
    name: 'Ulu Musi',
  },
  {
    id: '1611051',
    regencyId: '1611',
    name: 'Sikap Dalam',
  },
  {
    id: '1611060',
    regencyId: '1611',
    name: 'Talang Padang',
  },
  {
    id: '1611070',
    regencyId: '1611',
    name: 'Tebing Tinggi',
  },
  {
    id: '1611071',
    regencyId: '1611',
    name: 'Saling',
  },
  {
    id: '1612010',
    regencyId: '1612',
    name: 'Talang Ubi',
  },
  {
    id: '1612020',
    regencyId: '1612',
    name: 'Tanah Abang',
  },
  {
    id: '1612030',
    regencyId: '1612',
    name: 'Abab',
  },
  {
    id: '1612040',
    regencyId: '1612',
    name: 'Penukal',
  },
  {
    id: '1612050',
    regencyId: '1612',
    name: 'Penukal Utara',
  },
  {
    id: '1613010',
    regencyId: '1613',
    name: 'Ulu Rawas',
  },
  {
    id: '1613020',
    regencyId: '1613',
    name: 'Karang Jaya',
  },
  {
    id: '1613030',
    regencyId: '1613',
    name: 'Rawas Ulu',
  },
  {
    id: '1613040',
    regencyId: '1613',
    name: 'Rupit',
  },
  {
    id: '1613050',
    regencyId: '1613',
    name: 'Karang Dapo',
  },
  {
    id: '1613060',
    regencyId: '1613',
    name: 'Rawas Ilir',
  },
  {
    id: '1613070',
    regencyId: '1613',
    name: 'Nibung',
  },
  {
    id: '1671010',
    regencyId: '1671',
    name: 'Ilir Barat II',
  },
  {
    id: '1671011',
    regencyId: '1671',
    name: 'Gandus',
  },
  {
    id: '1671020',
    regencyId: '1671',
    name: 'Seberang Ulu I',
  },
  {
    id: '1671021',
    regencyId: '1671',
    name: 'Kertapati',
  },
  {
    id: '1671022',
    regencyId: '1671',
    name: 'Jakabaring',
  },
  {
    id: '1671030',
    regencyId: '1671',
    name: 'Seberang Ulu II',
  },
  {
    id: '1671031',
    regencyId: '1671',
    name: 'Plaju',
  },
  {
    id: '1671040',
    regencyId: '1671',
    name: 'Ilir Barat I',
  },
  {
    id: '1671041',
    regencyId: '1671',
    name: 'Bukit Kecil',
  },
  {
    id: '1671050',
    regencyId: '1671',
    name: 'Ilir Timur I',
  },
  {
    id: '1671051',
    regencyId: '1671',
    name: 'Kemuning',
  },
  {
    id: '1671060',
    regencyId: '1671',
    name: 'Ilir Timur II',
  },
  {
    id: '1671061',
    regencyId: '1671',
    name: 'Kalidoni',
  },
  {
    id: '1671062',
    regencyId: '1671',
    name: 'Ilir Timur III',
  },
  {
    id: '1671070',
    regencyId: '1671',
    name: 'Sako',
  },
  {
    id: '1671071',
    regencyId: '1671',
    name: 'Sematang Borang',
  },
  {
    id: '1671080',
    regencyId: '1671',
    name: 'Sukarami',
  },
  {
    id: '1671081',
    regencyId: '1671',
    name: 'Alang Alang Lebar',
  },
  {
    id: '1672010',
    regencyId: '1672',
    name: 'Rambang Kapak Tengah',
  },
  {
    id: '1672020',
    regencyId: '1672',
    name: 'Prabumulih Timur',
  },
  {
    id: '1672021',
    regencyId: '1672',
    name: 'Prabumulih Selatan',
  },
  {
    id: '1672030',
    regencyId: '1672',
    name: 'Prabumulih Barat',
  },
  {
    id: '1672031',
    regencyId: '1672',
    name: 'Prabumulih Utara',
  },
  {
    id: '1672040',
    regencyId: '1672',
    name: 'Cambai',
  },
  {
    id: '1673010',
    regencyId: '1673',
    name: 'Dempo Selatan',
  },
  {
    id: '1673011',
    regencyId: '1673',
    name: 'Dempo Tengah',
  },
  {
    id: '1673020',
    regencyId: '1673',
    name: 'Dempo Utara',
  },
  {
    id: '1673030',
    regencyId: '1673',
    name: 'Pagar Alam Selatan',
  },
  {
    id: '1673040',
    regencyId: '1673',
    name: 'Pagar Alam Utara',
  },
  {
    id: '1674011',
    regencyId: '1674',
    name: 'Lubuk Linggau Barat I',
  },
  {
    id: '1674012',
    regencyId: '1674',
    name: 'Lubuk Linggau Barat II',
  },
  {
    id: '1674021',
    regencyId: '1674',
    name: 'Lubuk Linggau Selatan I',
  },
  {
    id: '1674022',
    regencyId: '1674',
    name: 'Lubuk Linggau Selatan II',
  },
  {
    id: '1674031',
    regencyId: '1674',
    name: 'Lubuk Linggau Timur I',
  },
  {
    id: '1674032',
    regencyId: '1674',
    name: 'Lubuk Linggau Timur II',
  },
  {
    id: '1674041',
    regencyId: '1674',
    name: 'Lubuk Linggau Utara I',
  },
  {
    id: '1674042',
    regencyId: '1674',
    name: 'Lubuk Linggau Utara II',
  },
  {
    id: '1701040',
    regencyId: '1701',
    name: 'Manna',
  },
  {
    id: '1701041',
    regencyId: '1701',
    name: 'Kota Manna',
  },
  {
    id: '1701042',
    regencyId: '1701',
    name: 'Kedurang',
  },
  {
    id: '1701043',
    regencyId: '1701',
    name: 'Bunga Mas',
  },
  {
    id: '1701044',
    regencyId: '1701',
    name: 'Pasar Manna',
  },
  {
    id: '1701045',
    regencyId: '1701',
    name: 'Kedurang Ilir',
  },
  {
    id: '1701050',
    regencyId: '1701',
    name: 'Seginim',
  },
  {
    id: '1701051',
    regencyId: '1701',
    name: 'Air Nipis',
  },
  {
    id: '1701060',
    regencyId: '1701',
    name: 'Pino',
  },
  {
    id: '1701061',
    regencyId: '1701',
    name: 'Pinoraya',
  },
  {
    id: '1701062',
    regencyId: '1701',
    name: 'Ulu Manna',
  },
  {
    id: '1702020',
    regencyId: '1702',
    name: 'Kota Padang',
  },
  {
    id: '1702021',
    regencyId: '1702',
    name: 'Sindang Beliti Ilir',
  },
  {
    id: '1702030',
    regencyId: '1702',
    name: 'Padang Ulak Tanding',
  },
  {
    id: '1702031',
    regencyId: '1702',
    name: 'Sindang Kelingi',
  },
  {
    id: '1702032',
    regencyId: '1702',
    name: 'Bindu Riang',
  },
  {
    id: '1702033',
    regencyId: '1702',
    name: 'Sindang Beliti Ulu',
  },
  {
    id: '1702034',
    regencyId: '1702',
    name: 'Sindang Dataran',
  },
  {
    id: '1702040',
    regencyId: '1702',
    name: 'Curup',
  },
  {
    id: '1702041',
    regencyId: '1702',
    name: 'Bermani Ulu',
  },
  {
    id: '1702042',
    regencyId: '1702',
    name: 'Selupu Rejang',
  },
  {
    id: '1702043',
    regencyId: '1702',
    name: 'Curup Selatan',
  },
  {
    id: '1702044',
    regencyId: '1702',
    name: 'Curup Tengah',
  },
  {
    id: '1702045',
    regencyId: '1702',
    name: 'Bermani Ulu Raya',
  },
  {
    id: '1702046',
    regencyId: '1702',
    name: 'Curup Utara',
  },
  {
    id: '1702047',
    regencyId: '1702',
    name: 'Curup Timur',
  },
  {
    id: '1703010',
    regencyId: '1703',
    name: 'Enggano',
  },
  {
    id: '1703050',
    regencyId: '1703',
    name: 'Kerkap',
  },
  {
    id: '1703051',
    regencyId: '1703',
    name: 'Air Napal',
  },
  {
    id: '1703052',
    regencyId: '1703',
    name: 'Air Besi',
  },
  {
    id: '1703053',
    regencyId: '1703',
    name: 'Hulu Palik',
  },
  {
    id: '1703054',
    regencyId: '1703',
    name: 'Tanjung Agung Palik',
  },
  {
    id: '1703060',
    regencyId: '1703',
    name: 'Arga Makmur',
  },
  {
    id: '1703061',
    regencyId: '1703',
    name: 'Arma Jaya',
  },
  {
    id: '1703070',
    regencyId: '1703',
    name: 'Lais',
  },
  {
    id: '1703071',
    regencyId: '1703',
    name: 'Batik Nau',
  },
  {
    id: '1703072',
    regencyId: '1703',
    name: 'Giri Mulya',
  },
  {
    id: '1703073',
    regencyId: '1703',
    name: 'Air Padang',
  },
  {
    id: '1703080',
    regencyId: '1703',
    name: 'Padang Jaya',
  },
  {
    id: '1703090',
    regencyId: '1703',
    name: 'Ketahun',
  },
  {
    id: '1703091',
    regencyId: '1703',
    name: 'Napal Putih',
  },
  {
    id: '1703092',
    regencyId: '1703',
    name: 'Ulok Kupai',
  },
  {
    id: '1703093',
    regencyId: '1703',
    name: 'Pinang Raya',
  },
  {
    id: '1703100',
    regencyId: '1703',
    name: 'Putri Hijau',
  },
  {
    id: '1703101',
    regencyId: '1703',
    name: 'Marga Sakti Sebelat',
  },
  {
    id: '1704010',
    regencyId: '1704',
    name: 'Nasal',
  },
  {
    id: '1704020',
    regencyId: '1704',
    name: 'Maje',
  },
  {
    id: '1704030',
    regencyId: '1704',
    name: 'Kaur Selatan',
  },
  {
    id: '1704031',
    regencyId: '1704',
    name: 'Tetap',
  },
  {
    id: '1704040',
    regencyId: '1704',
    name: 'Kaur Tengah',
  },
  {
    id: '1704041',
    regencyId: '1704',
    name: 'Luas',
  },
  {
    id: '1704042',
    regencyId: '1704',
    name: 'Muara Sahung',
  },
  {
    id: '1704050',
    regencyId: '1704',
    name: 'Kinal',
  },
  {
    id: '1704051',
    regencyId: '1704',
    name: 'Semidang Gumay',
  },
  {
    id: '1704060',
    regencyId: '1704',
    name: 'Tanjung Kemuning',
  },
  {
    id: '1704061',
    regencyId: '1704',
    name: 'Kelam Tengah',
  },
  {
    id: '1704070',
    regencyId: '1704',
    name: 'Kaur Utara',
  },
  {
    id: '1704071',
    regencyId: '1704',
    name: 'Padang Guci Hilir',
  },
  {
    id: '1704072',
    regencyId: '1704',
    name: 'Lungkang Kule',
  },
  {
    id: '1704073',
    regencyId: '1704',
    name: 'Padang Guci Hulu',
  },
  {
    id: '1705010',
    regencyId: '1705',
    name: 'Semidang Alas Maras',
  },
  {
    id: '1705020',
    regencyId: '1705',
    name: 'Semidang Alas',
  },
  {
    id: '1705030',
    regencyId: '1705',
    name: 'Talo',
  },
  {
    id: '1705031',
    regencyId: '1705',
    name: 'Ilir Talo',
  },
  {
    id: '1705032',
    regencyId: '1705',
    name: 'Talo Kecil',
  },
  {
    id: '1705033',
    regencyId: '1705',
    name: 'Ulu Talo',
  },
  {
    id: '1705040',
    regencyId: '1705',
    name: 'Seluma',
  },
  {
    id: '1705041',
    regencyId: '1705',
    name: 'Seluma Selatan',
  },
  {
    id: '1705042',
    regencyId: '1705',
    name: 'Seluma Barat',
  },
  {
    id: '1705043',
    regencyId: '1705',
    name: 'Seluma Timur',
  },
  {
    id: '1705044',
    regencyId: '1705',
    name: 'Seluma Utara',
  },
  {
    id: '1705050',
    regencyId: '1705',
    name: 'Sukaraja',
  },
  {
    id: '1705051',
    regencyId: '1705',
    name: 'Air Periukan',
  },
  {
    id: '1705052',
    regencyId: '1705',
    name: 'Lubuk Sandi',
  },
  {
    id: '1706010',
    regencyId: '1706',
    name: 'Ipuh',
  },
  {
    id: '1706011',
    regencyId: '1706',
    name: 'Air Rami',
  },
  {
    id: '1706012',
    regencyId: '1706',
    name: 'Malin Deman',
  },
  {
    id: '1706020',
    regencyId: '1706',
    name: 'Pondok Suguh',
  },
  {
    id: '1706021',
    regencyId: '1706',
    name: 'Sungai Rumbai',
  },
  {
    id: '1706022',
    regencyId: '1706',
    name: 'Teramang Jaya',
  },
  {
    id: '1706030',
    regencyId: '1706',
    name: 'Teras Terunjam',
  },
  {
    id: '1706031',
    regencyId: '1706',
    name: 'Penarik',
  },
  {
    id: '1706032',
    regencyId: '1706',
    name: 'Selagan Raya',
  },
  {
    id: '1706040',
    regencyId: '1706',
    name: 'Kota Mukomuko',
  },
  {
    id: '1706041',
    regencyId: '1706',
    name: 'Air Dikit',
  },
  {
    id: '1706042',
    regencyId: '1706',
    name: 'Xiv Koto',
  },
  {
    id: '1706050',
    regencyId: '1706',
    name: 'Lubuk Pinang',
  },
  {
    id: '1706051',
    regencyId: '1706',
    name: 'Air Manjunto',
  },
  {
    id: '1706052',
    regencyId: '1706',
    name: 'V Koto',
  },
  {
    id: '1707010',
    regencyId: '1707',
    name: 'Rimbo Pengadang',
  },
  {
    id: '1707011',
    regencyId: '1707',
    name: 'Topos',
  },
  {
    id: '1707020',
    regencyId: '1707',
    name: 'Lebong Selatan',
  },
  {
    id: '1707021',
    regencyId: '1707',
    name: 'Bingin Kuning',
  },
  {
    id: '1707030',
    regencyId: '1707',
    name: 'Lebong Tengah',
  },
  {
    id: '1707031',
    regencyId: '1707',
    name: 'Lebong Sakti',
  },
  {
    id: '1707040',
    regencyId: '1707',
    name: 'Lebong Atas',
  },
  {
    id: '1707042',
    regencyId: '1707',
    name: 'Pelabai',
  },
  {
    id: '1707050',
    regencyId: '1707',
    name: 'Lebong Utara',
  },
  {
    id: '1707051',
    regencyId: '1707',
    name: 'Amen',
  },
  {
    id: '1707052',
    regencyId: '1707',
    name: 'Uram Jaya',
  },
  {
    id: '1707053',
    regencyId: '1707',
    name: 'Pinang Belapis',
  },
  {
    id: '1708010',
    regencyId: '1708',
    name: 'Muara Kemumu',
  },
  {
    id: '1708020',
    regencyId: '1708',
    name: 'Bermani Ilir',
  },
  {
    id: '1708030',
    regencyId: '1708',
    name: 'Seberang Musi',
  },
  {
    id: '1708040',
    regencyId: '1708',
    name: 'Tebat Karai',
  },
  {
    id: '1708050',
    regencyId: '1708',
    name: 'Kepahiang',
  },
  {
    id: '1708060',
    regencyId: '1708',
    name: 'Kaba Wetan',
  },
  {
    id: '1708070',
    regencyId: '1708',
    name: 'Ujan Mas',
  },
  {
    id: '1708080',
    regencyId: '1708',
    name: 'Merigi',
  },
  {
    id: '1709010',
    regencyId: '1709',
    name: 'Talang Empat',
  },
  {
    id: '1709020',
    regencyId: '1709',
    name: 'Karang Tinggi',
  },
  {
    id: '1709030',
    regencyId: '1709',
    name: 'Taba Penanjung',
  },
  {
    id: '1709031',
    regencyId: '1709',
    name: 'Merigi Kelindang',
  },
  {
    id: '1709040',
    regencyId: '1709',
    name: 'Pagar Jati',
  },
  {
    id: '1709041',
    regencyId: '1709',
    name: 'Merigi Sakti',
  },
  {
    id: '1709050',
    regencyId: '1709',
    name: 'Pondok Kelapa',
  },
  {
    id: '1709051',
    regencyId: '1709',
    name: 'Pondok Kubang',
  },
  {
    id: '1709060',
    regencyId: '1709',
    name: 'Pematang Tiga',
  },
  {
    id: '1709061',
    regencyId: '1709',
    name: 'Bang Haji',
  },
  {
    id: '1771010',
    regencyId: '1771',
    name: 'Selebar',
  },
  {
    id: '1771011',
    regencyId: '1771',
    name: 'Kampung Melayu',
  },
  {
    id: '1771020',
    regencyId: '1771',
    name: 'Gading Cempaka',
  },
  {
    id: '1771021',
    regencyId: '1771',
    name: 'Ratu Agung',
  },
  {
    id: '1771022',
    regencyId: '1771',
    name: 'Ratu Samban',
  },
  {
    id: '1771023',
    regencyId: '1771',
    name: 'Singaran Pati',
  },
  {
    id: '1771030',
    regencyId: '1771',
    name: 'Teluk Segara',
  },
  {
    id: '1771031',
    regencyId: '1771',
    name: 'Sungai Serut',
  },
  {
    id: '1771040',
    regencyId: '1771',
    name: 'Muara Bangka Hulu',
  },
  {
    id: '1801040',
    regencyId: '1801',
    name: 'Balik Bukit',
  },
  {
    id: '1801041',
    regencyId: '1801',
    name: 'Sukau',
  },
  {
    id: '1801042',
    regencyId: '1801',
    name: 'Lumbok Seminung',
  },
  {
    id: '1801050',
    regencyId: '1801',
    name: 'Belalau',
  },
  {
    id: '1801051',
    regencyId: '1801',
    name: 'Sekincau',
  },
  {
    id: '1801052',
    regencyId: '1801',
    name: 'Suoh',
  },
  {
    id: '1801053',
    regencyId: '1801',
    name: 'Batu Brak',
  },
  {
    id: '1801054',
    regencyId: '1801',
    name: 'Pagar Dewa',
  },
  {
    id: '1801055',
    regencyId: '1801',
    name: 'Batu Ketulis',
  },
  {
    id: '1801056',
    regencyId: '1801',
    name: 'Bandar Negeri Suoh',
  },
  {
    id: '1801060',
    regencyId: '1801',
    name: 'Sumber Jaya',
  },
  {
    id: '1801061',
    regencyId: '1801',
    name: 'Way Tenong',
  },
  {
    id: '1801062',
    regencyId: '1801',
    name: 'Gedung Surian',
  },
  {
    id: '1801063',
    regencyId: '1801',
    name: 'Kebun Tebu',
  },
  {
    id: '1801064',
    regencyId: '1801',
    name: 'Air Hitam',
  },
  {
    id: '1802010',
    regencyId: '1802',
    name: 'Wonosobo',
  },
  {
    id: '1802011',
    regencyId: '1802',
    name: 'Semaka',
  },
  {
    id: '1802012',
    regencyId: '1802',
    name: 'Bandar Negeri Semuong',
  },
  {
    id: '1802020',
    regencyId: '1802',
    name: 'Kota Agung',
  },
  {
    id: '1802021',
    regencyId: '1802',
    name: 'Pematang Sawa',
  },
  {
    id: '1802022',
    regencyId: '1802',
    name: 'Kota Agung Timur',
  },
  {
    id: '1802023',
    regencyId: '1802',
    name: 'Kota Agung Barat',
  },
  {
    id: '1802030',
    regencyId: '1802',
    name: 'Pulau Panggung',
  },
  {
    id: '1802031',
    regencyId: '1802',
    name: 'Ulubelu',
  },
  {
    id: '1802032',
    regencyId: '1802',
    name: 'Air Naningan',
  },
  {
    id: '1802040',
    regencyId: '1802',
    name: 'Talang Padang',
  },
  {
    id: '1802041',
    regencyId: '1802',
    name: 'Sumberejo',
  },
  {
    id: '1802042',
    regencyId: '1802',
    name: 'Gisting',
  },
  {
    id: '1802043',
    regencyId: '1802',
    name: 'Gunung Alip',
  },
  {
    id: '1802050',
    regencyId: '1802',
    name: 'Pugung',
  },
  {
    id: '1802101',
    regencyId: '1802',
    name: 'Bulok',
  },
  {
    id: '1802110',
    regencyId: '1802',
    name: 'Cukuh Balak',
  },
  {
    id: '1802111',
    regencyId: '1802',
    name: 'Kelumbayan',
  },
  {
    id: '1802112',
    regencyId: '1802',
    name: 'Limau',
  },
  {
    id: '1802113',
    regencyId: '1802',
    name: 'Kelumbayan Barat',
  },
  {
    id: '1803060',
    regencyId: '1803',
    name: 'Natar',
  },
  {
    id: '1803070',
    regencyId: '1803',
    name: 'Jati Agung',
  },
  {
    id: '1803080',
    regencyId: '1803',
    name: 'Tanjung Bintang',
  },
  {
    id: '1803081',
    regencyId: '1803',
    name: 'Tanjung Sari',
  },
  {
    id: '1803090',
    regencyId: '1803',
    name: 'Katibung',
  },
  {
    id: '1803091',
    regencyId: '1803',
    name: 'Merbau Mataram',
  },
  {
    id: '1803092',
    regencyId: '1803',
    name: 'Way Sulan',
  },
  {
    id: '1803100',
    regencyId: '1803',
    name: 'Sidomulyo',
  },
  {
    id: '1803101',
    regencyId: '1803',
    name: 'Candipuro',
  },
  {
    id: '1803102',
    regencyId: '1803',
    name: 'Way Panji',
  },
  {
    id: '1803110',
    regencyId: '1803',
    name: 'Kalianda',
  },
  {
    id: '1803111',
    regencyId: '1803',
    name: 'Rajabasa',
  },
  {
    id: '1803120',
    regencyId: '1803',
    name: 'Palas',
  },
  {
    id: '1803121',
    regencyId: '1803',
    name: 'Sragi',
  },
  {
    id: '1803130',
    regencyId: '1803',
    name: 'Penengahan',
  },
  {
    id: '1803131',
    regencyId: '1803',
    name: 'Ketapang',
  },
  {
    id: '1803132',
    regencyId: '1803',
    name: 'Bakauheni',
  },
  {
    id: '1804010',
    regencyId: '1804',
    name: 'Metro Kibang',
  },
  {
    id: '1804020',
    regencyId: '1804',
    name: 'Batanghari',
  },
  {
    id: '1804030',
    regencyId: '1804',
    name: 'Sekampung',
  },
  {
    id: '1804040',
    regencyId: '1804',
    name: 'Margatiga',
  },
  {
    id: '1804050',
    regencyId: '1804',
    name: 'Sekampung Udik',
  },
  {
    id: '1804060',
    regencyId: '1804',
    name: 'Jabung',
  },
  {
    id: '1804061',
    regencyId: '1804',
    name: 'Pasir Sakti',
  },
  {
    id: '1804062',
    regencyId: '1804',
    name: 'Waway Karya',
  },
  {
    id: '1804063',
    regencyId: '1804',
    name: 'Marga Sekampung',
  },
  {
    id: '1804070',
    regencyId: '1804',
    name: 'Labuhan Maringgai',
  },
  {
    id: '1804071',
    regencyId: '1804',
    name: 'Mataram Baru',
  },
  {
    id: '1804072',
    regencyId: '1804',
    name: 'Bandar Sribawono',
  },
  {
    id: '1804073',
    regencyId: '1804',
    name: 'Melinting',
  },
  {
    id: '1804074',
    regencyId: '1804',
    name: 'Gunung Pelindung',
  },
  {
    id: '1804080',
    regencyId: '1804',
    name: 'Way Jepara',
  },
  {
    id: '1804081',
    regencyId: '1804',
    name: 'Braja Slebah',
  },
  {
    id: '1804082',
    regencyId: '1804',
    name: 'Labuhan Ratu',
  },
  {
    id: '1804090',
    regencyId: '1804',
    name: 'Sukadana',
  },
  {
    id: '1804091',
    regencyId: '1804',
    name: 'Bumi Agung',
  },
  {
    id: '1804092',
    regencyId: '1804',
    name: 'Batanghari Nuban',
  },
  {
    id: '1804100',
    regencyId: '1804',
    name: 'Pekalongan',
  },
  {
    id: '1804110',
    regencyId: '1804',
    name: 'Raman Utara',
  },
  {
    id: '1804120',
    regencyId: '1804',
    name: 'Purbolinggo',
  },
  {
    id: '1804121',
    regencyId: '1804',
    name: 'Way Bungur',
  },
  {
    id: '1805010',
    regencyId: '1805',
    name: 'Padang Ratu',
  },
  {
    id: '1805011',
    regencyId: '1805',
    name: 'Selagai Lingga',
  },
  {
    id: '1805012',
    regencyId: '1805',
    name: 'Pubian',
  },
  {
    id: '1805013',
    regencyId: '1805',
    name: 'Anak Tuha',
  },
  {
    id: '1805014',
    regencyId: '1805',
    name: 'Anak Ratu Aji',
  },
  {
    id: '1805020',
    regencyId: '1805',
    name: 'Kalirejo',
  },
  {
    id: '1805021',
    regencyId: '1805',
    name: 'Sendang Agung',
  },
  {
    id: '1805030',
    regencyId: '1805',
    name: 'Bangunrejo',
  },
  {
    id: '1805040',
    regencyId: '1805',
    name: 'Gunung Sugih',
  },
  {
    id: '1805041',
    regencyId: '1805',
    name: 'Bekri',
  },
  {
    id: '1805042',
    regencyId: '1805',
    name: 'Bumi Ratu Nuban',
  },
  {
    id: '1805050',
    regencyId: '1805',
    name: 'Trimurjo',
  },
  {
    id: '1805060',
    regencyId: '1805',
    name: 'Punggur',
  },
  {
    id: '1805061',
    regencyId: '1805',
    name: 'Kota Gajah',
  },
  {
    id: '1805070',
    regencyId: '1805',
    name: 'Seputih Raman',
  },
  {
    id: '1805080',
    regencyId: '1805',
    name: 'Terbanggi Besar',
  },
  {
    id: '1805081',
    regencyId: '1805',
    name: 'Seputih Agung',
  },
  {
    id: '1805082',
    regencyId: '1805',
    name: 'Way Pengubuan',
  },
  {
    id: '1805090',
    regencyId: '1805',
    name: 'Terusan Nunyai',
  },
  {
    id: '1805100',
    regencyId: '1805',
    name: 'Seputih Mataram',
  },
  {
    id: '1805101',
    regencyId: '1805',
    name: 'Bandar Mataram',
  },
  {
    id: '1805110',
    regencyId: '1805',
    name: 'Seputih Banyak',
  },
  {
    id: '1805111',
    regencyId: '1805',
    name: 'Way Seputih',
  },
  {
    id: '1805120',
    regencyId: '1805',
    name: 'Rumbia',
  },
  {
    id: '1805121',
    regencyId: '1805',
    name: 'Bumi Nabung',
  },
  {
    id: '1805122',
    regencyId: '1805',
    name: 'Putra Rumbia',
  },
  {
    id: '1805130',
    regencyId: '1805',
    name: 'Seputih Surabaya',
  },
  {
    id: '1805131',
    regencyId: '1805',
    name: 'Bandar Surabaya',
  },
  {
    id: '1806010',
    regencyId: '1806',
    name: 'Bukit Kemuning',
  },
  {
    id: '1806011',
    regencyId: '1806',
    name: 'Abung Tinggi',
  },
  {
    id: '1806020',
    regencyId: '1806',
    name: 'Tanjung Raja',
  },
  {
    id: '1806030',
    regencyId: '1806',
    name: 'Abung Barat',
  },
  {
    id: '1806031',
    regencyId: '1806',
    name: 'Abung Tengah',
  },
  {
    id: '1806032',
    regencyId: '1806',
    name: 'Abung  Kunang',
  },
  {
    id: '1806033',
    regencyId: '1806',
    name: 'Abung Pekurun',
  },
  {
    id: '1806040',
    regencyId: '1806',
    name: 'Kotabumi',
  },
  {
    id: '1806041',
    regencyId: '1806',
    name: 'Kotabumi Utara',
  },
  {
    id: '1806042',
    regencyId: '1806',
    name: 'Kotabumi Selatan',
  },
  {
    id: '1806050',
    regencyId: '1806',
    name: 'Abung Selatan',
  },
  {
    id: '1806051',
    regencyId: '1806',
    name: 'Abung Semuli',
  },
  {
    id: '1806052',
    regencyId: '1806',
    name: 'Blambangan Pagar',
  },
  {
    id: '1806060',
    regencyId: '1806',
    name: 'Abung Timur',
  },
  {
    id: '1806061',
    regencyId: '1806',
    name: 'Abung Surakarta',
  },
  {
    id: '1806070',
    regencyId: '1806',
    name: 'Sungkai Selatan',
  },
  {
    id: '1806071',
    regencyId: '1806',
    name: 'Muara Sungkai',
  },
  {
    id: '1806072',
    regencyId: '1806',
    name: 'Bunga Mayang',
  },
  {
    id: '1806073',
    regencyId: '1806',
    name: 'Sungkai  Barat',
  },
  {
    id: '1806074',
    regencyId: '1806',
    name: 'Sungkai Jaya',
  },
  {
    id: '1806080',
    regencyId: '1806',
    name: 'Sungkai Utara',
  },
  {
    id: '1806081',
    regencyId: '1806',
    name: 'Hulusungkai',
  },
  {
    id: '1806082',
    regencyId: '1806',
    name: 'Sungkai Tengah',
  },
  {
    id: '1807010',
    regencyId: '1807',
    name: 'Banjit',
  },
  {
    id: '1807020',
    regencyId: '1807',
    name: 'Baradatu',
  },
  {
    id: '1807021',
    regencyId: '1807',
    name: 'Gunung Labuhan',
  },
  {
    id: '1807030',
    regencyId: '1807',
    name: 'Kasui',
  },
  {
    id: '1807031',
    regencyId: '1807',
    name: 'Rebang Tangkas',
  },
  {
    id: '1807040',
    regencyId: '1807',
    name: 'Blambangan Umpu',
  },
  {
    id: '1807041',
    regencyId: '1807',
    name: 'Way Tuba',
  },
  {
    id: '1807042',
    regencyId: '1807',
    name: 'Negeri Agung',
  },
  {
    id: '1807050',
    regencyId: '1807',
    name: 'Bahuga',
  },
  {
    id: '1807051',
    regencyId: '1807',
    name: 'Buay  Bahuga',
  },
  {
    id: '1807052',
    regencyId: '1807',
    name: 'Bumi Agung',
  },
  {
    id: '1807060',
    regencyId: '1807',
    name: 'Pakuan Ratu',
  },
  {
    id: '1807061',
    regencyId: '1807',
    name: 'Negara Batin',
  },
  {
    id: '1807062',
    regencyId: '1807',
    name: 'Negeri Besar',
  },
  {
    id: '1808030',
    regencyId: '1808',
    name: 'Banjar Agung',
  },
  {
    id: '1808031',
    regencyId: '1808',
    name: 'Banjar Margo',
  },
  {
    id: '1808032',
    regencyId: '1808',
    name: 'Banjar Baru',
  },
  {
    id: '1808040',
    regencyId: '1808',
    name: 'Gedung Aji',
  },
  {
    id: '1808041',
    regencyId: '1808',
    name: 'Penawar Aji',
  },
  {
    id: '1808042',
    regencyId: '1808',
    name: 'Meraksa Aji',
  },
  {
    id: '1808050',
    regencyId: '1808',
    name: 'Menggala',
  },
  {
    id: '1808051',
    regencyId: '1808',
    name: 'Penawar Tama',
  },
  {
    id: '1808052',
    regencyId: '1808',
    name: 'Rawajitu Selatan',
  },
  {
    id: '1808053',
    regencyId: '1808',
    name: 'Gedung Meneng',
  },
  {
    id: '1808054',
    regencyId: '1808',
    name: 'Rawajitu Timur',
  },
  {
    id: '1808055',
    regencyId: '1808',
    name: 'Rawa Pitu',
  },
  {
    id: '1808056',
    regencyId: '1808',
    name: 'Gedung Aji Baru',
  },
  {
    id: '1808057',
    regencyId: '1808',
    name: 'Dente Teladas',
  },
  {
    id: '1808058',
    regencyId: '1808',
    name: 'Menggala Timur',
  },
  {
    id: '1809010',
    regencyId: '1809',
    name: 'Punduh Pidada',
  },
  {
    id: '1809011',
    regencyId: '1809',
    name: 'Marga Punduh',
  },
  {
    id: '1809020',
    regencyId: '1809',
    name: 'Padang Cermin',
  },
  {
    id: '1809021',
    regencyId: '1809',
    name: 'Teluk Pandan',
  },
  {
    id: '1809022',
    regencyId: '1809',
    name: 'Way Ratai',
  },
  {
    id: '1809030',
    regencyId: '1809',
    name: 'Kedondong',
  },
  {
    id: '1809031',
    regencyId: '1809',
    name: 'Way Khilau',
  },
  {
    id: '1809040',
    regencyId: '1809',
    name: 'Way Lima',
  },
  {
    id: '1809050',
    regencyId: '1809',
    name: 'Gedung Tataan',
  },
  {
    id: '1809060',
    regencyId: '1809',
    name: 'Negeri Katon',
  },
  {
    id: '1809070',
    regencyId: '1809',
    name: 'Tegineneng',
  },
  {
    id: '1810010',
    regencyId: '1810',
    name: 'Pardasuka',
  },
  {
    id: '1810020',
    regencyId: '1810',
    name: 'Ambarawa',
  },
  {
    id: '1810030',
    regencyId: '1810',
    name: 'Pagelaran',
  },
  {
    id: '1810031',
    regencyId: '1810',
    name: 'Pagelaran Utara',
  },
  {
    id: '1810040',
    regencyId: '1810',
    name: 'Pringsewu',
  },
  {
    id: '1810050',
    regencyId: '1810',
    name: 'Gading Rejo',
  },
  {
    id: '1810060',
    regencyId: '1810',
    name: 'Sukoharjo',
  },
  {
    id: '1810070',
    regencyId: '1810',
    name: 'Banyumas',
  },
  {
    id: '1810080',
    regencyId: '1810',
    name: 'Adi Luwih',
  },
  {
    id: '1811010',
    regencyId: '1811',
    name: 'Way Serdang',
  },
  {
    id: '1811020',
    regencyId: '1811',
    name: 'Simpang Pematang',
  },
  {
    id: '1811030',
    regencyId: '1811',
    name: 'Panca Jaya',
  },
  {
    id: '1811040',
    regencyId: '1811',
    name: 'Tanjung Raya',
  },
  {
    id: '1811050',
    regencyId: '1811',
    name: 'Mesuji',
  },
  {
    id: '1811060',
    regencyId: '1811',
    name: 'Mesuji Timur',
  },
  {
    id: '1811070',
    regencyId: '1811',
    name: 'Rawajitu Utara',
  },
  {
    id: '1812010',
    regencyId: '1812',
    name: 'Tulang Bawang Udik',
  },
  {
    id: '1812020',
    regencyId: '1812',
    name: 'Tumi Jajar',
  },
  {
    id: '1812030',
    regencyId: '1812',
    name: 'Tulang Bawang Tengah',
  },
  {
    id: '1812040',
    regencyId: '1812',
    name: 'Pagar Dewa',
  },
  {
    id: '1812050',
    regencyId: '1812',
    name: 'Lambu Kibang',
  },
  {
    id: '1812060',
    regencyId: '1812',
    name: 'Gunung Terang',
  },
  {
    id: '1812061',
    regencyId: '1812',
    name: 'Batu Putih',
  },
  {
    id: '1812070',
    regencyId: '1812',
    name: 'Gunung Agung',
  },
  {
    id: '1812080',
    regencyId: '1812',
    name: 'Way Kenanga',
  },
  {
    id: '1813010',
    regencyId: '1813',
    name: 'Lemong',
  },
  {
    id: '1813020',
    regencyId: '1813',
    name: 'Pesisir Utara',
  },
  {
    id: '1813030',
    regencyId: '1813',
    name: 'Pulau Pisang',
  },
  {
    id: '1813040',
    regencyId: '1813',
    name: 'Karya Penggawa',
  },
  {
    id: '1813050',
    regencyId: '1813',
    name: 'Way Krui',
  },
  {
    id: '1813060',
    regencyId: '1813',
    name: 'Pesisir Tengah',
  },
  {
    id: '1813070',
    regencyId: '1813',
    name: 'Krui Selatan',
  },
  {
    id: '1813080',
    regencyId: '1813',
    name: 'Pesisir Selatan',
  },
  {
    id: '1813090',
    regencyId: '1813',
    name: 'Ngambur',
  },
  {
    id: '1813100',
    regencyId: '1813',
    name: 'Bengkunat',
  },
  {
    id: '1813110',
    regencyId: '1813',
    name: 'Bengkunat Belimbing',
  },
  {
    id: '1871010',
    regencyId: '1871',
    name: 'Teluk Betung Barat',
  },
  {
    id: '1871011',
    regencyId: '1871',
    name: 'Telukbetung Timur',
  },
  {
    id: '1871020',
    regencyId: '1871',
    name: 'Teluk Betung Selatan',
  },
  {
    id: '1871021',
    regencyId: '1871',
    name: 'Bumi Waras',
  },
  {
    id: '1871030',
    regencyId: '1871',
    name: 'Panjang',
  },
  {
    id: '1871040',
    regencyId: '1871',
    name: 'Tanjung Karang Timur',
  },
  {
    id: '1871041',
    regencyId: '1871',
    name: 'Kedamaian',
  },
  {
    id: '1871050',
    regencyId: '1871',
    name: 'Teluk Betung Utara',
  },
  {
    id: '1871060',
    regencyId: '1871',
    name: 'Tanjung Karang Pusat',
  },
  {
    id: '1871061',
    regencyId: '1871',
    name: 'Enggal',
  },
  {
    id: '1871070',
    regencyId: '1871',
    name: 'Tanjung Karang Barat',
  },
  {
    id: '1871071',
    regencyId: '1871',
    name: 'Kemiling',
  },
  {
    id: '1871072',
    regencyId: '1871',
    name: 'Langkapura',
  },
  {
    id: '1871080',
    regencyId: '1871',
    name: 'Kedaton',
  },
  {
    id: '1871081',
    regencyId: '1871',
    name: 'Rajabasa',
  },
  {
    id: '1871082',
    regencyId: '1871',
    name: 'Tanjung Senang',
  },
  {
    id: '1871083',
    regencyId: '1871',
    name: 'Labuhan Ratu',
  },
  {
    id: '1871090',
    regencyId: '1871',
    name: 'Sukarame',
  },
  {
    id: '1871091',
    regencyId: '1871',
    name: 'Sukabumi',
  },
  {
    id: '1871092',
    regencyId: '1871',
    name: 'Way Halim',
  },
  {
    id: '1872011',
    regencyId: '1872',
    name: 'Metro Selatan',
  },
  {
    id: '1872012',
    regencyId: '1872',
    name: 'Metro Barat',
  },
  {
    id: '1872021',
    regencyId: '1872',
    name: 'Metro Timur',
  },
  {
    id: '1872022',
    regencyId: '1872',
    name: 'Metro Pusat',
  },
  {
    id: '1872023',
    regencyId: '1872',
    name: 'Metro Utara',
  },
  {
    id: '1901070',
    regencyId: '1901',
    name: 'Mendo Barat',
  },
  {
    id: '1901080',
    regencyId: '1901',
    name: 'Merawang',
  },
  {
    id: '1901081',
    regencyId: '1901',
    name: 'Puding Besar',
  },
  {
    id: '1901090',
    regencyId: '1901',
    name: 'Sungai Liat',
  },
  {
    id: '1901091',
    regencyId: '1901',
    name: 'Pemali',
  },
  {
    id: '1901092',
    regencyId: '1901',
    name: 'Bakam',
  },
  {
    id: '1901130',
    regencyId: '1901',
    name: 'Belinyu',
  },
  {
    id: '1901131',
    regencyId: '1901',
    name: 'Riau Silip',
  },
  {
    id: '1902010',
    regencyId: '1902',
    name: 'Membalong',
  },
  {
    id: '1902060',
    regencyId: '1902',
    name: 'Tanjung Pandan',
  },
  {
    id: '1902061',
    regencyId: '1902',
    name: 'Badau',
  },
  {
    id: '1902062',
    regencyId: '1902',
    name: 'Sijuk',
  },
  {
    id: '1902063',
    regencyId: '1902',
    name: 'Selat Nasik',
  },
  {
    id: '1903010',
    regencyId: '1903',
    name: 'Kelapa',
  },
  {
    id: '1903020',
    regencyId: '1903',
    name: 'Tempilang',
  },
  {
    id: '1903030',
    regencyId: '1903',
    name: 'Mentok',
  },
  {
    id: '1903040',
    regencyId: '1903',
    name: 'Simpang Teritip',
  },
  {
    id: '1903050',
    regencyId: '1903',
    name: 'Jebus',
  },
  {
    id: '1903051',
    regencyId: '1903',
    name: 'Parittiga',
  },
  {
    id: '1904010',
    regencyId: '1904',
    name: 'Koba',
  },
  {
    id: '1904011',
    regencyId: '1904',
    name: 'Lubuk Besar',
  },
  {
    id: '1904020',
    regencyId: '1904',
    name: 'Pangkalan Baru',
  },
  {
    id: '1904021',
    regencyId: '1904',
    name: 'Namang',
  },
  {
    id: '1904030',
    regencyId: '1904',
    name: 'Sungai Selan',
  },
  {
    id: '1904040',
    regencyId: '1904',
    name: 'Simpang Katis',
  },
  {
    id: '1905010',
    regencyId: '1905',
    name: 'Payung',
  },
  {
    id: '1905011',
    regencyId: '1905',
    name: 'Pulau Besar',
  },
  {
    id: '1905020',
    regencyId: '1905',
    name: 'Simpang Rimba',
  },
  {
    id: '1905030',
    regencyId: '1905',
    name: 'Toboali',
  },
  {
    id: '1905031',
    regencyId: '1905',
    name: 'Tukak Sadai',
  },
  {
    id: '1905040',
    regencyId: '1905',
    name: 'Air Gegas',
  },
  {
    id: '1905050',
    regencyId: '1905',
    name: 'Lepar Pongok',
  },
  {
    id: '1905051',
    regencyId: '1905',
    name: 'Kepulauan Pongok',
  },
  {
    id: '1906010',
    regencyId: '1906',
    name: 'Dendang',
  },
  {
    id: '1906011',
    regencyId: '1906',
    name: 'Simpang Pesak',
  },
  {
    id: '1906020',
    regencyId: '1906',
    name: 'Gantung',
  },
  {
    id: '1906021',
    regencyId: '1906',
    name: 'Simpang Renggiang',
  },
  {
    id: '1906030',
    regencyId: '1906',
    name: 'Manggar',
  },
  {
    id: '1906031',
    regencyId: '1906',
    name: 'Damar',
  },
  {
    id: '1906040',
    regencyId: '1906',
    name: 'Kelapa Kampit',
  },
  {
    id: '1971010',
    regencyId: '1971',
    name: 'Rangkui',
  },
  {
    id: '1971020',
    regencyId: '1971',
    name: 'Bukit Intan',
  },
  {
    id: '1971021',
    regencyId: '1971',
    name: 'Girimaya',
  },
  {
    id: '1971030',
    regencyId: '1971',
    name: 'Pangkal Balam',
  },
  {
    id: '1971031',
    regencyId: '1971',
    name: 'Gabek',
  },
  {
    id: '1971040',
    regencyId: '1971',
    name: 'Taman Sari',
  },
  {
    id: '1971041',
    regencyId: '1971',
    name: 'Gerunggang',
  },
  {
    id: '2101010',
    regencyId: '2101',
    name: 'Moro',
  },
  {
    id: '2101011',
    regencyId: '2101',
    name: 'Durai',
  },
  {
    id: '2101020',
    regencyId: '2101',
    name: 'Kundur',
  },
  {
    id: '2101021',
    regencyId: '2101',
    name: 'Kundur Utara',
  },
  {
    id: '2101022',
    regencyId: '2101',
    name: 'Kundur Barat',
  },
  {
    id: '2101023',
    regencyId: '2101',
    name: 'Ungar',
  },
  {
    id: '2101024',
    regencyId: '2101',
    name: 'Belat',
  },
  {
    id: '2101030',
    regencyId: '2101',
    name: 'Karimun',
  },
  {
    id: '2101031',
    regencyId: '2101',
    name: 'Buru',
  },
  {
    id: '2101032',
    regencyId: '2101',
    name: 'Meral',
  },
  {
    id: '2101033',
    regencyId: '2101',
    name: 'Tebing',
  },
  {
    id: '2101034',
    regencyId: '2101',
    name: 'Meral Barat',
  },
  {
    id: '2102040',
    regencyId: '2102',
    name: 'Teluk Bintan',
  },
  {
    id: '2102050',
    regencyId: '2102',
    name: 'Bintan Utara',
  },
  {
    id: '2102051',
    regencyId: '2102',
    name: 'Teluk Sebong',
  },
  {
    id: '2102052',
    regencyId: '2102',
    name: 'Seri Kuala Lobam',
  },
  {
    id: '2102060',
    regencyId: '2102',
    name: 'Bintan Timur',
  },
  {
    id: '2102061',
    regencyId: '2102',
    name: 'Gunung Kijang',
  },
  {
    id: '2102062',
    regencyId: '2102',
    name: 'Mantang',
  },
  {
    id: '2102063',
    regencyId: '2102',
    name: 'Bintan Pesisir',
  },
  {
    id: '2102064',
    regencyId: '2102',
    name: 'Toapaya',
  },
  {
    id: '2102070',
    regencyId: '2102',
    name: 'Tambelan',
  },
  {
    id: '2103030',
    regencyId: '2103',
    name: 'Midai',
  },
  {
    id: '2103031',
    regencyId: '2103',
    name: 'Suak Midai',
  },
  {
    id: '2103040',
    regencyId: '2103',
    name: 'Bunguran Barat',
  },
  {
    id: '2103041',
    regencyId: '2103',
    name: 'Bunguran Utara',
  },
  {
    id: '2103042',
    regencyId: '2103',
    name: 'Pulau Laut',
  },
  {
    id: '2103043',
    regencyId: '2103',
    name: 'Pulau Tiga',
  },
  {
    id: '2103044',
    regencyId: '2103',
    name: 'Bunguran Batubi',
  },
  {
    id: '2103045',
    regencyId: '2103',
    name: 'Pulau Tiga Barat',
  },
  {
    id: '2103050',
    regencyId: '2103',
    name: 'Bunguran Timur',
  },
  {
    id: '2103051',
    regencyId: '2103',
    name: 'Bunguran Timur Laut',
  },
  {
    id: '2103052',
    regencyId: '2103',
    name: 'Bunguran Tengah',
  },
  {
    id: '2103053',
    regencyId: '2103',
    name: 'Bunguran Selatan',
  },
  {
    id: '2103060',
    regencyId: '2103',
    name: 'Serasan',
  },
  {
    id: '2103061',
    regencyId: '2103',
    name: 'Subi',
  },
  {
    id: '2103062',
    regencyId: '2103',
    name: 'Serasan Timur',
  },
  {
    id: '2104010',
    regencyId: '2104',
    name: 'Singkep Barat',
  },
  {
    id: '2104011',
    regencyId: '2104',
    name: 'Kepulauan Posek',
  },
  {
    id: '2104020',
    regencyId: '2104',
    name: 'Singkep',
  },
  {
    id: '2104021',
    regencyId: '2104',
    name: 'Singkep Selatan',
  },
  {
    id: '2104022',
    regencyId: '2104',
    name: 'Singkep Pesisir',
  },
  {
    id: '2104030',
    regencyId: '2104',
    name: 'Lingga',
  },
  {
    id: '2104031',
    regencyId: '2104',
    name: 'Selayar',
  },
  {
    id: '2104032',
    regencyId: '2104',
    name: 'Lingga Timur',
  },
  {
    id: '2104040',
    regencyId: '2104',
    name: 'Lingga Utara',
  },
  {
    id: '2104050',
    regencyId: '2104',
    name: 'Senayang',
  },
  {
    id: '2105010',
    regencyId: '2105',
    name: 'Jemaja',
  },
  {
    id: '2105020',
    regencyId: '2105',
    name: 'Jemaja Timur',
  },
  {
    id: '2105030',
    regencyId: '2105',
    name: 'Siantan Selatan',
  },
  {
    id: '2105040',
    regencyId: '2105',
    name: 'Siantan',
  },
  {
    id: '2105050',
    regencyId: '2105',
    name: 'Siantan Timur',
  },
  {
    id: '2105060',
    regencyId: '2105',
    name: 'Siantan Tengah',
  },
  {
    id: '2105070',
    regencyId: '2105',
    name: 'Palmatak',
  },
  {
    id: '2171010',
    regencyId: '2171',
    name: 'Belakang Padang',
  },
  {
    id: '2171020',
    regencyId: '2171',
    name: 'Bulang',
  },
  {
    id: '2171030',
    regencyId: '2171',
    name: 'Galang',
  },
  {
    id: '2171040',
    regencyId: '2171',
    name: 'Sei Beduk',
  },
  {
    id: '2171041',
    regencyId: '2171',
    name: 'Sagulung',
  },
  {
    id: '2171050',
    regencyId: '2171',
    name: 'Nongsa',
  },
  {
    id: '2171051',
    regencyId: '2171',
    name: 'Batam Kota',
  },
  {
    id: '2171060',
    regencyId: '2171',
    name: 'Sekupang',
  },
  {
    id: '2171061',
    regencyId: '2171',
    name: 'Batu Aji',
  },
  {
    id: '2171070',
    regencyId: '2171',
    name: 'Lubuk Baja',
  },
  {
    id: '2171080',
    regencyId: '2171',
    name: 'Batu Ampar',
  },
  {
    id: '2171081',
    regencyId: '2171',
    name: 'Bengkong',
  },
  {
    id: '2172010',
    regencyId: '2172',
    name: 'Bukit Bestari',
  },
  {
    id: '2172020',
    regencyId: '2172',
    name: 'Tanjungpinang Timur',
  },
  {
    id: '2172030',
    regencyId: '2172',
    name: 'Tanjungpinang Kota',
  },
  {
    id: '2172040',
    regencyId: '2172',
    name: 'Tanjungpinang Barat',
  },
  {
    id: '3101010',
    regencyId: '3101',
    name: 'Kepulauan Seribu Selatan',
  },
  {
    id: '3101020',
    regencyId: '3101',
    name: 'Kepulauan Seribu Utara',
  },
  {
    id: '3171010',
    regencyId: '3171',
    name: 'Jagakarsa',
  },
  {
    id: '3171020',
    regencyId: '3171',
    name: 'Pasar Minggu',
  },
  {
    id: '3171030',
    regencyId: '3171',
    name: 'Cilandak',
  },
  {
    id: '3171040',
    regencyId: '3171',
    name: 'Pesanggrahan',
  },
  {
    id: '3171050',
    regencyId: '3171',
    name: 'Kebayoran Lama',
  },
  {
    id: '3171060',
    regencyId: '3171',
    name: 'Kebayoran Baru',
  },
  {
    id: '3171070',
    regencyId: '3171',
    name: 'Mampang Prapatan',
  },
  {
    id: '3171080',
    regencyId: '3171',
    name: 'Pancoran',
  },
  {
    id: '3171090',
    regencyId: '3171',
    name: 'Tebet',
  },
  {
    id: '3171100',
    regencyId: '3171',
    name: 'Setia Budi',
  },
  {
    id: '3172010',
    regencyId: '3172',
    name: 'Pasar Rebo',
  },
  {
    id: '3172020',
    regencyId: '3172',
    name: 'Ciracas',
  },
  {
    id: '3172030',
    regencyId: '3172',
    name: 'Cipayung',
  },
  {
    id: '3172040',
    regencyId: '3172',
    name: 'Makasar',
  },
  {
    id: '3172050',
    regencyId: '3172',
    name: 'Kramat Jati',
  },
  {
    id: '3172060',
    regencyId: '3172',
    name: 'Jatinegara',
  },
  {
    id: '3172070',
    regencyId: '3172',
    name: 'Duren Sawit',
  },
  {
    id: '3172080',
    regencyId: '3172',
    name: 'Cakung',
  },
  {
    id: '3172090',
    regencyId: '3172',
    name: 'Pulo Gadung',
  },
  {
    id: '3172100',
    regencyId: '3172',
    name: 'Matraman',
  },
  {
    id: '3173010',
    regencyId: '3173',
    name: 'Tanah Abang',
  },
  {
    id: '3173020',
    regencyId: '3173',
    name: 'Menteng',
  },
  {
    id: '3173030',
    regencyId: '3173',
    name: 'Senen',
  },
  {
    id: '3173040',
    regencyId: '3173',
    name: 'Johar Baru',
  },
  {
    id: '3173050',
    regencyId: '3173',
    name: 'Cempaka Putih',
  },
  {
    id: '3173060',
    regencyId: '3173',
    name: 'Kemayoran',
  },
  {
    id: '3173070',
    regencyId: '3173',
    name: 'Sawah Besar',
  },
  {
    id: '3173080',
    regencyId: '3173',
    name: 'Gambir',
  },
  {
    id: '3174010',
    regencyId: '3174',
    name: 'Kembangan',
  },
  {
    id: '3174020',
    regencyId: '3174',
    name: 'Kebon Jeruk',
  },
  {
    id: '3174030',
    regencyId: '3174',
    name: 'Palmerah',
  },
  {
    id: '3174040',
    regencyId: '3174',
    name: 'Grogol Petamburan',
  },
  {
    id: '3174050',
    regencyId: '3174',
    name: 'Tambora',
  },
  {
    id: '3174060',
    regencyId: '3174',
    name: 'Taman Sari',
  },
  {
    id: '3174070',
    regencyId: '3174',
    name: 'Cengkareng',
  },
  {
    id: '3174080',
    regencyId: '3174',
    name: 'Kali Deres',
  },
  {
    id: '3175010',
    regencyId: '3175',
    name: 'Penjaringan',
  },
  {
    id: '3175020',
    regencyId: '3175',
    name: 'Pademangan',
  },
  {
    id: '3175030',
    regencyId: '3175',
    name: 'Tanjung Priok',
  },
  {
    id: '3175040',
    regencyId: '3175',
    name: 'Koja',
  },
  {
    id: '3175050',
    regencyId: '3175',
    name: 'Kelapa Gading',
  },
  {
    id: '3175060',
    regencyId: '3175',
    name: 'Cilincing',
  },
  {
    id: '3201010',
    regencyId: '3201',
    name: 'Nanggung',
  },
  {
    id: '3201020',
    regencyId: '3201',
    name: 'Leuwiliang',
  },
  {
    id: '3201021',
    regencyId: '3201',
    name: 'Leuwisadeng',
  },
  {
    id: '3201030',
    regencyId: '3201',
    name: 'Pamijahan',
  },
  {
    id: '3201040',
    regencyId: '3201',
    name: 'Cibungbulang',
  },
  {
    id: '3201050',
    regencyId: '3201',
    name: 'Ciampea',
  },
  {
    id: '3201051',
    regencyId: '3201',
    name: 'Tenjolaya',
  },
  {
    id: '3201060',
    regencyId: '3201',
    name: 'Dramaga',
  },
  {
    id: '3201070',
    regencyId: '3201',
    name: 'Ciomas',
  },
  {
    id: '3201071',
    regencyId: '3201',
    name: 'Tamansari',
  },
  {
    id: '3201080',
    regencyId: '3201',
    name: 'Cijeruk',
  },
  {
    id: '3201081',
    regencyId: '3201',
    name: 'Cigombong',
  },
  {
    id: '3201090',
    regencyId: '3201',
    name: 'Caringin',
  },
  {
    id: '3201100',
    regencyId: '3201',
    name: 'Ciawi',
  },
  {
    id: '3201110',
    regencyId: '3201',
    name: 'Cisarua',
  },
  {
    id: '3201120',
    regencyId: '3201',
    name: 'Megamendung',
  },
  {
    id: '3201130',
    regencyId: '3201',
    name: 'Sukaraja',
  },
  {
    id: '3201140',
    regencyId: '3201',
    name: 'Babakan Madang',
  },
  {
    id: '3201150',
    regencyId: '3201',
    name: 'Sukamakmur',
  },
  {
    id: '3201160',
    regencyId: '3201',
    name: 'Cariu',
  },
  {
    id: '3201161',
    regencyId: '3201',
    name: 'Tanjungsari',
  },
  {
    id: '3201170',
    regencyId: '3201',
    name: 'Jonggol',
  },
  {
    id: '3201180',
    regencyId: '3201',
    name: 'Cileungsi',
  },
  {
    id: '3201181',
    regencyId: '3201',
    name: 'Kelapa Nunggal',
  },
  {
    id: '3201190',
    regencyId: '3201',
    name: 'Gunung Putri',
  },
  {
    id: '3201200',
    regencyId: '3201',
    name: 'Citeureup',
  },
  {
    id: '3201210',
    regencyId: '3201',
    name: 'Cibinong',
  },
  {
    id: '3201220',
    regencyId: '3201',
    name: 'Bojong Gede',
  },
  {
    id: '3201221',
    regencyId: '3201',
    name: 'Tajur Halang',
  },
  {
    id: '3201230',
    regencyId: '3201',
    name: 'Kemang',
  },
  {
    id: '3201231',
    regencyId: '3201',
    name: 'Ranca Bungur',
  },
  {
    id: '3201240',
    regencyId: '3201',
    name: 'Parung',
  },
  {
    id: '3201241',
    regencyId: '3201',
    name: 'Ciseeng',
  },
  {
    id: '3201250',
    regencyId: '3201',
    name: 'Gunung Sindur',
  },
  {
    id: '3201260',
    regencyId: '3201',
    name: 'Rumpin',
  },
  {
    id: '3201270',
    regencyId: '3201',
    name: 'Cigudeg',
  },
  {
    id: '3201271',
    regencyId: '3201',
    name: 'Sukajaya',
  },
  {
    id: '3201280',
    regencyId: '3201',
    name: 'Jasinga',
  },
  {
    id: '3201290',
    regencyId: '3201',
    name: 'Tenjo',
  },
  {
    id: '3201300',
    regencyId: '3201',
    name: 'Parung Panjang',
  },
  {
    id: '3202010',
    regencyId: '3202',
    name: 'Ciemas',
  },
  {
    id: '3202020',
    regencyId: '3202',
    name: 'Ciracap',
  },
  {
    id: '3202021',
    regencyId: '3202',
    name: 'Waluran',
  },
  {
    id: '3202030',
    regencyId: '3202',
    name: 'Surade',
  },
  {
    id: '3202031',
    regencyId: '3202',
    name: 'Cibitung',
  },
  {
    id: '3202040',
    regencyId: '3202',
    name: 'Jampang Kulon',
  },
  {
    id: '3202041',
    regencyId: '3202',
    name: 'Cimanggu',
  },
  {
    id: '3202050',
    regencyId: '3202',
    name: 'Kali Bunder',
  },
  {
    id: '3202060',
    regencyId: '3202',
    name: 'Tegal Buleud',
  },
  {
    id: '3202070',
    regencyId: '3202',
    name: 'Cidolog',
  },
  {
    id: '3202080',
    regencyId: '3202',
    name: 'Sagaranten',
  },
  {
    id: '3202081',
    regencyId: '3202',
    name: 'Cidadap',
  },
  {
    id: '3202082',
    regencyId: '3202',
    name: 'Curugkembar',
  },
  {
    id: '3202090',
    regencyId: '3202',
    name: 'Pabuaran',
  },
  {
    id: '3202100',
    regencyId: '3202',
    name: 'Lengkong',
  },
  {
    id: '3202110',
    regencyId: '3202',
    name: 'Palabuhanratu',
  },
  {
    id: '3202111',
    regencyId: '3202',
    name: 'Simpenan',
  },
  {
    id: '3202120',
    regencyId: '3202',
    name: 'Warung Kiara',
  },
  {
    id: '3202121',
    regencyId: '3202',
    name: 'Bantargadung',
  },
  {
    id: '3202130',
    regencyId: '3202',
    name: 'Jampang Tengah',
  },
  {
    id: '3202131',
    regencyId: '3202',
    name: 'Purabaya',
  },
  {
    id: '3202140',
    regencyId: '3202',
    name: 'Cikembar',
  },
  {
    id: '3202150',
    regencyId: '3202',
    name: 'Nyalindung',
  },
  {
    id: '3202160',
    regencyId: '3202',
    name: 'Geger Bitung',
  },
  {
    id: '3202170',
    regencyId: '3202',
    name: 'Sukaraja',
  },
  {
    id: '3202171',
    regencyId: '3202',
    name: 'Kebonpedes',
  },
  {
    id: '3202172',
    regencyId: '3202',
    name: 'Cireunghas',
  },
  {
    id: '3202173',
    regencyId: '3202',
    name: 'Sukalarang',
  },
  {
    id: '3202180',
    regencyId: '3202',
    name: 'Sukabumi',
  },
  {
    id: '3202190',
    regencyId: '3202',
    name: 'Kadudampit',
  },
  {
    id: '3202200',
    regencyId: '3202',
    name: 'Cisaat',
  },
  {
    id: '3202201',
    regencyId: '3202',
    name: 'Gunungguruh',
  },
  {
    id: '3202210',
    regencyId: '3202',
    name: 'Cibadak',
  },
  {
    id: '3202211',
    regencyId: '3202',
    name: 'Cicantayan',
  },
  {
    id: '3202212',
    regencyId: '3202',
    name: 'Caringin',
  },
  {
    id: '3202220',
    regencyId: '3202',
    name: 'Nagrak',
  },
  {
    id: '3202221',
    regencyId: '3202',
    name: 'Ciambar',
  },
  {
    id: '3202230',
    regencyId: '3202',
    name: 'Cicurug',
  },
  {
    id: '3202240',
    regencyId: '3202',
    name: 'Cidahu',
  },
  {
    id: '3202250',
    regencyId: '3202',
    name: 'Parakan Salak',
  },
  {
    id: '3202260',
    regencyId: '3202',
    name: 'Parung Kuda',
  },
  {
    id: '3202261',
    regencyId: '3202',
    name: 'Bojong Genteng',
  },
  {
    id: '3202270',
    regencyId: '3202',
    name: 'Kalapa Nunggal',
  },
  {
    id: '3202280',
    regencyId: '3202',
    name: 'Cikidang',
  },
  {
    id: '3202290',
    regencyId: '3202',
    name: 'Cisolok',
  },
  {
    id: '3202291',
    regencyId: '3202',
    name: 'Cikakak',
  },
  {
    id: '3202300',
    regencyId: '3202',
    name: 'Kabandungan',
  },
  {
    id: '3203010',
    regencyId: '3203',
    name: 'Agrabinta',
  },
  {
    id: '3203011',
    regencyId: '3203',
    name: 'Leles',
  },
  {
    id: '3203020',
    regencyId: '3203',
    name: 'Sindangbarang',
  },
  {
    id: '3203030',
    regencyId: '3203',
    name: 'Cidaun',
  },
  {
    id: '3203040',
    regencyId: '3203',
    name: 'Naringgul',
  },
  {
    id: '3203050',
    regencyId: '3203',
    name: 'Cibinong',
  },
  {
    id: '3203051',
    regencyId: '3203',
    name: 'Cikadu',
  },
  {
    id: '3203060',
    regencyId: '3203',
    name: 'Tanggeung',
  },
  {
    id: '3203061',
    regencyId: '3203',
    name: 'Pasirkuda',
  },
  {
    id: '3203070',
    regencyId: '3203',
    name: 'Kadupandak',
  },
  {
    id: '3203071',
    regencyId: '3203',
    name: 'Cijati',
  },
  {
    id: '3203080',
    regencyId: '3203',
    name: 'Takokak',
  },
  {
    id: '3203090',
    regencyId: '3203',
    name: 'Sukanagara',
  },
  {
    id: '3203100',
    regencyId: '3203',
    name: 'Pagelaran',
  },
  {
    id: '3203110',
    regencyId: '3203',
    name: 'Campaka',
  },
  {
    id: '3203111',
    regencyId: '3203',
    name: 'Campaka Mulya',
  },
  {
    id: '3203120',
    regencyId: '3203',
    name: 'Cibeber',
  },
  {
    id: '3203130',
    regencyId: '3203',
    name: 'Warungkondang',
  },
  {
    id: '3203131',
    regencyId: '3203',
    name: 'Gekbrong',
  },
  {
    id: '3203140',
    regencyId: '3203',
    name: 'Cilaku',
  },
  {
    id: '3203150',
    regencyId: '3203',
    name: 'Sukaluyu',
  },
  {
    id: '3203160',
    regencyId: '3203',
    name: 'Bojongpicung',
  },
  {
    id: '3203161',
    regencyId: '3203',
    name: 'Haurwangi',
  },
  {
    id: '3203170',
    regencyId: '3203',
    name: 'Ciranjang',
  },
  {
    id: '3203180',
    regencyId: '3203',
    name: 'Mande',
  },
  {
    id: '3203190',
    regencyId: '3203',
    name: 'Karangtengah',
  },
  {
    id: '3203200',
    regencyId: '3203',
    name: 'Cianjur',
  },
  {
    id: '3203210',
    regencyId: '3203',
    name: 'Cugenang',
  },
  {
    id: '3203220',
    regencyId: '3203',
    name: 'Pacet',
  },
  {
    id: '3203221',
    regencyId: '3203',
    name: 'Cipanas',
  },
  {
    id: '3203230',
    regencyId: '3203',
    name: 'Sukaresmi',
  },
  {
    id: '3203240',
    regencyId: '3203',
    name: 'Cikalongkulon',
  },
  {
    id: '3204010',
    regencyId: '3204',
    name: 'Ciwidey',
  },
  {
    id: '3204011',
    regencyId: '3204',
    name: 'Rancabali',
  },
  {
    id: '3204020',
    regencyId: '3204',
    name: 'Pasirjambu',
  },
  {
    id: '3204030',
    regencyId: '3204',
    name: 'Cimaung',
  },
  {
    id: '3204040',
    regencyId: '3204',
    name: 'Pangalengan',
  },
  {
    id: '3204050',
    regencyId: '3204',
    name: 'Kertasari',
  },
  {
    id: '3204060',
    regencyId: '3204',
    name: 'Pacet',
  },
  {
    id: '3204070',
    regencyId: '3204',
    name: 'Ibun',
  },
  {
    id: '3204080',
    regencyId: '3204',
    name: 'Paseh',
  },
  {
    id: '3204090',
    regencyId: '3204',
    name: 'Cikancung',
  },
  {
    id: '3204100',
    regencyId: '3204',
    name: 'Cicalengka',
  },
  {
    id: '3204101',
    regencyId: '3204',
    name: 'Nagreg',
  },
  {
    id: '3204110',
    regencyId: '3204',
    name: 'Rancaekek',
  },
  {
    id: '3204120',
    regencyId: '3204',
    name: 'Majalaya',
  },
  {
    id: '3204121',
    regencyId: '3204',
    name: 'Solokan Jeruk',
  },
  {
    id: '3204130',
    regencyId: '3204',
    name: 'Ciparay',
  },
  {
    id: '3204140',
    regencyId: '3204',
    name: 'Baleendah',
  },
  {
    id: '3204150',
    regencyId: '3204',
    name: 'Arjasari',
  },
  {
    id: '3204160',
    regencyId: '3204',
    name: 'Banjaran',
  },
  {
    id: '3204161',
    regencyId: '3204',
    name: 'Cangkuang',
  },
  {
    id: '3204170',
    regencyId: '3204',
    name: 'Pameungpeuk',
  },
  {
    id: '3204180',
    regencyId: '3204',
    name: 'Katapang',
  },
  {
    id: '3204190',
    regencyId: '3204',
    name: 'Soreang',
  },
  {
    id: '3204191',
    regencyId: '3204',
    name: 'Kutawaringin',
  },
  {
    id: '3204250',
    regencyId: '3204',
    name: 'Margaasih',
  },
  {
    id: '3204260',
    regencyId: '3204',
    name: 'Margahayu',
  },
  {
    id: '3204270',
    regencyId: '3204',
    name: 'Dayeuhkolot',
  },
  {
    id: '3204280',
    regencyId: '3204',
    name: 'Bojongsoang',
  },
  {
    id: '3204290',
    regencyId: '3204',
    name: 'Cileunyi',
  },
  {
    id: '3204300',
    regencyId: '3204',
    name: 'Cilengkrang',
  },
  {
    id: '3204310',
    regencyId: '3204',
    name: 'Cimenyan',
  },
  {
    id: '3205010',
    regencyId: '3205',
    name: 'Cisewu',
  },
  {
    id: '3205011',
    regencyId: '3205',
    name: 'Caringin',
  },
  {
    id: '3205020',
    regencyId: '3205',
    name: 'Talegong',
  },
  {
    id: '3205030',
    regencyId: '3205',
    name: 'Bungbulang',
  },
  {
    id: '3205031',
    regencyId: '3205',
    name: 'Mekarmukti',
  },
  {
    id: '3205040',
    regencyId: '3205',
    name: 'Pamulihan',
  },
  {
    id: '3205050',
    regencyId: '3205',
    name: 'Pakenjeng',
  },
  {
    id: '3205060',
    regencyId: '3205',
    name: 'Cikelet',
  },
  {
    id: '3205070',
    regencyId: '3205',
    name: 'Pameungpeuk',
  },
  {
    id: '3205080',
    regencyId: '3205',
    name: 'Cibalong',
  },
  {
    id: '3205090',
    regencyId: '3205',
    name: 'Cisompet',
  },
  {
    id: '3205100',
    regencyId: '3205',
    name: 'Peundeuy',
  },
  {
    id: '3205110',
    regencyId: '3205',
    name: 'Singajaya',
  },
  {
    id: '3205111',
    regencyId: '3205',
    name: 'Cihurip',
  },
  {
    id: '3205120',
    regencyId: '3205',
    name: 'Cikajang',
  },
  {
    id: '3205130',
    regencyId: '3205',
    name: 'Banjarwangi',
  },
  {
    id: '3205140',
    regencyId: '3205',
    name: 'Cilawu',
  },
  {
    id: '3205150',
    regencyId: '3205',
    name: 'Bayongbong',
  },
  {
    id: '3205151',
    regencyId: '3205',
    name: 'Cigedug',
  },
  {
    id: '3205160',
    regencyId: '3205',
    name: 'Cisurupan',
  },
  {
    id: '3205161',
    regencyId: '3205',
    name: 'Sukaresmi',
  },
  {
    id: '3205170',
    regencyId: '3205',
    name: 'Samarang',
  },
  {
    id: '3205171',
    regencyId: '3205',
    name: 'Pasirwangi',
  },
  {
    id: '3205181',
    regencyId: '3205',
    name: 'Tarogong Kidul',
  },
  {
    id: '3205182',
    regencyId: '3205',
    name: 'Tarogong Kaler',
  },
  {
    id: '3205190',
    regencyId: '3205',
    name: 'Garut Kota',
  },
  {
    id: '3205200',
    regencyId: '3205',
    name: 'Karangpawitan',
  },
  {
    id: '3205210',
    regencyId: '3205',
    name: 'Wanaraja',
  },
  {
    id: '3205211',
    regencyId: '3205',
    name: 'Sucinaraja',
  },
  {
    id: '3205212',
    regencyId: '3205',
    name: 'Pangatikan',
  },
  {
    id: '3205220',
    regencyId: '3205',
    name: 'Sukawening',
  },
  {
    id: '3205221',
    regencyId: '3205',
    name: 'Karangtengah',
  },
  {
    id: '3205230',
    regencyId: '3205',
    name: 'Banyuresmi',
  },
  {
    id: '3205240',
    regencyId: '3205',
    name: 'Leles',
  },
  {
    id: '3205250',
    regencyId: '3205',
    name: 'Leuwigoong',
  },
  {
    id: '3205260',
    regencyId: '3205',
    name: 'Cibatu',
  },
  {
    id: '3205261',
    regencyId: '3205',
    name: 'Kersamanah',
  },
  {
    id: '3205270',
    regencyId: '3205',
    name: 'Cibiuk',
  },
  {
    id: '3205280',
    regencyId: '3205',
    name: 'Kadungora',
  },
  {
    id: '3205290',
    regencyId: '3205',
    name: 'Blubur Limbangan',
  },
  {
    id: '3205300',
    regencyId: '3205',
    name: 'Selaawi',
  },
  {
    id: '3205310',
    regencyId: '3205',
    name: 'Malangbong',
  },
  {
    id: '3206010',
    regencyId: '3206',
    name: 'Cipatujah',
  },
  {
    id: '3206020',
    regencyId: '3206',
    name: 'Karangnunggal',
  },
  {
    id: '3206030',
    regencyId: '3206',
    name: 'Cikalong',
  },
  {
    id: '3206040',
    regencyId: '3206',
    name: 'Pancatengah',
  },
  {
    id: '3206050',
    regencyId: '3206',
    name: 'Cikatomas',
  },
  {
    id: '3206060',
    regencyId: '3206',
    name: 'Cibalong',
  },
  {
    id: '3206061',
    regencyId: '3206',
    name: 'Parungponteng',
  },
  {
    id: '3206070',
    regencyId: '3206',
    name: 'Bantarkalong',
  },
  {
    id: '3206071',
    regencyId: '3206',
    name: 'Bojongasih',
  },
  {
    id: '3206072',
    regencyId: '3206',
    name: 'Culamega',
  },
  {
    id: '3206080',
    regencyId: '3206',
    name: 'Bojonggambir',
  },
  {
    id: '3206090',
    regencyId: '3206',
    name: 'Sodonghilir',
  },
  {
    id: '3206100',
    regencyId: '3206',
    name: 'Taraju',
  },
  {
    id: '3206110',
    regencyId: '3206',
    name: 'Salawu',
  },
  {
    id: '3206111',
    regencyId: '3206',
    name: 'Puspahiang',
  },
  {
    id: '3206120',
    regencyId: '3206',
    name: 'Tanjungjaya',
  },
  {
    id: '3206130',
    regencyId: '3206',
    name: 'Sukaraja',
  },
  {
    id: '3206140',
    regencyId: '3206',
    name: 'Salopa',
  },
  {
    id: '3206141',
    regencyId: '3206',
    name: 'Jatiwaras',
  },
  {
    id: '3206150',
    regencyId: '3206',
    name: 'Cineam',
  },
  {
    id: '3206151',
    regencyId: '3206',
    name: 'Karangjaya',
  },
  {
    id: '3206160',
    regencyId: '3206',
    name: 'Manonjaya',
  },
  {
    id: '3206161',
    regencyId: '3206',
    name: 'Gunungtanjung',
  },
  {
    id: '3206190',
    regencyId: '3206',
    name: 'Singaparna',
  },
  {
    id: '3206191',
    regencyId: '3206',
    name: 'Sukarame',
  },
  {
    id: '3206192',
    regencyId: '3206',
    name: 'Mangunreja',
  },
  {
    id: '3206200',
    regencyId: '3206',
    name: 'Cigalontang',
  },
  {
    id: '3206210',
    regencyId: '3206',
    name: 'Leuwisari',
  },
  {
    id: '3206211',
    regencyId: '3206',
    name: 'Sariwangi',
  },
  {
    id: '3206212',
    regencyId: '3206',
    name: 'Padakembang',
  },
  {
    id: '3206221',
    regencyId: '3206',
    name: 'Sukaratu',
  },
  {
    id: '3206230',
    regencyId: '3206',
    name: 'Cisayong',
  },
  {
    id: '3206231',
    regencyId: '3206',
    name: 'Sukahening',
  },
  {
    id: '3206240',
    regencyId: '3206',
    name: 'Rajapolah',
  },
  {
    id: '3206250',
    regencyId: '3206',
    name: 'Jamanis',
  },
  {
    id: '3206260',
    regencyId: '3206',
    name: 'Ciawi',
  },
  {
    id: '3206261',
    regencyId: '3206',
    name: 'Kadipaten',
  },
  {
    id: '3206270',
    regencyId: '3206',
    name: 'Pagerageung',
  },
  {
    id: '3206271',
    regencyId: '3206',
    name: 'Sukaresik',
  },
  {
    id: '3207100',
    regencyId: '3207',
    name: 'Banjarsari',
  },
  {
    id: '3207101',
    regencyId: '3207',
    name: 'Banjaranyar',
  },
  {
    id: '3207110',
    regencyId: '3207',
    name: 'Lakbok',
  },
  {
    id: '3207111',
    regencyId: '3207',
    name: 'Purwadadi',
  },
  {
    id: '3207120',
    regencyId: '3207',
    name: 'Pamarican',
  },
  {
    id: '3207130',
    regencyId: '3207',
    name: 'Cidolog',
  },
  {
    id: '3207140',
    regencyId: '3207',
    name: 'Cimaragas',
  },
  {
    id: '3207150',
    regencyId: '3207',
    name: 'Cijeungjing',
  },
  {
    id: '3207160',
    regencyId: '3207',
    name: 'Cisaga',
  },
  {
    id: '3207170',
    regencyId: '3207',
    name: 'Tambaksari',
  },
  {
    id: '3207180',
    regencyId: '3207',
    name: 'Rancah',
  },
  {
    id: '3207190',
    regencyId: '3207',
    name: 'Rajadesa',
  },
  {
    id: '3207200',
    regencyId: '3207',
    name: 'Sukadana',
  },
  {
    id: '3207210',
    regencyId: '3207',
    name: 'Ciamis',
  },
  {
    id: '3207211',
    regencyId: '3207',
    name: 'Baregbeg',
  },
  {
    id: '3207220',
    regencyId: '3207',
    name: 'Cikoneng',
  },
  {
    id: '3207221',
    regencyId: '3207',
    name: 'Sindangkasih',
  },
  {
    id: '3207230',
    regencyId: '3207',
    name: 'Cihaurbeuti',
  },
  {
    id: '3207240',
    regencyId: '3207',
    name: 'Sadananya',
  },
  {
    id: '3207250',
    regencyId: '3207',
    name: 'Cipaku',
  },
  {
    id: '3207260',
    regencyId: '3207',
    name: 'Jatinagara',
  },
  {
    id: '3207270',
    regencyId: '3207',
    name: 'Panawangan',
  },
  {
    id: '3207280',
    regencyId: '3207',
    name: 'Kawali',
  },
  {
    id: '3207281',
    regencyId: '3207',
    name: 'Lumbung',
  },
  {
    id: '3207290',
    regencyId: '3207',
    name: 'Panjalu',
  },
  {
    id: '3207291',
    regencyId: '3207',
    name: 'Sukamantri',
  },
  {
    id: '3207300',
    regencyId: '3207',
    name: 'Panumbangan',
  },
  {
    id: '3208010',
    regencyId: '3208',
    name: 'Darma',
  },
  {
    id: '3208020',
    regencyId: '3208',
    name: 'Kadugede',
  },
  {
    id: '3208021',
    regencyId: '3208',
    name: 'Nusaherang',
  },
  {
    id: '3208030',
    regencyId: '3208',
    name: 'Ciniru',
  },
  {
    id: '3208031',
    regencyId: '3208',
    name: 'Hantara',
  },
  {
    id: '3208040',
    regencyId: '3208',
    name: 'Selajambe',
  },
  {
    id: '3208050',
    regencyId: '3208',
    name: 'Subang',
  },
  {
    id: '3208051',
    regencyId: '3208',
    name: 'Cilebak',
  },
  {
    id: '3208060',
    regencyId: '3208',
    name: 'Ciwaru',
  },
  {
    id: '3208061',
    regencyId: '3208',
    name: 'Karangkancana',
  },
  {
    id: '3208070',
    regencyId: '3208',
    name: 'Cibingbin',
  },
  {
    id: '3208071',
    regencyId: '3208',
    name: 'Cibeureum',
  },
  {
    id: '3208080',
    regencyId: '3208',
    name: 'Luragung',
  },
  {
    id: '3208081',
    regencyId: '3208',
    name: 'Cimahi',
  },
  {
    id: '3208090',
    regencyId: '3208',
    name: 'Cidahu',
  },
  {
    id: '3208091',
    regencyId: '3208',
    name: 'Kalimanggis',
  },
  {
    id: '3208100',
    regencyId: '3208',
    name: 'Ciawigebang',
  },
  {
    id: '3208101',
    regencyId: '3208',
    name: 'Cipicung',
  },
  {
    id: '3208110',
    regencyId: '3208',
    name: 'Lebakwangi',
  },
  {
    id: '3208111',
    regencyId: '3208',
    name: 'Maleber',
  },
  {
    id: '3208120',
    regencyId: '3208',
    name: 'Garawangi',
  },
  {
    id: '3208121',
    regencyId: '3208',
    name: 'Sindangagung',
  },
  {
    id: '3208130',
    regencyId: '3208',
    name: 'Kuningan',
  },
  {
    id: '3208140',
    regencyId: '3208',
    name: 'Cigugur',
  },
  {
    id: '3208150',
    regencyId: '3208',
    name: 'Kramatmulya',
  },
  {
    id: '3208160',
    regencyId: '3208',
    name: 'Jalaksana',
  },
  {
    id: '3208161',
    regencyId: '3208',
    name: 'Japara',
  },
  {
    id: '3208170',
    regencyId: '3208',
    name: 'Cilimus',
  },
  {
    id: '3208171',
    regencyId: '3208',
    name: 'Cigandamekar',
  },
  {
    id: '3208180',
    regencyId: '3208',
    name: 'Mandirancan',
  },
  {
    id: '3208181',
    regencyId: '3208',
    name: 'Pancalang',
  },
  {
    id: '3208190',
    regencyId: '3208',
    name: 'Pasawahan',
  },
  {
    id: '3209010',
    regencyId: '3209',
    name: 'Waled',
  },
  {
    id: '3209011',
    regencyId: '3209',
    name: 'Pasaleman',
  },
  {
    id: '3209020',
    regencyId: '3209',
    name: 'Ciledug',
  },
  {
    id: '3209021',
    regencyId: '3209',
    name: 'Pabuaran',
  },
  {
    id: '3209030',
    regencyId: '3209',
    name: 'Losari',
  },
  {
    id: '3209031',
    regencyId: '3209',
    name: 'Pabedilan',
  },
  {
    id: '3209040',
    regencyId: '3209',
    name: 'Babakan',
  },
  {
    id: '3209041',
    regencyId: '3209',
    name: 'Gebang',
  },
  {
    id: '3209050',
    regencyId: '3209',
    name: 'Karangsembung',
  },
  {
    id: '3209051',
    regencyId: '3209',
    name: 'Karangwareng',
  },
  {
    id: '3209060',
    regencyId: '3209',
    name: 'Lemahabang',
  },
  {
    id: '3209061',
    regencyId: '3209',
    name: 'Susukanlebak',
  },
  {
    id: '3209070',
    regencyId: '3209',
    name: 'Sedong',
  },
  {
    id: '3209080',
    regencyId: '3209',
    name: 'Astanajapura',
  },
  {
    id: '3209081',
    regencyId: '3209',
    name: 'Pangenan',
  },
  {
    id: '3209090',
    regencyId: '3209',
    name: 'Mundu',
  },
  {
    id: '3209100',
    regencyId: '3209',
    name: 'Beber',
  },
  {
    id: '3209101',
    regencyId: '3209',
    name: 'Greged',
  },
  {
    id: '3209111',
    regencyId: '3209',
    name: 'Talun',
  },
  {
    id: '3209120',
    regencyId: '3209',
    name: 'Sumber',
  },
  {
    id: '3209121',
    regencyId: '3209',
    name: 'Dukupuntang',
  },
  {
    id: '3209130',
    regencyId: '3209',
    name: 'Palimanan',
  },
  {
    id: '3209140',
    regencyId: '3209',
    name: 'Plumbon',
  },
  {
    id: '3209141',
    regencyId: '3209',
    name: 'Depok',
  },
  {
    id: '3209150',
    regencyId: '3209',
    name: 'Weru',
  },
  {
    id: '3209151',
    regencyId: '3209',
    name: 'Plered',
  },
  {
    id: '3209161',
    regencyId: '3209',
    name: 'Tengah Tani',
  },
  {
    id: '3209162',
    regencyId: '3209',
    name: 'Kedawung',
  },
  {
    id: '3209171',
    regencyId: '3209',
    name: 'Gunungjati',
  },
  {
    id: '3209180',
    regencyId: '3209',
    name: 'Kapetakan',
  },
  {
    id: '3209181',
    regencyId: '3209',
    name: 'Suranenggala',
  },
  {
    id: '3209190',
    regencyId: '3209',
    name: 'Klangenan',
  },
  {
    id: '3209191',
    regencyId: '3209',
    name: 'Jamblang',
  },
  {
    id: '3209200',
    regencyId: '3209',
    name: 'Arjawinangun',
  },
  {
    id: '3209201',
    regencyId: '3209',
    name: 'Panguragan',
  },
  {
    id: '3209210',
    regencyId: '3209',
    name: 'Ciwaringin',
  },
  {
    id: '3209211',
    regencyId: '3209',
    name: 'Gempol',
  },
  {
    id: '3209220',
    regencyId: '3209',
    name: 'Susukan',
  },
  {
    id: '3209230',
    regencyId: '3209',
    name: 'Gegesik',
  },
  {
    id: '3209231',
    regencyId: '3209',
    name: 'Kaliwedi',
  },
  {
    id: '3210010',
    regencyId: '3210',
    name: 'Lemahsugih',
  },
  {
    id: '3210020',
    regencyId: '3210',
    name: 'Bantarujeg',
  },
  {
    id: '3210021',
    regencyId: '3210',
    name: 'Malausma',
  },
  {
    id: '3210030',
    regencyId: '3210',
    name: 'Cikijing',
  },
  {
    id: '3210031',
    regencyId: '3210',
    name: 'Cingambul',
  },
  {
    id: '3210040',
    regencyId: '3210',
    name: 'Talaga',
  },
  {
    id: '3210041',
    regencyId: '3210',
    name: 'Banjaran',
  },
  {
    id: '3210050',
    regencyId: '3210',
    name: 'Argapura',
  },
  {
    id: '3210060',
    regencyId: '3210',
    name: 'Maja',
  },
  {
    id: '3210070',
    regencyId: '3210',
    name: 'Majalengka',
  },
  {
    id: '3210080',
    regencyId: '3210',
    name: 'Cigasong',
  },
  {
    id: '3210090',
    regencyId: '3210',
    name: 'Sukahaji',
  },
  {
    id: '3210091',
    regencyId: '3210',
    name: 'Sindang',
  },
  {
    id: '3210100',
    regencyId: '3210',
    name: 'Rajagaluh',
  },
  {
    id: '3210110',
    regencyId: '3210',
    name: 'Sindangwangi',
  },
  {
    id: '3210120',
    regencyId: '3210',
    name: 'Leuwimunding',
  },
  {
    id: '3210130',
    regencyId: '3210',
    name: 'Palasah',
  },
  {
    id: '3210140',
    regencyId: '3210',
    name: 'Jatiwangi',
  },
  {
    id: '3210150',
    regencyId: '3210',
    name: 'Dawuan',
  },
  {
    id: '3210151',
    regencyId: '3210',
    name: 'Kasokandel',
  },
  {
    id: '3210160',
    regencyId: '3210',
    name: 'Panyingkiran',
  },
  {
    id: '3210170',
    regencyId: '3210',
    name: 'Kadipaten',
  },
  {
    id: '3210180',
    regencyId: '3210',
    name: 'Kertajati',
  },
  {
    id: '3210190',
    regencyId: '3210',
    name: 'Jatitujuh',
  },
  {
    id: '3210200',
    regencyId: '3210',
    name: 'Ligung',
  },
  {
    id: '3210210',
    regencyId: '3210',
    name: 'Sumberjaya',
  },
  {
    id: '3211010',
    regencyId: '3211',
    name: 'Jatinangor',
  },
  {
    id: '3211020',
    regencyId: '3211',
    name: 'Cimanggung',
  },
  {
    id: '3211030',
    regencyId: '3211',
    name: 'Tanjungsari',
  },
  {
    id: '3211031',
    regencyId: '3211',
    name: 'Sukasari',
  },
  {
    id: '3211032',
    regencyId: '3211',
    name: 'Pamulihan',
  },
  {
    id: '3211040',
    regencyId: '3211',
    name: 'Rancakalong',
  },
  {
    id: '3211050',
    regencyId: '3211',
    name: 'Sumedang Selatan',
  },
  {
    id: '3211060',
    regencyId: '3211',
    name: 'Sumedang Utara',
  },
  {
    id: '3211061',
    regencyId: '3211',
    name: 'Ganeas',
  },
  {
    id: '3211070',
    regencyId: '3211',
    name: 'Situraja',
  },
  {
    id: '3211071',
    regencyId: '3211',
    name: 'Cisitu',
  },
  {
    id: '3211080',
    regencyId: '3211',
    name: 'Darmaraja',
  },
  {
    id: '3211090',
    regencyId: '3211',
    name: 'Cibugel',
  },
  {
    id: '3211100',
    regencyId: '3211',
    name: 'Wado',
  },
  {
    id: '3211101',
    regencyId: '3211',
    name: 'Jatinunggal',
  },
  {
    id: '3211111',
    regencyId: '3211',
    name: 'Jatigede',
  },
  {
    id: '3211120',
    regencyId: '3211',
    name: 'Tomo',
  },
  {
    id: '3211130',
    regencyId: '3211',
    name: 'Ujung Jaya',
  },
  {
    id: '3211140',
    regencyId: '3211',
    name: 'Conggeang',
  },
  {
    id: '3211150',
    regencyId: '3211',
    name: 'Paseh',
  },
  {
    id: '3211160',
    regencyId: '3211',
    name: 'Cimalaka',
  },
  {
    id: '3211161',
    regencyId: '3211',
    name: 'Cisarua',
  },
  {
    id: '3211170',
    regencyId: '3211',
    name: 'Tanjungkerta',
  },
  {
    id: '3211171',
    regencyId: '3211',
    name: 'Tanjungmedar',
  },
  {
    id: '3211180',
    regencyId: '3211',
    name: 'Buahdua',
  },
  {
    id: '3211181',
    regencyId: '3211',
    name: 'Surian',
  },
  {
    id: '3212010',
    regencyId: '3212',
    name: 'Haurgeulis',
  },
  {
    id: '3212011',
    regencyId: '3212',
    name: 'Gantar',
  },
  {
    id: '3212020',
    regencyId: '3212',
    name: 'Kroya',
  },
  {
    id: '3212030',
    regencyId: '3212',
    name: 'Gabuswetan',
  },
  {
    id: '3212040',
    regencyId: '3212',
    name: 'Cikedung',
  },
  {
    id: '3212041',
    regencyId: '3212',
    name: 'Terisi',
  },
  {
    id: '3212050',
    regencyId: '3212',
    name: 'Lelea',
  },
  {
    id: '3212060',
    regencyId: '3212',
    name: 'Bangodua',
  },
  {
    id: '3212061',
    regencyId: '3212',
    name: 'Tukdana',
  },
  {
    id: '3212070',
    regencyId: '3212',
    name: 'Widasari',
  },
  {
    id: '3212080',
    regencyId: '3212',
    name: 'Kertasemaya',
  },
  {
    id: '3212081',
    regencyId: '3212',
    name: 'Sukagumiwang',
  },
  {
    id: '3212090',
    regencyId: '3212',
    name: 'Krangkeng',
  },
  {
    id: '3212100',
    regencyId: '3212',
    name: 'Karangampel',
  },
  {
    id: '3212101',
    regencyId: '3212',
    name: 'Kedokan Bunder',
  },
  {
    id: '3212110',
    regencyId: '3212',
    name: 'Juntinyuat',
  },
  {
    id: '3212120',
    regencyId: '3212',
    name: 'Sliyeg',
  },
  {
    id: '3212130',
    regencyId: '3212',
    name: 'Jatibarang',
  },
  {
    id: '3212140',
    regencyId: '3212',
    name: 'Balongan',
  },
  {
    id: '3212150',
    regencyId: '3212',
    name: 'Indramayu',
  },
  {
    id: '3212160',
    regencyId: '3212',
    name: 'Sindang',
  },
  {
    id: '3212161',
    regencyId: '3212',
    name: 'Cantigi',
  },
  {
    id: '3212162',
    regencyId: '3212',
    name: 'Pasekan',
  },
  {
    id: '3212170',
    regencyId: '3212',
    name: 'Lohbener',
  },
  {
    id: '3212171',
    regencyId: '3212',
    name: 'Arahan',
  },
  {
    id: '3212180',
    regencyId: '3212',
    name: 'Losarang',
  },
  {
    id: '3212190',
    regencyId: '3212',
    name: 'Kandanghaur',
  },
  {
    id: '3212200',
    regencyId: '3212',
    name: 'Bongas',
  },
  {
    id: '3212210',
    regencyId: '3212',
    name: 'Anjatan',
  },
  {
    id: '3212220',
    regencyId: '3212',
    name: 'Sukra',
  },
  {
    id: '3212221',
    regencyId: '3212',
    name: 'Patrol',
  },
  {
    id: '3213010',
    regencyId: '3213',
    name: 'Sagalaherang',
  },
  {
    id: '3213011',
    regencyId: '3213',
    name: 'Serangpanjang',
  },
  {
    id: '3213020',
    regencyId: '3213',
    name: 'Jalancagak',
  },
  {
    id: '3213021',
    regencyId: '3213',
    name: 'Ciater',
  },
  {
    id: '3213030',
    regencyId: '3213',
    name: 'Cisalak',
  },
  {
    id: '3213031',
    regencyId: '3213',
    name: 'Kasomalang',
  },
  {
    id: '3213040',
    regencyId: '3213',
    name: 'Tanjungsiang',
  },
  {
    id: '3213050',
    regencyId: '3213',
    name: 'Cijambe',
  },
  {
    id: '3213060',
    regencyId: '3213',
    name: 'Cibogo',
  },
  {
    id: '3213070',
    regencyId: '3213',
    name: 'Subang',
  },
  {
    id: '3213080',
    regencyId: '3213',
    name: 'Kalijati',
  },
  {
    id: '3213081',
    regencyId: '3213',
    name: 'Dawuan',
  },
  {
    id: '3213090',
    regencyId: '3213',
    name: 'Cipeundeuy',
  },
  {
    id: '3213100',
    regencyId: '3213',
    name: 'Pabuaran',
  },
  {
    id: '3213110',
    regencyId: '3213',
    name: 'Patokbeusi',
  },
  {
    id: '3213120',
    regencyId: '3213',
    name: 'Purwadadi',
  },
  {
    id: '3213130',
    regencyId: '3213',
    name: 'Cikaum',
  },
  {
    id: '3213140',
    regencyId: '3213',
    name: 'Pagaden',
  },
  {
    id: '3213141',
    regencyId: '3213',
    name: 'Pagaden Barat',
  },
  {
    id: '3213150',
    regencyId: '3213',
    name: 'Cipunagara',
  },
  {
    id: '3213160',
    regencyId: '3213',
    name: 'Compreng',
  },
  {
    id: '3213170',
    regencyId: '3213',
    name: 'Binong',
  },
  {
    id: '3213171',
    regencyId: '3213',
    name: 'Tambakdahan',
  },
  {
    id: '3213180',
    regencyId: '3213',
    name: 'Ciasem',
  },
  {
    id: '3213190',
    regencyId: '3213',
    name: 'Pamanukan',
  },
  {
    id: '3213191',
    regencyId: '3213',
    name: 'Sukasari',
  },
  {
    id: '3213200',
    regencyId: '3213',
    name: 'Pusakanagara',
  },
  {
    id: '3213201',
    regencyId: '3213',
    name: 'Pusakajaya',
  },
  {
    id: '3213210',
    regencyId: '3213',
    name: 'Legonkulon',
  },
  {
    id: '3213220',
    regencyId: '3213',
    name: 'Blanakan',
  },
  {
    id: '3214010',
    regencyId: '3214',
    name: 'Jatiluhur',
  },
  {
    id: '3214011',
    regencyId: '3214',
    name: 'Sukasari',
  },
  {
    id: '3214020',
    regencyId: '3214',
    name: 'Maniis',
  },
  {
    id: '3214030',
    regencyId: '3214',
    name: 'Tegal Waru',
  },
  {
    id: '3214040',
    regencyId: '3214',
    name: 'Plered',
  },
  {
    id: '3214050',
    regencyId: '3214',
    name: 'Sukatani',
  },
  {
    id: '3214060',
    regencyId: '3214',
    name: 'Darangdan',
  },
  {
    id: '3214070',
    regencyId: '3214',
    name: 'Bojong',
  },
  {
    id: '3214080',
    regencyId: '3214',
    name: 'Wanayasa',
  },
  {
    id: '3214081',
    regencyId: '3214',
    name: 'Kiarapedes',
  },
  {
    id: '3214090',
    regencyId: '3214',
    name: 'Pasawahan',
  },
  {
    id: '3214091',
    regencyId: '3214',
    name: 'Pondok Salam',
  },
  {
    id: '3214100',
    regencyId: '3214',
    name: 'Purwakarta',
  },
  {
    id: '3214101',
    regencyId: '3214',
    name: 'Babakancikao',
  },
  {
    id: '3214110',
    regencyId: '3214',
    name: 'Campaka',
  },
  {
    id: '3214111',
    regencyId: '3214',
    name: 'Cibatu',
  },
  {
    id: '3214112',
    regencyId: '3214',
    name: 'Bungursari',
  },
  {
    id: '3215010',
    regencyId: '3215',
    name: 'Pangkalan',
  },
  {
    id: '3215011',
    regencyId: '3215',
    name: 'Tegalwaru',
  },
  {
    id: '3215020',
    regencyId: '3215',
    name: 'Ciampel',
  },
  {
    id: '3215031',
    regencyId: '3215',
    name: 'Telukjambe Timur',
  },
  {
    id: '3215032',
    regencyId: '3215',
    name: 'Telukjambe Barat',
  },
  {
    id: '3215040',
    regencyId: '3215',
    name: 'Klari',
  },
  {
    id: '3215050',
    regencyId: '3215',
    name: 'Cikampek',
  },
  {
    id: '3215051',
    regencyId: '3215',
    name: 'Purwasari',
  },
  {
    id: '3215060',
    regencyId: '3215',
    name: 'Tirtamulya',
  },
  {
    id: '3215070',
    regencyId: '3215',
    name: 'Jatisari',
  },
  {
    id: '3215071',
    regencyId: '3215',
    name: 'Banyusari',
  },
  {
    id: '3215072',
    regencyId: '3215',
    name: 'Kotabaru',
  },
  {
    id: '3215081',
    regencyId: '3215',
    name: 'Cilamaya Wetan',
  },
  {
    id: '3215082',
    regencyId: '3215',
    name: 'Cilamaya Kulon',
  },
  {
    id: '3215090',
    regencyId: '3215',
    name: 'Lemahabang',
  },
  {
    id: '3215100',
    regencyId: '3215',
    name: 'Talagasari',
  },
  {
    id: '3215111',
    regencyId: '3215',
    name: 'Majalaya',
  },
  {
    id: '3215112',
    regencyId: '3215',
    name: 'Karawang Timur',
  },
  {
    id: '3215113',
    regencyId: '3215',
    name: 'Karawang Barat',
  },
  {
    id: '3215120',
    regencyId: '3215',
    name: 'Rawamerta',
  },
  {
    id: '3215130',
    regencyId: '3215',
    name: 'Tempuran',
  },
  {
    id: '3215140',
    regencyId: '3215',
    name: 'Kutawaluya',
  },
  {
    id: '3215150',
    regencyId: '3215',
    name: 'Rengasdengklok',
  },
  {
    id: '3215151',
    regencyId: '3215',
    name: 'Jayakerta',
  },
  {
    id: '3215160',
    regencyId: '3215',
    name: 'Pedes',
  },
  {
    id: '3215161',
    regencyId: '3215',
    name: 'Cilebar',
  },
  {
    id: '3215170',
    regencyId: '3215',
    name: 'Cibuaya',
  },
  {
    id: '3215180',
    regencyId: '3215',
    name: 'Tirtajaya',
  },
  {
    id: '3215190',
    regencyId: '3215',
    name: 'Batujaya',
  },
  {
    id: '3215200',
    regencyId: '3215',
    name: 'Pakisjaya',
  },
  {
    id: '3216010',
    regencyId: '3216',
    name: 'Setu',
  },
  {
    id: '3216021',
    regencyId: '3216',
    name: 'Serang Baru',
  },
  {
    id: '3216022',
    regencyId: '3216',
    name: 'Cikarang Pusat',
  },
  {
    id: '3216023',
    regencyId: '3216',
    name: 'Cikarang Selatan',
  },
  {
    id: '3216030',
    regencyId: '3216',
    name: 'Cibarusah',
  },
  {
    id: '3216031',
    regencyId: '3216',
    name: 'Bojongmangu',
  },
  {
    id: '3216041',
    regencyId: '3216',
    name: 'Cikarang Timur',
  },
  {
    id: '3216050',
    regencyId: '3216',
    name: 'Kedungwaringin',
  },
  {
    id: '3216061',
    regencyId: '3216',
    name: 'Cikarang Utara',
  },
  {
    id: '3216062',
    regencyId: '3216',
    name: 'Karangbahagia',
  },
  {
    id: '3216070',
    regencyId: '3216',
    name: 'Cibitung',
  },
  {
    id: '3216071',
    regencyId: '3216',
    name: 'Cikarang Barat',
  },
  {
    id: '3216081',
    regencyId: '3216',
    name: 'Tambun Selatan',
  },
  {
    id: '3216082',
    regencyId: '3216',
    name: 'Tambun Utara',
  },
  {
    id: '3216090',
    regencyId: '3216',
    name: 'Babelan',
  },
  {
    id: '3216100',
    regencyId: '3216',
    name: 'Tarumajaya',
  },
  {
    id: '3216110',
    regencyId: '3216',
    name: 'Tambelang',
  },
  {
    id: '3216111',
    regencyId: '3216',
    name: 'Sukawangi',
  },
  {
    id: '3216120',
    regencyId: '3216',
    name: 'Sukatani',
  },
  {
    id: '3216121',
    regencyId: '3216',
    name: 'Sukakarya',
  },
  {
    id: '3216130',
    regencyId: '3216',
    name: 'Pebayuran',
  },
  {
    id: '3216140',
    regencyId: '3216',
    name: 'Cabangbungin',
  },
  {
    id: '3216150',
    regencyId: '3216',
    name: 'Muara Gembong',
  },
  {
    id: '3217010',
    regencyId: '3217',
    name: 'Rongga',
  },
  {
    id: '3217020',
    regencyId: '3217',
    name: 'Gununghalu',
  },
  {
    id: '3217030',
    regencyId: '3217',
    name: 'Sindangkerta',
  },
  {
    id: '3217040',
    regencyId: '3217',
    name: 'Cililin',
  },
  {
    id: '3217050',
    regencyId: '3217',
    name: 'Cihampelas',
  },
  {
    id: '3217060',
    regencyId: '3217',
    name: 'Cipongkor',
  },
  {
    id: '3217070',
    regencyId: '3217',
    name: 'Batujajar',
  },
  {
    id: '3217071',
    regencyId: '3217',
    name: 'Saguling',
  },
  {
    id: '3217080',
    regencyId: '3217',
    name: 'Cipatat',
  },
  {
    id: '3217090',
    regencyId: '3217',
    name: 'Padalarang',
  },
  {
    id: '3217100',
    regencyId: '3217',
    name: 'Ngamprah',
  },
  {
    id: '3217110',
    regencyId: '3217',
    name: 'Parongpong',
  },
  {
    id: '3217120',
    regencyId: '3217',
    name: 'Lembang',
  },
  {
    id: '3217130',
    regencyId: '3217',
    name: 'Cisarua',
  },
  {
    id: '3217140',
    regencyId: '3217',
    name: 'Cikalong Wetan',
  },
  {
    id: '3217150',
    regencyId: '3217',
    name: 'Cipeundeuy',
  },
  {
    id: '3218010',
    regencyId: '3218',
    name: 'Cimerak',
  },
  {
    id: '3218020',
    regencyId: '3218',
    name: 'Cijulang',
  },
  {
    id: '3218030',
    regencyId: '3218',
    name: 'Cigugur',
  },
  {
    id: '3218040',
    regencyId: '3218',
    name: 'Langkaplancar',
  },
  {
    id: '3218050',
    regencyId: '3218',
    name: 'Parigi',
  },
  {
    id: '3218060',
    regencyId: '3218',
    name: 'Sidamulih',
  },
  {
    id: '3218070',
    regencyId: '3218',
    name: 'Pangandaran',
  },
  {
    id: '3218080',
    regencyId: '3218',
    name: 'Kalipucang',
  },
  {
    id: '3218090',
    regencyId: '3218',
    name: 'Padaherang',
  },
  {
    id: '3218100',
    regencyId: '3218',
    name: 'Mangunjaya',
  },
  {
    id: '3271010',
    regencyId: '3271',
    name: 'Bogor Selatan',
  },
  {
    id: '3271020',
    regencyId: '3271',
    name: 'Bogor Timur',
  },
  {
    id: '3271030',
    regencyId: '3271',
    name: 'Bogor Utara',
  },
  {
    id: '3271040',
    regencyId: '3271',
    name: 'Bogor Tengah',
  },
  {
    id: '3271050',
    regencyId: '3271',
    name: 'Bogor Barat',
  },
  {
    id: '3271060',
    regencyId: '3271',
    name: 'Tanah Sereal',
  },
  {
    id: '3272010',
    regencyId: '3272',
    name: 'Baros',
  },
  {
    id: '3272011',
    regencyId: '3272',
    name: 'Lembursitu',
  },
  {
    id: '3272012',
    regencyId: '3272',
    name: 'Cibeureum',
  },
  {
    id: '3272020',
    regencyId: '3272',
    name: 'Citamiang',
  },
  {
    id: '3272030',
    regencyId: '3272',
    name: 'Warudoyong',
  },
  {
    id: '3272040',
    regencyId: '3272',
    name: 'Gunung Puyuh',
  },
  {
    id: '3272050',
    regencyId: '3272',
    name: 'Cikole',
  },
  {
    id: '3273010',
    regencyId: '3273',
    name: 'Bandung Kulon',
  },
  {
    id: '3273020',
    regencyId: '3273',
    name: 'Babakan Ciparay',
  },
  {
    id: '3273030',
    regencyId: '3273',
    name: 'Bojongloa Kaler',
  },
  {
    id: '3273040',
    regencyId: '3273',
    name: 'Bojongloa Kidul',
  },
  {
    id: '3273050',
    regencyId: '3273',
    name: 'Astanaanyar',
  },
  {
    id: '3273060',
    regencyId: '3273',
    name: 'Regol',
  },
  {
    id: '3273070',
    regencyId: '3273',
    name: 'Lengkong',
  },
  {
    id: '3273080',
    regencyId: '3273',
    name: 'Bandung Kidul',
  },
  {
    id: '3273090',
    regencyId: '3273',
    name: 'Buahbatu',
  },
  {
    id: '3273100',
    regencyId: '3273',
    name: 'Rancasari',
  },
  {
    id: '3273101',
    regencyId: '3273',
    name: 'Gedebage',
  },
  {
    id: '3273110',
    regencyId: '3273',
    name: 'Cibiru',
  },
  {
    id: '3273111',
    regencyId: '3273',
    name: 'Panyileukan',
  },
  {
    id: '3273120',
    regencyId: '3273',
    name: 'Ujung Berung',
  },
  {
    id: '3273121',
    regencyId: '3273',
    name: 'Cinambo',
  },
  {
    id: '3273130',
    regencyId: '3273',
    name: 'Arcamanik',
  },
  {
    id: '3273141',
    regencyId: '3273',
    name: 'Antapani',
  },
  {
    id: '3273142',
    regencyId: '3273',
    name: 'Mandalajati',
  },
  {
    id: '3273150',
    regencyId: '3273',
    name: 'Kiaracondong',
  },
  {
    id: '3273160',
    regencyId: '3273',
    name: 'Batununggal',
  },
  {
    id: '3273170',
    regencyId: '3273',
    name: 'Sumur Bandung',
  },
  {
    id: '3273180',
    regencyId: '3273',
    name: 'Andir',
  },
  {
    id: '3273190',
    regencyId: '3273',
    name: 'Cicendo',
  },
  {
    id: '3273200',
    regencyId: '3273',
    name: 'Bandung Wetan',
  },
  {
    id: '3273210',
    regencyId: '3273',
    name: 'Cibeunying Kidul',
  },
  {
    id: '3273220',
    regencyId: '3273',
    name: 'Cibeunying Kaler',
  },
  {
    id: '3273230',
    regencyId: '3273',
    name: 'Coblong',
  },
  {
    id: '3273240',
    regencyId: '3273',
    name: 'Sukajadi',
  },
  {
    id: '3273250',
    regencyId: '3273',
    name: 'Sukasari',
  },
  {
    id: '3273260',
    regencyId: '3273',
    name: 'Cidadap',
  },
  {
    id: '3274010',
    regencyId: '3274',
    name: 'Harjamukti',
  },
  {
    id: '3274020',
    regencyId: '3274',
    name: 'Lemahwungkuk',
  },
  {
    id: '3274030',
    regencyId: '3274',
    name: 'Pekalipan',
  },
  {
    id: '3274040',
    regencyId: '3274',
    name: 'Kesambi',
  },
  {
    id: '3274050',
    regencyId: '3274',
    name: 'Kejaksan',
  },
  {
    id: '3275010',
    regencyId: '3275',
    name: 'Pondokgede',
  },
  {
    id: '3275011',
    regencyId: '3275',
    name: 'Jatisampurna',
  },
  {
    id: '3275012',
    regencyId: '3275',
    name: 'Pondokmelati',
  },
  {
    id: '3275020',
    regencyId: '3275',
    name: 'Jatiasih',
  },
  {
    id: '3275030',
    regencyId: '3275',
    name: 'Bantargebang',
  },
  {
    id: '3275031',
    regencyId: '3275',
    name: 'Mustikajaya',
  },
  {
    id: '3275040',
    regencyId: '3275',
    name: 'Bekasi Timur',
  },
  {
    id: '3275041',
    regencyId: '3275',
    name: 'Rawalumbu',
  },
  {
    id: '3275050',
    regencyId: '3275',
    name: 'Bekasi Selatan',
  },
  {
    id: '3275060',
    regencyId: '3275',
    name: 'Bekasi Barat',
  },
  {
    id: '3275061',
    regencyId: '3275',
    name: 'Medan Satria',
  },
  {
    id: '3275070',
    regencyId: '3275',
    name: 'Bekasi Utara',
  },
  {
    id: '3276010',
    regencyId: '3276',
    name: 'Sawangan',
  },
  {
    id: '3276011',
    regencyId: '3276',
    name: 'Bojongsari',
  },
  {
    id: '3276020',
    regencyId: '3276',
    name: 'Pancoran Mas',
  },
  {
    id: '3276021',
    regencyId: '3276',
    name: 'Cipayung',
  },
  {
    id: '3276030',
    regencyId: '3276',
    name: 'Sukma Jaya',
  },
  {
    id: '3276031',
    regencyId: '3276',
    name: 'Cilodong',
  },
  {
    id: '3276040',
    regencyId: '3276',
    name: 'Cimanggis',
  },
  {
    id: '3276041',
    regencyId: '3276',
    name: 'Tapos',
  },
  {
    id: '3276050',
    regencyId: '3276',
    name: 'Beji',
  },
  {
    id: '3276060',
    regencyId: '3276',
    name: 'Limo',
  },
  {
    id: '3276061',
    regencyId: '3276',
    name: 'Cinere',
  },
  {
    id: '3277010',
    regencyId: '3277',
    name: 'Cimahi Selatan',
  },
  {
    id: '3277020',
    regencyId: '3277',
    name: 'Cimahi Tengah',
  },
  {
    id: '3277030',
    regencyId: '3277',
    name: 'Cimahi Utara',
  },
  {
    id: '3278010',
    regencyId: '3278',
    name: 'Kawalu',
  },
  {
    id: '3278020',
    regencyId: '3278',
    name: 'Tamansari',
  },
  {
    id: '3278030',
    regencyId: '3278',
    name: 'Cibeureum',
  },
  {
    id: '3278031',
    regencyId: '3278',
    name: 'Purbaratu',
  },
  {
    id: '3278040',
    regencyId: '3278',
    name: 'Tawang',
  },
  {
    id: '3278050',
    regencyId: '3278',
    name: 'Cihideung',
  },
  {
    id: '3278060',
    regencyId: '3278',
    name: 'Mangkubumi',
  },
  {
    id: '3278070',
    regencyId: '3278',
    name: 'Indihiang',
  },
  {
    id: '3278071',
    regencyId: '3278',
    name: 'Bungursari',
  },
  {
    id: '3278080',
    regencyId: '3278',
    name: 'Cipedes',
  },
  {
    id: '3279010',
    regencyId: '3279',
    name: 'Banjar',
  },
  {
    id: '3279020',
    regencyId: '3279',
    name: 'Purwaharja',
  },
  {
    id: '3279030',
    regencyId: '3279',
    name: 'Pataruman',
  },
  {
    id: '3279040',
    regencyId: '3279',
    name: 'Langensari',
  },
  {
    id: '3301010',
    regencyId: '3301',
    name: 'Dayeuhluhur',
  },
  {
    id: '3301020',
    regencyId: '3301',
    name: 'Wanareja',
  },
  {
    id: '3301030',
    regencyId: '3301',
    name: 'Majenang',
  },
  {
    id: '3301040',
    regencyId: '3301',
    name: 'Cimanggu',
  },
  {
    id: '3301050',
    regencyId: '3301',
    name: 'Karangpucung',
  },
  {
    id: '3301060',
    regencyId: '3301',
    name: 'Cipari',
  },
  {
    id: '3301070',
    regencyId: '3301',
    name: 'Sidareja',
  },
  {
    id: '3301080',
    regencyId: '3301',
    name: 'Kedungreja',
  },
  {
    id: '3301090',
    regencyId: '3301',
    name: 'Patimuan',
  },
  {
    id: '3301100',
    regencyId: '3301',
    name: 'Gandrungmangu',
  },
  {
    id: '3301110',
    regencyId: '3301',
    name: 'Bantarsari',
  },
  {
    id: '3301120',
    regencyId: '3301',
    name: 'Kawunganten',
  },
  {
    id: '3301121',
    regencyId: '3301',
    name: 'Kampung Laut',
  },
  {
    id: '3301130',
    regencyId: '3301',
    name: 'Jeruklegi',
  },
  {
    id: '3301140',
    regencyId: '3301',
    name: 'Kesugihan',
  },
  {
    id: '3301150',
    regencyId: '3301',
    name: 'Adipala',
  },
  {
    id: '3301160',
    regencyId: '3301',
    name: 'Maos',
  },
  {
    id: '3301170',
    regencyId: '3301',
    name: 'Sampang',
  },
  {
    id: '3301180',
    regencyId: '3301',
    name: 'Kroya',
  },
  {
    id: '3301190',
    regencyId: '3301',
    name: 'Binangun',
  },
  {
    id: '3301200',
    regencyId: '3301',
    name: 'Nusawungu',
  },
  {
    id: '3301710',
    regencyId: '3301',
    name: 'Cilacap Selatan',
  },
  {
    id: '3301720',
    regencyId: '3301',
    name: 'Cilacap Tengah',
  },
  {
    id: '3301730',
    regencyId: '3301',
    name: 'Cilacap Utara',
  },
  {
    id: '3302010',
    regencyId: '3302',
    name: 'Lumbir',
  },
  {
    id: '3302020',
    regencyId: '3302',
    name: 'Wangon',
  },
  {
    id: '3302030',
    regencyId: '3302',
    name: 'Jatilawang',
  },
  {
    id: '3302040',
    regencyId: '3302',
    name: 'Rawalo',
  },
  {
    id: '3302050',
    regencyId: '3302',
    name: 'Kebasen',
  },
  {
    id: '3302060',
    regencyId: '3302',
    name: 'Kemranjen',
  },
  {
    id: '3302070',
    regencyId: '3302',
    name: 'Sumpiuh',
  },
  {
    id: '3302080',
    regencyId: '3302',
    name: 'Tambak',
  },
  {
    id: '3302090',
    regencyId: '3302',
    name: 'Somagede',
  },
  {
    id: '3302100',
    regencyId: '3302',
    name: 'Kalibagor',
  },
  {
    id: '3302110',
    regencyId: '3302',
    name: 'Banyumas',
  },
  {
    id: '3302120',
    regencyId: '3302',
    name: 'Patikraja',
  },
  {
    id: '3302130',
    regencyId: '3302',
    name: 'Purwojati',
  },
  {
    id: '3302140',
    regencyId: '3302',
    name: 'Ajibarang',
  },
  {
    id: '3302150',
    regencyId: '3302',
    name: 'Gumelar',
  },
  {
    id: '3302160',
    regencyId: '3302',
    name: 'Pekuncen',
  },
  {
    id: '3302170',
    regencyId: '3302',
    name: 'Cilongok',
  },
  {
    id: '3302180',
    regencyId: '3302',
    name: 'Karanglewas',
  },
  {
    id: '3302190',
    regencyId: '3302',
    name: 'Kedung Banteng',
  },
  {
    id: '3302200',
    regencyId: '3302',
    name: 'Baturraden',
  },
  {
    id: '3302210',
    regencyId: '3302',
    name: 'Sumbang',
  },
  {
    id: '3302220',
    regencyId: '3302',
    name: 'Kembaran',
  },
  {
    id: '3302230',
    regencyId: '3302',
    name: 'Sokaraja',
  },
  {
    id: '3302710',
    regencyId: '3302',
    name: 'Purwokerto Selatan',
  },
  {
    id: '3302720',
    regencyId: '3302',
    name: 'Purwokerto Barat',
  },
  {
    id: '3302730',
    regencyId: '3302',
    name: 'Purwokerto Timur',
  },
  {
    id: '3302740',
    regencyId: '3302',
    name: 'Purwokerto Utara',
  },
  {
    id: '3303010',
    regencyId: '3303',
    name: 'Kemangkon',
  },
  {
    id: '3303020',
    regencyId: '3303',
    name: 'Bukateja',
  },
  {
    id: '3303030',
    regencyId: '3303',
    name: 'Kejobong',
  },
  {
    id: '3303040',
    regencyId: '3303',
    name: 'Pengadegan',
  },
  {
    id: '3303050',
    regencyId: '3303',
    name: 'Kaligondang',
  },
  {
    id: '3303060',
    regencyId: '3303',
    name: 'Purbalingga',
  },
  {
    id: '3303070',
    regencyId: '3303',
    name: 'Kalimanah',
  },
  {
    id: '3303080',
    regencyId: '3303',
    name: 'Padamara',
  },
  {
    id: '3303090',
    regencyId: '3303',
    name: 'Kutasari',
  },
  {
    id: '3303100',
    regencyId: '3303',
    name: 'Bojongsari',
  },
  {
    id: '3303110',
    regencyId: '3303',
    name: 'Mrebet',
  },
  {
    id: '3303120',
    regencyId: '3303',
    name: 'Bobotsari',
  },
  {
    id: '3303130',
    regencyId: '3303',
    name: 'Karangreja',
  },
  {
    id: '3303131',
    regencyId: '3303',
    name: 'Karangjambu',
  },
  {
    id: '3303140',
    regencyId: '3303',
    name: 'Karanganyar',
  },
  {
    id: '3303141',
    regencyId: '3303',
    name: 'Kertanegara',
  },
  {
    id: '3303150',
    regencyId: '3303',
    name: 'Karangmoncol',
  },
  {
    id: '3303160',
    regencyId: '3303',
    name: 'Rembang',
  },
  {
    id: '3304010',
    regencyId: '3304',
    name: 'Susukan',
  },
  {
    id: '3304020',
    regencyId: '3304',
    name: 'Purwareja Klampok',
  },
  {
    id: '3304030',
    regencyId: '3304',
    name: 'Mandiraja',
  },
  {
    id: '3304040',
    regencyId: '3304',
    name: 'Purwanegara',
  },
  {
    id: '3304050',
    regencyId: '3304',
    name: 'Bawang',
  },
  {
    id: '3304060',
    regencyId: '3304',
    name: 'Banjarnegara',
  },
  {
    id: '3304061',
    regencyId: '3304',
    name: 'Pagedongan',
  },
  {
    id: '3304070',
    regencyId: '3304',
    name: 'Sigaluh',
  },
  {
    id: '3304080',
    regencyId: '3304',
    name: 'Madukara',
  },
  {
    id: '3304090',
    regencyId: '3304',
    name: 'Banjarmangu',
  },
  {
    id: '3304100',
    regencyId: '3304',
    name: 'Wanadadi',
  },
  {
    id: '3304110',
    regencyId: '3304',
    name: 'Rakit',
  },
  {
    id: '3304120',
    regencyId: '3304',
    name: 'Punggelan',
  },
  {
    id: '3304130',
    regencyId: '3304',
    name: 'Karangkobar',
  },
  {
    id: '3304140',
    regencyId: '3304',
    name: 'Pagentan',
  },
  {
    id: '3304150',
    regencyId: '3304',
    name: 'Pejawaran',
  },
  {
    id: '3304160',
    regencyId: '3304',
    name: 'Batur',
  },
  {
    id: '3304170',
    regencyId: '3304',
    name: 'Wanayasa',
  },
  {
    id: '3304180',
    regencyId: '3304',
    name: 'Kalibening',
  },
  {
    id: '3304181',
    regencyId: '3304',
    name: 'Pandanarum',
  },
  {
    id: '3305010',
    regencyId: '3305',
    name: 'Ayah',
  },
  {
    id: '3305020',
    regencyId: '3305',
    name: 'Buayan',
  },
  {
    id: '3305030',
    regencyId: '3305',
    name: 'Puring',
  },
  {
    id: '3305040',
    regencyId: '3305',
    name: 'Petanahan',
  },
  {
    id: '3305050',
    regencyId: '3305',
    name: 'Klirong',
  },
  {
    id: '3305060',
    regencyId: '3305',
    name: 'Buluspesantren',
  },
  {
    id: '3305070',
    regencyId: '3305',
    name: 'Ambal',
  },
  {
    id: '3305080',
    regencyId: '3305',
    name: 'Mirit',
  },
  {
    id: '3305081',
    regencyId: '3305',
    name: 'Bonorowo',
  },
  {
    id: '3305090',
    regencyId: '3305',
    name: 'Prembun',
  },
  {
    id: '3305091',
    regencyId: '3305',
    name: 'Padureso',
  },
  {
    id: '3305100',
    regencyId: '3305',
    name: 'Kutowinangun',
  },
  {
    id: '3305110',
    regencyId: '3305',
    name: 'Alian',
  },
  {
    id: '3305111',
    regencyId: '3305',
    name: 'Poncowarno',
  },
  {
    id: '3305120',
    regencyId: '3305',
    name: 'Kebumen',
  },
  {
    id: '3305130',
    regencyId: '3305',
    name: 'Pejagoan',
  },
  {
    id: '3305140',
    regencyId: '3305',
    name: 'Sruweng',
  },
  {
    id: '3305150',
    regencyId: '3305',
    name: 'Adimulyo',
  },
  {
    id: '3305160',
    regencyId: '3305',
    name: 'Kuwarasan',
  },
  {
    id: '3305170',
    regencyId: '3305',
    name: 'Rowokele',
  },
  {
    id: '3305180',
    regencyId: '3305',
    name: 'Sempor',
  },
  {
    id: '3305190',
    regencyId: '3305',
    name: 'Gombong',
  },
  {
    id: '3305200',
    regencyId: '3305',
    name: 'Karanganyar',
  },
  {
    id: '3305210',
    regencyId: '3305',
    name: 'Karanggayam',
  },
  {
    id: '3305220',
    regencyId: '3305',
    name: 'Sadang',
  },
  {
    id: '3305221',
    regencyId: '3305',
    name: 'Karangsambung',
  },
  {
    id: '3306010',
    regencyId: '3306',
    name: 'Grabag',
  },
  {
    id: '3306020',
    regencyId: '3306',
    name: 'Ngombol',
  },
  {
    id: '3306030',
    regencyId: '3306',
    name: 'Purwodadi',
  },
  {
    id: '3306040',
    regencyId: '3306',
    name: 'Bagelen',
  },
  {
    id: '3306050',
    regencyId: '3306',
    name: 'Kaligesing',
  },
  {
    id: '3306060',
    regencyId: '3306',
    name: 'Purworejo',
  },
  {
    id: '3306070',
    regencyId: '3306',
    name: 'Banyu Urip',
  },
  {
    id: '3306080',
    regencyId: '3306',
    name: 'Bayan',
  },
  {
    id: '3306090',
    regencyId: '3306',
    name: 'Kutoarjo',
  },
  {
    id: '3306100',
    regencyId: '3306',
    name: 'Butuh',
  },
  {
    id: '3306110',
    regencyId: '3306',
    name: 'Pituruh',
  },
  {
    id: '3306120',
    regencyId: '3306',
    name: 'Kemiri',
  },
  {
    id: '3306130',
    regencyId: '3306',
    name: 'Bruno',
  },
  {
    id: '3306140',
    regencyId: '3306',
    name: 'Gebang',
  },
  {
    id: '3306150',
    regencyId: '3306',
    name: 'Loano',
  },
  {
    id: '3306160',
    regencyId: '3306',
    name: 'Bener',
  },
  {
    id: '3307010',
    regencyId: '3307',
    name: 'Wadaslintang',
  },
  {
    id: '3307020',
    regencyId: '3307',
    name: 'Kepil',
  },
  {
    id: '3307030',
    regencyId: '3307',
    name: 'Sapuran',
  },
  {
    id: '3307031',
    regencyId: '3307',
    name: 'Kalibawang',
  },
  {
    id: '3307040',
    regencyId: '3307',
    name: 'Kaliwiro',
  },
  {
    id: '3307050',
    regencyId: '3307',
    name: 'Leksono',
  },
  {
    id: '3307051',
    regencyId: '3307',
    name: 'Sukoharjo',
  },
  {
    id: '3307060',
    regencyId: '3307',
    name: 'Selomerto',
  },
  {
    id: '3307070',
    regencyId: '3307',
    name: 'Kalikajar',
  },
  {
    id: '3307080',
    regencyId: '3307',
    name: 'Kertek',
  },
  {
    id: '3307090',
    regencyId: '3307',
    name: 'Wonosobo',
  },
  {
    id: '3307100',
    regencyId: '3307',
    name: 'Watumalang',
  },
  {
    id: '3307110',
    regencyId: '3307',
    name: 'Mojotengah',
  },
  {
    id: '3307120',
    regencyId: '3307',
    name: 'Garung',
  },
  {
    id: '3307130',
    regencyId: '3307',
    name: 'Kejajar',
  },
  {
    id: '3308010',
    regencyId: '3308',
    name: 'Salaman',
  },
  {
    id: '3308020',
    regencyId: '3308',
    name: 'Borobudur',
  },
  {
    id: '3308030',
    regencyId: '3308',
    name: 'Ngluwar',
  },
  {
    id: '3308040',
    regencyId: '3308',
    name: 'Salam',
  },
  {
    id: '3308050',
    regencyId: '3308',
    name: 'Srumbung',
  },
  {
    id: '3308060',
    regencyId: '3308',
    name: 'Dukun',
  },
  {
    id: '3308070',
    regencyId: '3308',
    name: 'Muntilan',
  },
  {
    id: '3308080',
    regencyId: '3308',
    name: 'Mungkid',
  },
  {
    id: '3308090',
    regencyId: '3308',
    name: 'Sawangan',
  },
  {
    id: '3308100',
    regencyId: '3308',
    name: 'Candimulyo',
  },
  {
    id: '3308110',
    regencyId: '3308',
    name: 'Mertoyudan',
  },
  {
    id: '3308120',
    regencyId: '3308',
    name: 'Tempuran',
  },
  {
    id: '3308130',
    regencyId: '3308',
    name: 'Kajoran',
  },
  {
    id: '3308140',
    regencyId: '3308',
    name: 'Kaliangkrik',
  },
  {
    id: '3308150',
    regencyId: '3308',
    name: 'Bandongan',
  },
  {
    id: '3308160',
    regencyId: '3308',
    name: 'Windusari',
  },
  {
    id: '3308170',
    regencyId: '3308',
    name: 'Secang',
  },
  {
    id: '3308180',
    regencyId: '3308',
    name: 'Tegalrejo',
  },
  {
    id: '3308190',
    regencyId: '3308',
    name: 'Pakis',
  },
  {
    id: '3308200',
    regencyId: '3308',
    name: 'Grabag',
  },
  {
    id: '3308210',
    regencyId: '3308',
    name: 'Ngablak',
  },
  {
    id: '3309010',
    regencyId: '3309',
    name: 'Selo',
  },
  {
    id: '3309020',
    regencyId: '3309',
    name: 'Ampel',
  },
  {
    id: '3309030',
    regencyId: '3309',
    name: 'Cepogo',
  },
  {
    id: '3309040',
    regencyId: '3309',
    name: 'Musuk',
  },
  {
    id: '3309050',
    regencyId: '3309',
    name: 'Boyolali',
  },
  {
    id: '3309060',
    regencyId: '3309',
    name: 'Mojosongo',
  },
  {
    id: '3309070',
    regencyId: '3309',
    name: 'Teras',
  },
  {
    id: '3309080',
    regencyId: '3309',
    name: 'Sawit',
  },
  {
    id: '3309090',
    regencyId: '3309',
    name: 'Banyudono',
  },
  {
    id: '3309100',
    regencyId: '3309',
    name: 'Sambi',
  },
  {
    id: '3309110',
    regencyId: '3309',
    name: 'Ngemplak',
  },
  {
    id: '3309120',
    regencyId: '3309',
    name: 'Nogosari',
  },
  {
    id: '3309130',
    regencyId: '3309',
    name: 'Simo',
  },
  {
    id: '3309140',
    regencyId: '3309',
    name: 'Karanggede',
  },
  {
    id: '3309150',
    regencyId: '3309',
    name: 'Klego',
  },
  {
    id: '3309160',
    regencyId: '3309',
    name: 'Andong',
  },
  {
    id: '3309170',
    regencyId: '3309',
    name: 'Kemusu',
  },
  {
    id: '3309180',
    regencyId: '3309',
    name: 'Wonosegoro',
  },
  {
    id: '3309190',
    regencyId: '3309',
    name: 'Juwangi',
  },
  {
    id: '3310010',
    regencyId: '3310',
    name: 'Prambanan',
  },
  {
    id: '3310020',
    regencyId: '3310',
    name: 'Gantiwarno',
  },
  {
    id: '3310030',
    regencyId: '3310',
    name: 'Wedi',
  },
  {
    id: '3310040',
    regencyId: '3310',
    name: 'Bayat',
  },
  {
    id: '3310050',
    regencyId: '3310',
    name: 'Cawas',
  },
  {
    id: '3310060',
    regencyId: '3310',
    name: 'Trucuk',
  },
  {
    id: '3310070',
    regencyId: '3310',
    name: 'Kalikotes',
  },
  {
    id: '3310080',
    regencyId: '3310',
    name: 'Kebonarum',
  },
  {
    id: '3310090',
    regencyId: '3310',
    name: 'Jogonalan',
  },
  {
    id: '3310100',
    regencyId: '3310',
    name: 'Manisrenggo',
  },
  {
    id: '3310110',
    regencyId: '3310',
    name: 'Karangnongko',
  },
  {
    id: '3310120',
    regencyId: '3310',
    name: 'Ngawen',
  },
  {
    id: '3310130',
    regencyId: '3310',
    name: 'Ceper',
  },
  {
    id: '3310140',
    regencyId: '3310',
    name: 'Pedan',
  },
  {
    id: '3310150',
    regencyId: '3310',
    name: 'Karangdowo',
  },
  {
    id: '3310160',
    regencyId: '3310',
    name: 'Juwiring',
  },
  {
    id: '3310170',
    regencyId: '3310',
    name: 'Wonosari',
  },
  {
    id: '3310180',
    regencyId: '3310',
    name: 'Delanggu',
  },
  {
    id: '3310190',
    regencyId: '3310',
    name: 'Polanharjo',
  },
  {
    id: '3310200',
    regencyId: '3310',
    name: 'Karanganom',
  },
  {
    id: '3310210',
    regencyId: '3310',
    name: 'Tulung',
  },
  {
    id: '3310220',
    regencyId: '3310',
    name: 'Jatinom',
  },
  {
    id: '3310230',
    regencyId: '3310',
    name: 'Kemalang',
  },
  {
    id: '3310710',
    regencyId: '3310',
    name: 'Klaten Selatan',
  },
  {
    id: '3310720',
    regencyId: '3310',
    name: 'Klaten Tengah',
  },
  {
    id: '3310730',
    regencyId: '3310',
    name: 'Klaten Utara',
  },
  {
    id: '3311010',
    regencyId: '3311',
    name: 'Weru',
  },
  {
    id: '3311020',
    regencyId: '3311',
    name: 'Bulu',
  },
  {
    id: '3311030',
    regencyId: '3311',
    name: 'Tawangsari',
  },
  {
    id: '3311040',
    regencyId: '3311',
    name: 'Sukoharjo',
  },
  {
    id: '3311050',
    regencyId: '3311',
    name: 'Nguter',
  },
  {
    id: '3311060',
    regencyId: '3311',
    name: 'Bendosari',
  },
  {
    id: '3311070',
    regencyId: '3311',
    name: 'Polokarto',
  },
  {
    id: '3311080',
    regencyId: '3311',
    name: 'Mojolaban',
  },
  {
    id: '3311090',
    regencyId: '3311',
    name: 'Grogol',
  },
  {
    id: '3311100',
    regencyId: '3311',
    name: 'Baki',
  },
  {
    id: '3311110',
    regencyId: '3311',
    name: 'Gatak',
  },
  {
    id: '3311120',
    regencyId: '3311',
    name: 'Kartasura',
  },
  {
    id: '3312010',
    regencyId: '3312',
    name: 'Pracimantoro',
  },
  {
    id: '3312020',
    regencyId: '3312',
    name: 'Paranggupito',
  },
  {
    id: '3312030',
    regencyId: '3312',
    name: 'Giritontro',
  },
  {
    id: '3312040',
    regencyId: '3312',
    name: 'Giriwoyo',
  },
  {
    id: '3312050',
    regencyId: '3312',
    name: 'Batuwarno',
  },
  {
    id: '3312060',
    regencyId: '3312',
    name: 'Karangtengah',
  },
  {
    id: '3312070',
    regencyId: '3312',
    name: 'Tirtomoyo',
  },
  {
    id: '3312080',
    regencyId: '3312',
    name: 'Nguntoronadi',
  },
  {
    id: '3312090',
    regencyId: '3312',
    name: 'Baturetno',
  },
  {
    id: '3312100',
    regencyId: '3312',
    name: 'Eromoko',
  },
  {
    id: '3312110',
    regencyId: '3312',
    name: 'Wuryantoro',
  },
  {
    id: '3312120',
    regencyId: '3312',
    name: 'Manyaran',
  },
  {
    id: '3312130',
    regencyId: '3312',
    name: 'Selogiri',
  },
  {
    id: '3312140',
    regencyId: '3312',
    name: 'Wonogiri',
  },
  {
    id: '3312150',
    regencyId: '3312',
    name: 'Ngadirojo',
  },
  {
    id: '3312160',
    regencyId: '3312',
    name: 'Sidoharjo',
  },
  {
    id: '3312170',
    regencyId: '3312',
    name: 'Jatiroto',
  },
  {
    id: '3312180',
    regencyId: '3312',
    name: 'Kismantoro',
  },
  {
    id: '3312190',
    regencyId: '3312',
    name: 'Purwantoro',
  },
  {
    id: '3312200',
    regencyId: '3312',
    name: 'Bulukerto',
  },
  {
    id: '3312201',
    regencyId: '3312',
    name: 'Puhpelem',
  },
  {
    id: '3312210',
    regencyId: '3312',
    name: 'Slogohimo',
  },
  {
    id: '3312220',
    regencyId: '3312',
    name: 'Jatisrono',
  },
  {
    id: '3312230',
    regencyId: '3312',
    name: 'Jatipurno',
  },
  {
    id: '3312240',
    regencyId: '3312',
    name: 'Girimarto',
  },
  {
    id: '3313010',
    regencyId: '3313',
    name: 'Jatipuro',
  },
  {
    id: '3313020',
    regencyId: '3313',
    name: 'Jatiyoso',
  },
  {
    id: '3313030',
    regencyId: '3313',
    name: 'Jumapolo',
  },
  {
    id: '3313040',
    regencyId: '3313',
    name: 'Jumantono',
  },
  {
    id: '3313050',
    regencyId: '3313',
    name: 'Matesih',
  },
  {
    id: '3313060',
    regencyId: '3313',
    name: 'Tawangmangu',
  },
  {
    id: '3313070',
    regencyId: '3313',
    name: 'Ngargoyoso',
  },
  {
    id: '3313080',
    regencyId: '3313',
    name: 'Karangpandan',
  },
  {
    id: '3313090',
    regencyId: '3313',
    name: 'Karanganyar',
  },
  {
    id: '3313100',
    regencyId: '3313',
    name: 'Tasikmadu',
  },
  {
    id: '3313110',
    regencyId: '3313',
    name: 'Jaten',
  },
  {
    id: '3313120',
    regencyId: '3313',
    name: 'Colomadu',
  },
  {
    id: '3313130',
    regencyId: '3313',
    name: 'Gondangrejo',
  },
  {
    id: '3313140',
    regencyId: '3313',
    name: 'Kebakkramat',
  },
  {
    id: '3313150',
    regencyId: '3313',
    name: 'Mojogedang',
  },
  {
    id: '3313160',
    regencyId: '3313',
    name: 'Kerjo',
  },
  {
    id: '3313170',
    regencyId: '3313',
    name: 'Jenawi',
  },
  {
    id: '3314010',
    regencyId: '3314',
    name: 'Kalijambe',
  },
  {
    id: '3314020',
    regencyId: '3314',
    name: 'Plupuh',
  },
  {
    id: '3314030',
    regencyId: '3314',
    name: 'Masaran',
  },
  {
    id: '3314040',
    regencyId: '3314',
    name: 'Kedawung',
  },
  {
    id: '3314050',
    regencyId: '3314',
    name: 'Sambirejo',
  },
  {
    id: '3314060',
    regencyId: '3314',
    name: 'Gondang',
  },
  {
    id: '3314070',
    regencyId: '3314',
    name: 'Sambung Macan',
  },
  {
    id: '3314080',
    regencyId: '3314',
    name: 'Ngrampal',
  },
  {
    id: '3314090',
    regencyId: '3314',
    name: 'Karangmalang',
  },
  {
    id: '3314100',
    regencyId: '3314',
    name: 'Sragen',
  },
  {
    id: '3314110',
    regencyId: '3314',
    name: 'Sidoharjo',
  },
  {
    id: '3314120',
    regencyId: '3314',
    name: 'Tanon',
  },
  {
    id: '3314130',
    regencyId: '3314',
    name: 'Gemolong',
  },
  {
    id: '3314140',
    regencyId: '3314',
    name: 'Miri',
  },
  {
    id: '3314150',
    regencyId: '3314',
    name: 'Sumberlawang',
  },
  {
    id: '3314160',
    regencyId: '3314',
    name: 'Mondokan',
  },
  {
    id: '3314170',
    regencyId: '3314',
    name: 'Sukodono',
  },
  {
    id: '3314180',
    regencyId: '3314',
    name: 'Gesi',
  },
  {
    id: '3314190',
    regencyId: '3314',
    name: 'Tangen',
  },
  {
    id: '3314200',
    regencyId: '3314',
    name: 'Jenar',
  },
  {
    id: '3315010',
    regencyId: '3315',
    name: 'Kedungjati',
  },
  {
    id: '3315020',
    regencyId: '3315',
    name: 'Karangrayung',
  },
  {
    id: '3315030',
    regencyId: '3315',
    name: 'Penawangan',
  },
  {
    id: '3315040',
    regencyId: '3315',
    name: 'Toroh',
  },
  {
    id: '3315050',
    regencyId: '3315',
    name: 'Geyer',
  },
  {
    id: '3315060',
    regencyId: '3315',
    name: 'Pulokulon',
  },
  {
    id: '3315070',
    regencyId: '3315',
    name: 'Kradenan',
  },
  {
    id: '3315080',
    regencyId: '3315',
    name: 'Gabus',
  },
  {
    id: '3315090',
    regencyId: '3315',
    name: 'Ngaringan',
  },
  {
    id: '3315100',
    regencyId: '3315',
    name: 'Wirosari',
  },
  {
    id: '3315110',
    regencyId: '3315',
    name: 'Tawangharjo',
  },
  {
    id: '3315120',
    regencyId: '3315',
    name: 'Grobogan',
  },
  {
    id: '3315130',
    regencyId: '3315',
    name: 'Purwodadi',
  },
  {
    id: '3315140',
    regencyId: '3315',
    name: 'Brati',
  },
  {
    id: '3315150',
    regencyId: '3315',
    name: 'Klambu',
  },
  {
    id: '3315160',
    regencyId: '3315',
    name: 'Godong',
  },
  {
    id: '3315170',
    regencyId: '3315',
    name: 'Gubug',
  },
  {
    id: '3315180',
    regencyId: '3315',
    name: 'Tegowanu',
  },
  {
    id: '3315190',
    regencyId: '3315',
    name: 'Tanggungharjo',
  },
  {
    id: '3316010',
    regencyId: '3316',
    name: 'Jati',
  },
  {
    id: '3316020',
    regencyId: '3316',
    name: 'Randublatung',
  },
  {
    id: '3316030',
    regencyId: '3316',
    name: 'Kradenan',
  },
  {
    id: '3316040',
    regencyId: '3316',
    name: 'Kedungtuban',
  },
  {
    id: '3316050',
    regencyId: '3316',
    name: 'Cepu',
  },
  {
    id: '3316060',
    regencyId: '3316',
    name: 'Sambong',
  },
  {
    id: '3316070',
    regencyId: '3316',
    name: 'Jiken',
  },
  {
    id: '3316080',
    regencyId: '3316',
    name: 'Bogorejo',
  },
  {
    id: '3316090',
    regencyId: '3316',
    name: 'Jepon',
  },
  {
    id: '3316100',
    regencyId: '3316',
    name: 'Kota Blora',
  },
  {
    id: '3316110',
    regencyId: '3316',
    name: 'Banjarejo',
  },
  {
    id: '3316120',
    regencyId: '3316',
    name: 'Tunjungan',
  },
  {
    id: '3316130',
    regencyId: '3316',
    name: 'Japah',
  },
  {
    id: '3316140',
    regencyId: '3316',
    name: 'Ngawen',
  },
  {
    id: '3316150',
    regencyId: '3316',
    name: 'Kunduran',
  },
  {
    id: '3316160',
    regencyId: '3316',
    name: 'Todanan',
  },
  {
    id: '3317010',
    regencyId: '3317',
    name: 'Sumber',
  },
  {
    id: '3317020',
    regencyId: '3317',
    name: 'Bulu',
  },
  {
    id: '3317030',
    regencyId: '3317',
    name: 'Gunem',
  },
  {
    id: '3317040',
    regencyId: '3317',
    name: 'Sale',
  },
  {
    id: '3317050',
    regencyId: '3317',
    name: 'Sarang',
  },
  {
    id: '3317060',
    regencyId: '3317',
    name: 'Sedan',
  },
  {
    id: '3317070',
    regencyId: '3317',
    name: 'Pamotan',
  },
  {
    id: '3317080',
    regencyId: '3317',
    name: 'Sulang',
  },
  {
    id: '3317090',
    regencyId: '3317',
    name: 'Kaliori',
  },
  {
    id: '3317100',
    regencyId: '3317',
    name: 'Rembang',
  },
  {
    id: '3317110',
    regencyId: '3317',
    name: 'Pancur',
  },
  {
    id: '3317120',
    regencyId: '3317',
    name: 'Kragan',
  },
  {
    id: '3317130',
    regencyId: '3317',
    name: 'Sluke',
  },
  {
    id: '3317140',
    regencyId: '3317',
    name: 'Lasem',
  },
  {
    id: '3318010',
    regencyId: '3318',
    name: 'Sukolilo',
  },
  {
    id: '3318020',
    regencyId: '3318',
    name: 'Kayen',
  },
  {
    id: '3318030',
    regencyId: '3318',
    name: 'Tambakromo',
  },
  {
    id: '3318040',
    regencyId: '3318',
    name: 'Winong',
  },
  {
    id: '3318050',
    regencyId: '3318',
    name: 'Pucakwangi',
  },
  {
    id: '3318060',
    regencyId: '3318',
    name: 'Jaken',
  },
  {
    id: '3318070',
    regencyId: '3318',
    name: 'Batangan',
  },
  {
    id: '3318080',
    regencyId: '3318',
    name: 'Juwana',
  },
  {
    id: '3318090',
    regencyId: '3318',
    name: 'Jakenan',
  },
  {
    id: '3318100',
    regencyId: '3318',
    name: 'Pati',
  },
  {
    id: '3318110',
    regencyId: '3318',
    name: 'Gabus',
  },
  {
    id: '3318120',
    regencyId: '3318',
    name: 'Margorejo',
  },
  {
    id: '3318130',
    regencyId: '3318',
    name: 'Gembong',
  },
  {
    id: '3318140',
    regencyId: '3318',
    name: 'Tlogowungu',
  },
  {
    id: '3318150',
    regencyId: '3318',
    name: 'Wedarijaksa',
  },
  {
    id: '3318160',
    regencyId: '3318',
    name: 'Trangkil',
  },
  {
    id: '3318170',
    regencyId: '3318',
    name: 'Margoyoso',
  },
  {
    id: '3318180',
    regencyId: '3318',
    name: 'Gunung Wungkal',
  },
  {
    id: '3318190',
    regencyId: '3318',
    name: 'Cluwak',
  },
  {
    id: '3318200',
    regencyId: '3318',
    name: 'Tayu',
  },
  {
    id: '3318210',
    regencyId: '3318',
    name: 'Dukuhseti',
  },
  {
    id: '3319010',
    regencyId: '3319',
    name: 'Kaliwungu',
  },
  {
    id: '3319020',
    regencyId: '3319',
    name: 'Kota Kudus',
  },
  {
    id: '3319030',
    regencyId: '3319',
    name: 'Jati',
  },
  {
    id: '3319040',
    regencyId: '3319',
    name: 'Undaan',
  },
  {
    id: '3319050',
    regencyId: '3319',
    name: 'Mejobo',
  },
  {
    id: '3319060',
    regencyId: '3319',
    name: 'Jekulo',
  },
  {
    id: '3319070',
    regencyId: '3319',
    name: 'Bae',
  },
  {
    id: '3319080',
    regencyId: '3319',
    name: 'Gebog',
  },
  {
    id: '3319090',
    regencyId: '3319',
    name: 'Dawe',
  },
  {
    id: '3320010',
    regencyId: '3320',
    name: 'Kedung',
  },
  {
    id: '3320020',
    regencyId: '3320',
    name: 'Pecangaan',
  },
  {
    id: '3320021',
    regencyId: '3320',
    name: 'Kalinyamatan',
  },
  {
    id: '3320030',
    regencyId: '3320',
    name: 'Welahan',
  },
  {
    id: '3320040',
    regencyId: '3320',
    name: 'Mayong',
  },
  {
    id: '3320050',
    regencyId: '3320',
    name: 'Nalumsari',
  },
  {
    id: '3320060',
    regencyId: '3320',
    name: 'Batealit',
  },
  {
    id: '3320070',
    regencyId: '3320',
    name: 'Tahunan',
  },
  {
    id: '3320080',
    regencyId: '3320',
    name: 'Jepara',
  },
  {
    id: '3320090',
    regencyId: '3320',
    name: 'Mlonggo',
  },
  {
    id: '3320091',
    regencyId: '3320',
    name: 'Pakis Aji',
  },
  {
    id: '3320100',
    regencyId: '3320',
    name: 'Bangsri',
  },
  {
    id: '3320101',
    regencyId: '3320',
    name: 'Kembang',
  },
  {
    id: '3320110',
    regencyId: '3320',
    name: 'Keling',
  },
  {
    id: '3320111',
    regencyId: '3320',
    name: 'Donorojo',
  },
  {
    id: '3320120',
    regencyId: '3320',
    name: 'Karimunjawa',
  },
  {
    id: '3321010',
    regencyId: '3321',
    name: 'Mranggen',
  },
  {
    id: '3321020',
    regencyId: '3321',
    name: 'Karangawen',
  },
  {
    id: '3321030',
    regencyId: '3321',
    name: 'Guntur',
  },
  {
    id: '3321040',
    regencyId: '3321',
    name: 'Sayung',
  },
  {
    id: '3321050',
    regencyId: '3321',
    name: 'Karang Tengah',
  },
  {
    id: '3321060',
    regencyId: '3321',
    name: 'Bonang',
  },
  {
    id: '3321070',
    regencyId: '3321',
    name: 'Demak',
  },
  {
    id: '3321080',
    regencyId: '3321',
    name: 'Wonosalam',
  },
  {
    id: '3321090',
    regencyId: '3321',
    name: 'Dempet',
  },
  {
    id: '3321091',
    regencyId: '3321',
    name: 'Kebonagung',
  },
  {
    id: '3321100',
    regencyId: '3321',
    name: 'Gajah',
  },
  {
    id: '3321110',
    regencyId: '3321',
    name: 'Karanganyar',
  },
  {
    id: '3321120',
    regencyId: '3321',
    name: 'Mijen',
  },
  {
    id: '3321130',
    regencyId: '3321',
    name: 'Wedung',
  },
  {
    id: '3322010',
    regencyId: '3322',
    name: 'Getasan',
  },
  {
    id: '3322020',
    regencyId: '3322',
    name: 'Tengaran',
  },
  {
    id: '3322030',
    regencyId: '3322',
    name: 'Susukan',
  },
  {
    id: '3322031',
    regencyId: '3322',
    name: 'Kaliwungu',
  },
  {
    id: '3322040',
    regencyId: '3322',
    name: 'Suruh',
  },
  {
    id: '3322050',
    regencyId: '3322',
    name: 'Pabelan',
  },
  {
    id: '3322060',
    regencyId: '3322',
    name: 'Tuntang',
  },
  {
    id: '3322070',
    regencyId: '3322',
    name: 'Banyubiru',
  },
  {
    id: '3322080',
    regencyId: '3322',
    name: 'Jambu',
  },
  {
    id: '3322090',
    regencyId: '3322',
    name: 'Sumowono',
  },
  {
    id: '3322100',
    regencyId: '3322',
    name: 'Ambarawa',
  },
  {
    id: '3322101',
    regencyId: '3322',
    name: 'Bandungan',
  },
  {
    id: '3322110',
    regencyId: '3322',
    name: 'Bawen',
  },
  {
    id: '3322120',
    regencyId: '3322',
    name: 'Bringin',
  },
  {
    id: '3322121',
    regencyId: '3322',
    name: 'Bancak',
  },
  {
    id: '3322130',
    regencyId: '3322',
    name: 'Pringapus',
  },
  {
    id: '3322140',
    regencyId: '3322',
    name: 'Bergas',
  },
  {
    id: '3322151',
    regencyId: '3322',
    name: 'Ungaran Barat',
  },
  {
    id: '3322152',
    regencyId: '3322',
    name: 'Ungaran Timur',
  },
  {
    id: '3323010',
    regencyId: '3323',
    name: 'Parakan',
  },
  {
    id: '3323011',
    regencyId: '3323',
    name: 'Kledung',
  },
  {
    id: '3323012',
    regencyId: '3323',
    name: 'Bansari',
  },
  {
    id: '3323020',
    regencyId: '3323',
    name: 'Bulu',
  },
  {
    id: '3323030',
    regencyId: '3323',
    name: 'Temanggung',
  },
  {
    id: '3323031',
    regencyId: '3323',
    name: 'Tlogomulyo',
  },
  {
    id: '3323040',
    regencyId: '3323',
    name: 'Tembarak',
  },
  {
    id: '3323041',
    regencyId: '3323',
    name: 'Selopampang',
  },
  {
    id: '3323050',
    regencyId: '3323',
    name: 'Kranggan',
  },
  {
    id: '3323060',
    regencyId: '3323',
    name: 'Pringsurat',
  },
  {
    id: '3323070',
    regencyId: '3323',
    name: 'Kaloran',
  },
  {
    id: '3323080',
    regencyId: '3323',
    name: 'Kandangan',
  },
  {
    id: '3323090',
    regencyId: '3323',
    name: 'Kedu',
  },
  {
    id: '3323100',
    regencyId: '3323',
    name: 'Ngadirejo',
  },
  {
    id: '3323110',
    regencyId: '3323',
    name: 'Jumo',
  },
  {
    id: '3323111',
    regencyId: '3323',
    name: 'Gemawang',
  },
  {
    id: '3323120',
    regencyId: '3323',
    name: 'Candiroto',
  },
  {
    id: '3323121',
    regencyId: '3323',
    name: 'Bejen',
  },
  {
    id: '3323130',
    regencyId: '3323',
    name: 'Tretep',
  },
  {
    id: '3323131',
    regencyId: '3323',
    name: 'Wonoboyo',
  },
  {
    id: '3324010',
    regencyId: '3324',
    name: 'Plantungan',
  },
  {
    id: '3324020',
    regencyId: '3324',
    name: 'Sukorejo',
  },
  {
    id: '3324030',
    regencyId: '3324',
    name: 'Pagerruyung',
  },
  {
    id: '3324040',
    regencyId: '3324',
    name: 'Patean',
  },
  {
    id: '3324050',
    regencyId: '3324',
    name: 'Singorojo',
  },
  {
    id: '3324060',
    regencyId: '3324',
    name: 'Limbangan',
  },
  {
    id: '3324070',
    regencyId: '3324',
    name: 'Boja',
  },
  {
    id: '3324080',
    regencyId: '3324',
    name: 'Kaliwungu',
  },
  {
    id: '3324081',
    regencyId: '3324',
    name: 'Kaliwungu Selatan',
  },
  {
    id: '3324090',
    regencyId: '3324',
    name: 'Brangsong',
  },
  {
    id: '3324100',
    regencyId: '3324',
    name: 'Pegandon',
  },
  {
    id: '3324101',
    regencyId: '3324',
    name: 'Ngampel',
  },
  {
    id: '3324110',
    regencyId: '3324',
    name: 'Gemuh',
  },
  {
    id: '3324111',
    regencyId: '3324',
    name: 'Ringinarum',
  },
  {
    id: '3324120',
    regencyId: '3324',
    name: 'Weleri',
  },
  {
    id: '3324130',
    regencyId: '3324',
    name: 'Rowosari',
  },
  {
    id: '3324140',
    regencyId: '3324',
    name: 'Kangkung',
  },
  {
    id: '3324150',
    regencyId: '3324',
    name: 'Cepiring',
  },
  {
    id: '3324160',
    regencyId: '3324',
    name: 'Patebon',
  },
  {
    id: '3324170',
    regencyId: '3324',
    name: 'Kota Kendal',
  },
  {
    id: '3325010',
    regencyId: '3325',
    name: 'Wonotunggal',
  },
  {
    id: '3325020',
    regencyId: '3325',
    name: 'Bandar',
  },
  {
    id: '3325030',
    regencyId: '3325',
    name: 'Blado',
  },
  {
    id: '3325040',
    regencyId: '3325',
    name: 'Reban',
  },
  {
    id: '3325050',
    regencyId: '3325',
    name: 'Bawang',
  },
  {
    id: '3325060',
    regencyId: '3325',
    name: 'Tersono',
  },
  {
    id: '3325070',
    regencyId: '3325',
    name: 'Gringsing',
  },
  {
    id: '3325080',
    regencyId: '3325',
    name: 'Limpung',
  },
  {
    id: '3325081',
    regencyId: '3325',
    name: 'Banyuputih',
  },
  {
    id: '3325090',
    regencyId: '3325',
    name: 'Subah',
  },
  {
    id: '3325091',
    regencyId: '3325',
    name: 'Pecalungan',
  },
  {
    id: '3325100',
    regencyId: '3325',
    name: 'Tulis',
  },
  {
    id: '3325101',
    regencyId: '3325',
    name: 'Kandeman',
  },
  {
    id: '3325110',
    regencyId: '3325',
    name: 'Batang',
  },
  {
    id: '3325120',
    regencyId: '3325',
    name: 'Warung Asem',
  },
  {
    id: '3326010',
    regencyId: '3326',
    name: 'Kandangserang',
  },
  {
    id: '3326020',
    regencyId: '3326',
    name: 'Paninggaran',
  },
  {
    id: '3326030',
    regencyId: '3326',
    name: 'Lebakbarang',
  },
  {
    id: '3326040',
    regencyId: '3326',
    name: 'Petungkriono',
  },
  {
    id: '3326050',
    regencyId: '3326',
    name: 'Talun',
  },
  {
    id: '3326060',
    regencyId: '3326',
    name: 'Doro',
  },
  {
    id: '3326070',
    regencyId: '3326',
    name: 'Karanganyar',
  },
  {
    id: '3326080',
    regencyId: '3326',
    name: 'Kajen',
  },
  {
    id: '3326090',
    regencyId: '3326',
    name: 'Kesesi',
  },
  {
    id: '3326100',
    regencyId: '3326',
    name: 'Sragi',
  },
  {
    id: '3326101',
    regencyId: '3326',
    name: 'Siwalan',
  },
  {
    id: '3326110',
    regencyId: '3326',
    name: 'Bojong',
  },
  {
    id: '3326120',
    regencyId: '3326',
    name: 'Wonopringgo',
  },
  {
    id: '3326130',
    regencyId: '3326',
    name: 'Kedungwuni',
  },
  {
    id: '3326131',
    regencyId: '3326',
    name: 'Karangdadap',
  },
  {
    id: '3326140',
    regencyId: '3326',
    name: 'Buaran',
  },
  {
    id: '3326150',
    regencyId: '3326',
    name: 'Tirto',
  },
  {
    id: '3326160',
    regencyId: '3326',
    name: 'Wiradesa',
  },
  {
    id: '3326161',
    regencyId: '3326',
    name: 'Wonokerto',
  },
  {
    id: '3327010',
    regencyId: '3327',
    name: 'Moga',
  },
  {
    id: '3327011',
    regencyId: '3327',
    name: 'Warungpring',
  },
  {
    id: '3327020',
    regencyId: '3327',
    name: 'Pulosari',
  },
  {
    id: '3327030',
    regencyId: '3327',
    name: 'Belik',
  },
  {
    id: '3327040',
    regencyId: '3327',
    name: 'Watukumpul',
  },
  {
    id: '3327050',
    regencyId: '3327',
    name: 'Bodeh',
  },
  {
    id: '3327060',
    regencyId: '3327',
    name: 'Bantarbolang',
  },
  {
    id: '3327070',
    regencyId: '3327',
    name: 'Randudongkal',
  },
  {
    id: '3327080',
    regencyId: '3327',
    name: 'Pemalang',
  },
  {
    id: '3327090',
    regencyId: '3327',
    name: 'Taman',
  },
  {
    id: '3327100',
    regencyId: '3327',
    name: 'Petarukan',
  },
  {
    id: '3327110',
    regencyId: '3327',
    name: 'Ampelgading',
  },
  {
    id: '3327120',
    regencyId: '3327',
    name: 'Comal',
  },
  {
    id: '3327130',
    regencyId: '3327',
    name: 'Ulujami',
  },
  {
    id: '3328010',
    regencyId: '3328',
    name: 'Margasari',
  },
  {
    id: '3328020',
    regencyId: '3328',
    name: 'Bumijawa',
  },
  {
    id: '3328030',
    regencyId: '3328',
    name: 'Bojong',
  },
  {
    id: '3328040',
    regencyId: '3328',
    name: 'Balapulang',
  },
  {
    id: '3328050',
    regencyId: '3328',
    name: 'Pagerbarang',
  },
  {
    id: '3328060',
    regencyId: '3328',
    name: 'Lebaksiu',
  },
  {
    id: '3328070',
    regencyId: '3328',
    name: 'Jatinegara',
  },
  {
    id: '3328080',
    regencyId: '3328',
    name: 'Kedung Banteng',
  },
  {
    id: '3328090',
    regencyId: '3328',
    name: 'Pangkah',
  },
  {
    id: '3328100',
    regencyId: '3328',
    name: 'Slawi',
  },
  {
    id: '3328110',
    regencyId: '3328',
    name: 'Dukuhwaru',
  },
  {
    id: '3328120',
    regencyId: '3328',
    name: 'Adiwerna',
  },
  {
    id: '3328130',
    regencyId: '3328',
    name: 'Dukuhturi',
  },
  {
    id: '3328140',
    regencyId: '3328',
    name: 'Talang',
  },
  {
    id: '3328150',
    regencyId: '3328',
    name: 'Tarub',
  },
  {
    id: '3328160',
    regencyId: '3328',
    name: 'Kramat',
  },
  {
    id: '3328170',
    regencyId: '3328',
    name: 'Suradadi',
  },
  {
    id: '3328180',
    regencyId: '3328',
    name: 'Warureja',
  },
  {
    id: '3329010',
    regencyId: '3329',
    name: 'Salem',
  },
  {
    id: '3329020',
    regencyId: '3329',
    name: 'Bantarkawung',
  },
  {
    id: '3329030',
    regencyId: '3329',
    name: 'Bumiayu',
  },
  {
    id: '3329040',
    regencyId: '3329',
    name: 'Paguyangan',
  },
  {
    id: '3329050',
    regencyId: '3329',
    name: 'Sirampog',
  },
  {
    id: '3329060',
    regencyId: '3329',
    name: 'Tonjong',
  },
  {
    id: '3329070',
    regencyId: '3329',
    name: 'Larangan',
  },
  {
    id: '3329080',
    regencyId: '3329',
    name: 'Ketanggungan',
  },
  {
    id: '3329090',
    regencyId: '3329',
    name: 'Banjarharjo',
  },
  {
    id: '3329100',
    regencyId: '3329',
    name: 'Losari',
  },
  {
    id: '3329110',
    regencyId: '3329',
    name: 'Tanjung',
  },
  {
    id: '3329120',
    regencyId: '3329',
    name: 'Kersana',
  },
  {
    id: '3329130',
    regencyId: '3329',
    name: 'Bulakamba',
  },
  {
    id: '3329140',
    regencyId: '3329',
    name: 'Wanasari',
  },
  {
    id: '3329150',
    regencyId: '3329',
    name: 'Songgom',
  },
  {
    id: '3329160',
    regencyId: '3329',
    name: 'Jatibarang',
  },
  {
    id: '3329170',
    regencyId: '3329',
    name: 'Brebes',
  },
  {
    id: '3371010',
    regencyId: '3371',
    name: 'Magelang Selatan',
  },
  {
    id: '3371011',
    regencyId: '3371',
    name: 'Magelang Tengah',
  },
  {
    id: '3371020',
    regencyId: '3371',
    name: 'Magelang Utara',
  },
  {
    id: '3372010',
    regencyId: '3372',
    name: 'Laweyan',
  },
  {
    id: '3372020',
    regencyId: '3372',
    name: 'Serengan',
  },
  {
    id: '3372030',
    regencyId: '3372',
    name: 'Pasar Kliwon',
  },
  {
    id: '3372040',
    regencyId: '3372',
    name: 'Jebres',
  },
  {
    id: '3372050',
    regencyId: '3372',
    name: 'Banjarsari',
  },
  {
    id: '3373010',
    regencyId: '3373',
    name: 'Argomulyo',
  },
  {
    id: '3373020',
    regencyId: '3373',
    name: 'Tingkir',
  },
  {
    id: '3373030',
    regencyId: '3373',
    name: 'Sidomukti',
  },
  {
    id: '3373040',
    regencyId: '3373',
    name: 'Sidorejo',
  },
  {
    id: '3374010',
    regencyId: '3374',
    name: 'Mijen',
  },
  {
    id: '3374020',
    regencyId: '3374',
    name: 'Gunung Pati',
  },
  {
    id: '3374030',
    regencyId: '3374',
    name: 'Banyumanik',
  },
  {
    id: '3374040',
    regencyId: '3374',
    name: 'Gajah Mungkur',
  },
  {
    id: '3374050',
    regencyId: '3374',
    name: 'Semarang Selatan',
  },
  {
    id: '3374060',
    regencyId: '3374',
    name: 'Candisari',
  },
  {
    id: '3374070',
    regencyId: '3374',
    name: 'Tembalang',
  },
  {
    id: '3374080',
    regencyId: '3374',
    name: 'Pedurungan',
  },
  {
    id: '3374090',
    regencyId: '3374',
    name: 'Genuk',
  },
  {
    id: '3374100',
    regencyId: '3374',
    name: 'Gayamsari',
  },
  {
    id: '3374110',
    regencyId: '3374',
    name: 'Semarang Timur',
  },
  {
    id: '3374120',
    regencyId: '3374',
    name: 'Semarang Utara',
  },
  {
    id: '3374130',
    regencyId: '3374',
    name: 'Semarang Tengah',
  },
  {
    id: '3374140',
    regencyId: '3374',
    name: 'Semarang Barat',
  },
  {
    id: '3374150',
    regencyId: '3374',
    name: 'Tugu',
  },
  {
    id: '3374160',
    regencyId: '3374',
    name: 'Ngaliyan',
  },
  {
    id: '3375010',
    regencyId: '3375',
    name: 'Pekalongan Barat',
  },
  {
    id: '3375020',
    regencyId: '3375',
    name: 'Pekalongan Timur',
  },
  {
    id: '3375030',
    regencyId: '3375',
    name: 'Pekalongan Selatan',
  },
  {
    id: '3375040',
    regencyId: '3375',
    name: 'Pekalongan Utara',
  },
  {
    id: '3376010',
    regencyId: '3376',
    name: 'Tegal Selatan',
  },
  {
    id: '3376020',
    regencyId: '3376',
    name: 'Tegal Timur',
  },
  {
    id: '3376030',
    regencyId: '3376',
    name: 'Tegal Barat',
  },
  {
    id: '3376040',
    regencyId: '3376',
    name: 'Margadana',
  },
  {
    id: '3401010',
    regencyId: '3401',
    name: 'Temon',
  },
  {
    id: '3401020',
    regencyId: '3401',
    name: 'Wates',
  },
  {
    id: '3401030',
    regencyId: '3401',
    name: 'Panjatan',
  },
  {
    id: '3401040',
    regencyId: '3401',
    name: 'Galur',
  },
  {
    id: '3401050',
    regencyId: '3401',
    name: 'Lendah',
  },
  {
    id: '3401060',
    regencyId: '3401',
    name: 'Sentolo',
  },
  {
    id: '3401070',
    regencyId: '3401',
    name: 'Pengasih',
  },
  {
    id: '3401080',
    regencyId: '3401',
    name: 'Kokap',
  },
  {
    id: '3401090',
    regencyId: '3401',
    name: 'Girimulyo',
  },
  {
    id: '3401100',
    regencyId: '3401',
    name: 'Nanggulan',
  },
  {
    id: '3401110',
    regencyId: '3401',
    name: 'Kalibawang',
  },
  {
    id: '3401120',
    regencyId: '3401',
    name: 'Samigaluh',
  },
  {
    id: '3402010',
    regencyId: '3402',
    name: 'Srandakan',
  },
  {
    id: '3402020',
    regencyId: '3402',
    name: 'Sanden',
  },
  {
    id: '3402030',
    regencyId: '3402',
    name: 'Kretek',
  },
  {
    id: '3402040',
    regencyId: '3402',
    name: 'Pundong',
  },
  {
    id: '3402050',
    regencyId: '3402',
    name: 'Bambang Lipuro',
  },
  {
    id: '3402060',
    regencyId: '3402',
    name: 'Pandak',
  },
  {
    id: '3402070',
    regencyId: '3402',
    name: 'Bantul',
  },
  {
    id: '3402080',
    regencyId: '3402',
    name: 'Jetis',
  },
  {
    id: '3402090',
    regencyId: '3402',
    name: 'Imogiri',
  },
  {
    id: '3402100',
    regencyId: '3402',
    name: 'Dlingo',
  },
  {
    id: '3402110',
    regencyId: '3402',
    name: 'Pleret',
  },
  {
    id: '3402120',
    regencyId: '3402',
    name: 'Piyungan',
  },
  {
    id: '3402130',
    regencyId: '3402',
    name: 'Banguntapan',
  },
  {
    id: '3402140',
    regencyId: '3402',
    name: 'Sewon',
  },
  {
    id: '3402150',
    regencyId: '3402',
    name: 'Kasihan',
  },
  {
    id: '3402160',
    regencyId: '3402',
    name: 'Pajangan',
  },
  {
    id: '3402170',
    regencyId: '3402',
    name: 'Sedayu',
  },
  {
    id: '3403010',
    regencyId: '3403',
    name: 'Panggang',
  },
  {
    id: '3403011',
    regencyId: '3403',
    name: 'Purwosari',
  },
  {
    id: '3403020',
    regencyId: '3403',
    name: 'Paliyan',
  },
  {
    id: '3403030',
    regencyId: '3403',
    name: 'Sapto Sari',
  },
  {
    id: '3403040',
    regencyId: '3403',
    name: 'Tepus',
  },
  {
    id: '3403041',
    regencyId: '3403',
    name: 'Tanjungsari',
  },
  {
    id: '3403050',
    regencyId: '3403',
    name: 'Rongkop',
  },
  {
    id: '3403051',
    regencyId: '3403',
    name: 'Girisubo',
  },
  {
    id: '3403060',
    regencyId: '3403',
    name: 'Semanu',
  },
  {
    id: '3403070',
    regencyId: '3403',
    name: 'Ponjong',
  },
  {
    id: '3403080',
    regencyId: '3403',
    name: 'Karangmojo',
  },
  {
    id: '3403090',
    regencyId: '3403',
    name: 'Wonosari',
  },
  {
    id: '3403100',
    regencyId: '3403',
    name: 'Playen',
  },
  {
    id: '3403110',
    regencyId: '3403',
    name: 'Patuk',
  },
  {
    id: '3403120',
    regencyId: '3403',
    name: 'Gedang Sari',
  },
  {
    id: '3403130',
    regencyId: '3403',
    name: 'Nglipar',
  },
  {
    id: '3403140',
    regencyId: '3403',
    name: 'Ngawen',
  },
  {
    id: '3403150',
    regencyId: '3403',
    name: 'Semin',
  },
  {
    id: '3404010',
    regencyId: '3404',
    name: 'Moyudan',
  },
  {
    id: '3404020',
    regencyId: '3404',
    name: 'Minggir',
  },
  {
    id: '3404030',
    regencyId: '3404',
    name: 'Seyegan',
  },
  {
    id: '3404040',
    regencyId: '3404',
    name: 'Godean',
  },
  {
    id: '3404050',
    regencyId: '3404',
    name: 'Gamping',
  },
  {
    id: '3404060',
    regencyId: '3404',
    name: 'Mlati',
  },
  {
    id: '3404070',
    regencyId: '3404',
    name: 'Depok',
  },
  {
    id: '3404080',
    regencyId: '3404',
    name: 'Berbah',
  },
  {
    id: '3404090',
    regencyId: '3404',
    name: 'Prambanan',
  },
  {
    id: '3404100',
    regencyId: '3404',
    name: 'Kalasan',
  },
  {
    id: '3404110',
    regencyId: '3404',
    name: 'Ngemplak',
  },
  {
    id: '3404120',
    regencyId: '3404',
    name: 'Ngaglik',
  },
  {
    id: '3404130',
    regencyId: '3404',
    name: 'Sleman',
  },
  {
    id: '3404140',
    regencyId: '3404',
    name: 'Tempel',
  },
  {
    id: '3404150',
    regencyId: '3404',
    name: 'Turi',
  },
  {
    id: '3404160',
    regencyId: '3404',
    name: 'Pakem',
  },
  {
    id: '3404170',
    regencyId: '3404',
    name: 'Cangkringan',
  },
  {
    id: '3471010',
    regencyId: '3471',
    name: 'Mantrijeron',
  },
  {
    id: '3471020',
    regencyId: '3471',
    name: 'Kraton',
  },
  {
    id: '3471030',
    regencyId: '3471',
    name: 'Mergangsan',
  },
  {
    id: '3471040',
    regencyId: '3471',
    name: 'Umbulharjo',
  },
  {
    id: '3471050',
    regencyId: '3471',
    name: 'Kotagede',
  },
  {
    id: '3471060',
    regencyId: '3471',
    name: 'Gondokusuman',
  },
  {
    id: '3471070',
    regencyId: '3471',
    name: 'Danurejan',
  },
  {
    id: '3471080',
    regencyId: '3471',
    name: 'Pakualaman',
  },
  {
    id: '3471090',
    regencyId: '3471',
    name: 'Gondomanan',
  },
  {
    id: '3471100',
    regencyId: '3471',
    name: 'Ngampilan',
  },
  {
    id: '3471110',
    regencyId: '3471',
    name: 'Wirobrajan',
  },
  {
    id: '3471120',
    regencyId: '3471',
    name: 'Gedong Tengen',
  },
  {
    id: '3471130',
    regencyId: '3471',
    name: 'Jetis',
  },
  {
    id: '3471140',
    regencyId: '3471',
    name: 'Tegalrejo',
  },
  {
    id: '3501010',
    regencyId: '3501',
    name: 'Donorojo',
  },
  {
    id: '3501020',
    regencyId: '3501',
    name: 'Punung',
  },
  {
    id: '3501030',
    regencyId: '3501',
    name: 'Pringkuku',
  },
  {
    id: '3501040',
    regencyId: '3501',
    name: 'Pacitan',
  },
  {
    id: '3501050',
    regencyId: '3501',
    name: 'Kebonagung',
  },
  {
    id: '3501060',
    regencyId: '3501',
    name: 'Arjosari',
  },
  {
    id: '3501070',
    regencyId: '3501',
    name: 'Nawangan',
  },
  {
    id: '3501080',
    regencyId: '3501',
    name: 'Bandar',
  },
  {
    id: '3501090',
    regencyId: '3501',
    name: 'Tegalombo',
  },
  {
    id: '3501100',
    regencyId: '3501',
    name: 'Tulakan',
  },
  {
    id: '3501110',
    regencyId: '3501',
    name: 'Ngadirojo',
  },
  {
    id: '3501120',
    regencyId: '3501',
    name: 'Sudimoro',
  },
  {
    id: '3502010',
    regencyId: '3502',
    name: 'Ngrayun',
  },
  {
    id: '3502020',
    regencyId: '3502',
    name: 'Slahung',
  },
  {
    id: '3502030',
    regencyId: '3502',
    name: 'Bungkal',
  },
  {
    id: '3502040',
    regencyId: '3502',
    name: 'Sambit',
  },
  {
    id: '3502050',
    regencyId: '3502',
    name: 'Sawoo',
  },
  {
    id: '3502060',
    regencyId: '3502',
    name: 'Sooko',
  },
  {
    id: '3502061',
    regencyId: '3502',
    name: 'Pudak',
  },
  {
    id: '3502070',
    regencyId: '3502',
    name: 'Pulung',
  },
  {
    id: '3502080',
    regencyId: '3502',
    name: 'Mlarak',
  },
  {
    id: '3502090',
    regencyId: '3502',
    name: 'Siman',
  },
  {
    id: '3502100',
    regencyId: '3502',
    name: 'Jetis',
  },
  {
    id: '3502110',
    regencyId: '3502',
    name: 'Balong',
  },
  {
    id: '3502120',
    regencyId: '3502',
    name: 'Kauman',
  },
  {
    id: '3502130',
    regencyId: '3502',
    name: 'Jambon',
  },
  {
    id: '3502140',
    regencyId: '3502',
    name: 'Badegan',
  },
  {
    id: '3502150',
    regencyId: '3502',
    name: 'Sampung',
  },
  {
    id: '3502160',
    regencyId: '3502',
    name: 'Sukorejo',
  },
  {
    id: '3502170',
    regencyId: '3502',
    name: 'Ponorogo',
  },
  {
    id: '3502180',
    regencyId: '3502',
    name: 'Babadan',
  },
  {
    id: '3502190',
    regencyId: '3502',
    name: 'Jenangan',
  },
  {
    id: '3502200',
    regencyId: '3502',
    name: 'Ngebel',
  },
  {
    id: '3503010',
    regencyId: '3503',
    name: 'Panggul',
  },
  {
    id: '3503020',
    regencyId: '3503',
    name: 'Munjungan',
  },
  {
    id: '3503030',
    regencyId: '3503',
    name: 'Watulimo',
  },
  {
    id: '3503040',
    regencyId: '3503',
    name: 'Kampak',
  },
  {
    id: '3503050',
    regencyId: '3503',
    name: 'Dongko',
  },
  {
    id: '3503060',
    regencyId: '3503',
    name: 'Pule',
  },
  {
    id: '3503070',
    regencyId: '3503',
    name: 'Karangan',
  },
  {
    id: '3503071',
    regencyId: '3503',
    name: 'Suruh',
  },
  {
    id: '3503080',
    regencyId: '3503',
    name: 'Gandusari',
  },
  {
    id: '3503090',
    regencyId: '3503',
    name: 'Durenan',
  },
  {
    id: '3503100',
    regencyId: '3503',
    name: 'Pogalan',
  },
  {
    id: '3503110',
    regencyId: '3503',
    name: 'Trenggalek',
  },
  {
    id: '3503120',
    regencyId: '3503',
    name: 'Tugu',
  },
  {
    id: '3503130',
    regencyId: '3503',
    name: 'Bendungan',
  },
  {
    id: '3504010',
    regencyId: '3504',
    name: 'Besuki',
  },
  {
    id: '3504020',
    regencyId: '3504',
    name: 'Bandung',
  },
  {
    id: '3504030',
    regencyId: '3504',
    name: 'Pakel',
  },
  {
    id: '3504040',
    regencyId: '3504',
    name: 'Campur Darat',
  },
  {
    id: '3504050',
    regencyId: '3504',
    name: 'Tanggung Gunung',
  },
  {
    id: '3504060',
    regencyId: '3504',
    name: 'Kalidawir',
  },
  {
    id: '3504070',
    regencyId: '3504',
    name: 'Pucang Laban',
  },
  {
    id: '3504080',
    regencyId: '3504',
    name: 'Rejotangan',
  },
  {
    id: '3504090',
    regencyId: '3504',
    name: 'Ngunut',
  },
  {
    id: '3504100',
    regencyId: '3504',
    name: 'Sumbergempol',
  },
  {
    id: '3504110',
    regencyId: '3504',
    name: 'Boyolangu',
  },
  {
    id: '3504120',
    regencyId: '3504',
    name: 'Tulungagung',
  },
  {
    id: '3504130',
    regencyId: '3504',
    name: 'Kedungwaru',
  },
  {
    id: '3504140',
    regencyId: '3504',
    name: 'Ngantru',
  },
  {
    id: '3504150',
    regencyId: '3504',
    name: 'Karangrejo',
  },
  {
    id: '3504160',
    regencyId: '3504',
    name: 'Kauman',
  },
  {
    id: '3504170',
    regencyId: '3504',
    name: 'Gondang',
  },
  {
    id: '3504180',
    regencyId: '3504',
    name: 'Pager Wojo',
  },
  {
    id: '3504190',
    regencyId: '3504',
    name: 'Sendang',
  },
  {
    id: '3505010',
    regencyId: '3505',
    name: 'Bakung',
  },
  {
    id: '3505020',
    regencyId: '3505',
    name: 'Wonotirto',
  },
  {
    id: '3505030',
    regencyId: '3505',
    name: 'Panggungrejo',
  },
  {
    id: '3505040',
    regencyId: '3505',
    name: 'Wates',
  },
  {
    id: '3505050',
    regencyId: '3505',
    name: 'Binangun',
  },
  {
    id: '3505060',
    regencyId: '3505',
    name: 'Sutojayan',
  },
  {
    id: '3505070',
    regencyId: '3505',
    name: 'Kademangan',
  },
  {
    id: '3505080',
    regencyId: '3505',
    name: 'Kanigoro',
  },
  {
    id: '3505090',
    regencyId: '3505',
    name: 'Talun',
  },
  {
    id: '3505100',
    regencyId: '3505',
    name: 'Selopuro',
  },
  {
    id: '3505110',
    regencyId: '3505',
    name: 'Kesamben',
  },
  {
    id: '3505120',
    regencyId: '3505',
    name: 'Selorejo',
  },
  {
    id: '3505130',
    regencyId: '3505',
    name: 'Doko',
  },
  {
    id: '3505140',
    regencyId: '3505',
    name: 'Wlingi',
  },
  {
    id: '3505150',
    regencyId: '3505',
    name: 'Gandusari',
  },
  {
    id: '3505160',
    regencyId: '3505',
    name: 'Garum',
  },
  {
    id: '3505170',
    regencyId: '3505',
    name: 'Nglegok',
  },
  {
    id: '3505180',
    regencyId: '3505',
    name: 'Sanankulon',
  },
  {
    id: '3505190',
    regencyId: '3505',
    name: 'Ponggok',
  },
  {
    id: '3505200',
    regencyId: '3505',
    name: 'Srengat',
  },
  {
    id: '3505210',
    regencyId: '3505',
    name: 'Wonodadi',
  },
  {
    id: '3505220',
    regencyId: '3505',
    name: 'Udanawu',
  },
  {
    id: '3506010',
    regencyId: '3506',
    name: 'Mojo',
  },
  {
    id: '3506020',
    regencyId: '3506',
    name: 'Semen',
  },
  {
    id: '3506030',
    regencyId: '3506',
    name: 'Ngadiluwih',
  },
  {
    id: '3506040',
    regencyId: '3506',
    name: 'Kras',
  },
  {
    id: '3506050',
    regencyId: '3506',
    name: 'Ringinrejo',
  },
  {
    id: '3506060',
    regencyId: '3506',
    name: 'Kandat',
  },
  {
    id: '3506070',
    regencyId: '3506',
    name: 'Wates',
  },
  {
    id: '3506080',
    regencyId: '3506',
    name: 'Ngancar',
  },
  {
    id: '3506090',
    regencyId: '3506',
    name: 'Plosoklaten',
  },
  {
    id: '3506100',
    regencyId: '3506',
    name: 'Gurah',
  },
  {
    id: '3506110',
    regencyId: '3506',
    name: 'Puncu',
  },
  {
    id: '3506120',
    regencyId: '3506',
    name: 'Kepung',
  },
  {
    id: '3506130',
    regencyId: '3506',
    name: 'Kandangan',
  },
  {
    id: '3506140',
    regencyId: '3506',
    name: 'Pare',
  },
  {
    id: '3506141',
    regencyId: '3506',
    name: 'Badas',
  },
  {
    id: '3506150',
    regencyId: '3506',
    name: 'Kunjang',
  },
  {
    id: '3506160',
    regencyId: '3506',
    name: 'Plemahan',
  },
  {
    id: '3506170',
    regencyId: '3506',
    name: 'Purwoasri',
  },
  {
    id: '3506180',
    regencyId: '3506',
    name: 'Papar',
  },
  {
    id: '3506190',
    regencyId: '3506',
    name: 'Pagu',
  },
  {
    id: '3506191',
    regencyId: '3506',
    name: 'Kayen Kidul',
  },
  {
    id: '3506200',
    regencyId: '3506',
    name: 'Gampengrejo',
  },
  {
    id: '3506201',
    regencyId: '3506',
    name: 'Ngasem',
  },
  {
    id: '3506210',
    regencyId: '3506',
    name: 'Banyakan',
  },
  {
    id: '3506220',
    regencyId: '3506',
    name: 'Grogol',
  },
  {
    id: '3506230',
    regencyId: '3506',
    name: 'Tarokan',
  },
  {
    id: '3507010',
    regencyId: '3507',
    name: 'Donomulyo',
  },
  {
    id: '3507020',
    regencyId: '3507',
    name: 'Kalipare',
  },
  {
    id: '3507030',
    regencyId: '3507',
    name: 'Pagak',
  },
  {
    id: '3507040',
    regencyId: '3507',
    name: 'Bantur',
  },
  {
    id: '3507050',
    regencyId: '3507',
    name: 'Gedangan',
  },
  {
    id: '3507060',
    regencyId: '3507',
    name: 'Sumbermanjing',
  },
  {
    id: '3507070',
    regencyId: '3507',
    name: 'Dampit',
  },
  {
    id: '3507080',
    regencyId: '3507',
    name: 'Tirto Yudo',
  },
  {
    id: '3507090',
    regencyId: '3507',
    name: 'Ampelgading',
  },
  {
    id: '3507100',
    regencyId: '3507',
    name: 'Poncokusumo',
  },
  {
    id: '3507110',
    regencyId: '3507',
    name: 'Wajak',
  },
  {
    id: '3507120',
    regencyId: '3507',
    name: 'Turen',
  },
  {
    id: '3507130',
    regencyId: '3507',
    name: 'Bululawang',
  },
  {
    id: '3507140',
    regencyId: '3507',
    name: 'Gondanglegi',
  },
  {
    id: '3507150',
    regencyId: '3507',
    name: 'Pagelaran',
  },
  {
    id: '3507160',
    regencyId: '3507',
    name: 'Kepanjen',
  },
  {
    id: '3507170',
    regencyId: '3507',
    name: 'Sumber Pucung',
  },
  {
    id: '3507180',
    regencyId: '3507',
    name: 'Kromengan',
  },
  {
    id: '3507190',
    regencyId: '3507',
    name: 'Ngajum',
  },
  {
    id: '3507200',
    regencyId: '3507',
    name: 'Wonosari',
  },
  {
    id: '3507210',
    regencyId: '3507',
    name: 'Wagir',
  },
  {
    id: '3507220',
    regencyId: '3507',
    name: 'Pakisaji',
  },
  {
    id: '3507230',
    regencyId: '3507',
    name: 'Tajinan',
  },
  {
    id: '3507240',
    regencyId: '3507',
    name: 'Tumpang',
  },
  {
    id: '3507250',
    regencyId: '3507',
    name: 'Pakis',
  },
  {
    id: '3507260',
    regencyId: '3507',
    name: 'Jabung',
  },
  {
    id: '3507270',
    regencyId: '3507',
    name: 'Lawang',
  },
  {
    id: '3507280',
    regencyId: '3507',
    name: 'Singosari',
  },
  {
    id: '3507290',
    regencyId: '3507',
    name: 'Karangploso',
  },
  {
    id: '3507300',
    regencyId: '3507',
    name: 'Dau',
  },
  {
    id: '3507310',
    regencyId: '3507',
    name: 'Pujon',
  },
  {
    id: '3507320',
    regencyId: '3507',
    name: 'Ngantang',
  },
  {
    id: '3507330',
    regencyId: '3507',
    name: 'Kasembon',
  },
  {
    id: '3508010',
    regencyId: '3508',
    name: 'Tempursari',
  },
  {
    id: '3508020',
    regencyId: '3508',
    name: 'Pronojiwo',
  },
  {
    id: '3508030',
    regencyId: '3508',
    name: 'Candipuro',
  },
  {
    id: '3508040',
    regencyId: '3508',
    name: 'Pasirian',
  },
  {
    id: '3508050',
    regencyId: '3508',
    name: 'Tempeh',
  },
  {
    id: '3508060',
    regencyId: '3508',
    name: 'Lumajang',
  },
  {
    id: '3508061',
    regencyId: '3508',
    name: 'Sumbersuko',
  },
  {
    id: '3508070',
    regencyId: '3508',
    name: 'Tekung',
  },
  {
    id: '3508080',
    regencyId: '3508',
    name: 'Kunir',
  },
  {
    id: '3508090',
    regencyId: '3508',
    name: 'Yosowilangun',
  },
  {
    id: '3508100',
    regencyId: '3508',
    name: 'Rowokangkung',
  },
  {
    id: '3508110',
    regencyId: '3508',
    name: 'Jatiroto',
  },
  {
    id: '3508120',
    regencyId: '3508',
    name: 'Randuagung',
  },
  {
    id: '3508130',
    regencyId: '3508',
    name: 'Sukodono',
  },
  {
    id: '3508140',
    regencyId: '3508',
    name: 'Padang',
  },
  {
    id: '3508150',
    regencyId: '3508',
    name: 'Pasrujambe',
  },
  {
    id: '3508160',
    regencyId: '3508',
    name: 'Senduro',
  },
  {
    id: '3508170',
    regencyId: '3508',
    name: 'Gucialit',
  },
  {
    id: '3508180',
    regencyId: '3508',
    name: 'Kedungjajang',
  },
  {
    id: '3508190',
    regencyId: '3508',
    name: 'Klakah',
  },
  {
    id: '3508200',
    regencyId: '3508',
    name: 'Ranuyoso',
  },
  {
    id: '3509010',
    regencyId: '3509',
    name: 'Kencong',
  },
  {
    id: '3509020',
    regencyId: '3509',
    name: 'Gumuk Mas',
  },
  {
    id: '3509030',
    regencyId: '3509',
    name: 'Puger',
  },
  {
    id: '3509040',
    regencyId: '3509',
    name: 'Wuluhan',
  },
  {
    id: '3509050',
    regencyId: '3509',
    name: 'Ambulu',
  },
  {
    id: '3509060',
    regencyId: '3509',
    name: 'Tempurejo',
  },
  {
    id: '3509070',
    regencyId: '3509',
    name: 'Silo',
  },
  {
    id: '3509080',
    regencyId: '3509',
    name: 'Mayang',
  },
  {
    id: '3509090',
    regencyId: '3509',
    name: 'Mumbulsari',
  },
  {
    id: '3509100',
    regencyId: '3509',
    name: 'Jenggawah',
  },
  {
    id: '3509110',
    regencyId: '3509',
    name: 'Ajung',
  },
  {
    id: '3509120',
    regencyId: '3509',
    name: 'Rambipuji',
  },
  {
    id: '3509130',
    regencyId: '3509',
    name: 'Balung',
  },
  {
    id: '3509140',
    regencyId: '3509',
    name: 'Umbulsari',
  },
  {
    id: '3509150',
    regencyId: '3509',
    name: 'Semboro',
  },
  {
    id: '3509160',
    regencyId: '3509',
    name: 'Jombang',
  },
  {
    id: '3509170',
    regencyId: '3509',
    name: 'Sumber Baru',
  },
  {
    id: '3509180',
    regencyId: '3509',
    name: 'Tanggul',
  },
  {
    id: '3509190',
    regencyId: '3509',
    name: 'Bangsalsari',
  },
  {
    id: '3509200',
    regencyId: '3509',
    name: 'Panti',
  },
  {
    id: '3509210',
    regencyId: '3509',
    name: 'Sukorambi',
  },
  {
    id: '3509220',
    regencyId: '3509',
    name: 'Arjasa',
  },
  {
    id: '3509230',
    regencyId: '3509',
    name: 'Pakusari',
  },
  {
    id: '3509240',
    regencyId: '3509',
    name: 'Kalisat',
  },
  {
    id: '3509250',
    regencyId: '3509',
    name: 'Ledokombo',
  },
  {
    id: '3509260',
    regencyId: '3509',
    name: 'Sumberjambe',
  },
  {
    id: '3509270',
    regencyId: '3509',
    name: 'Sukowono',
  },
  {
    id: '3509280',
    regencyId: '3509',
    name: 'Jelbuk',
  },
  {
    id: '3509710',
    regencyId: '3509',
    name: 'Kaliwates',
  },
  {
    id: '3509720',
    regencyId: '3509',
    name: 'Sumbersari',
  },
  {
    id: '3509730',
    regencyId: '3509',
    name: 'Patrang',
  },
  {
    id: '3510010',
    regencyId: '3510',
    name: 'Pesanggaran',
  },
  {
    id: '3510011',
    regencyId: '3510',
    name: 'Siliragung',
  },
  {
    id: '3510020',
    regencyId: '3510',
    name: 'Bangorejo',
  },
  {
    id: '3510030',
    regencyId: '3510',
    name: 'Purwoharjo',
  },
  {
    id: '3510040',
    regencyId: '3510',
    name: 'Tegaldlimo',
  },
  {
    id: '3510050',
    regencyId: '3510',
    name: 'Muncar',
  },
  {
    id: '3510060',
    regencyId: '3510',
    name: 'Cluring',
  },
  {
    id: '3510070',
    regencyId: '3510',
    name: 'Gambiran',
  },
  {
    id: '3510071',
    regencyId: '3510',
    name: 'Tegalsari',
  },
  {
    id: '3510080',
    regencyId: '3510',
    name: 'Glenmore',
  },
  {
    id: '3510090',
    regencyId: '3510',
    name: 'Kalibaru',
  },
  {
    id: '3510100',
    regencyId: '3510',
    name: 'Genteng',
  },
  {
    id: '3510110',
    regencyId: '3510',
    name: 'Srono',
  },
  {
    id: '3510120',
    regencyId: '3510',
    name: 'Rogojampi',
  },
  {
    id: '3510121',
    regencyId: '3510',
    name: 'Blimbingsari',
  },
  {
    id: '3510130',
    regencyId: '3510',
    name: 'Kabat',
  },
  {
    id: '3510140',
    regencyId: '3510',
    name: 'Singojuruh',
  },
  {
    id: '3510150',
    regencyId: '3510',
    name: 'Sempu',
  },
  {
    id: '3510160',
    regencyId: '3510',
    name: 'Songgon',
  },
  {
    id: '3510170',
    regencyId: '3510',
    name: 'Glagah',
  },
  {
    id: '3510171',
    regencyId: '3510',
    name: 'Licin',
  },
  {
    id: '3510180',
    regencyId: '3510',
    name: 'Banyuwangi',
  },
  {
    id: '3510190',
    regencyId: '3510',
    name: 'Giri',
  },
  {
    id: '3510200',
    regencyId: '3510',
    name: 'Kalipuro',
  },
  {
    id: '3510210',
    regencyId: '3510',
    name: 'Wongsorejo',
  },
  {
    id: '3511010',
    regencyId: '3511',
    name: 'Maesan',
  },
  {
    id: '3511020',
    regencyId: '3511',
    name: 'Grujugan',
  },
  {
    id: '3511030',
    regencyId: '3511',
    name: 'Tamanan',
  },
  {
    id: '3511031',
    regencyId: '3511',
    name: 'Jambesari Darus Sholah',
  },
  {
    id: '3511040',
    regencyId: '3511',
    name: 'Pujer',
  },
  {
    id: '3511050',
    regencyId: '3511',
    name: 'Tlogosari',
  },
  {
    id: '3511060',
    regencyId: '3511',
    name: 'Sukosari',
  },
  {
    id: '3511061',
    regencyId: '3511',
    name: 'Sumber Wringin',
  },
  {
    id: '3511070',
    regencyId: '3511',
    name: 'Tapen',
  },
  {
    id: '3511080',
    regencyId: '3511',
    name: 'Wonosari',
  },
  {
    id: '3511090',
    regencyId: '3511',
    name: 'Tenggarang',
  },
  {
    id: '3511100',
    regencyId: '3511',
    name: 'Bondowoso',
  },
  {
    id: '3511110',
    regencyId: '3511',
    name: 'Curah Dami',
  },
  {
    id: '3511111',
    regencyId: '3511',
    name: 'Binakal',
  },
  {
    id: '3511120',
    regencyId: '3511',
    name: 'Pakem',
  },
  {
    id: '3511130',
    regencyId: '3511',
    name: 'Wringin',
  },
  {
    id: '3511140',
    regencyId: '3511',
    name: 'Tegalampel',
  },
  {
    id: '3511141',
    regencyId: '3511',
    name: 'Taman Krocok',
  },
  {
    id: '3511150',
    regencyId: '3511',
    name: 'Klabang',
  },
  {
    id: '3511151',
    regencyId: '3511',
    name: 'Ijen',
  },
  {
    id: '3511152',
    regencyId: '3511',
    name: 'Botolinggo',
  },
  {
    id: '3511160',
    regencyId: '3511',
    name: 'Prajekan',
  },
  {
    id: '3511170',
    regencyId: '3511',
    name: 'Cermee',
  },
  {
    id: '3512010',
    regencyId: '3512',
    name: 'Sumbermalang',
  },
  {
    id: '3512020',
    regencyId: '3512',
    name: 'Jatibanteng',
  },
  {
    id: '3512030',
    regencyId: '3512',
    name: 'Banyuglugur',
  },
  {
    id: '3512040',
    regencyId: '3512',
    name: 'Besuki',
  },
  {
    id: '3512050',
    regencyId: '3512',
    name: 'Suboh',
  },
  {
    id: '3512060',
    regencyId: '3512',
    name: 'Mlandingan',
  },
  {
    id: '3512070',
    regencyId: '3512',
    name: 'Bungatan',
  },
  {
    id: '3512080',
    regencyId: '3512',
    name: 'Kendit',
  },
  {
    id: '3512090',
    regencyId: '3512',
    name: 'Panarukan',
  },
  {
    id: '3512100',
    regencyId: '3512',
    name: 'Situbondo',
  },
  {
    id: '3512110',
    regencyId: '3512',
    name: 'Mangaran',
  },
  {
    id: '3512120',
    regencyId: '3512',
    name: 'Panji',
  },
  {
    id: '3512130',
    regencyId: '3512',
    name: 'Kapongan',
  },
  {
    id: '3512140',
    regencyId: '3512',
    name: 'Arjasa',
  },
  {
    id: '3512150',
    regencyId: '3512',
    name: 'Jangkar',
  },
  {
    id: '3512160',
    regencyId: '3512',
    name: 'Asembagus',
  },
  {
    id: '3512170',
    regencyId: '3512',
    name: 'Banyuputih',
  },
  {
    id: '3513010',
    regencyId: '3513',
    name: 'Sukapura',
  },
  {
    id: '3513020',
    regencyId: '3513',
    name: 'Sumber',
  },
  {
    id: '3513030',
    regencyId: '3513',
    name: 'Kuripan',
  },
  {
    id: '3513040',
    regencyId: '3513',
    name: 'Bantaran',
  },
  {
    id: '3513050',
    regencyId: '3513',
    name: 'Leces',
  },
  {
    id: '3513060',
    regencyId: '3513',
    name: 'Tegalsiwalan',
  },
  {
    id: '3513070',
    regencyId: '3513',
    name: 'Banyuanyar',
  },
  {
    id: '3513080',
    regencyId: '3513',
    name: 'Tiris',
  },
  {
    id: '3513090',
    regencyId: '3513',
    name: 'Krucil',
  },
  {
    id: '3513100',
    regencyId: '3513',
    name: 'Gading',
  },
  {
    id: '3513110',
    regencyId: '3513',
    name: 'Pakuniran',
  },
  {
    id: '3513120',
    regencyId: '3513',
    name: 'Kotaanyar',
  },
  {
    id: '3513130',
    regencyId: '3513',
    name: 'Paiton',
  },
  {
    id: '3513140',
    regencyId: '3513',
    name: 'Besuk',
  },
  {
    id: '3513150',
    regencyId: '3513',
    name: 'Kraksaan',
  },
  {
    id: '3513160',
    regencyId: '3513',
    name: 'Krejengan',
  },
  {
    id: '3513170',
    regencyId: '3513',
    name: 'Pajarakan',
  },
  {
    id: '3513180',
    regencyId: '3513',
    name: 'Maron',
  },
  {
    id: '3513190',
    regencyId: '3513',
    name: 'Gending',
  },
  {
    id: '3513200',
    regencyId: '3513',
    name: 'Dringu',
  },
  {
    id: '3513210',
    regencyId: '3513',
    name: 'Wonomerto',
  },
  {
    id: '3513220',
    regencyId: '3513',
    name: 'Lumbang',
  },
  {
    id: '3513230',
    regencyId: '3513',
    name: 'Tongas',
  },
  {
    id: '3513240',
    regencyId: '3513',
    name: 'Sumberasih',
  },
  {
    id: '3514010',
    regencyId: '3514',
    name: 'Purwodadi',
  },
  {
    id: '3514020',
    regencyId: '3514',
    name: 'Tutur',
  },
  {
    id: '3514030',
    regencyId: '3514',
    name: 'Puspo',
  },
  {
    id: '3514040',
    regencyId: '3514',
    name: 'Tosari',
  },
  {
    id: '3514050',
    regencyId: '3514',
    name: 'Lumbang',
  },
  {
    id: '3514060',
    regencyId: '3514',
    name: 'Pasrepan',
  },
  {
    id: '3514070',
    regencyId: '3514',
    name: 'Kejayan',
  },
  {
    id: '3514080',
    regencyId: '3514',
    name: 'Wonorejo',
  },
  {
    id: '3514090',
    regencyId: '3514',
    name: 'Purwosari',
  },
  {
    id: '3514100',
    regencyId: '3514',
    name: 'Prigen',
  },
  {
    id: '3514110',
    regencyId: '3514',
    name: 'Sukorejo',
  },
  {
    id: '3514120',
    regencyId: '3514',
    name: 'Pandaan',
  },
  {
    id: '3514130',
    regencyId: '3514',
    name: 'Gempol',
  },
  {
    id: '3514140',
    regencyId: '3514',
    name: 'Beji',
  },
  {
    id: '3514150',
    regencyId: '3514',
    name: 'Bangil',
  },
  {
    id: '3514160',
    regencyId: '3514',
    name: 'Rembang',
  },
  {
    id: '3514170',
    regencyId: '3514',
    name: 'Kraton',
  },
  {
    id: '3514180',
    regencyId: '3514',
    name: 'Pohjentrek',
  },
  {
    id: '3514190',
    regencyId: '3514',
    name: 'Gondang Wetan',
  },
  {
    id: '3514200',
    regencyId: '3514',
    name: 'Rejoso',
  },
  {
    id: '3514210',
    regencyId: '3514',
    name: 'Winongan',
  },
  {
    id: '3514220',
    regencyId: '3514',
    name: 'Grati',
  },
  {
    id: '3514230',
    regencyId: '3514',
    name: 'Lekok',
  },
  {
    id: '3514240',
    regencyId: '3514',
    name: 'Nguling',
  },
  {
    id: '3515010',
    regencyId: '3515',
    name: 'Tarik',
  },
  {
    id: '3515020',
    regencyId: '3515',
    name: 'Prambon',
  },
  {
    id: '3515030',
    regencyId: '3515',
    name: 'Krembung',
  },
  {
    id: '3515040',
    regencyId: '3515',
    name: 'Porong',
  },
  {
    id: '3515050',
    regencyId: '3515',
    name: 'Jabon',
  },
  {
    id: '3515060',
    regencyId: '3515',
    name: 'Tanggulangin',
  },
  {
    id: '3515070',
    regencyId: '3515',
    name: 'Candi',
  },
  {
    id: '3515080',
    regencyId: '3515',
    name: 'Tulangan',
  },
  {
    id: '3515090',
    regencyId: '3515',
    name: 'Wonoayu',
  },
  {
    id: '3515100',
    regencyId: '3515',
    name: 'Sukodono',
  },
  {
    id: '3515110',
    regencyId: '3515',
    name: 'Sidoarjo',
  },
  {
    id: '3515120',
    regencyId: '3515',
    name: 'Buduran',
  },
  {
    id: '3515130',
    regencyId: '3515',
    name: 'Sedati',
  },
  {
    id: '3515140',
    regencyId: '3515',
    name: 'Waru',
  },
  {
    id: '3515150',
    regencyId: '3515',
    name: 'Gedangan',
  },
  {
    id: '3515160',
    regencyId: '3515',
    name: 'Taman',
  },
  {
    id: '3515170',
    regencyId: '3515',
    name: 'Krian',
  },
  {
    id: '3515180',
    regencyId: '3515',
    name: 'Balong Bendo',
  },
  {
    id: '3516010',
    regencyId: '3516',
    name: 'Jatirejo',
  },
  {
    id: '3516020',
    regencyId: '3516',
    name: 'Gondang',
  },
  {
    id: '3516030',
    regencyId: '3516',
    name: 'Pacet',
  },
  {
    id: '3516040',
    regencyId: '3516',
    name: 'Trawas',
  },
  {
    id: '3516050',
    regencyId: '3516',
    name: 'Ngoro',
  },
  {
    id: '3516060',
    regencyId: '3516',
    name: 'Pungging',
  },
  {
    id: '3516070',
    regencyId: '3516',
    name: 'Kutorejo',
  },
  {
    id: '3516080',
    regencyId: '3516',
    name: 'Mojosari',
  },
  {
    id: '3516090',
    regencyId: '3516',
    name: 'Bangsal',
  },
  {
    id: '3516091',
    regencyId: '3516',
    name: 'Mojoanyar',
  },
  {
    id: '3516100',
    regencyId: '3516',
    name: 'Dlanggu',
  },
  {
    id: '3516110',
    regencyId: '3516',
    name: 'Puri',
  },
  {
    id: '3516120',
    regencyId: '3516',
    name: 'Trowulan',
  },
  {
    id: '3516130',
    regencyId: '3516',
    name: 'Sooko',
  },
  {
    id: '3516140',
    regencyId: '3516',
    name: 'Gedek',
  },
  {
    id: '3516150',
    regencyId: '3516',
    name: 'Kemlagi',
  },
  {
    id: '3516160',
    regencyId: '3516',
    name: 'Jetis',
  },
  {
    id: '3516170',
    regencyId: '3516',
    name: 'Dawar Blandong',
  },
  {
    id: '3517010',
    regencyId: '3517',
    name: 'Bandar Kedung Mulyo',
  },
  {
    id: '3517020',
    regencyId: '3517',
    name: 'Perak',
  },
  {
    id: '3517030',
    regencyId: '3517',
    name: 'Gudo',
  },
  {
    id: '3517040',
    regencyId: '3517',
    name: 'Diwek',
  },
  {
    id: '3517050',
    regencyId: '3517',
    name: 'Ngoro',
  },
  {
    id: '3517060',
    regencyId: '3517',
    name: 'Mojowarno',
  },
  {
    id: '3517070',
    regencyId: '3517',
    name: 'Bareng',
  },
  {
    id: '3517080',
    regencyId: '3517',
    name: 'Wonosalam',
  },
  {
    id: '3517090',
    regencyId: '3517',
    name: 'Mojoagung',
  },
  {
    id: '3517100',
    regencyId: '3517',
    name: 'Sumobito',
  },
  {
    id: '3517110',
    regencyId: '3517',
    name: 'Jogo Roto',
  },
  {
    id: '3517120',
    regencyId: '3517',
    name: 'Peterongan',
  },
  {
    id: '3517130',
    regencyId: '3517',
    name: 'Jombang',
  },
  {
    id: '3517140',
    regencyId: '3517',
    name: 'Megaluh',
  },
  {
    id: '3517150',
    regencyId: '3517',
    name: 'Tembelang',
  },
  {
    id: '3517160',
    regencyId: '3517',
    name: 'Kesamben',
  },
  {
    id: '3517170',
    regencyId: '3517',
    name: 'Kudu',
  },
  {
    id: '3517171',
    regencyId: '3517',
    name: 'Ngusikan',
  },
  {
    id: '3517180',
    regencyId: '3517',
    name: 'Ploso',
  },
  {
    id: '3517190',
    regencyId: '3517',
    name: 'Kabuh',
  },
  {
    id: '3517200',
    regencyId: '3517',
    name: 'Plandaan',
  },
  {
    id: '3518010',
    regencyId: '3518',
    name: 'Sawahan',
  },
  {
    id: '3518020',
    regencyId: '3518',
    name: 'Ngetos',
  },
  {
    id: '3518030',
    regencyId: '3518',
    name: 'Berbek',
  },
  {
    id: '3518040',
    regencyId: '3518',
    name: 'Loceret',
  },
  {
    id: '3518050',
    regencyId: '3518',
    name: 'Pace',
  },
  {
    id: '3518060',
    regencyId: '3518',
    name: 'Tanjunganom',
  },
  {
    id: '3518070',
    regencyId: '3518',
    name: 'Prambon',
  },
  {
    id: '3518080',
    regencyId: '3518',
    name: 'Ngronggot',
  },
  {
    id: '3518090',
    regencyId: '3518',
    name: 'Kertosono',
  },
  {
    id: '3518100',
    regencyId: '3518',
    name: 'Patianrowo',
  },
  {
    id: '3518110',
    regencyId: '3518',
    name: 'Baron',
  },
  {
    id: '3518120',
    regencyId: '3518',
    name: 'Gondang',
  },
  {
    id: '3518130',
    regencyId: '3518',
    name: 'Sukomoro',
  },
  {
    id: '3518140',
    regencyId: '3518',
    name: 'Nganjuk',
  },
  {
    id: '3518150',
    regencyId: '3518',
    name: 'Bagor',
  },
  {
    id: '3518160',
    regencyId: '3518',
    name: 'Wilangan',
  },
  {
    id: '3518170',
    regencyId: '3518',
    name: 'Rejoso',
  },
  {
    id: '3518180',
    regencyId: '3518',
    name: 'Ngluyu',
  },
  {
    id: '3518190',
    regencyId: '3518',
    name: 'Lengkong',
  },
  {
    id: '3518200',
    regencyId: '3518',
    name: 'Jatikalen',
  },
  {
    id: '3519010',
    regencyId: '3519',
    name: 'Kebonsari',
  },
  {
    id: '3519020',
    regencyId: '3519',
    name: 'Geger',
  },
  {
    id: '3519030',
    regencyId: '3519',
    name: 'Dolopo',
  },
  {
    id: '3519040',
    regencyId: '3519',
    name: 'Dagangan',
  },
  {
    id: '3519050',
    regencyId: '3519',
    name: 'Wungu',
  },
  {
    id: '3519060',
    regencyId: '3519',
    name: 'Kare',
  },
  {
    id: '3519070',
    regencyId: '3519',
    name: 'Gemarang',
  },
  {
    id: '3519080',
    regencyId: '3519',
    name: 'Saradan',
  },
  {
    id: '3519090',
    regencyId: '3519',
    name: 'Pilangkenceng',
  },
  {
    id: '3519100',
    regencyId: '3519',
    name: 'Mejayan',
  },
  {
    id: '3519110',
    regencyId: '3519',
    name: 'Wonoasri',
  },
  {
    id: '3519120',
    regencyId: '3519',
    name: 'Balerejo',
  },
  {
    id: '3519130',
    regencyId: '3519',
    name: 'Madiun',
  },
  {
    id: '3519140',
    regencyId: '3519',
    name: 'Sawahan',
  },
  {
    id: '3519150',
    regencyId: '3519',
    name: 'Jiwan',
  },
  {
    id: '3520010',
    regencyId: '3520',
    name: 'Poncol',
  },
  {
    id: '3520020',
    regencyId: '3520',
    name: 'Parang',
  },
  {
    id: '3520030',
    regencyId: '3520',
    name: 'Lembeyan',
  },
  {
    id: '3520040',
    regencyId: '3520',
    name: 'Takeran',
  },
  {
    id: '3520041',
    regencyId: '3520',
    name: 'Nguntoronadi',
  },
  {
    id: '3520050',
    regencyId: '3520',
    name: 'Kawedanan',
  },
  {
    id: '3520060',
    regencyId: '3520',
    name: 'Magetan',
  },
  {
    id: '3520061',
    regencyId: '3520',
    name: 'Ngariboyo',
  },
  {
    id: '3520070',
    regencyId: '3520',
    name: 'Plaosan',
  },
  {
    id: '3520071',
    regencyId: '3520',
    name: 'Sidorejo',
  },
  {
    id: '3520080',
    regencyId: '3520',
    name: 'Panekan',
  },
  {
    id: '3520090',
    regencyId: '3520',
    name: 'Sukomoro',
  },
  {
    id: '3520100',
    regencyId: '3520',
    name: 'Bendo',
  },
  {
    id: '3520110',
    regencyId: '3520',
    name: 'Maospati',
  },
  {
    id: '3520120',
    regencyId: '3520',
    name: 'Karangrejo',
  },
  {
    id: '3520121',
    regencyId: '3520',
    name: 'Karas',
  },
  {
    id: '3520130',
    regencyId: '3520',
    name: 'Barat',
  },
  {
    id: '3520131',
    regencyId: '3520',
    name: 'Kartoharjo',
  },
  {
    id: '3521010',
    regencyId: '3521',
    name: 'Sine',
  },
  {
    id: '3521020',
    regencyId: '3521',
    name: 'Ngrambe',
  },
  {
    id: '3521030',
    regencyId: '3521',
    name: 'Jogorogo',
  },
  {
    id: '3521040',
    regencyId: '3521',
    name: 'Kendal',
  },
  {
    id: '3521050',
    regencyId: '3521',
    name: 'Geneng',
  },
  {
    id: '3521051',
    regencyId: '3521',
    name: 'Gerih',
  },
  {
    id: '3521060',
    regencyId: '3521',
    name: 'Kwadungan',
  },
  {
    id: '3521070',
    regencyId: '3521',
    name: 'Pangkur',
  },
  {
    id: '3521080',
    regencyId: '3521',
    name: 'Karangjati',
  },
  {
    id: '3521090',
    regencyId: '3521',
    name: 'Bringin',
  },
  {
    id: '3521100',
    regencyId: '3521',
    name: 'Padas',
  },
  {
    id: '3521101',
    regencyId: '3521',
    name: 'Kasreman',
  },
  {
    id: '3521110',
    regencyId: '3521',
    name: 'Ngawi',
  },
  {
    id: '3521120',
    regencyId: '3521',
    name: 'Paron',
  },
  {
    id: '3521130',
    regencyId: '3521',
    name: 'Kedunggalar',
  },
  {
    id: '3521140',
    regencyId: '3521',
    name: 'Pitu',
  },
  {
    id: '3521150',
    regencyId: '3521',
    name: 'Widodaren',
  },
  {
    id: '3521160',
    regencyId: '3521',
    name: 'Mantingan',
  },
  {
    id: '3521170',
    regencyId: '3521',
    name: 'Karanganyar',
  },
  {
    id: '3522010',
    regencyId: '3522',
    name: 'Margomulyo',
  },
  {
    id: '3522020',
    regencyId: '3522',
    name: 'Ngraho',
  },
  {
    id: '3522030',
    regencyId: '3522',
    name: 'Tambakrejo',
  },
  {
    id: '3522040',
    regencyId: '3522',
    name: 'Ngambon',
  },
  {
    id: '3522041',
    regencyId: '3522',
    name: 'Sekar',
  },
  {
    id: '3522050',
    regencyId: '3522',
    name: 'Bubulan',
  },
  {
    id: '3522051',
    regencyId: '3522',
    name: 'Gondang',
  },
  {
    id: '3522060',
    regencyId: '3522',
    name: 'Temayang',
  },
  {
    id: '3522070',
    regencyId: '3522',
    name: 'Sugihwaras',
  },
  {
    id: '3522080',
    regencyId: '3522',
    name: 'Kedungadem',
  },
  {
    id: '3522090',
    regencyId: '3522',
    name: 'Kepoh Baru',
  },
  {
    id: '3522100',
    regencyId: '3522',
    name: 'Baureno',
  },
  {
    id: '3522110',
    regencyId: '3522',
    name: 'Kanor',
  },
  {
    id: '3522120',
    regencyId: '3522',
    name: 'Sumberejo',
  },
  {
    id: '3522130',
    regencyId: '3522',
    name: 'Balen',
  },
  {
    id: '3522140',
    regencyId: '3522',
    name: 'Sukosewu',
  },
  {
    id: '3522150',
    regencyId: '3522',
    name: 'Kapas',
  },
  {
    id: '3522160',
    regencyId: '3522',
    name: 'Bojonegoro',
  },
  {
    id: '3522170',
    regencyId: '3522',
    name: 'Trucuk',
  },
  {
    id: '3522180',
    regencyId: '3522',
    name: 'Dander',
  },
  {
    id: '3522190',
    regencyId: '3522',
    name: 'Ngasem',
  },
  {
    id: '3522191',
    regencyId: '3522',
    name: 'Gayam',
  },
  {
    id: '3522200',
    regencyId: '3522',
    name: 'Kalitidu',
  },
  {
    id: '3522210',
    regencyId: '3522',
    name: 'Malo',
  },
  {
    id: '3522220',
    regencyId: '3522',
    name: 'Purwosari',
  },
  {
    id: '3522230',
    regencyId: '3522',
    name: 'Padangan',
  },
  {
    id: '3522240',
    regencyId: '3522',
    name: 'Kasiman',
  },
  {
    id: '3522241',
    regencyId: '3522',
    name: 'Kedewan',
  },
  {
    id: '3523010',
    regencyId: '3523',
    name: 'Kenduruan',
  },
  {
    id: '3523020',
    regencyId: '3523',
    name: 'Bangilan',
  },
  {
    id: '3523030',
    regencyId: '3523',
    name: 'Senori',
  },
  {
    id: '3523040',
    regencyId: '3523',
    name: 'Singgahan',
  },
  {
    id: '3523050',
    regencyId: '3523',
    name: 'Montong',
  },
  {
    id: '3523060',
    regencyId: '3523',
    name: 'Parengan',
  },
  {
    id: '3523070',
    regencyId: '3523',
    name: 'Soko',
  },
  {
    id: '3523080',
    regencyId: '3523',
    name: 'Rengel',
  },
  {
    id: '3523081',
    regencyId: '3523',
    name: 'Grabagan',
  },
  {
    id: '3523090',
    regencyId: '3523',
    name: 'Plumpang',
  },
  {
    id: '3523100',
    regencyId: '3523',
    name: 'Widang',
  },
  {
    id: '3523110',
    regencyId: '3523',
    name: 'Palang',
  },
  {
    id: '3523120',
    regencyId: '3523',
    name: 'Semanding',
  },
  {
    id: '3523130',
    regencyId: '3523',
    name: 'Tuban',
  },
  {
    id: '3523140',
    regencyId: '3523',
    name: 'Jenu',
  },
  {
    id: '3523150',
    regencyId: '3523',
    name: 'Merakurak',
  },
  {
    id: '3523160',
    regencyId: '3523',
    name: 'Kerek',
  },
  {
    id: '3523170',
    regencyId: '3523',
    name: 'Tambakboyo',
  },
  {
    id: '3523180',
    regencyId: '3523',
    name: 'Jatirogo',
  },
  {
    id: '3523190',
    regencyId: '3523',
    name: 'Bancar',
  },
  {
    id: '3524010',
    regencyId: '3524',
    name: 'Sukorame',
  },
  {
    id: '3524020',
    regencyId: '3524',
    name: 'Bluluk',
  },
  {
    id: '3524030',
    regencyId: '3524',
    name: 'Ngimbang',
  },
  {
    id: '3524040',
    regencyId: '3524',
    name: 'Sambeng',
  },
  {
    id: '3524050',
    regencyId: '3524',
    name: 'Mantup',
  },
  {
    id: '3524060',
    regencyId: '3524',
    name: 'Kembangbahu',
  },
  {
    id: '3524070',
    regencyId: '3524',
    name: 'Sugio',
  },
  {
    id: '3524080',
    regencyId: '3524',
    name: 'Kedungpring',
  },
  {
    id: '3524090',
    regencyId: '3524',
    name: 'Modo',
  },
  {
    id: '3524100',
    regencyId: '3524',
    name: 'Babat',
  },
  {
    id: '3524110',
    regencyId: '3524',
    name: 'Pucuk',
  },
  {
    id: '3524120',
    regencyId: '3524',
    name: 'Sukodadi',
  },
  {
    id: '3524130',
    regencyId: '3524',
    name: 'Lamongan',
  },
  {
    id: '3524140',
    regencyId: '3524',
    name: 'Tikung',
  },
  {
    id: '3524141',
    regencyId: '3524',
    name: 'Sarirejo',
  },
  {
    id: '3524150',
    regencyId: '3524',
    name: 'Deket',
  },
  {
    id: '3524160',
    regencyId: '3524',
    name: 'Glagah',
  },
  {
    id: '3524170',
    regencyId: '3524',
    name: 'Karangbinangun',
  },
  {
    id: '3524180',
    regencyId: '3524',
    name: 'Turi',
  },
  {
    id: '3524190',
    regencyId: '3524',
    name: 'Kalitengah',
  },
  {
    id: '3524200',
    regencyId: '3524',
    name: 'Karang Geneng',
  },
  {
    id: '3524210',
    regencyId: '3524',
    name: 'Sekaran',
  },
  {
    id: '3524220',
    regencyId: '3524',
    name: 'Maduran',
  },
  {
    id: '3524230',
    regencyId: '3524',
    name: 'Laren',
  },
  {
    id: '3524240',
    regencyId: '3524',
    name: 'Solokuro',
  },
  {
    id: '3524250',
    regencyId: '3524',
    name: 'Paciran',
  },
  {
    id: '3524260',
    regencyId: '3524',
    name: 'Brondong',
  },
  {
    id: '3525010',
    regencyId: '3525',
    name: 'Wringinanom',
  },
  {
    id: '3525020',
    regencyId: '3525',
    name: 'Driyorejo',
  },
  {
    id: '3525030',
    regencyId: '3525',
    name: 'Kedamean',
  },
  {
    id: '3525040',
    regencyId: '3525',
    name: 'Menganti',
  },
  {
    id: '3525050',
    regencyId: '3525',
    name: 'Cerme',
  },
  {
    id: '3525060',
    regencyId: '3525',
    name: 'Benjeng',
  },
  {
    id: '3525070',
    regencyId: '3525',
    name: 'Balongpanggang',
  },
  {
    id: '3525080',
    regencyId: '3525',
    name: 'Duduksampeyan',
  },
  {
    id: '3525090',
    regencyId: '3525',
    name: 'Kebomas',
  },
  {
    id: '3525100',
    regencyId: '3525',
    name: 'Gresik',
  },
  {
    id: '3525110',
    regencyId: '3525',
    name: 'Manyar',
  },
  {
    id: '3525120',
    regencyId: '3525',
    name: 'Bungah',
  },
  {
    id: '3525130',
    regencyId: '3525',
    name: 'Sidayu',
  },
  {
    id: '3525140',
    regencyId: '3525',
    name: 'Dukun',
  },
  {
    id: '3525150',
    regencyId: '3525',
    name: 'Panceng',
  },
  {
    id: '3525160',
    regencyId: '3525',
    name: 'Ujungpangkah',
  },
  {
    id: '3525170',
    regencyId: '3525',
    name: 'Sangkapura',
  },
  {
    id: '3525180',
    regencyId: '3525',
    name: 'Tambak',
  },
  {
    id: '3526010',
    regencyId: '3526',
    name: 'Kamal',
  },
  {
    id: '3526020',
    regencyId: '3526',
    name: 'Labang',
  },
  {
    id: '3526030',
    regencyId: '3526',
    name: 'Kwanyar',
  },
  {
    id: '3526040',
    regencyId: '3526',
    name: 'Modung',
  },
  {
    id: '3526050',
    regencyId: '3526',
    name: 'Blega',
  },
  {
    id: '3526060',
    regencyId: '3526',
    name: 'Konang',
  },
  {
    id: '3526070',
    regencyId: '3526',
    name: 'Galis',
  },
  {
    id: '3526080',
    regencyId: '3526',
    name: 'Tanah Merah',
  },
  {
    id: '3526090',
    regencyId: '3526',
    name: 'Tragah',
  },
  {
    id: '3526100',
    regencyId: '3526',
    name: 'Socah',
  },
  {
    id: '3526110',
    regencyId: '3526',
    name: 'Bangkalan',
  },
  {
    id: '3526120',
    regencyId: '3526',
    name: 'Burneh',
  },
  {
    id: '3526130',
    regencyId: '3526',
    name: 'Arosbaya',
  },
  {
    id: '3526140',
    regencyId: '3526',
    name: 'Geger',
  },
  {
    id: '3526150',
    regencyId: '3526',
    name: 'Kokop',
  },
  {
    id: '3526160',
    regencyId: '3526',
    name: 'Tanjungbumi',
  },
  {
    id: '3526170',
    regencyId: '3526',
    name: 'Sepulu',
  },
  {
    id: '3526180',
    regencyId: '3526',
    name: 'Klampis',
  },
  {
    id: '3527010',
    regencyId: '3527',
    name: 'Sreseh',
  },
  {
    id: '3527020',
    regencyId: '3527',
    name: 'Torjun',
  },
  {
    id: '3527021',
    regencyId: '3527',
    name: 'Pangarengan',
  },
  {
    id: '3527030',
    regencyId: '3527',
    name: 'Sampang',
  },
  {
    id: '3527040',
    regencyId: '3527',
    name: 'Camplong',
  },
  {
    id: '3527050',
    regencyId: '3527',
    name: 'Omben',
  },
  {
    id: '3527060',
    regencyId: '3527',
    name: 'Kedungdung',
  },
  {
    id: '3527070',
    regencyId: '3527',
    name: 'Jrengik',
  },
  {
    id: '3527080',
    regencyId: '3527',
    name: 'Tambelangan',
  },
  {
    id: '3527090',
    regencyId: '3527',
    name: 'Banyuates',
  },
  {
    id: '3527100',
    regencyId: '3527',
    name: 'Robatal',
  },
  {
    id: '3527101',
    regencyId: '3527',
    name: 'Karang Penang',
  },
  {
    id: '3527110',
    regencyId: '3527',
    name: 'Ketapang',
  },
  {
    id: '3527120',
    regencyId: '3527',
    name: 'Sokobanah',
  },
  {
    id: '3528010',
    regencyId: '3528',
    name: 'Tlanakan',
  },
  {
    id: '3528020',
    regencyId: '3528',
    name: 'Pademawu',
  },
  {
    id: '3528030',
    regencyId: '3528',
    name: 'Galis',
  },
  {
    id: '3528040',
    regencyId: '3528',
    name: 'Larangan',
  },
  {
    id: '3528050',
    regencyId: '3528',
    name: 'Pamekasan',
  },
  {
    id: '3528060',
    regencyId: '3528',
    name: 'Proppo',
  },
  {
    id: '3528070',
    regencyId: '3528',
    name: 'Palengaan',
  },
  {
    id: '3528080',
    regencyId: '3528',
    name: 'Pegantenan',
  },
  {
    id: '3528090',
    regencyId: '3528',
    name: 'Kadur',
  },
  {
    id: '3528100',
    regencyId: '3528',
    name: 'Pakong',
  },
  {
    id: '3528110',
    regencyId: '3528',
    name: 'Waru',
  },
  {
    id: '3528120',
    regencyId: '3528',
    name: 'Batu Marmar',
  },
  {
    id: '3528130',
    regencyId: '3528',
    name: 'Pasean',
  },
  {
    id: '3529010',
    regencyId: '3529',
    name: 'Pragaan',
  },
  {
    id: '3529020',
    regencyId: '3529',
    name: 'Bluto',
  },
  {
    id: '3529030',
    regencyId: '3529',
    name: 'Saronggi',
  },
  {
    id: '3529040',
    regencyId: '3529',
    name: 'Giligenteng',
  },
  {
    id: '3529050',
    regencyId: '3529',
    name: 'Talango',
  },
  {
    id: '3529060',
    regencyId: '3529',
    name: 'Kalianget',
  },
  {
    id: '3529070',
    regencyId: '3529',
    name: 'Kota Sumenep',
  },
  {
    id: '3529071',
    regencyId: '3529',
    name: 'Batuan',
  },
  {
    id: '3529080',
    regencyId: '3529',
    name: 'Lenteng',
  },
  {
    id: '3529090',
    regencyId: '3529',
    name: 'Ganding',
  },
  {
    id: '3529100',
    regencyId: '3529',
    name: 'Guluk Guluk',
  },
  {
    id: '3529110',
    regencyId: '3529',
    name: 'Pasongsongan',
  },
  {
    id: '3529120',
    regencyId: '3529',
    name: 'Ambunten',
  },
  {
    id: '3529130',
    regencyId: '3529',
    name: 'Rubaru',
  },
  {
    id: '3529140',
    regencyId: '3529',
    name: 'Dasuk',
  },
  {
    id: '3529150',
    regencyId: '3529',
    name: 'Manding',
  },
  {
    id: '3529160',
    regencyId: '3529',
    name: 'Batuputih',
  },
  {
    id: '3529170',
    regencyId: '3529',
    name: 'Gapura',
  },
  {
    id: '3529180',
    regencyId: '3529',
    name: 'Batang Batang',
  },
  {
    id: '3529190',
    regencyId: '3529',
    name: 'Dungkek',
  },
  {
    id: '3529200',
    regencyId: '3529',
    name: 'Nonggunong',
  },
  {
    id: '3529210',
    regencyId: '3529',
    name: 'Gayam',
  },
  {
    id: '3529220',
    regencyId: '3529',
    name: 'Raas',
  },
  {
    id: '3529230',
    regencyId: '3529',
    name: 'Sapeken',
  },
  {
    id: '3529240',
    regencyId: '3529',
    name: 'Arjasa',
  },
  {
    id: '3529241',
    regencyId: '3529',
    name: 'Kangayan',
  },
  {
    id: '3529250',
    regencyId: '3529',
    name: 'Masalembu',
  },
  {
    id: '3571010',
    regencyId: '3571',
    name: 'Mojoroto',
  },
  {
    id: '3571020',
    regencyId: '3571',
    name: 'Kota Kediri',
  },
  {
    id: '3571030',
    regencyId: '3571',
    name: 'Pesantren',
  },
  {
    id: '3572010',
    regencyId: '3572',
    name: 'Sukorejo',
  },
  {
    id: '3572020',
    regencyId: '3572',
    name: 'Kepanjenkidul',
  },
  {
    id: '3572030',
    regencyId: '3572',
    name: 'Sananwetan',
  },
  {
    id: '3573010',
    regencyId: '3573',
    name: 'Kedungkandang',
  },
  {
    id: '3573020',
    regencyId: '3573',
    name: 'Sukun',
  },
  {
    id: '3573030',
    regencyId: '3573',
    name: 'Klojen',
  },
  {
    id: '3573040',
    regencyId: '3573',
    name: 'Blimbing',
  },
  {
    id: '3573050',
    regencyId: '3573',
    name: 'Lowokwaru',
  },
  {
    id: '3574010',
    regencyId: '3574',
    name: 'Kademangan',
  },
  {
    id: '3574011',
    regencyId: '3574',
    name: 'Kedopok',
  },
  {
    id: '3574020',
    regencyId: '3574',
    name: 'Wonoasih',
  },
  {
    id: '3574030',
    regencyId: '3574',
    name: 'Mayangan',
  },
  {
    id: '3574031',
    regencyId: '3574',
    name: 'Kanigaran',
  },
  {
    id: '3575010',
    regencyId: '3575',
    name: 'Gadingrejo',
  },
  {
    id: '3575020',
    regencyId: '3575',
    name: 'Purworejo',
  },
  {
    id: '3575030',
    regencyId: '3575',
    name: 'Bugulkidul',
  },
  {
    id: '3575031',
    regencyId: '3575',
    name: 'Panggungrejo',
  },
  {
    id: '3576010',
    regencyId: '3576',
    name: 'Prajurit Kulon',
  },
  {
    id: '3576020',
    regencyId: '3576',
    name: 'Magersari',
  },
  {
    id: '3576021',
    regencyId: '3576',
    name: 'Kranggan',
  },
  {
    id: '3577010',
    regencyId: '3577',
    name: 'Mangu Harjo',
  },
  {
    id: '3577020',
    regencyId: '3577',
    name: 'Taman',
  },
  {
    id: '3577030',
    regencyId: '3577',
    name: 'Kartoharjo',
  },
  {
    id: '3578010',
    regencyId: '3578',
    name: 'Karang Pilang',
  },
  {
    id: '3578020',
    regencyId: '3578',
    name: 'Jambangan',
  },
  {
    id: '3578030',
    regencyId: '3578',
    name: 'Gayungan',
  },
  {
    id: '3578040',
    regencyId: '3578',
    name: 'Wonocolo',
  },
  {
    id: '3578050',
    regencyId: '3578',
    name: 'Tenggilis Mejoyo',
  },
  {
    id: '3578060',
    regencyId: '3578',
    name: 'Gunung Anyar',
  },
  {
    id: '3578070',
    regencyId: '3578',
    name: 'Rungkut',
  },
  {
    id: '3578080',
    regencyId: '3578',
    name: 'Sukolilo',
  },
  {
    id: '3578090',
    regencyId: '3578',
    name: 'Mulyorejo',
  },
  {
    id: '3578100',
    regencyId: '3578',
    name: 'Gubeng',
  },
  {
    id: '3578110',
    regencyId: '3578',
    name: 'Wonokromo',
  },
  {
    id: '3578120',
    regencyId: '3578',
    name: 'Dukuh Pakis',
  },
  {
    id: '3578130',
    regencyId: '3578',
    name: 'Wiyung',
  },
  {
    id: '3578140',
    regencyId: '3578',
    name: 'Lakarsantri',
  },
  {
    id: '3578141',
    regencyId: '3578',
    name: 'Sambikerep',
  },
  {
    id: '3578150',
    regencyId: '3578',
    name: 'Tandes',
  },
  {
    id: '3578160',
    regencyId: '3578',
    name: 'Suko Manunggal',
  },
  {
    id: '3578170',
    regencyId: '3578',
    name: 'Sawahan',
  },
  {
    id: '3578180',
    regencyId: '3578',
    name: 'Tegalsari',
  },
  {
    id: '3578190',
    regencyId: '3578',
    name: 'Genteng',
  },
  {
    id: '3578200',
    regencyId: '3578',
    name: 'Tambaksari',
  },
  {
    id: '3578210',
    regencyId: '3578',
    name: 'Kenjeran',
  },
  {
    id: '3578211',
    regencyId: '3578',
    name: 'Bulak',
  },
  {
    id: '3578220',
    regencyId: '3578',
    name: 'Simokerto',
  },
  {
    id: '3578230',
    regencyId: '3578',
    name: 'Semampir',
  },
  {
    id: '3578240',
    regencyId: '3578',
    name: 'Pabean Cantian',
  },
  {
    id: '3578250',
    regencyId: '3578',
    name: 'Bubutan',
  },
  {
    id: '3578260',
    regencyId: '3578',
    name: 'Krembangan',
  },
  {
    id: '3578270',
    regencyId: '3578',
    name: 'Asemrowo',
  },
  {
    id: '3578280',
    regencyId: '3578',
    name: 'Benowo',
  },
  {
    id: '3578281',
    regencyId: '3578',
    name: 'Pakal',
  },
  {
    id: '3579010',
    regencyId: '3579',
    name: 'Batu',
  },
  {
    id: '3579020',
    regencyId: '3579',
    name: 'Junrejo',
  },
  {
    id: '3579030',
    regencyId: '3579',
    name: 'Bumiaji',
  },
  {
    id: '3601010',
    regencyId: '3601',
    name: 'Sumur',
  },
  {
    id: '3601020',
    regencyId: '3601',
    name: 'Cimanggu',
  },
  {
    id: '3601030',
    regencyId: '3601',
    name: 'Cibaliung',
  },
  {
    id: '3601031',
    regencyId: '3601',
    name: 'Cibitung',
  },
  {
    id: '3601040',
    regencyId: '3601',
    name: 'Cikeusik',
  },
  {
    id: '3601050',
    regencyId: '3601',
    name: 'Cigeulis',
  },
  {
    id: '3601060',
    regencyId: '3601',
    name: 'Panimbang',
  },
  {
    id: '3601061',
    regencyId: '3601',
    name: 'Sobang',
  },
  {
    id: '3601070',
    regencyId: '3601',
    name: 'Munjul',
  },
  {
    id: '3601071',
    regencyId: '3601',
    name: 'Angsana',
  },
  {
    id: '3601072',
    regencyId: '3601',
    name: 'Sindangresmi',
  },
  {
    id: '3601080',
    regencyId: '3601',
    name: 'Picung',
  },
  {
    id: '3601090',
    regencyId: '3601',
    name: 'Bojong',
  },
  {
    id: '3601100',
    regencyId: '3601',
    name: 'Saketi',
  },
  {
    id: '3601101',
    regencyId: '3601',
    name: 'Cisata',
  },
  {
    id: '3601110',
    regencyId: '3601',
    name: 'Pagelaran',
  },
  {
    id: '3601111',
    regencyId: '3601',
    name: 'Patia',
  },
  {
    id: '3601112',
    regencyId: '3601',
    name: 'Sukaresmi',
  },
  {
    id: '3601120',
    regencyId: '3601',
    name: 'Labuan',
  },
  {
    id: '3601121',
    regencyId: '3601',
    name: 'Carita',
  },
  {
    id: '3601130',
    regencyId: '3601',
    name: 'Jiput',
  },
  {
    id: '3601131',
    regencyId: '3601',
    name: 'Cikedal',
  },
  {
    id: '3601140',
    regencyId: '3601',
    name: 'Menes',
  },
  {
    id: '3601141',
    regencyId: '3601',
    name: 'Pulosari',
  },
  {
    id: '3601150',
    regencyId: '3601',
    name: 'Mandalawangi',
  },
  {
    id: '3601160',
    regencyId: '3601',
    name: 'Cimanuk',
  },
  {
    id: '3601161',
    regencyId: '3601',
    name: 'Cipeucang',
  },
  {
    id: '3601170',
    regencyId: '3601',
    name: 'Banjar',
  },
  {
    id: '3601171',
    regencyId: '3601',
    name: 'Kaduhejo',
  },
  {
    id: '3601172',
    regencyId: '3601',
    name: 'Mekarjaya',
  },
  {
    id: '3601180',
    regencyId: '3601',
    name: 'Pandeglang',
  },
  {
    id: '3601181',
    regencyId: '3601',
    name: 'Majasari',
  },
  {
    id: '3601190',
    regencyId: '3601',
    name: 'Cadasari',
  },
  {
    id: '3601191',
    regencyId: '3601',
    name: 'Karangtanjung',
  },
  {
    id: '3601192',
    regencyId: '3601',
    name: 'Koroncong',
  },
  {
    id: '3602010',
    regencyId: '3602',
    name: 'Malingping',
  },
  {
    id: '3602011',
    regencyId: '3602',
    name: 'Wanasalam',
  },
  {
    id: '3602020',
    regencyId: '3602',
    name: 'Panggarangan',
  },
  {
    id: '3602021',
    regencyId: '3602',
    name: 'Cihara',
  },
  {
    id: '3602030',
    regencyId: '3602',
    name: 'Bayah',
  },
  {
    id: '3602031',
    regencyId: '3602',
    name: 'Cilograng',
  },
  {
    id: '3602040',
    regencyId: '3602',
    name: 'Cibeber',
  },
  {
    id: '3602050',
    regencyId: '3602',
    name: 'Cijaku',
  },
  {
    id: '3602051',
    regencyId: '3602',
    name: 'Cigemblong',
  },
  {
    id: '3602060',
    regencyId: '3602',
    name: 'Banjarsari',
  },
  {
    id: '3602070',
    regencyId: '3602',
    name: 'Cileles',
  },
  {
    id: '3602080',
    regencyId: '3602',
    name: 'Gunung Kencana',
  },
  {
    id: '3602090',
    regencyId: '3602',
    name: 'Bojongmanik',
  },
  {
    id: '3602091',
    regencyId: '3602',
    name: 'Cirinten',
  },
  {
    id: '3602100',
    regencyId: '3602',
    name: 'Leuwidamar',
  },
  {
    id: '3602110',
    regencyId: '3602',
    name: 'Muncang',
  },
  {
    id: '3602111',
    regencyId: '3602',
    name: 'Sobang',
  },
  {
    id: '3602120',
    regencyId: '3602',
    name: 'Cipanas',
  },
  {
    id: '3602121',
    regencyId: '3602',
    name: 'Lebakgedong',
  },
  {
    id: '3602130',
    regencyId: '3602',
    name: 'Sajira',
  },
  {
    id: '3602140',
    regencyId: '3602',
    name: 'Cimarga',
  },
  {
    id: '3602150',
    regencyId: '3602',
    name: 'Cikulur',
  },
  {
    id: '3602160',
    regencyId: '3602',
    name: 'Warunggunung',
  },
  {
    id: '3602170',
    regencyId: '3602',
    name: 'Cibadak',
  },
  {
    id: '3602180',
    regencyId: '3602',
    name: 'Rangkasbitung',
  },
  {
    id: '3602181',
    regencyId: '3602',
    name: 'Kalanganyar',
  },
  {
    id: '3602190',
    regencyId: '3602',
    name: 'Maja',
  },
  {
    id: '3602191',
    regencyId: '3602',
    name: 'Curugbitung',
  },
  {
    id: '3603010',
    regencyId: '3603',
    name: 'Cisoka',
  },
  {
    id: '3603011',
    regencyId: '3603',
    name: 'Solear',
  },
  {
    id: '3603020',
    regencyId: '3603',
    name: 'Tigaraksa',
  },
  {
    id: '3603021',
    regencyId: '3603',
    name: 'Jambe',
  },
  {
    id: '3603030',
    regencyId: '3603',
    name: 'Cikupa',
  },
  {
    id: '3603040',
    regencyId: '3603',
    name: 'Panongan',
  },
  {
    id: '3603050',
    regencyId: '3603',
    name: 'Curug',
  },
  {
    id: '3603051',
    regencyId: '3603',
    name: 'Kelapa Dua',
  },
  {
    id: '3603060',
    regencyId: '3603',
    name: 'Legok',
  },
  {
    id: '3603070',
    regencyId: '3603',
    name: 'Pagedangan',
  },
  {
    id: '3603081',
    regencyId: '3603',
    name: 'Cisauk',
  },
  {
    id: '3603120',
    regencyId: '3603',
    name: 'Pasarkemis',
  },
  {
    id: '3603121',
    regencyId: '3603',
    name: 'Sindang Jaya',
  },
  {
    id: '3603130',
    regencyId: '3603',
    name: 'Balaraja',
  },
  {
    id: '3603131',
    regencyId: '3603',
    name: 'Jayanti',
  },
  {
    id: '3603132',
    regencyId: '3603',
    name: 'Sukamulya',
  },
  {
    id: '3603140',
    regencyId: '3603',
    name: 'Kresek',
  },
  {
    id: '3603141',
    regencyId: '3603',
    name: 'Gunung Kaler',
  },
  {
    id: '3603150',
    regencyId: '3603',
    name: 'Kronjo',
  },
  {
    id: '3603151',
    regencyId: '3603',
    name: 'Mekar Baru',
  },
  {
    id: '3603160',
    regencyId: '3603',
    name: 'Mauk',
  },
  {
    id: '3603161',
    regencyId: '3603',
    name: 'Kemiri',
  },
  {
    id: '3603162',
    regencyId: '3603',
    name: 'Sukadiri',
  },
  {
    id: '3603170',
    regencyId: '3603',
    name: 'Rajeg',
  },
  {
    id: '3603180',
    regencyId: '3603',
    name: 'Sepatan',
  },
  {
    id: '3603181',
    regencyId: '3603',
    name: 'Sepatan Timur',
  },
  {
    id: '3603190',
    regencyId: '3603',
    name: 'Pakuhaji',
  },
  {
    id: '3603200',
    regencyId: '3603',
    name: 'Teluknaga',
  },
  {
    id: '3603210',
    regencyId: '3603',
    name: 'Kosambi',
  },
  {
    id: '3604010',
    regencyId: '3604',
    name: 'Cinangka',
  },
  {
    id: '3604020',
    regencyId: '3604',
    name: 'Padarincang',
  },
  {
    id: '3604030',
    regencyId: '3604',
    name: 'Ciomas',
  },
  {
    id: '3604040',
    regencyId: '3604',
    name: 'Pabuaran',
  },
  {
    id: '3604041',
    regencyId: '3604',
    name: 'Gunung Sari',
  },
  {
    id: '3604050',
    regencyId: '3604',
    name: 'Baros',
  },
  {
    id: '3604060',
    regencyId: '3604',
    name: 'Petir',
  },
  {
    id: '3604061',
    regencyId: '3604',
    name: 'Tunjung Teja',
  },
  {
    id: '3604080',
    regencyId: '3604',
    name: 'Cikeusal',
  },
  {
    id: '3604090',
    regencyId: '3604',
    name: 'Pamarayan',
  },
  {
    id: '3604091',
    regencyId: '3604',
    name: 'Bandung',
  },
  {
    id: '3604100',
    regencyId: '3604',
    name: 'Jawilan',
  },
  {
    id: '3604110',
    regencyId: '3604',
    name: 'Kopo',
  },
  {
    id: '3604120',
    regencyId: '3604',
    name: 'Cikande',
  },
  {
    id: '3604121',
    regencyId: '3604',
    name: 'Kibin',
  },
  {
    id: '3604130',
    regencyId: '3604',
    name: 'Kragilan',
  },
  {
    id: '3604180',
    regencyId: '3604',
    name: 'Waringinkurung',
  },
  {
    id: '3604190',
    regencyId: '3604',
    name: 'Mancak',
  },
  {
    id: '3604200',
    regencyId: '3604',
    name: 'Anyar',
  },
  {
    id: '3604210',
    regencyId: '3604',
    name: 'Bojonegara',
  },
  {
    id: '3604211',
    regencyId: '3604',
    name: 'Pulo Ampel',
  },
  {
    id: '3604220',
    regencyId: '3604',
    name: 'Kramatwatu',
  },
  {
    id: '3604240',
    regencyId: '3604',
    name: 'Ciruas',
  },
  {
    id: '3604250',
    regencyId: '3604',
    name: 'Pontang',
  },
  {
    id: '3604251',
    regencyId: '3604',
    name: 'Lebak Wangi',
  },
  {
    id: '3604260',
    regencyId: '3604',
    name: 'Carenang',
  },
  {
    id: '3604261',
    regencyId: '3604',
    name: 'Binuang',
  },
  {
    id: '3604270',
    regencyId: '3604',
    name: 'Tirtayasa',
  },
  {
    id: '3604271',
    regencyId: '3604',
    name: 'Tanara',
  },
  {
    id: '3671010',
    regencyId: '3671',
    name: 'Ciledug',
  },
  {
    id: '3671011',
    regencyId: '3671',
    name: 'Larangan',
  },
  {
    id: '3671012',
    regencyId: '3671',
    name: 'Karang Tengah',
  },
  {
    id: '3671020',
    regencyId: '3671',
    name: 'Cipondoh',
  },
  {
    id: '3671021',
    regencyId: '3671',
    name: 'Pinang',
  },
  {
    id: '3671030',
    regencyId: '3671',
    name: 'Tangerang',
  },
  {
    id: '3671031',
    regencyId: '3671',
    name: 'Karawaci',
  },
  {
    id: '3671040',
    regencyId: '3671',
    name: 'Jati Uwung',
  },
  {
    id: '3671041',
    regencyId: '3671',
    name: 'Cibodas',
  },
  {
    id: '3671042',
    regencyId: '3671',
    name: 'Periuk',
  },
  {
    id: '3671050',
    regencyId: '3671',
    name: 'Batuceper',
  },
  {
    id: '3671051',
    regencyId: '3671',
    name: 'Neglasari',
  },
  {
    id: '3671060',
    regencyId: '3671',
    name: 'Benda',
  },
  {
    id: '3672010',
    regencyId: '3672',
    name: 'Ciwandan',
  },
  {
    id: '3672011',
    regencyId: '3672',
    name: 'Citangkil',
  },
  {
    id: '3672020',
    regencyId: '3672',
    name: 'Pulomerak',
  },
  {
    id: '3672021',
    regencyId: '3672',
    name: 'Purwakarta',
  },
  {
    id: '3672022',
    regencyId: '3672',
    name: 'Grogol',
  },
  {
    id: '3672030',
    regencyId: '3672',
    name: 'Cilegon',
  },
  {
    id: '3672031',
    regencyId: '3672',
    name: 'Jombang',
  },
  {
    id: '3672040',
    regencyId: '3672',
    name: 'Cibeber',
  },
  {
    id: '3673010',
    regencyId: '3673',
    name: 'Curug',
  },
  {
    id: '3673020',
    regencyId: '3673',
    name: 'Walantaka',
  },
  {
    id: '3673030',
    regencyId: '3673',
    name: 'Cipocok Jaya',
  },
  {
    id: '3673040',
    regencyId: '3673',
    name: 'Serang',
  },
  {
    id: '3673050',
    regencyId: '3673',
    name: 'Taktakan',
  },
  {
    id: '3673060',
    regencyId: '3673',
    name: 'Kasemen',
  },
  {
    id: '3674010',
    regencyId: '3674',
    name: 'Setu',
  },
  {
    id: '3674020',
    regencyId: '3674',
    name: 'Serpong',
  },
  {
    id: '3674030',
    regencyId: '3674',
    name: 'Pamulang',
  },
  {
    id: '3674040',
    regencyId: '3674',
    name: 'Ciputat',
  },
  {
    id: '3674050',
    regencyId: '3674',
    name: 'Ciputat Timur',
  },
  {
    id: '3674060',
    regencyId: '3674',
    name: 'Pondok Aren',
  },
  {
    id: '3674070',
    regencyId: '3674',
    name: 'Serpong Utara',
  },
  {
    id: '5101010',
    regencyId: '5101',
    name: 'Melaya',
  },
  {
    id: '5101020',
    regencyId: '5101',
    name: 'Negara',
  },
  {
    id: '5101021',
    regencyId: '5101',
    name: 'Jembrana',
  },
  {
    id: '5101030',
    regencyId: '5101',
    name: 'Mendoyo',
  },
  {
    id: '5101040',
    regencyId: '5101',
    name: 'Pekutatan',
  },
  {
    id: '5102010',
    regencyId: '5102',
    name: 'Selemadeg',
  },
  {
    id: '5102011',
    regencyId: '5102',
    name: 'Selemadeg Timur',
  },
  {
    id: '5102012',
    regencyId: '5102',
    name: 'Selemadeg Barat',
  },
  {
    id: '5102020',
    regencyId: '5102',
    name: 'Kerambitan',
  },
  {
    id: '5102030',
    regencyId: '5102',
    name: 'Tabanan',
  },
  {
    id: '5102040',
    regencyId: '5102',
    name: 'Kediri',
  },
  {
    id: '5102050',
    regencyId: '5102',
    name: 'Marga',
  },
  {
    id: '5102060',
    regencyId: '5102',
    name: 'Baturiti',
  },
  {
    id: '5102070',
    regencyId: '5102',
    name: 'Penebel',
  },
  {
    id: '5102080',
    regencyId: '5102',
    name: 'Pupuan',
  },
  {
    id: '5103010',
    regencyId: '5103',
    name: 'Kuta Selatan',
  },
  {
    id: '5103020',
    regencyId: '5103',
    name: 'Kuta',
  },
  {
    id: '5103030',
    regencyId: '5103',
    name: 'Kuta Utara',
  },
  {
    id: '5103040',
    regencyId: '5103',
    name: 'Mengwi',
  },
  {
    id: '5103050',
    regencyId: '5103',
    name: 'Abiansemal',
  },
  {
    id: '5103060',
    regencyId: '5103',
    name: 'Petang',
  },
  {
    id: '5104010',
    regencyId: '5104',
    name: 'Sukawati',
  },
  {
    id: '5104020',
    regencyId: '5104',
    name: 'Blahbatuh',
  },
  {
    id: '5104030',
    regencyId: '5104',
    name: 'Gianyar',
  },
  {
    id: '5104040',
    regencyId: '5104',
    name: 'Tampaksiring',
  },
  {
    id: '5104050',
    regencyId: '5104',
    name: 'Ubud',
  },
  {
    id: '5104060',
    regencyId: '5104',
    name: 'Tegallalang',
  },
  {
    id: '5104070',
    regencyId: '5104',
    name: 'Payangan',
  },
  {
    id: '5105010',
    regencyId: '5105',
    name: 'Nusapenida',
  },
  {
    id: '5105020',
    regencyId: '5105',
    name: 'Banjarangkan',
  },
  {
    id: '5105030',
    regencyId: '5105',
    name: 'Klungkung',
  },
  {
    id: '5105040',
    regencyId: '5105',
    name: 'Dawan',
  },
  {
    id: '5106010',
    regencyId: '5106',
    name: 'Susut',
  },
  {
    id: '5106020',
    regencyId: '5106',
    name: 'Bangli',
  },
  {
    id: '5106030',
    regencyId: '5106',
    name: 'Tembuku',
  },
  {
    id: '5106040',
    regencyId: '5106',
    name: 'Kintamani',
  },
  {
    id: '5107010',
    regencyId: '5107',
    name: 'Rendang',
  },
  {
    id: '5107020',
    regencyId: '5107',
    name: 'Sidemen',
  },
  {
    id: '5107030',
    regencyId: '5107',
    name: 'Manggis',
  },
  {
    id: '5107040',
    regencyId: '5107',
    name: 'Karangasem',
  },
  {
    id: '5107050',
    regencyId: '5107',
    name: 'Abang',
  },
  {
    id: '5107060',
    regencyId: '5107',
    name: 'Bebandem',
  },
  {
    id: '5107070',
    regencyId: '5107',
    name: 'Selat',
  },
  {
    id: '5107080',
    regencyId: '5107',
    name: 'Kubu',
  },
  {
    id: '5108010',
    regencyId: '5108',
    name: 'Gerokgak',
  },
  {
    id: '5108020',
    regencyId: '5108',
    name: 'Seririt',
  },
  {
    id: '5108030',
    regencyId: '5108',
    name: 'Busungbiu',
  },
  {
    id: '5108040',
    regencyId: '5108',
    name: 'Banjar',
  },
  {
    id: '5108050',
    regencyId: '5108',
    name: 'Sukasada',
  },
  {
    id: '5108060',
    regencyId: '5108',
    name: 'Buleleng',
  },
  {
    id: '5108070',
    regencyId: '5108',
    name: 'Sawan',
  },
  {
    id: '5108080',
    regencyId: '5108',
    name: 'Kubutambahan',
  },
  {
    id: '5108090',
    regencyId: '5108',
    name: 'Tejakula',
  },
  {
    id: '5171010',
    regencyId: '5171',
    name: 'Denpasar Selatan',
  },
  {
    id: '5171020',
    regencyId: '5171',
    name: 'Denpasar Timur',
  },
  {
    id: '5171030',
    regencyId: '5171',
    name: 'Denpasar Barat',
  },
  {
    id: '5171031',
    regencyId: '5171',
    name: 'Denpasar Utara',
  },
  {
    id: '5201010',
    regencyId: '5201',
    name: 'Sekotong',
  },
  {
    id: '5201011',
    regencyId: '5201',
    name: 'Lembar',
  },
  {
    id: '5201020',
    regencyId: '5201',
    name: 'Gerung',
  },
  {
    id: '5201030',
    regencyId: '5201',
    name: 'Labu Api',
  },
  {
    id: '5201040',
    regencyId: '5201',
    name: 'Kediri',
  },
  {
    id: '5201041',
    regencyId: '5201',
    name: 'Kuripan',
  },
  {
    id: '5201050',
    regencyId: '5201',
    name: 'Narmada',
  },
  {
    id: '5201051',
    regencyId: '5201',
    name: 'Lingsar',
  },
  {
    id: '5201060',
    regencyId: '5201',
    name: 'Gunung Sari',
  },
  {
    id: '5201061',
    regencyId: '5201',
    name: 'Batu Layar',
  },
  {
    id: '5202010',
    regencyId: '5202',
    name: 'Praya Barat',
  },
  {
    id: '5202011',
    regencyId: '5202',
    name: 'Praya Barat Daya',
  },
  {
    id: '5202020',
    regencyId: '5202',
    name: 'Pujut',
  },
  {
    id: '5202030',
    regencyId: '5202',
    name: 'Praya Timur',
  },
  {
    id: '5202040',
    regencyId: '5202',
    name: 'Janapria',
  },
  {
    id: '5202050',
    regencyId: '5202',
    name: 'Kopang',
  },
  {
    id: '5202060',
    regencyId: '5202',
    name: 'Praya',
  },
  {
    id: '5202061',
    regencyId: '5202',
    name: 'Praya Tengah',
  },
  {
    id: '5202070',
    regencyId: '5202',
    name: 'Jonggat',
  },
  {
    id: '5202080',
    regencyId: '5202',
    name: 'Pringgarata',
  },
  {
    id: '5202090',
    regencyId: '5202',
    name: 'Batukliang',
  },
  {
    id: '5202091',
    regencyId: '5202',
    name: 'Batukliang Utara',
  },
  {
    id: '5203010',
    regencyId: '5203',
    name: 'Keruak',
  },
  {
    id: '5203011',
    regencyId: '5203',
    name: 'Jerowaru',
  },
  {
    id: '5203020',
    regencyId: '5203',
    name: 'Sakra',
  },
  {
    id: '5203021',
    regencyId: '5203',
    name: 'Sakra Barat',
  },
  {
    id: '5203022',
    regencyId: '5203',
    name: 'Sakra Timur',
  },
  {
    id: '5203030',
    regencyId: '5203',
    name: 'Terara',
  },
  {
    id: '5203031',
    regencyId: '5203',
    name: 'Montong Gading',
  },
  {
    id: '5203040',
    regencyId: '5203',
    name: 'Sikur',
  },
  {
    id: '5203050',
    regencyId: '5203',
    name: 'Masbagik',
  },
  {
    id: '5203051',
    regencyId: '5203',
    name: 'Pringgasela',
  },
  {
    id: '5203060',
    regencyId: '5203',
    name: 'Sukamulia',
  },
  {
    id: '5203061',
    regencyId: '5203',
    name: 'Suralaga',
  },
  {
    id: '5203070',
    regencyId: '5203',
    name: 'Selong',
  },
  {
    id: '5203071',
    regencyId: '5203',
    name: 'Labuhan Haji',
  },
  {
    id: '5203080',
    regencyId: '5203',
    name: 'Pringgabaya',
  },
  {
    id: '5203081',
    regencyId: '5203',
    name: 'Suela',
  },
  {
    id: '5203090',
    regencyId: '5203',
    name: 'Aikmel',
  },
  {
    id: '5203091',
    regencyId: '5203',
    name: 'Wanasaba',
  },
  {
    id: '5203092',
    regencyId: '5203',
    name: 'Sembalun',
  },
  {
    id: '5203100',
    regencyId: '5203',
    name: 'Sambelia',
  },
  {
    id: '5204020',
    regencyId: '5204',
    name: 'Lunyuk',
  },
  {
    id: '5204021',
    regencyId: '5204',
    name: 'Orong Telu',
  },
  {
    id: '5204050',
    regencyId: '5204',
    name: 'Alas',
  },
  {
    id: '5204051',
    regencyId: '5204',
    name: 'Alas Barat',
  },
  {
    id: '5204052',
    regencyId: '5204',
    name: 'Buer',
  },
  {
    id: '5204061',
    regencyId: '5204',
    name: 'Utan',
  },
  {
    id: '5204062',
    regencyId: '5204',
    name: 'Rhee',
  },
  {
    id: '5204070',
    regencyId: '5204',
    name: 'Batulanteh',
  },
  {
    id: '5204080',
    regencyId: '5204',
    name: 'Sumbawa',
  },
  {
    id: '5204081',
    regencyId: '5204',
    name: 'Labuhan Badas',
  },
  {
    id: '5204082',
    regencyId: '5204',
    name: 'Unter Iwes',
  },
  {
    id: '5204090',
    regencyId: '5204',
    name: 'Moyohilir',
  },
  {
    id: '5204091',
    regencyId: '5204',
    name: 'Moyo Utara',
  },
  {
    id: '5204100',
    regencyId: '5204',
    name: 'Moyohulu',
  },
  {
    id: '5204110',
    regencyId: '5204',
    name: 'Ropang',
  },
  {
    id: '5204111',
    regencyId: '5204',
    name: 'Lenangguar',
  },
  {
    id: '5204112',
    regencyId: '5204',
    name: 'Lantung',
  },
  {
    id: '5204121',
    regencyId: '5204',
    name: 'Lape',
  },
  {
    id: '5204122',
    regencyId: '5204',
    name: 'Lopok',
  },
  {
    id: '5204130',
    regencyId: '5204',
    name: 'Plampang',
  },
  {
    id: '5204131',
    regencyId: '5204',
    name: 'Labangka',
  },
  {
    id: '5204132',
    regencyId: '5204',
    name: 'Maronge',
  },
  {
    id: '5204140',
    regencyId: '5204',
    name: 'Empang',
  },
  {
    id: '5204141',
    regencyId: '5204',
    name: 'Tarano',
  },
  {
    id: '5205010',
    regencyId: '5205',
    name: "Hu'U",
  },
  {
    id: '5205011',
    regencyId: '5205',
    name: 'Pajo',
  },
  {
    id: '5205020',
    regencyId: '5205',
    name: 'Dompu',
  },
  {
    id: '5205030',
    regencyId: '5205',
    name: 'Woja',
  },
  {
    id: '5205040',
    regencyId: '5205',
    name: 'Kilo',
  },
  {
    id: '5205050',
    regencyId: '5205',
    name: 'Kempo',
  },
  {
    id: '5205051',
    regencyId: '5205',
    name: 'Manggalewa',
  },
  {
    id: '5205060',
    regencyId: '5205',
    name: 'Pekat',
  },
  {
    id: '5206010',
    regencyId: '5206',
    name: 'Monta',
  },
  {
    id: '5206011',
    regencyId: '5206',
    name: 'Parado',
  },
  {
    id: '5206020',
    regencyId: '5206',
    name: 'Bolo',
  },
  {
    id: '5206021',
    regencyId: '5206',
    name: 'Mada Pangga',
  },
  {
    id: '5206030',
    regencyId: '5206',
    name: 'Woha',
  },
  {
    id: '5206040',
    regencyId: '5206',
    name: 'Belo',
  },
  {
    id: '5206041',
    regencyId: '5206',
    name: 'Palibelo',
  },
  {
    id: '5206050',
    regencyId: '5206',
    name: 'Wawo',
  },
  {
    id: '5206051',
    regencyId: '5206',
    name: 'Langgudu',
  },
  {
    id: '5206052',
    regencyId: '5206',
    name: 'Lambitu',
  },
  {
    id: '5206060',
    regencyId: '5206',
    name: 'Sape',
  },
  {
    id: '5206061',
    regencyId: '5206',
    name: 'Lambu',
  },
  {
    id: '5206070',
    regencyId: '5206',
    name: 'Wera',
  },
  {
    id: '5206071',
    regencyId: '5206',
    name: 'Ambalawi',
  },
  {
    id: '5206080',
    regencyId: '5206',
    name: 'Donggo',
  },
  {
    id: '5206081',
    regencyId: '5206',
    name: 'Soromandi',
  },
  {
    id: '5206090',
    regencyId: '5206',
    name: 'Sanggar',
  },
  {
    id: '5206091',
    regencyId: '5206',
    name: 'Tambora',
  },
  {
    id: '5207010',
    regencyId: '5207',
    name: 'Sekongkang',
  },
  {
    id: '5207020',
    regencyId: '5207',
    name: 'Jereweh',
  },
  {
    id: '5207021',
    regencyId: '5207',
    name: 'Maluk',
  },
  {
    id: '5207030',
    regencyId: '5207',
    name: 'Taliwang',
  },
  {
    id: '5207031',
    regencyId: '5207',
    name: 'Brang Ene',
  },
  {
    id: '5207040',
    regencyId: '5207',
    name: 'Brang Rea',
  },
  {
    id: '5207050',
    regencyId: '5207',
    name: 'Seteluk',
  },
  {
    id: '5207051',
    regencyId: '5207',
    name: 'Poto Tano',
  },
  {
    id: '5208010',
    regencyId: '5208',
    name: 'Pemenang',
  },
  {
    id: '5208020',
    regencyId: '5208',
    name: 'Tanjung',
  },
  {
    id: '5208030',
    regencyId: '5208',
    name: 'Gangga',
  },
  {
    id: '5208040',
    regencyId: '5208',
    name: 'Kayangan',
  },
  {
    id: '5208050',
    regencyId: '5208',
    name: 'Bayan',
  },
  {
    id: '5271010',
    regencyId: '5271',
    name: 'Ampenan',
  },
  {
    id: '5271011',
    regencyId: '5271',
    name: 'Sekarbela',
  },
  {
    id: '5271020',
    regencyId: '5271',
    name: 'Mataram',
  },
  {
    id: '5271021',
    regencyId: '5271',
    name: 'Selaparang',
  },
  {
    id: '5271030',
    regencyId: '5271',
    name: 'Cakranegara',
  },
  {
    id: '5271031',
    regencyId: '5271',
    name: 'Sandubaya',
  },
  {
    id: '5272010',
    regencyId: '5272',
    name: 'Rasanae Barat',
  },
  {
    id: '5272011',
    regencyId: '5272',
    name: 'Mpunda',
  },
  {
    id: '5272020',
    regencyId: '5272',
    name: 'Rasanae Timur',
  },
  {
    id: '5272021',
    regencyId: '5272',
    name: 'Raba',
  },
  {
    id: '5272030',
    regencyId: '5272',
    name: 'Asakota',
  },
  {
    id: '5301021',
    regencyId: '5301',
    name: 'Lamboya',
  },
  {
    id: '5301022',
    regencyId: '5301',
    name: 'Wanokaka',
  },
  {
    id: '5301023',
    regencyId: '5301',
    name: 'Laboya Barat',
  },
  {
    id: '5301050',
    regencyId: '5301',
    name: 'Loli',
  },
  {
    id: '5301060',
    regencyId: '5301',
    name: 'Kota Waikabubak',
  },
  {
    id: '5301072',
    regencyId: '5301',
    name: 'Tana Righu',
  },
  {
    id: '5302010',
    regencyId: '5302',
    name: 'Lewa',
  },
  {
    id: '5302011',
    regencyId: '5302',
    name: 'Nggaha Oriangu',
  },
  {
    id: '5302012',
    regencyId: '5302',
    name: 'Lewa Tidahu',
  },
  {
    id: '5302013',
    regencyId: '5302',
    name: 'Katala Hamu Lingu',
  },
  {
    id: '5302020',
    regencyId: '5302',
    name: 'Tabundung',
  },
  {
    id: '5302021',
    regencyId: '5302',
    name: 'Pinupahar',
  },
  {
    id: '5302030',
    regencyId: '5302',
    name: 'Paberiwai',
  },
  {
    id: '5302031',
    regencyId: '5302',
    name: 'Karera',
  },
  {
    id: '5302032',
    regencyId: '5302',
    name: 'Matawai La Pawu',
  },
  {
    id: '5302033',
    regencyId: '5302',
    name: 'Kahaungu Eti',
  },
  {
    id: '5302034',
    regencyId: '5302',
    name: 'Mahu',
  },
  {
    id: '5302035',
    regencyId: '5302',
    name: 'Ngadu Ngala',
  },
  {
    id: '5302040',
    regencyId: '5302',
    name: 'Pahunga Lodu',
  },
  {
    id: '5302041',
    regencyId: '5302',
    name: 'Wula Waijelu',
  },
  {
    id: '5302051',
    regencyId: '5302',
    name: 'Rindi',
  },
  {
    id: '5302052',
    regencyId: '5302',
    name: 'Umalulu',
  },
  {
    id: '5302060',
    regencyId: '5302',
    name: 'Pandawai',
  },
  {
    id: '5302061',
    regencyId: '5302',
    name: 'Kambata Mapambuhang',
  },
  {
    id: '5302070',
    regencyId: '5302',
    name: 'Kota Waingapu',
  },
  {
    id: '5302071',
    regencyId: '5302',
    name: 'Kambera',
  },
  {
    id: '5302080',
    regencyId: '5302',
    name: 'Haharu',
  },
  {
    id: '5302081',
    regencyId: '5302',
    name: 'Kanatang',
  },
  {
    id: '5303100',
    regencyId: '5303',
    name: 'Semau',
  },
  {
    id: '5303101',
    regencyId: '5303',
    name: 'Semau Selatan',
  },
  {
    id: '5303110',
    regencyId: '5303',
    name: 'Kupang Barat',
  },
  {
    id: '5303111',
    regencyId: '5303',
    name: 'Nekamese',
  },
  {
    id: '5303120',
    regencyId: '5303',
    name: 'Kupang Tengah',
  },
  {
    id: '5303121',
    regencyId: '5303',
    name: 'Taebenu',
  },
  {
    id: '5303130',
    regencyId: '5303',
    name: 'Amarasi',
  },
  {
    id: '5303131',
    regencyId: '5303',
    name: 'Amarasi Barat',
  },
  {
    id: '5303132',
    regencyId: '5303',
    name: 'Amarasi Selatan',
  },
  {
    id: '5303133',
    regencyId: '5303',
    name: 'Amarasi Timur',
  },
  {
    id: '5303140',
    regencyId: '5303',
    name: 'Kupang Timur',
  },
  {
    id: '5303141',
    regencyId: '5303',
    name: 'Amabi Oefeto Timur',
  },
  {
    id: '5303142',
    regencyId: '5303',
    name: 'Amabi Oefeto',
  },
  {
    id: '5303150',
    regencyId: '5303',
    name: 'Sulamu',
  },
  {
    id: '5303160',
    regencyId: '5303',
    name: 'Fatuleu',
  },
  {
    id: '5303161',
    regencyId: '5303',
    name: 'Fatuleu Tengah',
  },
  {
    id: '5303162',
    regencyId: '5303',
    name: 'Fatuleu Barat',
  },
  {
    id: '5303170',
    regencyId: '5303',
    name: 'Takari',
  },
  {
    id: '5303180',
    regencyId: '5303',
    name: 'Amfoang Selatan',
  },
  {
    id: '5303181',
    regencyId: '5303',
    name: 'Amfoang Barat Daya',
  },
  {
    id: '5303182',
    regencyId: '5303',
    name: 'Amfoang Tengah',
  },
  {
    id: '5303190',
    regencyId: '5303',
    name: 'Amfoang Utara',
  },
  {
    id: '5303191',
    regencyId: '5303',
    name: 'Amfoang Barat Laut',
  },
  {
    id: '5303192',
    regencyId: '5303',
    name: 'Amfoang Timur',
  },
  {
    id: '5304010',
    regencyId: '5304',
    name: 'Mollo Utara',
  },
  {
    id: '5304011',
    regencyId: '5304',
    name: 'Fatumnasi',
  },
  {
    id: '5304012',
    regencyId: '5304',
    name: 'Tobu',
  },
  {
    id: '5304013',
    regencyId: '5304',
    name: 'Nunbena',
  },
  {
    id: '5304020',
    regencyId: '5304',
    name: 'Mollo Selatan',
  },
  {
    id: '5304021',
    regencyId: '5304',
    name: 'Polen',
  },
  {
    id: '5304022',
    regencyId: '5304',
    name: 'Mollo Barat',
  },
  {
    id: '5304023',
    regencyId: '5304',
    name: 'Mollo Tengah',
  },
  {
    id: '5304030',
    regencyId: '5304',
    name: 'Kota Soe',
  },
  {
    id: '5304040',
    regencyId: '5304',
    name: 'Amanuban Barat',
  },
  {
    id: '5304041',
    regencyId: '5304',
    name: 'Batu Putih',
  },
  {
    id: '5304042',
    regencyId: '5304',
    name: 'Kuatnana',
  },
  {
    id: '5304050',
    regencyId: '5304',
    name: 'Amanuban Selatan',
  },
  {
    id: '5304051',
    regencyId: '5304',
    name: 'Noebeba',
  },
  {
    id: '5304060',
    regencyId: '5304',
    name: 'Kuan Fatu',
  },
  {
    id: '5304061',
    regencyId: '5304',
    name: 'Kualin',
  },
  {
    id: '5304070',
    regencyId: '5304',
    name: 'Amanuban Tengah',
  },
  {
    id: '5304071',
    regencyId: '5304',
    name: 'Kolbano',
  },
  {
    id: '5304072',
    regencyId: '5304',
    name: 'Oenino',
  },
  {
    id: '5304080',
    regencyId: '5304',
    name: 'Amanuban Timur',
  },
  {
    id: '5304081',
    regencyId: '5304',
    name: 'Fautmolo',
  },
  {
    id: '5304082',
    regencyId: '5304',
    name: 'Fatukopa',
  },
  {
    id: '5304090',
    regencyId: '5304',
    name: 'Kie',
  },
  {
    id: '5304091',
    regencyId: '5304',
    name: "Kot'Olin",
  },
  {
    id: '5304100',
    regencyId: '5304',
    name: 'Amanatun Selatan',
  },
  {
    id: '5304101',
    regencyId: '5304',
    name: 'Boking',
  },
  {
    id: '5304102',
    regencyId: '5304',
    name: 'Nunkolo',
  },
  {
    id: '5304103',
    regencyId: '5304',
    name: 'Noebana',
  },
  {
    id: '5304104',
    regencyId: '5304',
    name: 'Santian',
  },
  {
    id: '5304110',
    regencyId: '5304',
    name: 'Amanatun Utara',
  },
  {
    id: '5304111',
    regencyId: '5304',
    name: 'Toianas',
  },
  {
    id: '5304112',
    regencyId: '5304',
    name: 'Kokbaun',
  },
  {
    id: '5305010',
    regencyId: '5305',
    name: 'Miomaffo Barat',
  },
  {
    id: '5305011',
    regencyId: '5305',
    name: 'Miomaffo Tengah',
  },
  {
    id: '5305012',
    regencyId: '5305',
    name: 'Musi',
  },
  {
    id: '5305013',
    regencyId: '5305',
    name: 'Mutis',
  },
  {
    id: '5305020',
    regencyId: '5305',
    name: 'Miomaffo Timur',
  },
  {
    id: '5305021',
    regencyId: '5305',
    name: 'Noemuti',
  },
  {
    id: '5305022',
    regencyId: '5305',
    name: 'Bikomi Selatan',
  },
  {
    id: '5305023',
    regencyId: '5305',
    name: 'Bikomi Tengah',
  },
  {
    id: '5305024',
    regencyId: '5305',
    name: 'Bikomi Nilulat',
  },
  {
    id: '5305025',
    regencyId: '5305',
    name: 'Bikomi Utara',
  },
  {
    id: '5305026',
    regencyId: '5305',
    name: 'Naibenu',
  },
  {
    id: '5305027',
    regencyId: '5305',
    name: 'Noemuti Timur',
  },
  {
    id: '5305030',
    regencyId: '5305',
    name: 'Kota Kefamenanu',
  },
  {
    id: '5305040',
    regencyId: '5305',
    name: 'Insana',
  },
  {
    id: '5305041',
    regencyId: '5305',
    name: 'Insana Utara',
  },
  {
    id: '5305042',
    regencyId: '5305',
    name: 'Insana Barat',
  },
  {
    id: '5305043',
    regencyId: '5305',
    name: 'Insana Tengah',
  },
  {
    id: '5305044',
    regencyId: '5305',
    name: 'Insana Fafinesu',
  },
  {
    id: '5305050',
    regencyId: '5305',
    name: 'Biboki Selatan',
  },
  {
    id: '5305051',
    regencyId: '5305',
    name: 'Biboki Tanpah',
  },
  {
    id: '5305052',
    regencyId: '5305',
    name: 'Biboki Moenleu',
  },
  {
    id: '5305060',
    regencyId: '5305',
    name: 'Biboki Utara',
  },
  {
    id: '5305061',
    regencyId: '5305',
    name: 'Biboki Anleu',
  },
  {
    id: '5305062',
    regencyId: '5305',
    name: 'Biboki Feotleu',
  },
  {
    id: '5306032',
    regencyId: '5306',
    name: 'Rai Manuk',
  },
  {
    id: '5306050',
    regencyId: '5306',
    name: 'Tasifeto Barat',
  },
  {
    id: '5306051',
    regencyId: '5306',
    name: 'Kakuluk Mesak',
  },
  {
    id: '5306052',
    regencyId: '5306',
    name: 'Nanaet Dubesi',
  },
  {
    id: '5306060',
    regencyId: '5306',
    name: 'Atambua',
  },
  {
    id: '5306061',
    regencyId: '5306',
    name: 'Atambua Barat',
  },
  {
    id: '5306062',
    regencyId: '5306',
    name: 'Atambua Selatan',
  },
  {
    id: '5306070',
    regencyId: '5306',
    name: 'Tasifeto Timur',
  },
  {
    id: '5306071',
    regencyId: '5306',
    name: 'Raihat',
  },
  {
    id: '5306072',
    regencyId: '5306',
    name: 'Lasiolat',
  },
  {
    id: '5306080',
    regencyId: '5306',
    name: 'Lamaknen',
  },
  {
    id: '5306081',
    regencyId: '5306',
    name: 'Lamaknen Selatan',
  },
  {
    id: '5307010',
    regencyId: '5307',
    name: 'Pantar',
  },
  {
    id: '5307011',
    regencyId: '5307',
    name: 'Pantar Barat',
  },
  {
    id: '5307012',
    regencyId: '5307',
    name: 'Pantar Timur',
  },
  {
    id: '5307013',
    regencyId: '5307',
    name: 'Pantar Barat Laut',
  },
  {
    id: '5307014',
    regencyId: '5307',
    name: 'Pantar Tengah',
  },
  {
    id: '5307020',
    regencyId: '5307',
    name: 'Alor Barat Daya',
  },
  {
    id: '5307021',
    regencyId: '5307',
    name: 'Mataru',
  },
  {
    id: '5307030',
    regencyId: '5307',
    name: 'Alor Selatan',
  },
  {
    id: '5307040',
    regencyId: '5307',
    name: 'Alor Timur',
  },
  {
    id: '5307041',
    regencyId: '5307',
    name: 'Alor Timur Laut',
  },
  {
    id: '5307042',
    regencyId: '5307',
    name: 'Pureman',
  },
  {
    id: '5307050',
    regencyId: '5307',
    name: 'Teluk Mutiara',
  },
  {
    id: '5307051',
    regencyId: '5307',
    name: 'Kabola',
  },
  {
    id: '5307060',
    regencyId: '5307',
    name: 'Alor Barat Laut',
  },
  {
    id: '5307061',
    regencyId: '5307',
    name: 'Alor Tengah Utara',
  },
  {
    id: '5307062',
    regencyId: '5307',
    name: 'Pulau Pura',
  },
  {
    id: '5307063',
    regencyId: '5307',
    name: 'Lembur',
  },
  {
    id: '5308010',
    regencyId: '5308',
    name: 'Nagawutung',
  },
  {
    id: '5308011',
    regencyId: '5308',
    name: 'Wulandoni',
  },
  {
    id: '5308020',
    regencyId: '5308',
    name: 'Atadei',
  },
  {
    id: '5308030',
    regencyId: '5308',
    name: 'Ile Ape',
  },
  {
    id: '5308031',
    regencyId: '5308',
    name: 'Ile Ape Timur',
  },
  {
    id: '5308040',
    regencyId: '5308',
    name: 'Lebatukan',
  },
  {
    id: '5308050',
    regencyId: '5308',
    name: 'Nubatukan',
  },
  {
    id: '5308060',
    regencyId: '5308',
    name: 'Omesuri',
  },
  {
    id: '5308070',
    regencyId: '5308',
    name: 'Buyasari',
  },
  {
    id: '5309010',
    regencyId: '5309',
    name: 'Wulanggitang',
  },
  {
    id: '5309011',
    regencyId: '5309',
    name: 'Titehena',
  },
  {
    id: '5309012',
    regencyId: '5309',
    name: 'Ilebura',
  },
  {
    id: '5309020',
    regencyId: '5309',
    name: 'Tanjung Bunga',
  },
  {
    id: '5309021',
    regencyId: '5309',
    name: 'Lewo Lema',
  },
  {
    id: '5309030',
    regencyId: '5309',
    name: 'Larantuka',
  },
  {
    id: '5309031',
    regencyId: '5309',
    name: 'Ile Mandiri',
  },
  {
    id: '5309032',
    regencyId: '5309',
    name: 'Demon Pagong',
  },
  {
    id: '5309040',
    regencyId: '5309',
    name: 'Solor Barat',
  },
  {
    id: '5309041',
    regencyId: '5309',
    name: 'Solor Selatan',
  },
  {
    id: '5309050',
    regencyId: '5309',
    name: 'Solor Timur',
  },
  {
    id: '5309060',
    regencyId: '5309',
    name: 'Adonara Barat',
  },
  {
    id: '5309061',
    regencyId: '5309',
    name: 'Wotan Ulu Mado',
  },
  {
    id: '5309062',
    regencyId: '5309',
    name: 'Adonara Tengah',
  },
  {
    id: '5309070',
    regencyId: '5309',
    name: 'Adonara Timur',
  },
  {
    id: '5309071',
    regencyId: '5309',
    name: 'Ile Boleng',
  },
  {
    id: '5309072',
    regencyId: '5309',
    name: 'Witihama',
  },
  {
    id: '5309073',
    regencyId: '5309',
    name: 'Kelubagolit',
  },
  {
    id: '5309074',
    regencyId: '5309',
    name: 'Adonara',
  },
  {
    id: '5310010',
    regencyId: '5310',
    name: 'Paga',
  },
  {
    id: '5310011',
    regencyId: '5310',
    name: 'Mego',
  },
  {
    id: '5310012',
    regencyId: '5310',
    name: 'Tana Wawo',
  },
  {
    id: '5310020',
    regencyId: '5310',
    name: 'Lela',
  },
  {
    id: '5310030',
    regencyId: '5310',
    name: 'Bola',
  },
  {
    id: '5310031',
    regencyId: '5310',
    name: 'Doreng',
  },
  {
    id: '5310032',
    regencyId: '5310',
    name: 'Mapitara',
  },
  {
    id: '5310040',
    regencyId: '5310',
    name: 'Talibura',
  },
  {
    id: '5310041',
    regencyId: '5310',
    name: 'Waigete',
  },
  {
    id: '5310042',
    regencyId: '5310',
    name: 'Waiblama',
  },
  {
    id: '5310050',
    regencyId: '5310',
    name: 'Kewapante',
  },
  {
    id: '5310051',
    regencyId: '5310',
    name: 'Hewokloang',
  },
  {
    id: '5310052',
    regencyId: '5310',
    name: 'Kangae',
  },
  {
    id: '5310061',
    regencyId: '5310',
    name: 'Palue',
  },
  {
    id: '5310062',
    regencyId: '5310',
    name: 'Koting',
  },
  {
    id: '5310063',
    regencyId: '5310',
    name: 'Nelle',
  },
  {
    id: '5310070',
    regencyId: '5310',
    name: 'Nita',
  },
  {
    id: '5310071',
    regencyId: '5310',
    name: 'Magepanda',
  },
  {
    id: '5310080',
    regencyId: '5310',
    name: 'Alok',
  },
  {
    id: '5310081',
    regencyId: '5310',
    name: 'Alok Barat',
  },
  {
    id: '5310082',
    regencyId: '5310',
    name: 'Alok Timur',
  },
  {
    id: '5311010',
    regencyId: '5311',
    name: 'Nangapanda',
  },
  {
    id: '5311011',
    regencyId: '5311',
    name: 'Pulau Ende',
  },
  {
    id: '5311012',
    regencyId: '5311',
    name: 'Maukaro',
  },
  {
    id: '5311020',
    regencyId: '5311',
    name: 'Ende',
  },
  {
    id: '5311030',
    regencyId: '5311',
    name: 'Ende Selatan',
  },
  {
    id: '5311031',
    regencyId: '5311',
    name: 'Ende Timur',
  },
  {
    id: '5311032',
    regencyId: '5311',
    name: 'Ende Tengah',
  },
  {
    id: '5311033',
    regencyId: '5311',
    name: 'Ende Utara',
  },
  {
    id: '5311040',
    regencyId: '5311',
    name: 'Ndona',
  },
  {
    id: '5311041',
    regencyId: '5311',
    name: 'Ndona Timur',
  },
  {
    id: '5311050',
    regencyId: '5311',
    name: 'Wolowaru',
  },
  {
    id: '5311051',
    regencyId: '5311',
    name: 'Wolojita',
  },
  {
    id: '5311052',
    regencyId: '5311',
    name: 'Lio Timur',
  },
  {
    id: '5311053',
    regencyId: '5311',
    name: 'Kelimutu',
  },
  {
    id: '5311054',
    regencyId: '5311',
    name: 'Ndori',
  },
  {
    id: '5311060',
    regencyId: '5311',
    name: 'Maurole',
  },
  {
    id: '5311061',
    regencyId: '5311',
    name: 'Kotabaru',
  },
  {
    id: '5311062',
    regencyId: '5311',
    name: 'Detukeli',
  },
  {
    id: '5311063',
    regencyId: '5311',
    name: 'Lepembusu Kelisoke',
  },
  {
    id: '5311070',
    regencyId: '5311',
    name: 'Detusoko',
  },
  {
    id: '5311071',
    regencyId: '5311',
    name: 'Wewaria',
  },
  {
    id: '5312010',
    regencyId: '5312',
    name: 'Aimere',
  },
  {
    id: '5312011',
    regencyId: '5312',
    name: 'Jerebuu',
  },
  {
    id: '5312012',
    regencyId: '5312',
    name: 'Inerie',
  },
  {
    id: '5312020',
    regencyId: '5312',
    name: 'Bajawa',
  },
  {
    id: '5312030',
    regencyId: '5312',
    name: 'Golewa',
  },
  {
    id: '5312031',
    regencyId: '5312',
    name: 'Golewa Selatan',
  },
  {
    id: '5312032',
    regencyId: '5312',
    name: 'Golewa Barat',
  },
  {
    id: '5312070',
    regencyId: '5312',
    name: 'Bajawa Utara',
  },
  {
    id: '5312071',
    regencyId: '5312',
    name: 'Soa',
  },
  {
    id: '5312080',
    regencyId: '5312',
    name: 'Riung',
  },
  {
    id: '5312081',
    regencyId: '5312',
    name: 'Riung Barat',
  },
  {
    id: '5312082',
    regencyId: '5312',
    name: 'Wolomeze',
  },
  {
    id: '5313040',
    regencyId: '5313',
    name: 'Satar Mese',
  },
  {
    id: '5313041',
    regencyId: '5313',
    name: 'Satar Mese Barat',
  },
  {
    id: '5313042',
    regencyId: '5313',
    name: 'Satar Mese Utara',
  },
  {
    id: '5313110',
    regencyId: '5313',
    name: 'Langke Rembong',
  },
  {
    id: '5313120',
    regencyId: '5313',
    name: 'Ruteng',
  },
  {
    id: '5313121',
    regencyId: '5313',
    name: 'Wae Rii',
  },
  {
    id: '5313122',
    regencyId: '5313',
    name: 'Lelak',
  },
  {
    id: '5313123',
    regencyId: '5313',
    name: 'Rahong Utara',
  },
  {
    id: '5313130',
    regencyId: '5313',
    name: 'Cibal',
  },
  {
    id: '5313131',
    regencyId: '5313',
    name: 'Cibal Barat',
  },
  {
    id: '5313140',
    regencyId: '5313',
    name: 'Reok',
  },
  {
    id: '5313141',
    regencyId: '5313',
    name: 'Reok Barat',
  },
  {
    id: '5314010',
    regencyId: '5314',
    name: 'Rote Barat Daya',
  },
  {
    id: '5314020',
    regencyId: '5314',
    name: 'Rote Barat Laut',
  },
  {
    id: '5314030',
    regencyId: '5314',
    name: 'Lobalain',
  },
  {
    id: '5314040',
    regencyId: '5314',
    name: 'Rote Tengah',
  },
  {
    id: '5314041',
    regencyId: '5314',
    name: 'Rote Selatan',
  },
  {
    id: '5314050',
    regencyId: '5314',
    name: 'Pantai Baru',
  },
  {
    id: '5314060',
    regencyId: '5314',
    name: 'Rote Timur',
  },
  {
    id: '5314061',
    regencyId: '5314',
    name: 'Landu Leko',
  },
  {
    id: '5314070',
    regencyId: '5314',
    name: 'Rote Barat',
  },
  {
    id: '5314071',
    regencyId: '5314',
    name: 'Ndao Nuse',
  },
  {
    id: '5315010',
    regencyId: '5315',
    name: 'Komodo',
  },
  {
    id: '5315011',
    regencyId: '5315',
    name: 'Boleng',
  },
  {
    id: '5315020',
    regencyId: '5315',
    name: 'Sano Nggoang',
  },
  {
    id: '5315021',
    regencyId: '5315',
    name: 'Mbeliling',
  },
  {
    id: '5315030',
    regencyId: '5315',
    name: 'Lembor',
  },
  {
    id: '5315031',
    regencyId: '5315',
    name: 'Welak',
  },
  {
    id: '5315032',
    regencyId: '5315',
    name: 'Lembor Selatan',
  },
  {
    id: '5315040',
    regencyId: '5315',
    name: 'Kuwus',
  },
  {
    id: '5315041',
    regencyId: '5315',
    name: 'Ndoso',
  },
  {
    id: '5315050',
    regencyId: '5315',
    name: 'Macang Pacar',
  },
  {
    id: '5316010',
    regencyId: '5316',
    name: 'Katikutana',
  },
  {
    id: '5316011',
    regencyId: '5316',
    name: 'Katikutana Selatan',
  },
  {
    id: '5316020',
    regencyId: '5316',
    name: 'Umbu Ratu Nggay Barat',
  },
  {
    id: '5316030',
    regencyId: '5316',
    name: 'Umbu Ratu Nggay',
  },
  {
    id: '5316040',
    regencyId: '5316',
    name: 'Mamboro',
  },
  {
    id: '5317010',
    regencyId: '5317',
    name: 'Kodi Bangedo',
  },
  {
    id: '5317011',
    regencyId: '5317',
    name: 'Kodi Balaghar',
  },
  {
    id: '5317020',
    regencyId: '5317',
    name: 'Kodi',
  },
  {
    id: '5317030',
    regencyId: '5317',
    name: 'Kodi Utara',
  },
  {
    id: '5317040',
    regencyId: '5317',
    name: 'Wewewa Selatan',
  },
  {
    id: '5317050',
    regencyId: '5317',
    name: 'Wewewa Barat',
  },
  {
    id: '5317060',
    regencyId: '5317',
    name: 'Wewewa Timur',
  },
  {
    id: '5317061',
    regencyId: '5317',
    name: 'Wewewa Tengah',
  },
  {
    id: '5317070',
    regencyId: '5317',
    name: 'Wewewa Utara',
  },
  {
    id: '5317080',
    regencyId: '5317',
    name: 'Loura',
  },
  {
    id: '5317081',
    regencyId: '5317',
    name: 'Kota Tambolaka',
  },
  {
    id: '5318010',
    regencyId: '5318',
    name: 'Mauponggo',
  },
  {
    id: '5318020',
    regencyId: '5318',
    name: 'Keo Tengah',
  },
  {
    id: '5318030',
    regencyId: '5318',
    name: 'Nangaroro',
  },
  {
    id: '5318040',
    regencyId: '5318',
    name: 'Boawae',
  },
  {
    id: '5318050',
    regencyId: '5318',
    name: 'Aesesa Selatan',
  },
  {
    id: '5318060',
    regencyId: '5318',
    name: 'Aesesa',
  },
  {
    id: '5318070',
    regencyId: '5318',
    name: 'Wolowae',
  },
  {
    id: '5319010',
    regencyId: '5319',
    name: 'Borong',
  },
  {
    id: '5319011',
    regencyId: '5319',
    name: 'Rana Mese',
  },
  {
    id: '5319020',
    regencyId: '5319',
    name: 'Kota Komba',
  },
  {
    id: '5319030',
    regencyId: '5319',
    name: 'Elar',
  },
  {
    id: '5319031',
    regencyId: '5319',
    name: 'Elar Selatan',
  },
  {
    id: '5319040',
    regencyId: '5319',
    name: 'Sambi Rampas',
  },
  {
    id: '5319050',
    regencyId: '5319',
    name: 'Poco Ranaka',
  },
  {
    id: '5319051',
    regencyId: '5319',
    name: 'Poco Ranaka Timur',
  },
  {
    id: '5319060',
    regencyId: '5319',
    name: 'Lamba Leda',
  },
  {
    id: '5320010',
    regencyId: '5320',
    name: 'Raijua',
  },
  {
    id: '5320020',
    regencyId: '5320',
    name: 'Hawu Mehara',
  },
  {
    id: '5320030',
    regencyId: '5320',
    name: 'Sabu Liae',
  },
  {
    id: '5320040',
    regencyId: '5320',
    name: 'Sabu Barat',
  },
  {
    id: '5320050',
    regencyId: '5320',
    name: 'Sabu Tengah',
  },
  {
    id: '5320060',
    regencyId: '5320',
    name: 'Sabu Timur',
  },
  {
    id: '5321010',
    regencyId: '5321',
    name: 'Wewiku',
  },
  {
    id: '5321020',
    regencyId: '5321',
    name: 'Malaka Barat',
  },
  {
    id: '5321030',
    regencyId: '5321',
    name: 'Weliman',
  },
  {
    id: '5321040',
    regencyId: '5321',
    name: 'Rinhat',
  },
  {
    id: '5321050',
    regencyId: '5321',
    name: 'Io Kufeu',
  },
  {
    id: '5321060',
    regencyId: '5321',
    name: 'Sasita Mean',
  },
  {
    id: '5321070',
    regencyId: '5321',
    name: 'Malaka Tengah',
  },
  {
    id: '5321080',
    regencyId: '5321',
    name: 'Botin Leobele',
  },
  {
    id: '5321090',
    regencyId: '5321',
    name: 'Laen Manen',
  },
  {
    id: '5321100',
    regencyId: '5321',
    name: 'Malaka Timur',
  },
  {
    id: '5321110',
    regencyId: '5321',
    name: 'Kobalima',
  },
  {
    id: '5321120',
    regencyId: '5321',
    name: 'Kobalima Timur',
  },
  {
    id: '5371010',
    regencyId: '5371',
    name: 'Alak',
  },
  {
    id: '5371020',
    regencyId: '5371',
    name: 'Maulafa',
  },
  {
    id: '5371030',
    regencyId: '5371',
    name: 'Oebobo',
  },
  {
    id: '5371031',
    regencyId: '5371',
    name: 'Kota Raja',
  },
  {
    id: '5371040',
    regencyId: '5371',
    name: 'Kelapa Lima',
  },
  {
    id: '5371041',
    regencyId: '5371',
    name: 'Kota Lama',
  },
  {
    id: '6101010',
    regencyId: '6101',
    name: 'Selakau',
  },
  {
    id: '6101011',
    regencyId: '6101',
    name: 'Selakau Timur',
  },
  {
    id: '6101020',
    regencyId: '6101',
    name: 'Pemangkat',
  },
  {
    id: '6101021',
    regencyId: '6101',
    name: 'Semparuk',
  },
  {
    id: '6101022',
    regencyId: '6101',
    name: 'Salatiga',
  },
  {
    id: '6101030',
    regencyId: '6101',
    name: 'Tebas',
  },
  {
    id: '6101031',
    regencyId: '6101',
    name: 'Tekarang',
  },
  {
    id: '6101040',
    regencyId: '6101',
    name: 'Sambas',
  },
  {
    id: '6101041',
    regencyId: '6101',
    name: 'Subah',
  },
  {
    id: '6101042',
    regencyId: '6101',
    name: 'Sebawi',
  },
  {
    id: '6101043',
    regencyId: '6101',
    name: 'Sajad',
  },
  {
    id: '6101050',
    regencyId: '6101',
    name: 'Jawai',
  },
  {
    id: '6101051',
    regencyId: '6101',
    name: 'Jawai Selatan',
  },
  {
    id: '6101060',
    regencyId: '6101',
    name: 'Teluk Keramat',
  },
  {
    id: '6101061',
    regencyId: '6101',
    name: 'Galing',
  },
  {
    id: '6101062',
    regencyId: '6101',
    name: 'Tangaran',
  },
  {
    id: '6101070',
    regencyId: '6101',
    name: 'Sejangkung',
  },
  {
    id: '6101080',
    regencyId: '6101',
    name: 'Sajingan Besar',
  },
  {
    id: '6101090',
    regencyId: '6101',
    name: 'Paloh',
  },
  {
    id: '6102010',
    regencyId: '6102',
    name: 'Sungai Raya',
  },
  {
    id: '6102011',
    regencyId: '6102',
    name: 'Capkala',
  },
  {
    id: '6102012',
    regencyId: '6102',
    name: 'Sungai Raya Kepulauan',
  },
  {
    id: '6102030',
    regencyId: '6102',
    name: 'Samalantan',
  },
  {
    id: '6102031',
    regencyId: '6102',
    name: 'Monterado',
  },
  {
    id: '6102032',
    regencyId: '6102',
    name: 'Lembah Bawang',
  },
  {
    id: '6102040',
    regencyId: '6102',
    name: 'Bengkayang',
  },
  {
    id: '6102041',
    regencyId: '6102',
    name: 'Teriak',
  },
  {
    id: '6102042',
    regencyId: '6102',
    name: 'Sungai Betung',
  },
  {
    id: '6102050',
    regencyId: '6102',
    name: 'Ledo',
  },
  {
    id: '6102051',
    regencyId: '6102',
    name: 'Suti Semarang',
  },
  {
    id: '6102052',
    regencyId: '6102',
    name: 'Lumar',
  },
  {
    id: '6102060',
    regencyId: '6102',
    name: 'Sanggau Ledo',
  },
  {
    id: '6102061',
    regencyId: '6102',
    name: 'Tujuhbelas',
  },
  {
    id: '6102070',
    regencyId: '6102',
    name: 'Seluas',
  },
  {
    id: '6102080',
    regencyId: '6102',
    name: 'Jagoi Babang',
  },
  {
    id: '6102081',
    regencyId: '6102',
    name: 'Siding',
  },
  {
    id: '6103020',
    regencyId: '6103',
    name: 'Sebangki',
  },
  {
    id: '6103030',
    regencyId: '6103',
    name: 'Ngabang',
  },
  {
    id: '6103031',
    regencyId: '6103',
    name: 'Jelimpo',
  },
  {
    id: '6103040',
    regencyId: '6103',
    name: 'Sengah Temila',
  },
  {
    id: '6103050',
    regencyId: '6103',
    name: 'Mandor',
  },
  {
    id: '6103060',
    regencyId: '6103',
    name: 'Menjalin',
  },
  {
    id: '6103070',
    regencyId: '6103',
    name: 'Mempawah Hulu',
  },
  {
    id: '6103071',
    regencyId: '6103',
    name: 'Sompak',
  },
  {
    id: '6103080',
    regencyId: '6103',
    name: 'Menyuke',
  },
  {
    id: '6103081',
    regencyId: '6103',
    name: 'Banyuke Hulu',
  },
  {
    id: '6103090',
    regencyId: '6103',
    name: 'Meranti',
  },
  {
    id: '6103100',
    regencyId: '6103',
    name: 'Kuala Behe',
  },
  {
    id: '6103110',
    regencyId: '6103',
    name: 'Air Besar',
  },
  {
    id: '6104080',
    regencyId: '6104',
    name: 'Siantan',
  },
  {
    id: '6104081',
    regencyId: '6104',
    name: 'Segedong',
  },
  {
    id: '6104090',
    regencyId: '6104',
    name: 'Sungai Pinyuh',
  },
  {
    id: '6104091',
    regencyId: '6104',
    name: 'Anjongan',
  },
  {
    id: '6104100',
    regencyId: '6104',
    name: 'Mempawah Hilir',
  },
  {
    id: '6104101',
    regencyId: '6104',
    name: 'Mempawah Timur',
  },
  {
    id: '6104110',
    regencyId: '6104',
    name: 'Sungai Kunyit',
  },
  {
    id: '6104120',
    regencyId: '6104',
    name: 'Toho',
  },
  {
    id: '6104121',
    regencyId: '6104',
    name: 'Sadaniang',
  },
  {
    id: '6105010',
    regencyId: '6105',
    name: 'Toba',
  },
  {
    id: '6105020',
    regencyId: '6105',
    name: 'Meliau',
  },
  {
    id: '6105060',
    regencyId: '6105',
    name: 'Kapuas',
  },
  {
    id: '6105070',
    regencyId: '6105',
    name: 'Mukok',
  },
  {
    id: '6105120',
    regencyId: '6105',
    name: 'Jangkang',
  },
  {
    id: '6105130',
    regencyId: '6105',
    name: 'Bonti',
  },
  {
    id: '6105140',
    regencyId: '6105',
    name: 'Parindu',
  },
  {
    id: '6105150',
    regencyId: '6105',
    name: 'Tayan Hilir',
  },
  {
    id: '6105160',
    regencyId: '6105',
    name: 'Balai',
  },
  {
    id: '6105170',
    regencyId: '6105',
    name: 'Tayan Hulu',
  },
  {
    id: '6105180',
    regencyId: '6105',
    name: 'Kembayan',
  },
  {
    id: '6105190',
    regencyId: '6105',
    name: 'Beduwai',
  },
  {
    id: '6105200',
    regencyId: '6105',
    name: 'Noyan',
  },
  {
    id: '6105210',
    regencyId: '6105',
    name: 'Sekayam',
  },
  {
    id: '6105220',
    regencyId: '6105',
    name: 'Entikong',
  },
  {
    id: '6106010',
    regencyId: '6106',
    name: 'Kendawangan',
  },
  {
    id: '6106020',
    regencyId: '6106',
    name: 'Manis Mata',
  },
  {
    id: '6106030',
    regencyId: '6106',
    name: 'Marau',
  },
  {
    id: '6106031',
    regencyId: '6106',
    name: 'Singkup',
  },
  {
    id: '6106032',
    regencyId: '6106',
    name: 'Air Upas',
  },
  {
    id: '6106040',
    regencyId: '6106',
    name: 'Jelai Hulu',
  },
  {
    id: '6106050',
    regencyId: '6106',
    name: 'Tumbang Titi',
  },
  {
    id: '6106051',
    regencyId: '6106',
    name: 'Pemahan',
  },
  {
    id: '6106052',
    regencyId: '6106',
    name: 'Sungai Melayu Rayak',
  },
  {
    id: '6106060',
    regencyId: '6106',
    name: 'Matan Hilir Selatan',
  },
  {
    id: '6106061',
    regencyId: '6106',
    name: 'Benua Kayong',
  },
  {
    id: '6106070',
    regencyId: '6106',
    name: 'Matan Hilir Utara',
  },
  {
    id: '6106071',
    regencyId: '6106',
    name: 'Delta Pawan',
  },
  {
    id: '6106072',
    regencyId: '6106',
    name: 'Muara Pawan',
  },
  {
    id: '6106090',
    regencyId: '6106',
    name: 'Nanga Tayap',
  },
  {
    id: '6106100',
    regencyId: '6106',
    name: 'Sandai',
  },
  {
    id: '6106101',
    regencyId: '6106',
    name: 'Hulu Sungai',
  },
  {
    id: '6106110',
    regencyId: '6106',
    name: 'Sungai Laur',
  },
  {
    id: '6106120',
    regencyId: '6106',
    name: 'Simpang Hulu',
  },
  {
    id: '6106121',
    regencyId: '6106',
    name: 'Simpang Dua',
  },
  {
    id: '6107060',
    regencyId: '6107',
    name: 'Serawai',
  },
  {
    id: '6107070',
    regencyId: '6107',
    name: 'Ambalau',
  },
  {
    id: '6107080',
    regencyId: '6107',
    name: 'Kayan Hulu',
  },
  {
    id: '6107110',
    regencyId: '6107',
    name: 'Sepauk',
  },
  {
    id: '6107120',
    regencyId: '6107',
    name: 'Tempunak',
  },
  {
    id: '6107130',
    regencyId: '6107',
    name: 'Sungai Tebelian',
  },
  {
    id: '6107140',
    regencyId: '6107',
    name: 'Sintang',
  },
  {
    id: '6107150',
    regencyId: '6107',
    name: 'Dedai',
  },
  {
    id: '6107160',
    regencyId: '6107',
    name: 'Kayan Hilir',
  },
  {
    id: '6107170',
    regencyId: '6107',
    name: 'Kelam Permai',
  },
  {
    id: '6107180',
    regencyId: '6107',
    name: 'Binjai Hulu',
  },
  {
    id: '6107190',
    regencyId: '6107',
    name: 'Ketungau Hilir',
  },
  {
    id: '6107200',
    regencyId: '6107',
    name: 'Ketungau Tengah',
  },
  {
    id: '6107210',
    regencyId: '6107',
    name: 'Ketungau Hulu',
  },
  {
    id: '6108010',
    regencyId: '6108',
    name: 'Silat Hilir',
  },
  {
    id: '6108020',
    regencyId: '6108',
    name: 'Silat Hulu',
  },
  {
    id: '6108030',
    regencyId: '6108',
    name: 'Hulu Gurung',
  },
  {
    id: '6108040',
    regencyId: '6108',
    name: 'Bunut Hulu',
  },
  {
    id: '6108050',
    regencyId: '6108',
    name: 'Mentebah',
  },
  {
    id: '6108060',
    regencyId: '6108',
    name: 'Bika',
  },
  {
    id: '6108070',
    regencyId: '6108',
    name: 'Kalis',
  },
  {
    id: '6108080',
    regencyId: '6108',
    name: 'Putussibau Selatan',
  },
  {
    id: '6108090',
    regencyId: '6108',
    name: 'Embaloh Hilir',
  },
  {
    id: '6108100',
    regencyId: '6108',
    name: 'Bunut Hilir',
  },
  {
    id: '6108110',
    regencyId: '6108',
    name: 'Boyan Tanjung',
  },
  {
    id: '6108120',
    regencyId: '6108',
    name: 'Pengkadan',
  },
  {
    id: '6108130',
    regencyId: '6108',
    name: 'Jongkong',
  },
  {
    id: '6108140',
    regencyId: '6108',
    name: 'Selimbau',
  },
  {
    id: '6108150',
    regencyId: '6108',
    name: 'Suhaid',
  },
  {
    id: '6108160',
    regencyId: '6108',
    name: 'Seberuang',
  },
  {
    id: '6108170',
    regencyId: '6108',
    name: 'Semitau',
  },
  {
    id: '6108180',
    regencyId: '6108',
    name: 'Empanang',
  },
  {
    id: '6108190',
    regencyId: '6108',
    name: 'Puring Kencana',
  },
  {
    id: '6108200',
    regencyId: '6108',
    name: 'Badau',
  },
  {
    id: '6108210',
    regencyId: '6108',
    name: 'Batang Lupar',
  },
  {
    id: '6108220',
    regencyId: '6108',
    name: 'Embaloh Hulu',
  },
  {
    id: '6108230',
    regencyId: '6108',
    name: 'Putussibau Utara',
  },
  {
    id: '6109010',
    regencyId: '6109',
    name: 'Nanga Mahap',
  },
  {
    id: '6109020',
    regencyId: '6109',
    name: 'Nanga Taman',
  },
  {
    id: '6109030',
    regencyId: '6109',
    name: 'Sekadau Hulu',
  },
  {
    id: '6109040',
    regencyId: '6109',
    name: 'Sekadau Hilir',
  },
  {
    id: '6109050',
    regencyId: '6109',
    name: 'Belitang Hilir',
  },
  {
    id: '6109060',
    regencyId: '6109',
    name: 'Belitang',
  },
  {
    id: '6109070',
    regencyId: '6109',
    name: 'Belitang Hulu',
  },
  {
    id: '6110010',
    regencyId: '6110',
    name: 'Sokan',
  },
  {
    id: '6110020',
    regencyId: '6110',
    name: 'Tanah Pinoh',
  },
  {
    id: '6110021',
    regencyId: '6110',
    name: 'Tanah Pinoh Barat',
  },
  {
    id: '6110030',
    regencyId: '6110',
    name: 'Sayan',
  },
  {
    id: '6110040',
    regencyId: '6110',
    name: 'Belimbing',
  },
  {
    id: '6110041',
    regencyId: '6110',
    name: 'Belimbing Hulu',
  },
  {
    id: '6110050',
    regencyId: '6110',
    name: 'Nanga Pinoh',
  },
  {
    id: '6110051',
    regencyId: '6110',
    name: 'Pinoh Selatan',
  },
  {
    id: '6110052',
    regencyId: '6110',
    name: 'Pinoh Utara',
  },
  {
    id: '6110060',
    regencyId: '6110',
    name: 'Ella Hilir',
  },
  {
    id: '6110070',
    regencyId: '6110',
    name: 'Menukung',
  },
  {
    id: '6111010',
    regencyId: '6111',
    name: 'Pulau Maya',
  },
  {
    id: '6111011',
    regencyId: '6111',
    name: 'Kepulauan Karimata',
  },
  {
    id: '6111020',
    regencyId: '6111',
    name: 'Sukadana',
  },
  {
    id: '6111030',
    regencyId: '6111',
    name: 'Simpang Hilir',
  },
  {
    id: '6111040',
    regencyId: '6111',
    name: 'Teluk Batang',
  },
  {
    id: '6111050',
    regencyId: '6111',
    name: 'Seponti',
  },
  {
    id: '6112010',
    regencyId: '6112',
    name: 'Batu Ampar',
  },
  {
    id: '6112020',
    regencyId: '6112',
    name: 'Terentang',
  },
  {
    id: '6112030',
    regencyId: '6112',
    name: 'Kubu',
  },
  {
    id: '6112040',
    regencyId: '6112',
    name: "Telok Pa'Kedai",
  },
  {
    id: '6112050',
    regencyId: '6112',
    name: 'Sungai Kakap',
  },
  {
    id: '6112060',
    regencyId: '6112',
    name: 'Rasau Jaya',
  },
  {
    id: '6112070',
    regencyId: '6112',
    name: 'Sungai Raya',
  },
  {
    id: '6112080',
    regencyId: '6112',
    name: 'Sungai Ambawang',
  },
  {
    id: '6112090',
    regencyId: '6112',
    name: 'Kuala Mandor-B',
  },
  {
    id: '6171010',
    regencyId: '6171',
    name: 'Pontianak Selatan',
  },
  {
    id: '6171011',
    regencyId: '6171',
    name: 'Pontianak Tenggara',
  },
  {
    id: '6171020',
    regencyId: '6171',
    name: 'Pontianak Timur',
  },
  {
    id: '6171030',
    regencyId: '6171',
    name: 'Pontianak Barat',
  },
  {
    id: '6171031',
    regencyId: '6171',
    name: 'Pontianak Kota',
  },
  {
    id: '6171040',
    regencyId: '6171',
    name: 'Pontianak Utara',
  },
  {
    id: '6172010',
    regencyId: '6172',
    name: 'Singkawang Selatan',
  },
  {
    id: '6172020',
    regencyId: '6172',
    name: 'Singkawang Timur',
  },
  {
    id: '6172030',
    regencyId: '6172',
    name: 'Singkawang Utara',
  },
  {
    id: '6172040',
    regencyId: '6172',
    name: 'Singkawang Barat',
  },
  {
    id: '6172050',
    regencyId: '6172',
    name: 'Singkawang Tengah',
  },
  {
    id: '6201040',
    regencyId: '6201',
    name: 'Kotawaringin Lama',
  },
  {
    id: '6201050',
    regencyId: '6201',
    name: 'Arut Selatan',
  },
  {
    id: '6201060',
    regencyId: '6201',
    name: 'Kumai',
  },
  {
    id: '6201061',
    regencyId: '6201',
    name: 'Pangkalan Banteng',
  },
  {
    id: '6201062',
    regencyId: '6201',
    name: 'Pangkalan Lada',
  },
  {
    id: '6201070',
    regencyId: '6201',
    name: 'Arut Utara',
  },
  {
    id: '6202020',
    regencyId: '6202',
    name: 'Mentaya Hilir Selatan',
  },
  {
    id: '6202021',
    regencyId: '6202',
    name: 'Teluk Sampit',
  },
  {
    id: '6202050',
    regencyId: '6202',
    name: 'Pulau Hanaut',
  },
  {
    id: '6202060',
    regencyId: '6202',
    name: 'Mentawa Baru/Ketapang',
  },
  {
    id: '6202061',
    regencyId: '6202',
    name: 'Seranau',
  },
  {
    id: '6202070',
    regencyId: '6202',
    name: 'Mentaya Hilir Utara',
  },
  {
    id: '6202110',
    regencyId: '6202',
    name: 'Kota Besi',
  },
  {
    id: '6202111',
    regencyId: '6202',
    name: 'Telawang',
  },
  {
    id: '6202120',
    regencyId: '6202',
    name: 'Baamang',
  },
  {
    id: '6202190',
    regencyId: '6202',
    name: 'Cempaga',
  },
  {
    id: '6202191',
    regencyId: '6202',
    name: 'Cempaga Hulu',
  },
  {
    id: '6202200',
    regencyId: '6202',
    name: 'Parenggean',
  },
  {
    id: '6202201',
    regencyId: '6202',
    name: 'Tualan Hulu',
  },
  {
    id: '6202210',
    regencyId: '6202',
    name: 'Mentaya Hulu',
  },
  {
    id: '6202211',
    regencyId: '6202',
    name: 'Bukit Santuai',
  },
  {
    id: '6202230',
    regencyId: '6202',
    name: 'Antang Kalang',
  },
  {
    id: '6202231',
    regencyId: '6202',
    name: 'Telaga Antang',
  },
  {
    id: '6203020',
    regencyId: '6203',
    name: 'Kapuas Kuala',
  },
  {
    id: '6203021',
    regencyId: '6203',
    name: 'Tamban Catur',
  },
  {
    id: '6203030',
    regencyId: '6203',
    name: 'Kapuas Timur',
  },
  {
    id: '6203040',
    regencyId: '6203',
    name: 'Selat',
  },
  {
    id: '6203041',
    regencyId: '6203',
    name: 'Bataguh',
  },
  {
    id: '6203070',
    regencyId: '6203',
    name: 'Basarang',
  },
  {
    id: '6203080',
    regencyId: '6203',
    name: 'Kapuas Hilir',
  },
  {
    id: '6203090',
    regencyId: '6203',
    name: 'Pulau Petak',
  },
  {
    id: '6203100',
    regencyId: '6203',
    name: 'Kapuas Murung',
  },
  {
    id: '6203101',
    regencyId: '6203',
    name: 'Dadahup',
  },
  {
    id: '6203110',
    regencyId: '6203',
    name: 'Kapuas Barat',
  },
  {
    id: '6203150',
    regencyId: '6203',
    name: 'Mantangai',
  },
  {
    id: '6203160',
    regencyId: '6203',
    name: 'Timpah',
  },
  {
    id: '6203170',
    regencyId: '6203',
    name: 'Kapuas Tengah',
  },
  {
    id: '6203171',
    regencyId: '6203',
    name: 'Pasak Talawang',
  },
  {
    id: '6203180',
    regencyId: '6203',
    name: 'Kapuas Hulu',
  },
  {
    id: '6203181',
    regencyId: '6203',
    name: 'Mandau Talawang',
  },
  {
    id: '6204010',
    regencyId: '6204',
    name: 'Jenamas',
  },
  {
    id: '6204020',
    regencyId: '6204',
    name: 'Dusun Hilir',
  },
  {
    id: '6204030',
    regencyId: '6204',
    name: 'Karau Kuala',
  },
  {
    id: '6204040',
    regencyId: '6204',
    name: 'Dusun Selatan',
  },
  {
    id: '6204050',
    regencyId: '6204',
    name: 'Dusun Utara',
  },
  {
    id: '6204060',
    regencyId: '6204',
    name: 'Gunung Bintang Awai',
  },
  {
    id: '6205010',
    regencyId: '6205',
    name: 'Montallat',
  },
  {
    id: '6205020',
    regencyId: '6205',
    name: 'Gunung Timang',
  },
  {
    id: '6205030',
    regencyId: '6205',
    name: 'Gunung Purei',
  },
  {
    id: '6205040',
    regencyId: '6205',
    name: 'Teweh Timur',
  },
  {
    id: '6205050',
    regencyId: '6205',
    name: 'Teweh Tengah',
  },
  {
    id: '6205051',
    regencyId: '6205',
    name: 'Teweh  Baru',
  },
  {
    id: '6205052',
    regencyId: '6205',
    name: 'Teweh Selatan',
  },
  {
    id: '6205060',
    regencyId: '6205',
    name: 'Lahei',
  },
  {
    id: '6205061',
    regencyId: '6205',
    name: 'Lahei Barat',
  },
  {
    id: '6206010',
    regencyId: '6206',
    name: 'Jelai',
  },
  {
    id: '6206011',
    regencyId: '6206',
    name: 'Pantai Lunci',
  },
  {
    id: '6206020',
    regencyId: '6206',
    name: 'Sukamara',
  },
  {
    id: '6206030',
    regencyId: '6206',
    name: 'Balai Riam',
  },
  {
    id: '6206031',
    regencyId: '6206',
    name: 'Permata Kecubung',
  },
  {
    id: '6207010',
    regencyId: '6207',
    name: 'Bulik',
  },
  {
    id: '6207011',
    regencyId: '6207',
    name: 'Sematu Jaya',
  },
  {
    id: '6207012',
    regencyId: '6207',
    name: 'Menthobi Raya',
  },
  {
    id: '6207013',
    regencyId: '6207',
    name: 'Bulik Timur',
  },
  {
    id: '6207020',
    regencyId: '6207',
    name: 'Lamandau',
  },
  {
    id: '6207021',
    regencyId: '6207',
    name: 'Belantikan Raya',
  },
  {
    id: '6207030',
    regencyId: '6207',
    name: 'Delang',
  },
  {
    id: '6207031',
    regencyId: '6207',
    name: 'Batangkawa',
  },
  {
    id: '6208010',
    regencyId: '6208',
    name: 'Seruyan Hilir',
  },
  {
    id: '6208011',
    regencyId: '6208',
    name: 'Seruyan Hilir Timur',
  },
  {
    id: '6208020',
    regencyId: '6208',
    name: 'Danau Sembuluh',
  },
  {
    id: '6208021',
    regencyId: '6208',
    name: 'Seruyan Raya',
  },
  {
    id: '6208030',
    regencyId: '6208',
    name: 'Hanau',
  },
  {
    id: '6208031',
    regencyId: '6208',
    name: 'Danau Seluluk',
  },
  {
    id: '6208040',
    regencyId: '6208',
    name: 'Seruyan Tengah',
  },
  {
    id: '6208041',
    regencyId: '6208',
    name: 'Batu Ampar',
  },
  {
    id: '6208050',
    regencyId: '6208',
    name: 'Seruyan Hulu',
  },
  {
    id: '6208051',
    regencyId: '6208',
    name: 'Suling Tambun',
  },
  {
    id: '6209010',
    regencyId: '6209',
    name: 'Katingan Kuala',
  },
  {
    id: '6209020',
    regencyId: '6209',
    name: 'Mendawai',
  },
  {
    id: '6209030',
    regencyId: '6209',
    name: 'Kamipang',
  },
  {
    id: '6209040',
    regencyId: '6209',
    name: 'Tasik Payawan',
  },
  {
    id: '6209050',
    regencyId: '6209',
    name: 'Katingan Hilir',
  },
  {
    id: '6209060',
    regencyId: '6209',
    name: 'Tewang Sangalang Garing',
  },
  {
    id: '6209070',
    regencyId: '6209',
    name: 'Pulau Malan',
  },
  {
    id: '6209080',
    regencyId: '6209',
    name: 'Katingan Tengah',
  },
  {
    id: '6209090',
    regencyId: '6209',
    name: 'Sanaman Mantikei',
  },
  {
    id: '6209091',
    regencyId: '6209',
    name: 'Petak Malai',
  },
  {
    id: '6209100',
    regencyId: '6209',
    name: 'Marikit',
  },
  {
    id: '6209110',
    regencyId: '6209',
    name: 'Katingan Hulu',
  },
  {
    id: '6209111',
    regencyId: '6209',
    name: 'Bukit Raya',
  },
  {
    id: '6210010',
    regencyId: '6210',
    name: 'Kahayan Kuala',
  },
  {
    id: '6210011',
    regencyId: '6210',
    name: 'Sebangau Kuala',
  },
  {
    id: '6210020',
    regencyId: '6210',
    name: 'Pandih Batu',
  },
  {
    id: '6210030',
    regencyId: '6210',
    name: 'Maliku',
  },
  {
    id: '6210040',
    regencyId: '6210',
    name: 'Kahayan Hilir',
  },
  {
    id: '6210041',
    regencyId: '6210',
    name: 'Jabiren Raya',
  },
  {
    id: '6210050',
    regencyId: '6210',
    name: 'Kahayan Tengah',
  },
  {
    id: '6210060',
    regencyId: '6210',
    name: 'Banama Tingang',
  },
  {
    id: '6211010',
    regencyId: '6211',
    name: 'Manuhing',
  },
  {
    id: '6211011',
    regencyId: '6211',
    name: 'Manuhing Raya',
  },
  {
    id: '6211020',
    regencyId: '6211',
    name: 'Rungan',
  },
  {
    id: '6211021',
    regencyId: '6211',
    name: 'Rungan Hulu',
  },
  {
    id: '6211022',
    regencyId: '6211',
    name: 'Rungan Barat',
  },
  {
    id: '6211030',
    regencyId: '6211',
    name: 'Sepang',
  },
  {
    id: '6211031',
    regencyId: '6211',
    name: 'Mihing Raya',
  },
  {
    id: '6211040',
    regencyId: '6211',
    name: 'Kurun',
  },
  {
    id: '6211050',
    regencyId: '6211',
    name: 'Tewah',
  },
  {
    id: '6211060',
    regencyId: '6211',
    name: 'Kahayan Hulu Utara',
  },
  {
    id: '6211061',
    regencyId: '6211',
    name: 'Damang Batu',
  },
  {
    id: '6211062',
    regencyId: '6211',
    name: 'Miri Manasa',
  },
  {
    id: '6212010',
    regencyId: '6212',
    name: 'Benua Lima',
  },
  {
    id: '6212020',
    regencyId: '6212',
    name: 'Dusun Timur',
  },
  {
    id: '6212021',
    regencyId: '6212',
    name: 'Paju Epat',
  },
  {
    id: '6212030',
    regencyId: '6212',
    name: 'Awang',
  },
  {
    id: '6212040',
    regencyId: '6212',
    name: 'Patangkep Tutui',
  },
  {
    id: '6212050',
    regencyId: '6212',
    name: 'Dusun Tengah',
  },
  {
    id: '6212051',
    regencyId: '6212',
    name: 'Raren Batuah',
  },
  {
    id: '6212052',
    regencyId: '6212',
    name: 'Paku',
  },
  {
    id: '6212053',
    regencyId: '6212',
    name: 'Karusen Janang',
  },
  {
    id: '6212060',
    regencyId: '6212',
    name: 'Pematang Karau',
  },
  {
    id: '6213010',
    regencyId: '6213',
    name: 'Permata Intan',
  },
  {
    id: '6213011',
    regencyId: '6213',
    name: 'Sungai Babuat',
  },
  {
    id: '6213020',
    regencyId: '6213',
    name: 'Murung',
  },
  {
    id: '6213030',
    regencyId: '6213',
    name: 'Laung Tuhup',
  },
  {
    id: '6213031',
    regencyId: '6213',
    name: 'Barito Tuhup Raya',
  },
  {
    id: '6213040',
    regencyId: '6213',
    name: 'Tanah Siang',
  },
  {
    id: '6213041',
    regencyId: '6213',
    name: 'Tanah Siang Selatan',
  },
  {
    id: '6213050',
    regencyId: '6213',
    name: 'Sumber Barito',
  },
  {
    id: '6213051',
    regencyId: '6213',
    name: 'Seribu Riam',
  },
  {
    id: '6213052',
    regencyId: '6213',
    name: 'Uut Murung',
  },
  {
    id: '6271010',
    regencyId: '6271',
    name: 'Pahandut',
  },
  {
    id: '6271011',
    regencyId: '6271',
    name: 'Sabangau',
  },
  {
    id: '6271012',
    regencyId: '6271',
    name: 'Jekan Raya',
  },
  {
    id: '6271020',
    regencyId: '6271',
    name: 'Bukit Batu',
  },
  {
    id: '6271021',
    regencyId: '6271',
    name: 'Rakumpit',
  },
  {
    id: '6301010',
    regencyId: '6301',
    name: 'Panyipatan',
  },
  {
    id: '6301020',
    regencyId: '6301',
    name: 'Takisung',
  },
  {
    id: '6301030',
    regencyId: '6301',
    name: 'Kurau',
  },
  {
    id: '6301031',
    regencyId: '6301',
    name: 'Bumi Makmur',
  },
  {
    id: '6301040',
    regencyId: '6301',
    name: 'Bati - Bati',
  },
  {
    id: '6301050',
    regencyId: '6301',
    name: 'Tambang Ulang',
  },
  {
    id: '6301060',
    regencyId: '6301',
    name: 'Pelaihari',
  },
  {
    id: '6301061',
    regencyId: '6301',
    name: 'Bajuin',
  },
  {
    id: '6301070',
    regencyId: '6301',
    name: 'Batu Ampar',
  },
  {
    id: '6301080',
    regencyId: '6301',
    name: 'Jorong',
  },
  {
    id: '6301090',
    regencyId: '6301',
    name: 'Kintap',
  },
  {
    id: '6302010',
    regencyId: '6302',
    name: 'Pulau Sembilan',
  },
  {
    id: '6302020',
    regencyId: '6302',
    name: 'Pulau Laut Barat',
  },
  {
    id: '6302021',
    regencyId: '6302',
    name: 'Pulau Laut Tanjung Selayar',
  },
  {
    id: '6302030',
    regencyId: '6302',
    name: 'Pulau Laut Selatan',
  },
  {
    id: '6302031',
    regencyId: '6302',
    name: 'Pulau Laut Kepulauan',
  },
  {
    id: '6302040',
    regencyId: '6302',
    name: 'Pulau Laut Timur',
  },
  {
    id: '6302050',
    regencyId: '6302',
    name: 'Pulau Sebuku',
  },
  {
    id: '6302060',
    regencyId: '6302',
    name: 'Pulau Laut Utara',
  },
  {
    id: '6302061',
    regencyId: '6302',
    name: 'Pulau Laut Tengah',
  },
  {
    id: '6302120',
    regencyId: '6302',
    name: 'Kelumpang Selatan',
  },
  {
    id: '6302121',
    regencyId: '6302',
    name: 'Kelumpang Hilir',
  },
  {
    id: '6302130',
    regencyId: '6302',
    name: 'Kelumpang Hulu',
  },
  {
    id: '6302140',
    regencyId: '6302',
    name: 'Hampang',
  },
  {
    id: '6302150',
    regencyId: '6302',
    name: 'Sungai Durian',
  },
  {
    id: '6302160',
    regencyId: '6302',
    name: 'Kelumpang Tengah',
  },
  {
    id: '6302161',
    regencyId: '6302',
    name: 'Kelumpang Barat',
  },
  {
    id: '6302170',
    regencyId: '6302',
    name: 'Kelumpang Utara',
  },
  {
    id: '6302180',
    regencyId: '6302',
    name: 'Pamukan Selatan',
  },
  {
    id: '6302190',
    regencyId: '6302',
    name: 'Sampanahan',
  },
  {
    id: '6302200',
    regencyId: '6302',
    name: 'Pamukan Utara',
  },
  {
    id: '6302201',
    regencyId: '6302',
    name: 'Pamukan Barat',
  },
  {
    id: '6303010',
    regencyId: '6303',
    name: 'Aluh - Aluh',
  },
  {
    id: '6303011',
    regencyId: '6303',
    name: 'Beruntung Baru',
  },
  {
    id: '6303020',
    regencyId: '6303',
    name: 'Gambut',
  },
  {
    id: '6303030',
    regencyId: '6303',
    name: 'Kertak Hanyar',
  },
  {
    id: '6303031',
    regencyId: '6303',
    name: 'Tatah Makmur',
  },
  {
    id: '6303040',
    regencyId: '6303',
    name: 'Sungai Tabuk',
  },
  {
    id: '6303050',
    regencyId: '6303',
    name: 'Martapura',
  },
  {
    id: '6303051',
    regencyId: '6303',
    name: 'Martapura Timur',
  },
  {
    id: '6303052',
    regencyId: '6303',
    name: 'Martapura Barat',
  },
  {
    id: '6303060',
    regencyId: '6303',
    name: 'Astambul',
  },
  {
    id: '6303070',
    regencyId: '6303',
    name: 'Karang Intan',
  },
  {
    id: '6303080',
    regencyId: '6303',
    name: 'Aranio',
  },
  {
    id: '6303090',
    regencyId: '6303',
    name: 'Sungai Pinang',
  },
  {
    id: '6303091',
    regencyId: '6303',
    name: 'Paramasan',
  },
  {
    id: '6303100',
    regencyId: '6303',
    name: 'Pengaron',
  },
  {
    id: '6303101',
    regencyId: '6303',
    name: 'Sambung Makmur',
  },
  {
    id: '6303110',
    regencyId: '6303',
    name: 'Mataraman',
  },
  {
    id: '6303120',
    regencyId: '6303',
    name: 'Simpang Empat',
  },
  {
    id: '6303121',
    regencyId: '6303',
    name: 'Telaga Bauntung',
  },
  {
    id: '6304010',
    regencyId: '6304',
    name: 'Tabunganen',
  },
  {
    id: '6304020',
    regencyId: '6304',
    name: 'Tamban',
  },
  {
    id: '6304030',
    regencyId: '6304',
    name: 'Mekar Sari',
  },
  {
    id: '6304040',
    regencyId: '6304',
    name: 'Anjir Pasar',
  },
  {
    id: '6304050',
    regencyId: '6304',
    name: 'Anjir Muara',
  },
  {
    id: '6304060',
    regencyId: '6304',
    name: 'Alalak',
  },
  {
    id: '6304070',
    regencyId: '6304',
    name: 'Mandastana',
  },
  {
    id: '6304071',
    regencyId: '6304',
    name: 'Jejangkit',
  },
  {
    id: '6304080',
    regencyId: '6304',
    name: 'Belawang',
  },
  {
    id: '6304090',
    regencyId: '6304',
    name: 'Wanaraya',
  },
  {
    id: '6304100',
    regencyId: '6304',
    name: 'Barambai',
  },
  {
    id: '6304110',
    regencyId: '6304',
    name: 'Rantau Badauh',
  },
  {
    id: '6304120',
    regencyId: '6304',
    name: 'Cerbon',
  },
  {
    id: '6304130',
    regencyId: '6304',
    name: 'Bakumpai',
  },
  {
    id: '6304140',
    regencyId: '6304',
    name: 'Marabahan',
  },
  {
    id: '6304150',
    regencyId: '6304',
    name: 'Tabukan',
  },
  {
    id: '6304160',
    regencyId: '6304',
    name: 'Kuripan',
  },
  {
    id: '6305010',
    regencyId: '6305',
    name: 'Binuang',
  },
  {
    id: '6305011',
    regencyId: '6305',
    name: 'Hatungun',
  },
  {
    id: '6305020',
    regencyId: '6305',
    name: 'Tapin Selatan',
  },
  {
    id: '6305021',
    regencyId: '6305',
    name: 'Salam Babaris',
  },
  {
    id: '6305030',
    regencyId: '6305',
    name: 'Tapin Tengah',
  },
  {
    id: '6305040',
    regencyId: '6305',
    name: 'Bungur',
  },
  {
    id: '6305050',
    regencyId: '6305',
    name: 'Piani',
  },
  {
    id: '6305060',
    regencyId: '6305',
    name: 'Lokpaikat',
  },
  {
    id: '6305070',
    regencyId: '6305',
    name: 'Tapin Utara',
  },
  {
    id: '6305080',
    regencyId: '6305',
    name: 'Bakarangan',
  },
  {
    id: '6305090',
    regencyId: '6305',
    name: 'Candi Laras Selatan',
  },
  {
    id: '6305100',
    regencyId: '6305',
    name: 'Candi Laras Utara',
  },
  {
    id: '6306010',
    regencyId: '6306',
    name: 'Padang Batung',
  },
  {
    id: '6306020',
    regencyId: '6306',
    name: 'Loksado',
  },
  {
    id: '6306030',
    regencyId: '6306',
    name: 'Telaga Langsat',
  },
  {
    id: '6306040',
    regencyId: '6306',
    name: 'Angkinang',
  },
  {
    id: '6306050',
    regencyId: '6306',
    name: 'Kandangan',
  },
  {
    id: '6306060',
    regencyId: '6306',
    name: 'Sungai Raya',
  },
  {
    id: '6306070',
    regencyId: '6306',
    name: 'Simpur',
  },
  {
    id: '6306080',
    regencyId: '6306',
    name: 'Kalumpang',
  },
  {
    id: '6306090',
    regencyId: '6306',
    name: 'Daha Selatan',
  },
  {
    id: '6306091',
    regencyId: '6306',
    name: 'Daha Barat',
  },
  {
    id: '6306100',
    regencyId: '6306',
    name: 'Daha Utara',
  },
  {
    id: '6307010',
    regencyId: '6307',
    name: 'Haruyan',
  },
  {
    id: '6307020',
    regencyId: '6307',
    name: 'Batu Benawa',
  },
  {
    id: '6307030',
    regencyId: '6307',
    name: 'Hantakan',
  },
  {
    id: '6307040',
    regencyId: '6307',
    name: 'Batang Alai Selatan',
  },
  {
    id: '6307041',
    regencyId: '6307',
    name: 'Batang Alai Timur',
  },
  {
    id: '6307050',
    regencyId: '6307',
    name: 'Barabai',
  },
  {
    id: '6307060',
    regencyId: '6307',
    name: 'Labuan Amas Selatan',
  },
  {
    id: '6307070',
    regencyId: '6307',
    name: 'Labuan Amas Utara',
  },
  {
    id: '6307080',
    regencyId: '6307',
    name: 'Pandawan',
  },
  {
    id: '6307090',
    regencyId: '6307',
    name: 'Batang Alai Utara',
  },
  {
    id: '6307091',
    regencyId: '6307',
    name: 'Limpasu',
  },
  {
    id: '6308010',
    regencyId: '6308',
    name: 'Danau Panggang',
  },
  {
    id: '6308011',
    regencyId: '6308',
    name: 'Paminggir',
  },
  {
    id: '6308020',
    regencyId: '6308',
    name: 'Babirik',
  },
  {
    id: '6308030',
    regencyId: '6308',
    name: 'Sungai Pandan',
  },
  {
    id: '6308031',
    regencyId: '6308',
    name: 'Sungai Tabukan',
  },
  {
    id: '6308040',
    regencyId: '6308',
    name: 'Amuntai Selatan',
  },
  {
    id: '6308050',
    regencyId: '6308',
    name: 'Amuntai Tengah',
  },
  {
    id: '6308060',
    regencyId: '6308',
    name: 'Banjang',
  },
  {
    id: '6308070',
    regencyId: '6308',
    name: 'Amuntai Utara',
  },
  {
    id: '6308071',
    regencyId: '6308',
    name: 'Haur Gading',
  },
  {
    id: '6309010',
    regencyId: '6309',
    name: 'Banua Lawas',
  },
  {
    id: '6309020',
    regencyId: '6309',
    name: 'Pugaan',
  },
  {
    id: '6309030',
    regencyId: '6309',
    name: 'Kelua',
  },
  {
    id: '6309040',
    regencyId: '6309',
    name: 'Muara Harus',
  },
  {
    id: '6309050',
    regencyId: '6309',
    name: 'Tanta',
  },
  {
    id: '6309060',
    regencyId: '6309',
    name: 'Tanjung',
  },
  {
    id: '6309070',
    regencyId: '6309',
    name: 'Murung Pudak',
  },
  {
    id: '6309080',
    regencyId: '6309',
    name: 'Haruai',
  },
  {
    id: '6309081',
    regencyId: '6309',
    name: 'Bintang Ara',
  },
  {
    id: '6309090',
    regencyId: '6309',
    name: 'Upau',
  },
  {
    id: '6309100',
    regencyId: '6309',
    name: 'Muara Uya',
  },
  {
    id: '6309110',
    regencyId: '6309',
    name: 'Jaro',
  },
  {
    id: '6310010',
    regencyId: '6310',
    name: 'Kusan Hilir',
  },
  {
    id: '6310020',
    regencyId: '6310',
    name: 'Sungai Loban',
  },
  {
    id: '6310030',
    regencyId: '6310',
    name: 'Satui',
  },
  {
    id: '6310031',
    regencyId: '6310',
    name: 'Angsana',
  },
  {
    id: '6310040',
    regencyId: '6310',
    name: 'Kusan Hulu',
  },
  {
    id: '6310041',
    regencyId: '6310',
    name: 'Kuranji',
  },
  {
    id: '6310050',
    regencyId: '6310',
    name: 'Batu Licin',
  },
  {
    id: '6310051',
    regencyId: '6310',
    name: 'Karang Bintang',
  },
  {
    id: '6310052',
    regencyId: '6310',
    name: 'Simpang Empat',
  },
  {
    id: '6310053',
    regencyId: '6310',
    name: 'Mantewe',
  },
  {
    id: '6311010',
    regencyId: '6311',
    name: 'Lampihong',
  },
  {
    id: '6311020',
    regencyId: '6311',
    name: 'Batu Mandi',
  },
  {
    id: '6311030',
    regencyId: '6311',
    name: 'Awayan',
  },
  {
    id: '6311031',
    regencyId: '6311',
    name: 'Tebing Tinggi',
  },
  {
    id: '6311040',
    regencyId: '6311',
    name: 'Paringin',
  },
  {
    id: '6311041',
    regencyId: '6311',
    name: 'Paringin Selatan',
  },
  {
    id: '6311050',
    regencyId: '6311',
    name: 'Juai',
  },
  {
    id: '6311060',
    regencyId: '6311',
    name: 'Halong',
  },
  {
    id: '6371010',
    regencyId: '6371',
    name: 'Banjarmasin Selatan',
  },
  {
    id: '6371020',
    regencyId: '6371',
    name: 'Banjarmasin Timur',
  },
  {
    id: '6371030',
    regencyId: '6371',
    name: 'Banjarmasin Barat',
  },
  {
    id: '6371031',
    regencyId: '6371',
    name: 'Banjarmasin Tengah',
  },
  {
    id: '6371040',
    regencyId: '6371',
    name: 'Banjarmasin Utara',
  },
  {
    id: '6372010',
    regencyId: '6372',
    name: 'Landasan Ulin',
  },
  {
    id: '6372011',
    regencyId: '6372',
    name: 'Liang Anggang',
  },
  {
    id: '6372020',
    regencyId: '6372',
    name: 'Cempaka',
  },
  {
    id: '6372031',
    regencyId: '6372',
    name: 'Banjar Baru Utara',
  },
  {
    id: '6372032',
    regencyId: '6372',
    name: 'Banjar Baru Selatan',
  },
  {
    id: '6401010',
    regencyId: '6401',
    name: 'Batu Sopang',
  },
  {
    id: '6401011',
    regencyId: '6401',
    name: 'Muara Samu',
  },
  {
    id: '6401021',
    regencyId: '6401',
    name: 'Batu Engau',
  },
  {
    id: '6401022',
    regencyId: '6401',
    name: 'Tanjung Harapan',
  },
  {
    id: '6401030',
    regencyId: '6401',
    name: 'Pasir Belengkong',
  },
  {
    id: '6401040',
    regencyId: '6401',
    name: 'Tanah Grogot',
  },
  {
    id: '6401050',
    regencyId: '6401',
    name: 'Kuaro',
  },
  {
    id: '6401060',
    regencyId: '6401',
    name: 'Long Ikis',
  },
  {
    id: '6401070',
    regencyId: '6401',
    name: 'Muara Komam',
  },
  {
    id: '6401080',
    regencyId: '6401',
    name: 'Long Kali',
  },
  {
    id: '6402010',
    regencyId: '6402',
    name: 'Bongan',
  },
  {
    id: '6402020',
    regencyId: '6402',
    name: 'Jempang',
  },
  {
    id: '6402030',
    regencyId: '6402',
    name: 'Penyinggahan',
  },
  {
    id: '6402040',
    regencyId: '6402',
    name: 'Muara Pahu',
  },
  {
    id: '6402041',
    regencyId: '6402',
    name: 'Siluq Ngurai',
  },
  {
    id: '6402050',
    regencyId: '6402',
    name: 'Muara Lawa',
  },
  {
    id: '6402051',
    regencyId: '6402',
    name: 'Bentian Besar',
  },
  {
    id: '6402060',
    regencyId: '6402',
    name: 'Damai',
  },
  {
    id: '6402061',
    regencyId: '6402',
    name: 'Nyuatan',
  },
  {
    id: '6402070',
    regencyId: '6402',
    name: 'Barong Tongkok',
  },
  {
    id: '6402071',
    regencyId: '6402',
    name: 'Linggang Bigung',
  },
  {
    id: '6402080',
    regencyId: '6402',
    name: 'Melak',
  },
  {
    id: '6402081',
    regencyId: '6402',
    name: 'Sekolaq Darat',
  },
  {
    id: '6402082',
    regencyId: '6402',
    name: 'Manor Bulatn',
  },
  {
    id: '6402090',
    regencyId: '6402',
    name: 'Long Iram',
  },
  {
    id: '6402091',
    regencyId: '6402',
    name: 'Tering',
  },
  {
    id: '6403010',
    regencyId: '6403',
    name: 'Semboja',
  },
  {
    id: '6403020',
    regencyId: '6403',
    name: 'Muara Jawa',
  },
  {
    id: '6403030',
    regencyId: '6403',
    name: 'Sanga-Sanga',
  },
  {
    id: '6403040',
    regencyId: '6403',
    name: 'Loa Janan',
  },
  {
    id: '6403050',
    regencyId: '6403',
    name: 'Loa Kulu',
  },
  {
    id: '6403060',
    regencyId: '6403',
    name: 'Muara Muntai',
  },
  {
    id: '6403070',
    regencyId: '6403',
    name: 'Muara Wis',
  },
  {
    id: '6403080',
    regencyId: '6403',
    name: 'Kotabangun',
  },
  {
    id: '6403090',
    regencyId: '6403',
    name: 'Tenggarong',
  },
  {
    id: '6403100',
    regencyId: '6403',
    name: 'Sebulu',
  },
  {
    id: '6403110',
    regencyId: '6403',
    name: 'Tenggarong Seberang',
  },
  {
    id: '6403120',
    regencyId: '6403',
    name: 'Anggana',
  },
  {
    id: '6403130',
    regencyId: '6403',
    name: 'Muara Badak',
  },
  {
    id: '6403140',
    regencyId: '6403',
    name: 'Marang Kayu',
  },
  {
    id: '6403150',
    regencyId: '6403',
    name: 'Muara Kaman',
  },
  {
    id: '6403160',
    regencyId: '6403',
    name: 'Kenohan',
  },
  {
    id: '6403170',
    regencyId: '6403',
    name: 'Kembang Janggut',
  },
  {
    id: '6403180',
    regencyId: '6403',
    name: 'Tabang',
  },
  {
    id: '6404010',
    regencyId: '6404',
    name: 'Muara Ancalong',
  },
  {
    id: '6404011',
    regencyId: '6404',
    name: 'Busang',
  },
  {
    id: '6404012',
    regencyId: '6404',
    name: 'Long Mesangat',
  },
  {
    id: '6404020',
    regencyId: '6404',
    name: 'Muara Wahau',
  },
  {
    id: '6404021',
    regencyId: '6404',
    name: 'Telen',
  },
  {
    id: '6404022',
    regencyId: '6404',
    name: 'Kongbeng',
  },
  {
    id: '6404030',
    regencyId: '6404',
    name: 'Muara Bengkal',
  },
  {
    id: '6404031',
    regencyId: '6404',
    name: 'Batu Ampar',
  },
  {
    id: '6404040',
    regencyId: '6404',
    name: 'Sangatta Utara',
  },
  {
    id: '6404041',
    regencyId: '6404',
    name: 'Bengalon',
  },
  {
    id: '6404042',
    regencyId: '6404',
    name: 'Teluk Pandan',
  },
  {
    id: '6404043',
    regencyId: '6404',
    name: 'Sangatta Selatan',
  },
  {
    id: '6404044',
    regencyId: '6404',
    name: 'Rantau Pulung',
  },
  {
    id: '6404050',
    regencyId: '6404',
    name: 'Sangkulirang',
  },
  {
    id: '6404051',
    regencyId: '6404',
    name: 'Kaliorang',
  },
  {
    id: '6404052',
    regencyId: '6404',
    name: 'Sandaran',
  },
  {
    id: '6404053',
    regencyId: '6404',
    name: 'Kaubun',
  },
  {
    id: '6404054',
    regencyId: '6404',
    name: 'Karangan',
  },
  {
    id: '6405010',
    regencyId: '6405',
    name: 'Kelay',
  },
  {
    id: '6405020',
    regencyId: '6405',
    name: 'Talisayan',
  },
  {
    id: '6405021',
    regencyId: '6405',
    name: 'Tabalar',
  },
  {
    id: '6405030',
    regencyId: '6405',
    name: 'Biduk Biduk',
  },
  {
    id: '6405040',
    regencyId: '6405',
    name: 'Pulau Derawan',
  },
  {
    id: '6405041',
    regencyId: '6405',
    name: 'Maratua',
  },
  {
    id: '6405050',
    regencyId: '6405',
    name: 'Sambaliung',
  },
  {
    id: '6405060',
    regencyId: '6405',
    name: 'Tanjung Redeb',
  },
  {
    id: '6405070',
    regencyId: '6405',
    name: 'Gunung Tabur',
  },
  {
    id: '6405080',
    regencyId: '6405',
    name: 'Segah',
  },
  {
    id: '6405090',
    regencyId: '6405',
    name: 'Teluk Bayur',
  },
  {
    id: '6405100',
    regencyId: '6405',
    name: 'Batu Putih',
  },
  {
    id: '6405110',
    regencyId: '6405',
    name: 'Biatan',
  },
  {
    id: '6409010',
    regencyId: '6409',
    name: 'Babulu',
  },
  {
    id: '6409020',
    regencyId: '6409',
    name: 'Waru',
  },
  {
    id: '6409030',
    regencyId: '6409',
    name: 'Penajam',
  },
  {
    id: '6409040',
    regencyId: '6409',
    name: 'Sepaku',
  },
  {
    id: '6411010',
    regencyId: '6411',
    name: 'Laham',
  },
  {
    id: '6411020',
    regencyId: '6411',
    name: 'Long Hubung',
  },
  {
    id: '6411030',
    regencyId: '6411',
    name: 'Long Bagun',
  },
  {
    id: '6411040',
    regencyId: '6411',
    name: 'Long Pahangai',
  },
  {
    id: '6411050',
    regencyId: '6411',
    name: 'Long Apari',
  },
  {
    id: '6471010',
    regencyId: '6471',
    name: 'Balikpapan Selatan',
  },
  {
    id: '6471011',
    regencyId: '6471',
    name: 'Balikpapan Kota',
  },
  {
    id: '6471020',
    regencyId: '6471',
    name: 'Balikpapan Timur',
  },
  {
    id: '6471030',
    regencyId: '6471',
    name: 'Balikpapan Utara',
  },
  {
    id: '6471040',
    regencyId: '6471',
    name: 'Balikpapan Tengah',
  },
  {
    id: '6471050',
    regencyId: '6471',
    name: 'Balikpapan Barat',
  },
  {
    id: '6472010',
    regencyId: '6472',
    name: 'Palaran',
  },
  {
    id: '6472020',
    regencyId: '6472',
    name: 'Samarinda Ilir',
  },
  {
    id: '6472021',
    regencyId: '6472',
    name: 'Samarinda Kota',
  },
  {
    id: '6472022',
    regencyId: '6472',
    name: 'Sambutan',
  },
  {
    id: '6472030',
    regencyId: '6472',
    name: 'Samarinda Seberang',
  },
  {
    id: '6472031',
    regencyId: '6472',
    name: 'Loa Janan Ilir',
  },
  {
    id: '6472040',
    regencyId: '6472',
    name: 'Sungai Kunjang',
  },
  {
    id: '6472050',
    regencyId: '6472',
    name: 'Samarinda Ulu',
  },
  {
    id: '6472060',
    regencyId: '6472',
    name: 'Samarinda Utara',
  },
  {
    id: '6472061',
    regencyId: '6472',
    name: 'Sungai Pinang',
  },
  {
    id: '6474010',
    regencyId: '6474',
    name: 'Bontang Selatan',
  },
  {
    id: '6474020',
    regencyId: '6474',
    name: 'Bontang Utara',
  },
  {
    id: '6474030',
    regencyId: '6474',
    name: 'Bontang Barat',
  },
  {
    id: '6501010',
    regencyId: '6501',
    name: 'Sungai Boh',
  },
  {
    id: '6501020',
    regencyId: '6501',
    name: 'Kayan Selatan',
  },
  {
    id: '6501030',
    regencyId: '6501',
    name: 'Kayan Hulu',
  },
  {
    id: '6501040',
    regencyId: '6501',
    name: 'Kayan Hilir',
  },
  {
    id: '6501050',
    regencyId: '6501',
    name: 'Pujungan',
  },
  {
    id: '6501060',
    regencyId: '6501',
    name: 'Bahau Hulu',
  },
  {
    id: '6501070',
    regencyId: '6501',
    name: 'Sungai Tubu',
  },
  {
    id: '6501080',
    regencyId: '6501',
    name: 'Malinau Selatan Hulu',
  },
  {
    id: '6501090',
    regencyId: '6501',
    name: 'Malinau Selatan',
  },
  {
    id: '6501100',
    regencyId: '6501',
    name: 'Malinau Selatan Hilir',
  },
  {
    id: '6501110',
    regencyId: '6501',
    name: 'Mentarang',
  },
  {
    id: '6501120',
    regencyId: '6501',
    name: 'Mentarang Hulu',
  },
  {
    id: '6501130',
    regencyId: '6501',
    name: 'Malinau Utara',
  },
  {
    id: '6501140',
    regencyId: '6501',
    name: 'Malinau Barat',
  },
  {
    id: '6501150',
    regencyId: '6501',
    name: 'Malinau Kota',
  },
  {
    id: '6502010',
    regencyId: '6502',
    name: 'Peso',
  },
  {
    id: '6502020',
    regencyId: '6502',
    name: 'Peso Hilir',
  },
  {
    id: '6502030',
    regencyId: '6502',
    name: 'Tanjung Palas Barat',
  },
  {
    id: '6502040',
    regencyId: '6502',
    name: 'Tanjung Palas',
  },
  {
    id: '6502050',
    regencyId: '6502',
    name: 'Tanjung Selor',
  },
  {
    id: '6502060',
    regencyId: '6502',
    name: 'Tanjung Palas Timur',
  },
  {
    id: '6502070',
    regencyId: '6502',
    name: 'Tanjung Palas Tengah',
  },
  {
    id: '6502080',
    regencyId: '6502',
    name: 'Tanjung Palas Utara',
  },
  {
    id: '6502090',
    regencyId: '6502',
    name: 'Sekatak',
  },
  {
    id: '6502100',
    regencyId: '6502',
    name: 'Bunyu',
  },
  {
    id: '6503010',
    regencyId: '6503',
    name: 'Muruk Rian',
  },
  {
    id: '6503020',
    regencyId: '6503',
    name: 'Sesayap',
  },
  {
    id: '6503030',
    regencyId: '6503',
    name: 'Betayau',
  },
  {
    id: '6503040',
    regencyId: '6503',
    name: 'Sesayap Hilir',
  },
  {
    id: '6503050',
    regencyId: '6503',
    name: 'Tana Lia',
  },
  {
    id: '6504010',
    regencyId: '6504',
    name: 'Krayan Selatan',
  },
  {
    id: '6504011',
    regencyId: '6504',
    name: 'Krayan Tengah',
  },
  {
    id: '6504020',
    regencyId: '6504',
    name: 'Krayan',
  },
  {
    id: '6504021',
    regencyId: '6504',
    name: 'Krayan Timur',
  },
  {
    id: '6504022',
    regencyId: '6504',
    name: 'Krayan Barat',
  },
  {
    id: '6504030',
    regencyId: '6504',
    name: 'Lumbis Ogong',
  },
  {
    id: '6504040',
    regencyId: '6504',
    name: 'Lumbis',
  },
  {
    id: '6504050',
    regencyId: '6504',
    name: 'Sembakung Atulai',
  },
  {
    id: '6504060',
    regencyId: '6504',
    name: 'Sembakung',
  },
  {
    id: '6504070',
    regencyId: '6504',
    name: 'Sebuku',
  },
  {
    id: '6504080',
    regencyId: '6504',
    name: 'Tulin Onsoi',
  },
  {
    id: '6504090',
    regencyId: '6504',
    name: 'Sei Menggaris',
  },
  {
    id: '6504100',
    regencyId: '6504',
    name: 'Nunukan',
  },
  {
    id: '6504110',
    regencyId: '6504',
    name: 'Nunukan Selatan',
  },
  {
    id: '6504120',
    regencyId: '6504',
    name: 'Sebatik Barat',
  },
  {
    id: '6504130',
    regencyId: '6504',
    name: 'Sebatik',
  },
  {
    id: '6504140',
    regencyId: '6504',
    name: 'Sebatik Timur',
  },
  {
    id: '6504150',
    regencyId: '6504',
    name: 'Sebatik Tengah',
  },
  {
    id: '6504160',
    regencyId: '6504',
    name: 'Sebatik Utara',
  },
  {
    id: '6571010',
    regencyId: '6571',
    name: 'Tarakan Timur',
  },
  {
    id: '6571020',
    regencyId: '6571',
    name: 'Tarakan Tengah',
  },
  {
    id: '6571030',
    regencyId: '6571',
    name: 'Tarakan Barat',
  },
  {
    id: '6571040',
    regencyId: '6571',
    name: 'Tarakan Utara',
  },
  {
    id: '7101021',
    regencyId: '7101',
    name: 'Dumoga Barat',
  },
  {
    id: '7101022',
    regencyId: '7101',
    name: 'Dumoga Utara',
  },
  {
    id: '7101023',
    regencyId: '7101',
    name: 'Dumoga Timur',
  },
  {
    id: '7101024',
    regencyId: '7101',
    name: 'Dumoga Tengah',
  },
  {
    id: '7101025',
    regencyId: '7101',
    name: 'Dumoga Tenggara',
  },
  {
    id: '7101026',
    regencyId: '7101',
    name: 'Dumoga',
  },
  {
    id: '7101060',
    regencyId: '7101',
    name: 'Lolayan',
  },
  {
    id: '7101081',
    regencyId: '7101',
    name: 'Passi Barat',
  },
  {
    id: '7101082',
    regencyId: '7101',
    name: 'Passi Timur',
  },
  {
    id: '7101083',
    regencyId: '7101',
    name: 'Bilalang',
  },
  {
    id: '7101090',
    regencyId: '7101',
    name: 'Poigar',
  },
  {
    id: '7101100',
    regencyId: '7101',
    name: 'Bolaang',
  },
  {
    id: '7101101',
    regencyId: '7101',
    name: 'Bolaang Timur',
  },
  {
    id: '7101110',
    regencyId: '7101',
    name: 'Lolak',
  },
  {
    id: '7101120',
    regencyId: '7101',
    name: 'Sangtombolang',
  },
  {
    id: '7102091',
    regencyId: '7102',
    name: 'Langowan Timur',
  },
  {
    id: '7102092',
    regencyId: '7102',
    name: 'Langowan Barat',
  },
  {
    id: '7102093',
    regencyId: '7102',
    name: 'Langowan Selatan',
  },
  {
    id: '7102094',
    regencyId: '7102',
    name: 'Langowan Utara',
  },
  {
    id: '7102110',
    regencyId: '7102',
    name: 'Tompaso',
  },
  {
    id: '7102111',
    regencyId: '7102',
    name: 'Tompaso Barat',
  },
  {
    id: '7102120',
    regencyId: '7102',
    name: 'Kawangkoan',
  },
  {
    id: '7102121',
    regencyId: '7102',
    name: 'Kawangkoan Barat',
  },
  {
    id: '7102122',
    regencyId: '7102',
    name: 'Kawangkoan Utara',
  },
  {
    id: '7102130',
    regencyId: '7102',
    name: 'Sonder',
  },
  {
    id: '7102160',
    regencyId: '7102',
    name: 'Tombariri',
  },
  {
    id: '7102161',
    regencyId: '7102',
    name: 'Tombariri Timur',
  },
  {
    id: '7102170',
    regencyId: '7102',
    name: 'Pineleng',
  },
  {
    id: '7102171',
    regencyId: '7102',
    name: 'Tombulu',
  },
  {
    id: '7102172',
    regencyId: '7102',
    name: 'Mandolang',
  },
  {
    id: '7102190',
    regencyId: '7102',
    name: 'Tondano Barat',
  },
  {
    id: '7102191',
    regencyId: '7102',
    name: 'Tondano Selatan',
  },
  {
    id: '7102200',
    regencyId: '7102',
    name: 'Remboken',
  },
  {
    id: '7102210',
    regencyId: '7102',
    name: 'Kakas',
  },
  {
    id: '7102211',
    regencyId: '7102',
    name: 'Kakas Barat',
  },
  {
    id: '7102220',
    regencyId: '7102',
    name: 'Lembean Timur',
  },
  {
    id: '7102230',
    regencyId: '7102',
    name: 'Eris',
  },
  {
    id: '7102240',
    regencyId: '7102',
    name: 'Kombi',
  },
  {
    id: '7102250',
    regencyId: '7102',
    name: 'Tondano Timur',
  },
  {
    id: '7102251',
    regencyId: '7102',
    name: 'Tondano Utara',
  },
  {
    id: '7103040',
    regencyId: '7103',
    name: 'Manganitu Selatan',
  },
  {
    id: '7103041',
    regencyId: '7103',
    name: 'Tatoareng',
  },
  {
    id: '7103050',
    regencyId: '7103',
    name: 'Tamako',
  },
  {
    id: '7103060',
    regencyId: '7103',
    name: 'Tabukan Selatan',
  },
  {
    id: '7103061',
    regencyId: '7103',
    name: 'Tabukan Selatan Tengah',
  },
  {
    id: '7103062',
    regencyId: '7103',
    name: 'Tabukan Selatan Tenggara',
  },
  {
    id: '7103070',
    regencyId: '7103',
    name: 'Tabukan Tengah',
  },
  {
    id: '7103080',
    regencyId: '7103',
    name: 'Manganitu',
  },
  {
    id: '7103090',
    regencyId: '7103',
    name: 'Tahuna',
  },
  {
    id: '7103091',
    regencyId: '7103',
    name: 'Tahuna Timur',
  },
  {
    id: '7103092',
    regencyId: '7103',
    name: 'Tahuna Barat',
  },
  {
    id: '7103100',
    regencyId: '7103',
    name: 'Tabukan Utara',
  },
  {
    id: '7103101',
    regencyId: '7103',
    name: 'Nusa Tabukan',
  },
  {
    id: '7103102',
    regencyId: '7103',
    name: 'Kepulauan Marore',
  },
  {
    id: '7103110',
    regencyId: '7103',
    name: 'Kendahe',
  },
  {
    id: '7104010',
    regencyId: '7104',
    name: 'Kabaruan',
  },
  {
    id: '7104011',
    regencyId: '7104',
    name: 'Damau',
  },
  {
    id: '7104020',
    regencyId: '7104',
    name: 'Lirung',
  },
  {
    id: '7104021',
    regencyId: '7104',
    name: 'Salibabu',
  },
  {
    id: '7104022',
    regencyId: '7104',
    name: 'Kalongan',
  },
  {
    id: '7104023',
    regencyId: '7104',
    name: 'Moronge',
  },
  {
    id: '7104030',
    regencyId: '7104',
    name: 'Melonguane',
  },
  {
    id: '7104031',
    regencyId: '7104',
    name: 'Melonguane Timur',
  },
  {
    id: '7104040',
    regencyId: '7104',
    name: 'Beo',
  },
  {
    id: '7104041',
    regencyId: '7104',
    name: 'Beo Utara',
  },
  {
    id: '7104042',
    regencyId: '7104',
    name: 'Beo Selatan',
  },
  {
    id: '7104050',
    regencyId: '7104',
    name: 'Rainis',
  },
  {
    id: '7104051',
    regencyId: '7104',
    name: "Tampa Na'Mma",
  },
  {
    id: '7104052',
    regencyId: '7104',
    name: 'Pulutan',
  },
  {
    id: '7104060',
    regencyId: '7104',
    name: 'Essang',
  },
  {
    id: '7104061',
    regencyId: '7104',
    name: 'Essang Selatan',
  },
  {
    id: '7104070',
    regencyId: '7104',
    name: 'Gemeh',
  },
  {
    id: '7104080',
    regencyId: '7104',
    name: 'Nanusa',
  },
  {
    id: '7104081',
    regencyId: '7104',
    name: 'Miangas',
  },
  {
    id: '7105010',
    regencyId: '7105',
    name: 'Modoinding',
  },
  {
    id: '7105020',
    regencyId: '7105',
    name: 'Tompaso Baru',
  },
  {
    id: '7105021',
    regencyId: '7105',
    name: 'Maesaan',
  },
  {
    id: '7105070',
    regencyId: '7105',
    name: 'Ranoyapo',
  },
  {
    id: '7105080',
    regencyId: '7105',
    name: 'Motoling',
  },
  {
    id: '7105081',
    regencyId: '7105',
    name: 'Kumelembuai',
  },
  {
    id: '7105082',
    regencyId: '7105',
    name: 'Motoling Barat',
  },
  {
    id: '7105083',
    regencyId: '7105',
    name: 'Motoling Timur',
  },
  {
    id: '7105090',
    regencyId: '7105',
    name: 'Sinonsayang',
  },
  {
    id: '7105100',
    regencyId: '7105',
    name: 'Tenga',
  },
  {
    id: '7105111',
    regencyId: '7105',
    name: 'Amurang',
  },
  {
    id: '7105112',
    regencyId: '7105',
    name: 'Amurang Barat',
  },
  {
    id: '7105113',
    regencyId: '7105',
    name: 'Amurang Timur',
  },
  {
    id: '7105120',
    regencyId: '7105',
    name: 'Tareran',
  },
  {
    id: '7105121',
    regencyId: '7105',
    name: 'Sulta',
  },
  {
    id: '7105130',
    regencyId: '7105',
    name: 'Tumpaan',
  },
  {
    id: '7105131',
    regencyId: '7105',
    name: 'Tatapaan',
  },
  {
    id: '7106010',
    regencyId: '7106',
    name: 'Kema',
  },
  {
    id: '7106020',
    regencyId: '7106',
    name: 'Kauditan',
  },
  {
    id: '7106030',
    regencyId: '7106',
    name: 'Airmadidi',
  },
  {
    id: '7106040',
    regencyId: '7106',
    name: 'Kalawat',
  },
  {
    id: '7106050',
    regencyId: '7106',
    name: 'Dimembe',
  },
  {
    id: '7106051',
    regencyId: '7106',
    name: 'Talawaan',
  },
  {
    id: '7106060',
    regencyId: '7106',
    name: 'Wori',
  },
  {
    id: '7106070',
    regencyId: '7106',
    name: 'Likupang Barat',
  },
  {
    id: '7106080',
    regencyId: '7106',
    name: 'Likupang Timur',
  },
  {
    id: '7106081',
    regencyId: '7106',
    name: 'Likupang Selatan',
  },
  {
    id: '7107010',
    regencyId: '7107',
    name: 'Sangkub',
  },
  {
    id: '7107020',
    regencyId: '7107',
    name: 'Bintauna',
  },
  {
    id: '7107030',
    regencyId: '7107',
    name: 'Bolang Itang Timur',
  },
  {
    id: '7107040',
    regencyId: '7107',
    name: 'Bolang Itang Barat',
  },
  {
    id: '7107050',
    regencyId: '7107',
    name: 'Kaidipang',
  },
  {
    id: '7107060',
    regencyId: '7107',
    name: 'Pinogaluman',
  },
  {
    id: '7108010',
    regencyId: '7108',
    name: 'Biaro',
  },
  {
    id: '7108020',
    regencyId: '7108',
    name: 'Tagulandang Selatan',
  },
  {
    id: '7108030',
    regencyId: '7108',
    name: 'Tagulandang',
  },
  {
    id: '7108040',
    regencyId: '7108',
    name: 'Tagulandang Utara',
  },
  {
    id: '7108050',
    regencyId: '7108',
    name: 'Siau Barat Selatan',
  },
  {
    id: '7108060',
    regencyId: '7108',
    name: 'Siau Timur Selatan',
  },
  {
    id: '7108070',
    regencyId: '7108',
    name: 'Siau Barat',
  },
  {
    id: '7108080',
    regencyId: '7108',
    name: 'Siau Tengah',
  },
  {
    id: '7108090',
    regencyId: '7108',
    name: 'Siau Timur',
  },
  {
    id: '7108100',
    regencyId: '7108',
    name: 'Siau Barat Utara',
  },
  {
    id: '7109010',
    regencyId: '7109',
    name: 'Ratatotok',
  },
  {
    id: '7109020',
    regencyId: '7109',
    name: 'Pusomaen',
  },
  {
    id: '7109030',
    regencyId: '7109',
    name: 'Belang',
  },
  {
    id: '7109040',
    regencyId: '7109',
    name: 'Ratahan',
  },
  {
    id: '7109041',
    regencyId: '7109',
    name: 'Pasan',
  },
  {
    id: '7109042',
    regencyId: '7109',
    name: 'Ratahan Timur',
  },
  {
    id: '7109050',
    regencyId: '7109',
    name: 'Tombatu',
  },
  {
    id: '7109051',
    regencyId: '7109',
    name: 'Tombatu Timur',
  },
  {
    id: '7109052',
    regencyId: '7109',
    name: 'Tombatu Utara',
  },
  {
    id: '7109060',
    regencyId: '7109',
    name: 'Touluaan',
  },
  {
    id: '7109061',
    regencyId: '7109',
    name: 'Touluaan Selatan',
  },
  {
    id: '7109062',
    regencyId: '7109',
    name: 'Silian Raya',
  },
  {
    id: '7110010',
    regencyId: '7110',
    name: 'Posigadan',
  },
  {
    id: '7110011',
    regencyId: '7110',
    name: 'Tomini',
  },
  {
    id: '7110020',
    regencyId: '7110',
    name: 'Bolang Uki',
  },
  {
    id: '7110021',
    regencyId: '7110',
    name: 'Helumo',
  },
  {
    id: '7110030',
    regencyId: '7110',
    name: 'Pinolosian',
  },
  {
    id: '7110040',
    regencyId: '7110',
    name: 'Pinolosian Tengah',
  },
  {
    id: '7110050',
    regencyId: '7110',
    name: 'Pinolosian Timur',
  },
  {
    id: '7111010',
    regencyId: '7111',
    name: 'Nuangan',
  },
  {
    id: '7111011',
    regencyId: '7111',
    name: 'Motongkad',
  },
  {
    id: '7111020',
    regencyId: '7111',
    name: 'Tutuyan',
  },
  {
    id: '7111030',
    regencyId: '7111',
    name: 'Kotabunan',
  },
  {
    id: '7111040',
    regencyId: '7111',
    name: 'Modayag',
  },
  {
    id: '7111041',
    regencyId: '7111',
    name: 'Mooat',
  },
  {
    id: '7111050',
    regencyId: '7111',
    name: 'Modayag Barat',
  },
  {
    id: '7171010',
    regencyId: '7171',
    name: 'Malalayang',
  },
  {
    id: '7171020',
    regencyId: '7171',
    name: 'Sario',
  },
  {
    id: '7171021',
    regencyId: '7171',
    name: 'Wanea',
  },
  {
    id: '7171030',
    regencyId: '7171',
    name: 'Wenang',
  },
  {
    id: '7171031',
    regencyId: '7171',
    name: 'Tikala',
  },
  {
    id: '7171032',
    regencyId: '7171',
    name: 'Paal Dua',
  },
  {
    id: '7171040',
    regencyId: '7171',
    name: 'Mapanget',
  },
  {
    id: '7171051',
    regencyId: '7171',
    name: 'Singkil',
  },
  {
    id: '7171052',
    regencyId: '7171',
    name: 'Tuminting',
  },
  {
    id: '7171053',
    regencyId: '7171',
    name: 'Bunaken',
  },
  {
    id: '7171054',
    regencyId: '7171',
    name: 'Bunaken Kepulauan',
  },
  {
    id: '7172010',
    regencyId: '7172',
    name: 'Madidir',
  },
  {
    id: '7172011',
    regencyId: '7172',
    name: 'Matuari',
  },
  {
    id: '7172012',
    regencyId: '7172',
    name: 'Girian',
  },
  {
    id: '7172021',
    regencyId: '7172',
    name: 'Lembeh Selatan',
  },
  {
    id: '7172022',
    regencyId: '7172',
    name: 'Lembeh Utara',
  },
  {
    id: '7172030',
    regencyId: '7172',
    name: 'Aertembaga',
  },
  {
    id: '7172031',
    regencyId: '7172',
    name: 'Maesa',
  },
  {
    id: '7172040',
    regencyId: '7172',
    name: 'Ranowulu',
  },
  {
    id: '7173010',
    regencyId: '7173',
    name: 'Tomohon Selatan',
  },
  {
    id: '7173020',
    regencyId: '7173',
    name: 'Tomohon Tengah',
  },
  {
    id: '7173021',
    regencyId: '7173',
    name: 'Tomohon Timur',
  },
  {
    id: '7173022',
    regencyId: '7173',
    name: 'Tomohon Barat',
  },
  {
    id: '7173030',
    regencyId: '7173',
    name: 'Tomohon Utara',
  },
  {
    id: '7174010',
    regencyId: '7174',
    name: 'Kotamobagu Selatan',
  },
  {
    id: '7174020',
    regencyId: '7174',
    name: 'Kotamobagu Timur',
  },
  {
    id: '7174030',
    regencyId: '7174',
    name: 'Kotamobagu Barat',
  },
  {
    id: '7174040',
    regencyId: '7174',
    name: 'Kotamobagu Utara',
  },
  {
    id: '7201030',
    regencyId: '7201',
    name: 'Totikum',
  },
  {
    id: '7201031',
    regencyId: '7201',
    name: 'Totikum Selatan',
  },
  {
    id: '7201040',
    regencyId: '7201',
    name: 'Tinangkung',
  },
  {
    id: '7201041',
    regencyId: '7201',
    name: 'Tinangkung Selatan',
  },
  {
    id: '7201042',
    regencyId: '7201',
    name: 'Tinangkung Utara',
  },
  {
    id: '7201050',
    regencyId: '7201',
    name: 'Liang',
  },
  {
    id: '7201051',
    regencyId: '7201',
    name: 'Peling Tengah',
  },
  {
    id: '7201060',
    regencyId: '7201',
    name: 'Bulagi',
  },
  {
    id: '7201061',
    regencyId: '7201',
    name: 'Bulagi Selatan',
  },
  {
    id: '7201062',
    regencyId: '7201',
    name: 'Bulagi Utara',
  },
  {
    id: '7201070',
    regencyId: '7201',
    name: 'Buko',
  },
  {
    id: '7201071',
    regencyId: '7201',
    name: 'Buko Selatan',
  },
  {
    id: '7202010',
    regencyId: '7202',
    name: 'Toili',
  },
  {
    id: '7202011',
    regencyId: '7202',
    name: 'Toili Barat',
  },
  {
    id: '7202012',
    regencyId: '7202',
    name: 'Moilong',
  },
  {
    id: '7202020',
    regencyId: '7202',
    name: 'Batui',
  },
  {
    id: '7202021',
    regencyId: '7202',
    name: 'Batui Selatan',
  },
  {
    id: '7202030',
    regencyId: '7202',
    name: 'Bunta',
  },
  {
    id: '7202031',
    regencyId: '7202',
    name: 'Nuhon',
  },
  {
    id: '7202032',
    regencyId: '7202',
    name: 'Simpang Raya',
  },
  {
    id: '7202040',
    regencyId: '7202',
    name: 'Kintom',
  },
  {
    id: '7202050',
    regencyId: '7202',
    name: 'Luwuk',
  },
  {
    id: '7202051',
    regencyId: '7202',
    name: 'Luwuk Timur',
  },
  {
    id: '7202052',
    regencyId: '7202',
    name: 'Luwuk Utara',
  },
  {
    id: '7202053',
    regencyId: '7202',
    name: 'Luwuk Selatan',
  },
  {
    id: '7202054',
    regencyId: '7202',
    name: 'Nambo',
  },
  {
    id: '7202060',
    regencyId: '7202',
    name: 'Pagimana',
  },
  {
    id: '7202061',
    regencyId: '7202',
    name: 'Bualemo',
  },
  {
    id: '7202062',
    regencyId: '7202',
    name: 'Lobu',
  },
  {
    id: '7202070',
    regencyId: '7202',
    name: 'Lamala',
  },
  {
    id: '7202071',
    regencyId: '7202',
    name: 'Masama',
  },
  {
    id: '7202072',
    regencyId: '7202',
    name: 'Mantoh',
  },
  {
    id: '7202080',
    regencyId: '7202',
    name: 'Balantak',
  },
  {
    id: '7202081',
    regencyId: '7202',
    name: 'Balantak Selatan',
  },
  {
    id: '7202082',
    regencyId: '7202',
    name: 'Balantak Utara',
  },
  {
    id: '7203010',
    regencyId: '7203',
    name: 'Menui Kepulauan',
  },
  {
    id: '7203020',
    regencyId: '7203',
    name: 'Bungku Selatan',
  },
  {
    id: '7203021',
    regencyId: '7203',
    name: 'Bahodopi',
  },
  {
    id: '7203022',
    regencyId: '7203',
    name: 'Bungku Pesisir',
  },
  {
    id: '7203030',
    regencyId: '7203',
    name: 'Bungku Tengah',
  },
  {
    id: '7203031',
    regencyId: '7203',
    name: 'Bungku Timur',
  },
  {
    id: '7203040',
    regencyId: '7203',
    name: 'Bungku Barat',
  },
  {
    id: '7203041',
    regencyId: '7203',
    name: 'Bumi Raya',
  },
  {
    id: '7203042',
    regencyId: '7203',
    name: 'Wita Ponda',
  },
  {
    id: '7204010',
    regencyId: '7204',
    name: 'Pamona Selatan',
  },
  {
    id: '7204011',
    regencyId: '7204',
    name: 'Pamona Barat',
  },
  {
    id: '7204012',
    regencyId: '7204',
    name: 'Pamona Tenggara',
  },
  {
    id: '7204020',
    regencyId: '7204',
    name: 'Lore Selatan',
  },
  {
    id: '7204021',
    regencyId: '7204',
    name: 'Lore Barat',
  },
  {
    id: '7204030',
    regencyId: '7204',
    name: 'Pamona Pusalemba',
  },
  {
    id: '7204031',
    regencyId: '7204',
    name: 'Pamona Timur',
  },
  {
    id: '7204032',
    regencyId: '7204',
    name: 'Pamona Utara',
  },
  {
    id: '7204040',
    regencyId: '7204',
    name: 'Lore Utara',
  },
  {
    id: '7204041',
    regencyId: '7204',
    name: 'Lore Tengah',
  },
  {
    id: '7204042',
    regencyId: '7204',
    name: 'Lore Timur',
  },
  {
    id: '7204043',
    regencyId: '7204',
    name: 'Lore Peore',
  },
  {
    id: '7204050',
    regencyId: '7204',
    name: 'Poso Pesisir',
  },
  {
    id: '7204051',
    regencyId: '7204',
    name: 'Poso Pesisir Selatan',
  },
  {
    id: '7204052',
    regencyId: '7204',
    name: 'Poso Pesisir Utara',
  },
  {
    id: '7204060',
    regencyId: '7204',
    name: 'Lage',
  },
  {
    id: '7204070',
    regencyId: '7204',
    name: 'Poso Kota',
  },
  {
    id: '7204071',
    regencyId: '7204',
    name: 'Poso Kota Utara',
  },
  {
    id: '7204072',
    regencyId: '7204',
    name: 'Poso Kota Selatan',
  },
  {
    id: '7205041',
    regencyId: '7205',
    name: 'Rio Pakava',
  },
  {
    id: '7205051',
    regencyId: '7205',
    name: 'Pinembani',
  },
  {
    id: '7205080',
    regencyId: '7205',
    name: 'Banawa',
  },
  {
    id: '7205081',
    regencyId: '7205',
    name: 'Banawa Selatan',
  },
  {
    id: '7205082',
    regencyId: '7205',
    name: 'Banawa Tengah',
  },
  {
    id: '7205090',
    regencyId: '7205',
    name: 'Labuan',
  },
  {
    id: '7205091',
    regencyId: '7205',
    name: 'Tanantovea',
  },
  {
    id: '7205100',
    regencyId: '7205',
    name: 'Sindue',
  },
  {
    id: '7205101',
    regencyId: '7205',
    name: 'Sindue Tombusabora',
  },
  {
    id: '7205102',
    regencyId: '7205',
    name: 'Sindue Tobata',
  },
  {
    id: '7205120',
    regencyId: '7205',
    name: 'Sirenja',
  },
  {
    id: '7205130',
    regencyId: '7205',
    name: 'Balaesang',
  },
  {
    id: '7205131',
    regencyId: '7205',
    name: 'Balaesang Tanjung',
  },
  {
    id: '7205140',
    regencyId: '7205',
    name: 'Dampelas',
  },
  {
    id: '7205160',
    regencyId: '7205',
    name: 'Sojol',
  },
  {
    id: '7205161',
    regencyId: '7205',
    name: 'Sojol Utara',
  },
  {
    id: '7206010',
    regencyId: '7206',
    name: 'Dampal Selatan',
  },
  {
    id: '7206020',
    regencyId: '7206',
    name: 'Dampal Utara',
  },
  {
    id: '7206030',
    regencyId: '7206',
    name: 'Dondo',
  },
  {
    id: '7206031',
    regencyId: '7206',
    name: 'Ogodeide',
  },
  {
    id: '7206032',
    regencyId: '7206',
    name: 'Basidondo',
  },
  {
    id: '7206040',
    regencyId: '7206',
    name: 'Baolan',
  },
  {
    id: '7206041',
    regencyId: '7206',
    name: 'Lampasio',
  },
  {
    id: '7206050',
    regencyId: '7206',
    name: 'Galang',
  },
  {
    id: '7206060',
    regencyId: '7206',
    name: 'Tolitoli Utara',
  },
  {
    id: '7206061',
    regencyId: '7206',
    name: 'Dako Pamean',
  },
  {
    id: '7207010',
    regencyId: '7207',
    name: 'Lakea',
  },
  {
    id: '7207011',
    regencyId: '7207',
    name: 'Biau',
  },
  {
    id: '7207012',
    regencyId: '7207',
    name: 'Karamat',
  },
  {
    id: '7207020',
    regencyId: '7207',
    name: 'Momunu',
  },
  {
    id: '7207021',
    regencyId: '7207',
    name: 'Tiloan',
  },
  {
    id: '7207030',
    regencyId: '7207',
    name: 'Bokat',
  },
  {
    id: '7207031',
    regencyId: '7207',
    name: 'Bukal',
  },
  {
    id: '7207040',
    regencyId: '7207',
    name: 'Bunobogu',
  },
  {
    id: '7207041',
    regencyId: '7207',
    name: 'Gadung',
  },
  {
    id: '7207050',
    regencyId: '7207',
    name: 'Paleleh',
  },
  {
    id: '7207051',
    regencyId: '7207',
    name: 'Paleleh Barat',
  },
  {
    id: '7208010',
    regencyId: '7208',
    name: 'Sausu',
  },
  {
    id: '7208011',
    regencyId: '7208',
    name: 'Torue',
  },
  {
    id: '7208012',
    regencyId: '7208',
    name: 'Balinggi',
  },
  {
    id: '7208020',
    regencyId: '7208',
    name: 'Parigi',
  },
  {
    id: '7208021',
    regencyId: '7208',
    name: 'Parigi Selatan',
  },
  {
    id: '7208022',
    regencyId: '7208',
    name: 'Parigi Barat',
  },
  {
    id: '7208023',
    regencyId: '7208',
    name: 'Parigi Utara',
  },
  {
    id: '7208024',
    regencyId: '7208',
    name: 'Parigi Tengah',
  },
  {
    id: '7208030',
    regencyId: '7208',
    name: 'Ampibabo',
  },
  {
    id: '7208031',
    regencyId: '7208',
    name: 'Kasimbar',
  },
  {
    id: '7208032',
    regencyId: '7208',
    name: 'Toribulu',
  },
  {
    id: '7208033',
    regencyId: '7208',
    name: 'Siniu',
  },
  {
    id: '7208040',
    regencyId: '7208',
    name: 'Tinombo',
  },
  {
    id: '7208041',
    regencyId: '7208',
    name: 'Tinombo Selatan',
  },
  {
    id: '7208042',
    regencyId: '7208',
    name: 'Sidoan',
  },
  {
    id: '7208050',
    regencyId: '7208',
    name: 'Tomini',
  },
  {
    id: '7208051',
    regencyId: '7208',
    name: 'Mepanga',
  },
  {
    id: '7208052',
    regencyId: '7208',
    name: 'Palasa',
  },
  {
    id: '7208060',
    regencyId: '7208',
    name: 'Moutong',
  },
  {
    id: '7208061',
    regencyId: '7208',
    name: 'Bolano Lambunu',
  },
  {
    id: '7208062',
    regencyId: '7208',
    name: 'Taopa',
  },
  {
    id: '7208063',
    regencyId: '7208',
    name: 'Bolano',
  },
  {
    id: '7208064',
    regencyId: '7208',
    name: 'Ongka Malino',
  },
  {
    id: '7209010',
    regencyId: '7209',
    name: 'Tojo Barat',
  },
  {
    id: '7209020',
    regencyId: '7209',
    name: 'Tojo',
  },
  {
    id: '7209030',
    regencyId: '7209',
    name: 'Ulubongka',
  },
  {
    id: '7209040',
    regencyId: '7209',
    name: 'Ampana Tete',
  },
  {
    id: '7209050',
    regencyId: '7209',
    name: 'Ampana Kota',
  },
  {
    id: '7209051',
    regencyId: '7209',
    name: 'Ratolindo',
  },
  {
    id: '7209060',
    regencyId: '7209',
    name: 'Una - Una',
  },
  {
    id: '7209061',
    regencyId: '7209',
    name: 'Batudaka',
  },
  {
    id: '7209070',
    regencyId: '7209',
    name: 'Togean',
  },
  {
    id: '7209080',
    regencyId: '7209',
    name: 'Walea Kepulauan',
  },
  {
    id: '7209081',
    regencyId: '7209',
    name: 'Walea Besar',
  },
  {
    id: '7209082',
    regencyId: '7209',
    name: 'Talatako',
  },
  {
    id: '7210010',
    regencyId: '7210',
    name: 'Pipikoro',
  },
  {
    id: '7210020',
    regencyId: '7210',
    name: 'Kulawi Selatan',
  },
  {
    id: '7210030',
    regencyId: '7210',
    name: 'Kulawi',
  },
  {
    id: '7210040',
    regencyId: '7210',
    name: 'Lindu',
  },
  {
    id: '7210050',
    regencyId: '7210',
    name: 'Nokilalaki',
  },
  {
    id: '7210060',
    regencyId: '7210',
    name: 'Palolo',
  },
  {
    id: '7210070',
    regencyId: '7210',
    name: 'Gumbasa',
  },
  {
    id: '7210080',
    regencyId: '7210',
    name: 'Dolo Selatan',
  },
  {
    id: '7210090',
    regencyId: '7210',
    name: 'Dolo Barat',
  },
  {
    id: '7210100',
    regencyId: '7210',
    name: 'Tanambulava',
  },
  {
    id: '7210110',
    regencyId: '7210',
    name: 'Dolo',
  },
  {
    id: '7210120',
    regencyId: '7210',
    name: 'Sigi Biromaru',
  },
  {
    id: '7210130',
    regencyId: '7210',
    name: 'Marawola',
  },
  {
    id: '7210140',
    regencyId: '7210',
    name: 'Marawola Barat',
  },
  {
    id: '7210150',
    regencyId: '7210',
    name: 'Kinovaro',
  },
  {
    id: '7211010',
    regencyId: '7211',
    name: 'Bangkurung',
  },
  {
    id: '7211020',
    regencyId: '7211',
    name: 'Labobo',
  },
  {
    id: '7211030',
    regencyId: '7211',
    name: 'Banggai Utara',
  },
  {
    id: '7211040',
    regencyId: '7211',
    name: 'Banggai',
  },
  {
    id: '7211050',
    regencyId: '7211',
    name: 'Banggai Tengah',
  },
  {
    id: '7211060',
    regencyId: '7211',
    name: 'Banggai Selatan',
  },
  {
    id: '7211070',
    regencyId: '7211',
    name: 'Bokan Kepulauan',
  },
  {
    id: '7212010',
    regencyId: '7212',
    name: 'Mori Atas',
  },
  {
    id: '7212020',
    regencyId: '7212',
    name: 'Lembo',
  },
  {
    id: '7212030',
    regencyId: '7212',
    name: 'Lembo Raya',
  },
  {
    id: '7212040',
    regencyId: '7212',
    name: 'Petasia Timur',
  },
  {
    id: '7212050',
    regencyId: '7212',
    name: 'Petasia',
  },
  {
    id: '7212060',
    regencyId: '7212',
    name: 'Petasia Barat',
  },
  {
    id: '7212070',
    regencyId: '7212',
    name: 'Mori Utara',
  },
  {
    id: '7212080',
    regencyId: '7212',
    name: 'Soyo Jaya',
  },
  {
    id: '7212090',
    regencyId: '7212',
    name: 'Bungku Utara',
  },
  {
    id: '7212100',
    regencyId: '7212',
    name: 'Mamosalato',
  },
  {
    id: '7271010',
    regencyId: '7271',
    name: 'Palu Barat',
  },
  {
    id: '7271011',
    regencyId: '7271',
    name: 'Tatanga',
  },
  {
    id: '7271012',
    regencyId: '7271',
    name: 'Ulujadi',
  },
  {
    id: '7271020',
    regencyId: '7271',
    name: 'Palu Selatan',
  },
  {
    id: '7271030',
    regencyId: '7271',
    name: 'Palu Timur',
  },
  {
    id: '7271031',
    regencyId: '7271',
    name: 'Mantikulore',
  },
  {
    id: '7271040',
    regencyId: '7271',
    name: 'Palu Utara',
  },
  {
    id: '7271041',
    regencyId: '7271',
    name: 'Tawaeli',
  },
  {
    id: '7301010',
    regencyId: '7301',
    name: 'Pasimarannu',
  },
  {
    id: '7301011',
    regencyId: '7301',
    name: 'Pasilambena',
  },
  {
    id: '7301020',
    regencyId: '7301',
    name: 'Pasimassunggu',
  },
  {
    id: '7301021',
    regencyId: '7301',
    name: 'Takabonerate',
  },
  {
    id: '7301022',
    regencyId: '7301',
    name: 'Pasimassunggu Timur',
  },
  {
    id: '7301030',
    regencyId: '7301',
    name: 'Bontosikuyu',
  },
  {
    id: '7301040',
    regencyId: '7301',
    name: 'Bontoharu',
  },
  {
    id: '7301041',
    regencyId: '7301',
    name: 'Benteng',
  },
  {
    id: '7301042',
    regencyId: '7301',
    name: 'Bontomanai',
  },
  {
    id: '7301050',
    regencyId: '7301',
    name: 'Bontomatene',
  },
  {
    id: '7301051',
    regencyId: '7301',
    name: 'Buki',
  },
  {
    id: '7302010',
    regencyId: '7302',
    name: 'Gantarang',
  },
  {
    id: '7302020',
    regencyId: '7302',
    name: 'Ujung Bulu',
  },
  {
    id: '7302021',
    regencyId: '7302',
    name: 'Ujung Loe',
  },
  {
    id: '7302030',
    regencyId: '7302',
    name: 'Bonto Bahari',
  },
  {
    id: '7302040',
    regencyId: '7302',
    name: 'Bontotiro',
  },
  {
    id: '7302050',
    regencyId: '7302',
    name: 'Hero Lange-Lange',
  },
  {
    id: '7302060',
    regencyId: '7302',
    name: 'Kajang',
  },
  {
    id: '7302070',
    regencyId: '7302',
    name: 'Bulukumpa',
  },
  {
    id: '7302080',
    regencyId: '7302',
    name: 'Rilau Ale',
  },
  {
    id: '7302090',
    regencyId: '7302',
    name: 'Kindang',
  },
  {
    id: '7303010',
    regencyId: '7303',
    name: 'Bissappu',
  },
  {
    id: '7303011',
    regencyId: '7303',
    name: 'Uluere',
  },
  {
    id: '7303012',
    regencyId: '7303',
    name: 'Sinoa',
  },
  {
    id: '7303020',
    regencyId: '7303',
    name: 'Bantaeng',
  },
  {
    id: '7303021',
    regencyId: '7303',
    name: 'Eremerasa',
  },
  {
    id: '7303030',
    regencyId: '7303',
    name: 'Tompobulu',
  },
  {
    id: '7303031',
    regencyId: '7303',
    name: "Pa'Jukukang",
  },
  {
    id: '7303032',
    regencyId: '7303',
    name: 'Gantarangkeke',
  },
  {
    id: '7304010',
    regencyId: '7304',
    name: 'Bangkala',
  },
  {
    id: '7304011',
    regencyId: '7304',
    name: 'Bangkala Barat',
  },
  {
    id: '7304020',
    regencyId: '7304',
    name: 'Tamalatea',
  },
  {
    id: '7304021',
    regencyId: '7304',
    name: 'Bontoramba',
  },
  {
    id: '7304030',
    regencyId: '7304',
    name: 'Binamu',
  },
  {
    id: '7304031',
    regencyId: '7304',
    name: 'Turatea',
  },
  {
    id: '7304040',
    regencyId: '7304',
    name: 'Batang',
  },
  {
    id: '7304041',
    regencyId: '7304',
    name: 'Arungkeke',
  },
  {
    id: '7304042',
    regencyId: '7304',
    name: 'Tarowang',
  },
  {
    id: '7304050',
    regencyId: '7304',
    name: 'Kelara',
  },
  {
    id: '7304051',
    regencyId: '7304',
    name: 'Rumbia',
  },
  {
    id: '7305010',
    regencyId: '7305',
    name: 'Mangara Bombang',
  },
  {
    id: '7305020',
    regencyId: '7305',
    name: 'Mappakasunggu',
  },
  {
    id: '7305021',
    regencyId: '7305',
    name: 'Sanrobone',
  },
  {
    id: '7305030',
    regencyId: '7305',
    name: 'Polombangkeng Selatan',
  },
  {
    id: '7305031',
    regencyId: '7305',
    name: 'Pattallassang',
  },
  {
    id: '7305040',
    regencyId: '7305',
    name: 'Polombangkeng Utara',
  },
  {
    id: '7305050',
    regencyId: '7305',
    name: 'Galesong Selatan',
  },
  {
    id: '7305051',
    regencyId: '7305',
    name: 'Galesong',
  },
  {
    id: '7305060',
    regencyId: '7305',
    name: 'Galesong Utara',
  },
  {
    id: '7306010',
    regencyId: '7306',
    name: 'Bontonompo',
  },
  {
    id: '7306011',
    regencyId: '7306',
    name: 'Bontonompo Selatan',
  },
  {
    id: '7306020',
    regencyId: '7306',
    name: 'Bajeng',
  },
  {
    id: '7306021',
    regencyId: '7306',
    name: 'Bajeng Barat',
  },
  {
    id: '7306030',
    regencyId: '7306',
    name: 'Pallangga',
  },
  {
    id: '7306031',
    regencyId: '7306',
    name: 'Barombong',
  },
  {
    id: '7306040',
    regencyId: '7306',
    name: 'Somba Opu',
  },
  {
    id: '7306050',
    regencyId: '7306',
    name: 'Bontomarannu',
  },
  {
    id: '7306051',
    regencyId: '7306',
    name: 'Pattallassang',
  },
  {
    id: '7306060',
    regencyId: '7306',
    name: 'Parangloe',
  },
  {
    id: '7306061',
    regencyId: '7306',
    name: 'Manuju',
  },
  {
    id: '7306070',
    regencyId: '7306',
    name: 'Tinggimoncong',
  },
  {
    id: '7306071',
    regencyId: '7306',
    name: 'Tombolo Pao',
  },
  {
    id: '7306072',
    regencyId: '7306',
    name: 'Parigi',
  },
  {
    id: '7306080',
    regencyId: '7306',
    name: 'Bungaya',
  },
  {
    id: '7306081',
    regencyId: '7306',
    name: 'Bontolempangan',
  },
  {
    id: '7306090',
    regencyId: '7306',
    name: 'Tompobulu',
  },
  {
    id: '7306091',
    regencyId: '7306',
    name: 'Biringbulu',
  },
  {
    id: '7307010',
    regencyId: '7307',
    name: 'Sinjai Barat',
  },
  {
    id: '7307020',
    regencyId: '7307',
    name: 'Sinjai Borong',
  },
  {
    id: '7307030',
    regencyId: '7307',
    name: 'Sinjai Selatan',
  },
  {
    id: '7307040',
    regencyId: '7307',
    name: 'Tellu Limpoe',
  },
  {
    id: '7307050',
    regencyId: '7307',
    name: 'Sinjai Timur',
  },
  {
    id: '7307060',
    regencyId: '7307',
    name: 'Sinjai Tengah',
  },
  {
    id: '7307070',
    regencyId: '7307',
    name: 'Sinjai Utara',
  },
  {
    id: '7307080',
    regencyId: '7307',
    name: 'Bulupoddo',
  },
  {
    id: '7307090',
    regencyId: '7307',
    name: 'Pulau Sembilan',
  },
  {
    id: '7308010',
    regencyId: '7308',
    name: 'Mandai',
  },
  {
    id: '7308011',
    regencyId: '7308',
    name: 'Moncongloe',
  },
  {
    id: '7308020',
    regencyId: '7308',
    name: 'Maros Baru',
  },
  {
    id: '7308021',
    regencyId: '7308',
    name: 'Marusu',
  },
  {
    id: '7308022',
    regencyId: '7308',
    name: 'Turikale',
  },
  {
    id: '7308023',
    regencyId: '7308',
    name: 'Lau',
  },
  {
    id: '7308030',
    regencyId: '7308',
    name: 'Bontoa',
  },
  {
    id: '7308040',
    regencyId: '7308',
    name: 'Bantimurung',
  },
  {
    id: '7308041',
    regencyId: '7308',
    name: 'Simbang',
  },
  {
    id: '7308050',
    regencyId: '7308',
    name: 'Tanralili',
  },
  {
    id: '7308051',
    regencyId: '7308',
    name: 'Tompu Bulu',
  },
  {
    id: '7308060',
    regencyId: '7308',
    name: 'Camba',
  },
  {
    id: '7308061',
    regencyId: '7308',
    name: 'Cenrana',
  },
  {
    id: '7308070',
    regencyId: '7308',
    name: 'Mallawa',
  },
  {
    id: '7309010',
    regencyId: '7309',
    name: 'Liukang Tangaya',
  },
  {
    id: '7309020',
    regencyId: '7309',
    name: 'Liukang Kalmas',
  },
  {
    id: '7309030',
    regencyId: '7309',
    name: 'Liukang Tupabbiring',
  },
  {
    id: '7309031',
    regencyId: '7309',
    name: 'Liukang Tupabbiring Utara',
  },
  {
    id: '7309040',
    regencyId: '7309',
    name: 'Pangkajene',
  },
  {
    id: '7309041',
    regencyId: '7309',
    name: 'Minasatene',
  },
  {
    id: '7309050',
    regencyId: '7309',
    name: 'Balocci',
  },
  {
    id: '7309051',
    regencyId: '7309',
    name: 'Tondong Tallasa',
  },
  {
    id: '7309060',
    regencyId: '7309',
    name: 'Bungoro',
  },
  {
    id: '7309070',
    regencyId: '7309',
    name: 'Labakkang',
  },
  {
    id: '7309080',
    regencyId: '7309',
    name: "Ma'Rang",
  },
  {
    id: '7309091',
    regencyId: '7309',
    name: 'Segeri',
  },
  {
    id: '7309092',
    regencyId: '7309',
    name: 'Mandalle',
  },
  {
    id: '7310010',
    regencyId: '7310',
    name: 'Tanete Riaja',
  },
  {
    id: '7310011',
    regencyId: '7310',
    name: 'Pujananting',
  },
  {
    id: '7310020',
    regencyId: '7310',
    name: 'Tanete Rilau',
  },
  {
    id: '7310030',
    regencyId: '7310',
    name: 'Barru',
  },
  {
    id: '7310040',
    regencyId: '7310',
    name: 'Soppeng Riaja',
  },
  {
    id: '7310041',
    regencyId: '7310',
    name: 'Balusu',
  },
  {
    id: '7310050',
    regencyId: '7310',
    name: 'Mallusetasi',
  },
  {
    id: '7311010',
    regencyId: '7311',
    name: 'Bontocani',
  },
  {
    id: '7311020',
    regencyId: '7311',
    name: 'Kahu',
  },
  {
    id: '7311030',
    regencyId: '7311',
    name: 'Kajuara',
  },
  {
    id: '7311040',
    regencyId: '7311',
    name: 'Salomekko',
  },
  {
    id: '7311050',
    regencyId: '7311',
    name: 'Tonra',
  },
  {
    id: '7311060',
    regencyId: '7311',
    name: 'Patimpeng',
  },
  {
    id: '7311070',
    regencyId: '7311',
    name: 'Libureng',
  },
  {
    id: '7311080',
    regencyId: '7311',
    name: 'Mare',
  },
  {
    id: '7311090',
    regencyId: '7311',
    name: 'Sibulue',
  },
  {
    id: '7311100',
    regencyId: '7311',
    name: 'Cina',
  },
  {
    id: '7311110',
    regencyId: '7311',
    name: 'Barebbo',
  },
  {
    id: '7311120',
    regencyId: '7311',
    name: 'Ponre',
  },
  {
    id: '7311130',
    regencyId: '7311',
    name: 'Lappariaja',
  },
  {
    id: '7311140',
    regencyId: '7311',
    name: 'Lamuru',
  },
  {
    id: '7311141',
    regencyId: '7311',
    name: 'Tellu Limpoe',
  },
  {
    id: '7311150',
    regencyId: '7311',
    name: 'Bengo',
  },
  {
    id: '7311160',
    regencyId: '7311',
    name: 'Ulaweng',
  },
  {
    id: '7311170',
    regencyId: '7311',
    name: 'Palakka',
  },
  {
    id: '7311180',
    regencyId: '7311',
    name: 'Awangpone',
  },
  {
    id: '7311190',
    regencyId: '7311',
    name: 'Tellu Siattinge',
  },
  {
    id: '7311200',
    regencyId: '7311',
    name: 'Amali',
  },
  {
    id: '7311210',
    regencyId: '7311',
    name: 'Ajangale',
  },
  {
    id: '7311220',
    regencyId: '7311',
    name: 'Dua Boccoe',
  },
  {
    id: '7311230',
    regencyId: '7311',
    name: 'Cenrana',
  },
  {
    id: '7311710',
    regencyId: '7311',
    name: 'Tanete Riattang Barat',
  },
  {
    id: '7311720',
    regencyId: '7311',
    name: 'Tanete Riattang',
  },
  {
    id: '7311730',
    regencyId: '7311',
    name: 'Tanete Riattang Timur',
  },
  {
    id: '7312010',
    regencyId: '7312',
    name: 'Mario Riwawo',
  },
  {
    id: '7312020',
    regencyId: '7312',
    name: 'Lalabata',
  },
  {
    id: '7312030',
    regencyId: '7312',
    name: 'Lili Riaja',
  },
  {
    id: '7312031',
    regencyId: '7312',
    name: 'Ganra',
  },
  {
    id: '7312032',
    regencyId: '7312',
    name: 'Citta',
  },
  {
    id: '7312040',
    regencyId: '7312',
    name: 'Lili Rilau',
  },
  {
    id: '7312050',
    regencyId: '7312',
    name: 'Donri Donri',
  },
  {
    id: '7312060',
    regencyId: '7312',
    name: 'Mario Riawa',
  },
  {
    id: '7313010',
    regencyId: '7313',
    name: 'Sabbang Paru',
  },
  {
    id: '7313020',
    regencyId: '7313',
    name: 'Tempe',
  },
  {
    id: '7313030',
    regencyId: '7313',
    name: 'Pammana',
  },
  {
    id: '7313040',
    regencyId: '7313',
    name: 'Bola',
  },
  {
    id: '7313050',
    regencyId: '7313',
    name: 'Takkalalla',
  },
  {
    id: '7313060',
    regencyId: '7313',
    name: 'Sajoanging',
  },
  {
    id: '7313061',
    regencyId: '7313',
    name: 'Penrang',
  },
  {
    id: '7313070',
    regencyId: '7313',
    name: 'Majauleng',
  },
  {
    id: '7313080',
    regencyId: '7313',
    name: 'Tana Sitolo',
  },
  {
    id: '7313090',
    regencyId: '7313',
    name: 'Belawa',
  },
  {
    id: '7313100',
    regencyId: '7313',
    name: 'Maniang Pajo',
  },
  {
    id: '7313101',
    regencyId: '7313',
    name: 'Gilireng',
  },
  {
    id: '7313110',
    regencyId: '7313',
    name: 'Keera',
  },
  {
    id: '7313120',
    regencyId: '7313',
    name: 'Pitumpanua',
  },
  {
    id: '7314010',
    regencyId: '7314',
    name: 'Panca Lautang',
  },
  {
    id: '7314020',
    regencyId: '7314',
    name: 'Tellulimpo E',
  },
  {
    id: '7314030',
    regencyId: '7314',
    name: 'Watang Pulu',
  },
  {
    id: '7314040',
    regencyId: '7314',
    name: 'Baranti',
  },
  {
    id: '7314050',
    regencyId: '7314',
    name: 'Panca Rijang',
  },
  {
    id: '7314051',
    regencyId: '7314',
    name: 'Kulo',
  },
  {
    id: '7314060',
    regencyId: '7314',
    name: 'Maritengngae',
  },
  {
    id: '7314061',
    regencyId: '7314',
    name: 'Watang Sidenreng',
  },
  {
    id: '7314070',
    regencyId: '7314',
    name: 'Pitu Riawa',
  },
  {
    id: '7314080',
    regencyId: '7314',
    name: 'Duapitue',
  },
  {
    id: '7314081',
    regencyId: '7314',
    name: 'Pitu Riase',
  },
  {
    id: '7315010',
    regencyId: '7315',
    name: 'Suppa',
  },
  {
    id: '7315020',
    regencyId: '7315',
    name: 'Mattirosompe',
  },
  {
    id: '7315021',
    regencyId: '7315',
    name: 'Lanrisang',
  },
  {
    id: '7315030',
    regencyId: '7315',
    name: 'Mattiro Bulu',
  },
  {
    id: '7315040',
    regencyId: '7315',
    name: 'Watang Sawitto',
  },
  {
    id: '7315041',
    regencyId: '7315',
    name: 'Paleteang',
  },
  {
    id: '7315042',
    regencyId: '7315',
    name: 'Tiroang',
  },
  {
    id: '7315050',
    regencyId: '7315',
    name: 'Patampanua',
  },
  {
    id: '7315060',
    regencyId: '7315',
    name: 'Cempa',
  },
  {
    id: '7315070',
    regencyId: '7315',
    name: 'Duampanua',
  },
  {
    id: '7315071',
    regencyId: '7315',
    name: 'Batulappa',
  },
  {
    id: '7315080',
    regencyId: '7315',
    name: 'Lembang',
  },
  {
    id: '7316010',
    regencyId: '7316',
    name: 'Maiwa',
  },
  {
    id: '7316011',
    regencyId: '7316',
    name: 'Bungin',
  },
  {
    id: '7316020',
    regencyId: '7316',
    name: 'Enrekang',
  },
  {
    id: '7316021',
    regencyId: '7316',
    name: 'Cendana',
  },
  {
    id: '7316030',
    regencyId: '7316',
    name: 'Baraka',
  },
  {
    id: '7316031',
    regencyId: '7316',
    name: 'Buntu Batu',
  },
  {
    id: '7316040',
    regencyId: '7316',
    name: 'Anggeraja',
  },
  {
    id: '7316041',
    regencyId: '7316',
    name: 'Malua',
  },
  {
    id: '7316050',
    regencyId: '7316',
    name: 'Alla',
  },
  {
    id: '7316051',
    regencyId: '7316',
    name: 'Curio',
  },
  {
    id: '7316052',
    regencyId: '7316',
    name: 'Masalle',
  },
  {
    id: '7316053',
    regencyId: '7316',
    name: 'Baroko',
  },
  {
    id: '7317010',
    regencyId: '7317',
    name: 'Larompong',
  },
  {
    id: '7317011',
    regencyId: '7317',
    name: 'Larompong Selatan',
  },
  {
    id: '7317020',
    regencyId: '7317',
    name: 'Suli',
  },
  {
    id: '7317021',
    regencyId: '7317',
    name: 'Suli Barat',
  },
  {
    id: '7317030',
    regencyId: '7317',
    name: 'Belopa',
  },
  {
    id: '7317031',
    regencyId: '7317',
    name: 'Kamanre',
  },
  {
    id: '7317032',
    regencyId: '7317',
    name: 'Belopa Utara',
  },
  {
    id: '7317040',
    regencyId: '7317',
    name: 'Bajo',
  },
  {
    id: '7317041',
    regencyId: '7317',
    name: 'Bajo Barat',
  },
  {
    id: '7317050',
    regencyId: '7317',
    name: 'Bassesangtempe',
  },
  {
    id: '7317051',
    regencyId: '7317',
    name: 'Latimojong',
  },
  {
    id: '7317052',
    regencyId: '7317',
    name: 'Bassesangtempe Utara',
  },
  {
    id: '7317060',
    regencyId: '7317',
    name: 'Bupon',
  },
  {
    id: '7317061',
    regencyId: '7317',
    name: 'Ponrang',
  },
  {
    id: '7317062',
    regencyId: '7317',
    name: 'Ponrang Selatan',
  },
  {
    id: '7317070',
    regencyId: '7317',
    name: 'Bua',
  },
  {
    id: '7317080',
    regencyId: '7317',
    name: 'Walenrang',
  },
  {
    id: '7317081',
    regencyId: '7317',
    name: 'Walenrang Timur',
  },
  {
    id: '7317090',
    regencyId: '7317',
    name: 'Lamasi',
  },
  {
    id: '7317091',
    regencyId: '7317',
    name: 'Walenrang Utara',
  },
  {
    id: '7317092',
    regencyId: '7317',
    name: 'Walenrang Barat',
  },
  {
    id: '7317093',
    regencyId: '7317',
    name: 'Lamasi Timur',
  },
  {
    id: '7318010',
    regencyId: '7318',
    name: 'Bonggakaradeng',
  },
  {
    id: '7318011',
    regencyId: '7318',
    name: 'Simbuang',
  },
  {
    id: '7318012',
    regencyId: '7318',
    name: 'Rano',
  },
  {
    id: '7318013',
    regencyId: '7318',
    name: 'Mappak',
  },
  {
    id: '7318020',
    regencyId: '7318',
    name: 'Mengkendek',
  },
  {
    id: '7318021',
    regencyId: '7318',
    name: 'Gandang Batu Silanan',
  },
  {
    id: '7318030',
    regencyId: '7318',
    name: 'Sangalla',
  },
  {
    id: '7318031',
    regencyId: '7318',
    name: 'Sangala Selatan',
  },
  {
    id: '7318032',
    regencyId: '7318',
    name: 'Sangalla Utara',
  },
  {
    id: '7318040',
    regencyId: '7318',
    name: 'Makale',
  },
  {
    id: '7318041',
    regencyId: '7318',
    name: 'Makale Selatan',
  },
  {
    id: '7318042',
    regencyId: '7318',
    name: 'Makale Utara',
  },
  {
    id: '7318050',
    regencyId: '7318',
    name: 'Saluputti',
  },
  {
    id: '7318051',
    regencyId: '7318',
    name: 'Bittuang',
  },
  {
    id: '7318052',
    regencyId: '7318',
    name: 'Rembon',
  },
  {
    id: '7318053',
    regencyId: '7318',
    name: 'Masanda',
  },
  {
    id: '7318054',
    regencyId: '7318',
    name: 'Malimbong Balepe',
  },
  {
    id: '7318061',
    regencyId: '7318',
    name: 'Rantetayo',
  },
  {
    id: '7318067',
    regencyId: '7318',
    name: 'Kurra',
  },
  {
    id: '7322010',
    regencyId: '7322',
    name: 'Sabbang',
  },
  {
    id: '7322020',
    regencyId: '7322',
    name: 'Baebunta',
  },
  {
    id: '7322030',
    regencyId: '7322',
    name: 'Malangke',
  },
  {
    id: '7322031',
    regencyId: '7322',
    name: 'Malangke Barat',
  },
  {
    id: '7322040',
    regencyId: '7322',
    name: 'Sukamaju',
  },
  {
    id: '7322050',
    regencyId: '7322',
    name: 'Bone-Bone',
  },
  {
    id: '7322051',
    regencyId: '7322',
    name: 'Tana Lili',
  },
  {
    id: '7322120',
    regencyId: '7322',
    name: 'Masamba',
  },
  {
    id: '7322121',
    regencyId: '7322',
    name: 'Mappedeceng',
  },
  {
    id: '7322122',
    regencyId: '7322',
    name: 'Rampi',
  },
  {
    id: '7322130',
    regencyId: '7322',
    name: 'Limbong',
  },
  {
    id: '7322131',
    regencyId: '7322',
    name: 'Seko',
  },
  {
    id: '7325010',
    regencyId: '7325',
    name: 'Burau',
  },
  {
    id: '7325020',
    regencyId: '7325',
    name: 'Wotu',
  },
  {
    id: '7325030',
    regencyId: '7325',
    name: 'Tomoni',
  },
  {
    id: '7325031',
    regencyId: '7325',
    name: 'Tomoni Timur',
  },
  {
    id: '7325040',
    regencyId: '7325',
    name: 'Angkona',
  },
  {
    id: '7325050',
    regencyId: '7325',
    name: 'Malili',
  },
  {
    id: '7325060',
    regencyId: '7325',
    name: 'Towuti',
  },
  {
    id: '7325070',
    regencyId: '7325',
    name: 'Nuha',
  },
  {
    id: '7325071',
    regencyId: '7325',
    name: 'Wasuponda',
  },
  {
    id: '7325080',
    regencyId: '7325',
    name: 'Mangkutana',
  },
  {
    id: '7325081',
    regencyId: '7325',
    name: 'Kalaena',
  },
  {
    id: '7326010',
    regencyId: '7326',
    name: 'Sopai',
  },
  {
    id: '7326020',
    regencyId: '7326',
    name: 'Kesu',
  },
  {
    id: '7326030',
    regencyId: '7326',
    name: 'Sanggalangi',
  },
  {
    id: '7326040',
    regencyId: '7326',
    name: 'Buntao',
  },
  {
    id: '7326050',
    regencyId: '7326',
    name: 'Rantebua',
  },
  {
    id: '7326060',
    regencyId: '7326',
    name: 'Nanggala',
  },
  {
    id: '7326070',
    regencyId: '7326',
    name: 'Tondon',
  },
  {
    id: '7326080',
    regencyId: '7326',
    name: 'Tallunglipu',
  },
  {
    id: '7326090',
    regencyId: '7326',
    name: 'Rantepao',
  },
  {
    id: '7326100',
    regencyId: '7326',
    name: 'Tikala',
  },
  {
    id: '7326110',
    regencyId: '7326',
    name: 'Sesean',
  },
  {
    id: '7326120',
    regencyId: '7326',
    name: 'Balusu',
  },
  {
    id: '7326130',
    regencyId: '7326',
    name: "Sa'Dan",
  },
  {
    id: '7326140',
    regencyId: '7326',
    name: 'Bengkelekila',
  },
  {
    id: '7326150',
    regencyId: '7326',
    name: 'Sesean Suloara',
  },
  {
    id: '7326160',
    regencyId: '7326',
    name: 'Kapala Pitu',
  },
  {
    id: '7326170',
    regencyId: '7326',
    name: 'Dende Piongan Napo',
  },
  {
    id: '7326180',
    regencyId: '7326',
    name: 'Awan Rante Karua',
  },
  {
    id: '7326190',
    regencyId: '7326',
    name: 'Rindingalo',
  },
  {
    id: '7326200',
    regencyId: '7326',
    name: 'Buntu Pepasan',
  },
  {
    id: '7326210',
    regencyId: '7326',
    name: 'Baruppu',
  },
  {
    id: '7371010',
    regencyId: '7371',
    name: 'Mariso',
  },
  {
    id: '7371020',
    regencyId: '7371',
    name: 'Mamajang',
  },
  {
    id: '7371030',
    regencyId: '7371',
    name: 'Tamalate',
  },
  {
    id: '7371031',
    regencyId: '7371',
    name: 'Rappocini',
  },
  {
    id: '7371040',
    regencyId: '7371',
    name: 'Makassar',
  },
  {
    id: '7371050',
    regencyId: '7371',
    name: 'Ujung Pandang',
  },
  {
    id: '7371060',
    regencyId: '7371',
    name: 'Wajo',
  },
  {
    id: '7371070',
    regencyId: '7371',
    name: 'Bontoala',
  },
  {
    id: '7371080',
    regencyId: '7371',
    name: 'Ujung Tanah',
  },
  {
    id: '7371081',
    regencyId: '7371',
    name: 'Kepulauan Sangkarrang',
  },
  {
    id: '7371090',
    regencyId: '7371',
    name: 'Tallo',
  },
  {
    id: '7371100',
    regencyId: '7371',
    name: 'Panakkukang',
  },
  {
    id: '7371101',
    regencyId: '7371',
    name: 'Manggala',
  },
  {
    id: '7371110',
    regencyId: '7371',
    name: 'Biring Kanaya',
  },
  {
    id: '7371111',
    regencyId: '7371',
    name: 'Tamalanrea',
  },
  {
    id: '7372010',
    regencyId: '7372',
    name: 'Bacukiki',
  },
  {
    id: '7372011',
    regencyId: '7372',
    name: 'Bacukiki Barat',
  },
  {
    id: '7372020',
    regencyId: '7372',
    name: 'Ujung',
  },
  {
    id: '7372030',
    regencyId: '7372',
    name: 'Soreang',
  },
  {
    id: '7373010',
    regencyId: '7373',
    name: 'Wara Selatan',
  },
  {
    id: '7373011',
    regencyId: '7373',
    name: 'Sendana',
  },
  {
    id: '7373020',
    regencyId: '7373',
    name: 'Wara',
  },
  {
    id: '7373021',
    regencyId: '7373',
    name: 'Wara Timur',
  },
  {
    id: '7373022',
    regencyId: '7373',
    name: 'Mungkajang',
  },
  {
    id: '7373030',
    regencyId: '7373',
    name: 'Wara Utara',
  },
  {
    id: '7373031',
    regencyId: '7373',
    name: 'Bara',
  },
  {
    id: '7373040',
    regencyId: '7373',
    name: 'Telluwanua',
  },
  {
    id: '7373041',
    regencyId: '7373',
    name: 'Wara Barat',
  },
  {
    id: '7401050',
    regencyId: '7401',
    name: 'Lasalimu',
  },
  {
    id: '7401051',
    regencyId: '7401',
    name: 'Lasalimu Selatan',
  },
  {
    id: '7401052',
    regencyId: '7401',
    name: 'Siontapina',
  },
  {
    id: '7401060',
    regencyId: '7401',
    name: 'Pasar Wajo',
  },
  {
    id: '7401061',
    regencyId: '7401',
    name: 'Wolowa',
  },
  {
    id: '7401062',
    regencyId: '7401',
    name: 'Wabula',
  },
  {
    id: '7401110',
    regencyId: '7401',
    name: 'Kapontori',
  },
  {
    id: '7402010',
    regencyId: '7402',
    name: 'Tongkuno',
  },
  {
    id: '7402011',
    regencyId: '7402',
    name: 'Tongkuno Selatan',
  },
  {
    id: '7402020',
    regencyId: '7402',
    name: 'Parigi',
  },
  {
    id: '7402021',
    regencyId: '7402',
    name: 'Bone',
  },
  {
    id: '7402022',
    regencyId: '7402',
    name: 'Marobo',
  },
  {
    id: '7402030',
    regencyId: '7402',
    name: 'Kabawo',
  },
  {
    id: '7402031',
    regencyId: '7402',
    name: 'Kabangka',
  },
  {
    id: '7402032',
    regencyId: '7402',
    name: 'Kontukowuna',
  },
  {
    id: '7402061',
    regencyId: '7402',
    name: 'Kontunaga',
  },
  {
    id: '7402062',
    regencyId: '7402',
    name: 'Watopute',
  },
  {
    id: '7402070',
    regencyId: '7402',
    name: 'Katobu',
  },
  {
    id: '7402071',
    regencyId: '7402',
    name: 'Lohia',
  },
  {
    id: '7402072',
    regencyId: '7402',
    name: 'Duruka',
  },
  {
    id: '7402073',
    regencyId: '7402',
    name: 'Batalaiworu',
  },
  {
    id: '7402080',
    regencyId: '7402',
    name: 'Napabalano',
  },
  {
    id: '7402081',
    regencyId: '7402',
    name: 'Lasalepa',
  },
  {
    id: '7402083',
    regencyId: '7402',
    name: 'Towea',
  },
  {
    id: '7402090',
    regencyId: '7402',
    name: 'Wakorumba Selatan',
  },
  {
    id: '7402091',
    regencyId: '7402',
    name: 'Pasir Putih',
  },
  {
    id: '7402092',
    regencyId: '7402',
    name: 'Pasi Kolaga',
  },
  {
    id: '7402111',
    regencyId: '7402',
    name: 'Maligano',
  },
  {
    id: '7402112',
    regencyId: '7402',
    name: 'Batukara',
  },
  {
    id: '7403090',
    regencyId: '7403',
    name: 'Soropia',
  },
  {
    id: '7403091',
    regencyId: '7403',
    name: 'Lalonggasumeeto',
  },
  {
    id: '7403100',
    regencyId: '7403',
    name: 'Sampara',
  },
  {
    id: '7403101',
    regencyId: '7403',
    name: 'Bondoala',
  },
  {
    id: '7403102',
    regencyId: '7403',
    name: 'Besulutu',
  },
  {
    id: '7403103',
    regencyId: '7403',
    name: 'Kapoiala',
  },
  {
    id: '7403104',
    regencyId: '7403',
    name: 'Anggalomoare',
  },
  {
    id: '7403105',
    regencyId: '7403',
    name: 'Morosi',
  },
  {
    id: '7403130',
    regencyId: '7403',
    name: 'Lambuya',
  },
  {
    id: '7403131',
    regencyId: '7403',
    name: 'Uepai',
  },
  {
    id: '7403132',
    regencyId: '7403',
    name: 'Puriala',
  },
  {
    id: '7403133',
    regencyId: '7403',
    name: 'Onembute',
  },
  {
    id: '7403140',
    regencyId: '7403',
    name: 'Pondidaha',
  },
  {
    id: '7403141',
    regencyId: '7403',
    name: 'Wonggeduku',
  },
  {
    id: '7403142',
    regencyId: '7403',
    name: 'Amonggedo',
  },
  {
    id: '7403143',
    regencyId: '7403',
    name: 'Wonggeduku Barat',
  },
  {
    id: '7403150',
    regencyId: '7403',
    name: 'Wawotobi',
  },
  {
    id: '7403151',
    regencyId: '7403',
    name: 'Meluhu',
  },
  {
    id: '7403152',
    regencyId: '7403',
    name: 'Konawe',
  },
  {
    id: '7403153',
    regencyId: '7403',
    name: 'Anggotoa',
  },
  {
    id: '7403170',
    regencyId: '7403',
    name: 'Unaaha',
  },
  {
    id: '7403171',
    regencyId: '7403',
    name: 'Anggaberi',
  },
  {
    id: '7403180',
    regencyId: '7403',
    name: 'Abuki',
  },
  {
    id: '7403181',
    regencyId: '7403',
    name: 'Latoma',
  },
  {
    id: '7403182',
    regencyId: '7403',
    name: 'Tongauna',
  },
  {
    id: '7403183',
    regencyId: '7403',
    name: 'Asinua',
  },
  {
    id: '7403184',
    regencyId: '7403',
    name: 'Padangguni',
  },
  {
    id: '7403185',
    regencyId: '7403',
    name: 'Tongauna Utara',
  },
  {
    id: '7403193',
    regencyId: '7403',
    name: 'Routa',
  },
  {
    id: '7404010',
    regencyId: '7404',
    name: 'Watubangga',
  },
  {
    id: '7404011',
    regencyId: '7404',
    name: 'Tanggetada',
  },
  {
    id: '7404012',
    regencyId: '7404',
    name: 'Toari',
  },
  {
    id: '7404013',
    regencyId: '7404',
    name: 'Polinggona',
  },
  {
    id: '7404020',
    regencyId: '7404',
    name: 'Pomalaa',
  },
  {
    id: '7404030',
    regencyId: '7404',
    name: 'Wundulako',
  },
  {
    id: '7404031',
    regencyId: '7404',
    name: 'Baula',
  },
  {
    id: '7404060',
    regencyId: '7404',
    name: 'Kolaka',
  },
  {
    id: '7404061',
    regencyId: '7404',
    name: 'Latambaga',
  },
  {
    id: '7404070',
    regencyId: '7404',
    name: 'Wolo',
  },
  {
    id: '7404071',
    regencyId: '7404',
    name: 'Samaturu',
  },
  {
    id: '7404072',
    regencyId: '7404',
    name: 'Iwoimendaa',
  },
  {
    id: '7405010',
    regencyId: '7405',
    name: 'Tinanggea',
  },
  {
    id: '7405011',
    regencyId: '7405',
    name: 'Lalembuu',
  },
  {
    id: '7405020',
    regencyId: '7405',
    name: 'Andoolo',
  },
  {
    id: '7405021',
    regencyId: '7405',
    name: 'Buke',
  },
  {
    id: '7405022',
    regencyId: '7405',
    name: 'Andoolo Barat',
  },
  {
    id: '7405030',
    regencyId: '7405',
    name: 'Palangga',
  },
  {
    id: '7405031',
    regencyId: '7405',
    name: 'Palangga Selatan',
  },
  {
    id: '7405032',
    regencyId: '7405',
    name: 'Baito',
  },
  {
    id: '7405040',
    regencyId: '7405',
    name: 'Lainea',
  },
  {
    id: '7405041',
    regencyId: '7405',
    name: 'Laeya',
  },
  {
    id: '7405050',
    regencyId: '7405',
    name: 'Kolono',
  },
  {
    id: '7405051',
    regencyId: '7405',
    name: 'Kolono Timur',
  },
  {
    id: '7405060',
    regencyId: '7405',
    name: 'Laonti',
  },
  {
    id: '7405070',
    regencyId: '7405',
    name: 'Moramo',
  },
  {
    id: '7405071',
    regencyId: '7405',
    name: 'Moramo Utara',
  },
  {
    id: '7405080',
    regencyId: '7405',
    name: 'Konda',
  },
  {
    id: '7405081',
    regencyId: '7405',
    name: 'Wolasi',
  },
  {
    id: '7405090',
    regencyId: '7405',
    name: 'Ranomeeto',
  },
  {
    id: '7405091',
    regencyId: '7405',
    name: 'Ranomeeto Barat',
  },
  {
    id: '7405100',
    regencyId: '7405',
    name: 'Landono',
  },
  {
    id: '7405101',
    regencyId: '7405',
    name: 'Mowila',
  },
  {
    id: '7405102',
    regencyId: '7405',
    name: 'Sabulakoa',
  },
  {
    id: '7405110',
    regencyId: '7405',
    name: 'Angata',
  },
  {
    id: '7405111',
    regencyId: '7405',
    name: 'Benua',
  },
  {
    id: '7405112',
    regencyId: '7405',
    name: 'Basala',
  },
  {
    id: '7406010',
    regencyId: '7406',
    name: 'Kabaena',
  },
  {
    id: '7406011',
    regencyId: '7406',
    name: 'Kabaena Utara',
  },
  {
    id: '7406012',
    regencyId: '7406',
    name: 'Kabaena Selatan',
  },
  {
    id: '7406013',
    regencyId: '7406',
    name: 'Kabaena Barat',
  },
  {
    id: '7406020',
    regencyId: '7406',
    name: 'Kabaena Timur',
  },
  {
    id: '7406021',
    regencyId: '7406',
    name: 'Kabaena Tengah',
  },
  {
    id: '7406030',
    regencyId: '7406',
    name: 'Rumbia',
  },
  {
    id: '7406031',
    regencyId: '7406',
    name: 'Mata Oleo',
  },
  {
    id: '7406032',
    regencyId: '7406',
    name: 'KEP. Masaloka Raya',
  },
  {
    id: '7406033',
    regencyId: '7406',
    name: 'Rumbia Tengah',
  },
  {
    id: '7406040',
    regencyId: '7406',
    name: 'Rarowatu',
  },
  {
    id: '7406041',
    regencyId: '7406',
    name: 'Rarowatu Utara',
  },
  {
    id: '7406042',
    regencyId: '7406',
    name: 'Mata Usu',
  },
  {
    id: '7406043',
    regencyId: '7406',
    name: 'Lantari Jaya',
  },
  {
    id: '7406050',
    regencyId: '7406',
    name: 'Poleang Timur',
  },
  {
    id: '7406051',
    regencyId: '7406',
    name: 'Poleang Utara',
  },
  {
    id: '7406052',
    regencyId: '7406',
    name: 'Poleang Selatan',
  },
  {
    id: '7406053',
    regencyId: '7406',
    name: 'Poleang Tenggara',
  },
  {
    id: '7406060',
    regencyId: '7406',
    name: 'Poleang',
  },
  {
    id: '7406061',
    regencyId: '7406',
    name: 'Poleang Barat',
  },
  {
    id: '7406062',
    regencyId: '7406',
    name: 'Tontonunu',
  },
  {
    id: '7406063',
    regencyId: '7406',
    name: 'Poleang Tengah',
  },
  {
    id: '7407010',
    regencyId: '7407',
    name: 'Binongko',
  },
  {
    id: '7407011',
    regencyId: '7407',
    name: 'Togo Binongko',
  },
  {
    id: '7407020',
    regencyId: '7407',
    name: 'Tomia',
  },
  {
    id: '7407021',
    regencyId: '7407',
    name: 'Tomia Timur',
  },
  {
    id: '7407030',
    regencyId: '7407',
    name: 'Kaledupa',
  },
  {
    id: '7407031',
    regencyId: '7407',
    name: 'Kaledupa Selatan',
  },
  {
    id: '7407040',
    regencyId: '7407',
    name: 'Wangi-Wangi',
  },
  {
    id: '7407050',
    regencyId: '7407',
    name: 'Wangi-Wangi Selatan',
  },
  {
    id: '7408010',
    regencyId: '7408',
    name: 'Ranteangin',
  },
  {
    id: '7408011',
    regencyId: '7408',
    name: 'Lambai',
  },
  {
    id: '7408012',
    regencyId: '7408',
    name: 'Wawo',
  },
  {
    id: '7408020',
    regencyId: '7408',
    name: 'Lasusua',
  },
  {
    id: '7408021',
    regencyId: '7408',
    name: 'Katoi',
  },
  {
    id: '7408030',
    regencyId: '7408',
    name: 'Kodeoha',
  },
  {
    id: '7408031',
    regencyId: '7408',
    name: 'Tiwu',
  },
  {
    id: '7408040',
    regencyId: '7408',
    name: 'Ngapa',
  },
  {
    id: '7408041',
    regencyId: '7408',
    name: 'Watunohu',
  },
  {
    id: '7408050',
    regencyId: '7408',
    name: 'Pakue',
  },
  {
    id: '7408051',
    regencyId: '7408',
    name: 'Pakue Utara',
  },
  {
    id: '7408052',
    regencyId: '7408',
    name: 'Pakue Tengah',
  },
  {
    id: '7408060',
    regencyId: '7408',
    name: 'Batu Putih',
  },
  {
    id: '7408061',
    regencyId: '7408',
    name: 'Porehu',
  },
  {
    id: '7408062',
    regencyId: '7408',
    name: 'Tolala',
  },
  {
    id: '7409100',
    regencyId: '7409',
    name: 'Bonegunu',
  },
  {
    id: '7409101',
    regencyId: '7409',
    name: 'Kambowa',
  },
  {
    id: '7409110',
    regencyId: '7409',
    name: 'Wakorumba',
  },
  {
    id: '7409120',
    regencyId: '7409',
    name: 'Kulisusu',
  },
  {
    id: '7409121',
    regencyId: '7409',
    name: 'Kulisusu Barat',
  },
  {
    id: '7409122',
    regencyId: '7409',
    name: 'Kulisusu Utara',
  },
  {
    id: '7410010',
    regencyId: '7410',
    name: 'Sawa',
  },
  {
    id: '7410011',
    regencyId: '7410',
    name: 'Motui',
  },
  {
    id: '7410020',
    regencyId: '7410',
    name: 'Lembo',
  },
  {
    id: '7410030',
    regencyId: '7410',
    name: 'Lasolo',
  },
  {
    id: '7410031',
    regencyId: '7410',
    name: 'Wawolesea',
  },
  {
    id: '7410032',
    regencyId: '7410',
    name: 'Lasolo Kepulauan',
  },
  {
    id: '7410040',
    regencyId: '7410',
    name: 'Molawe',
  },
  {
    id: '7410050',
    regencyId: '7410',
    name: 'Asera',
  },
  {
    id: '7410051',
    regencyId: '7410',
    name: 'Andowia',
  },
  {
    id: '7410052',
    regencyId: '7410',
    name: 'Oheo',
  },
  {
    id: '7410060',
    regencyId: '7410',
    name: 'Langgikima',
  },
  {
    id: '7410070',
    regencyId: '7410',
    name: 'Wiwirano',
  },
  {
    id: '7410071',
    regencyId: '7410',
    name: 'Landawe',
  },
  {
    id: '7411010',
    regencyId: '7411',
    name: 'Aere',
  },
  {
    id: '7411020',
    regencyId: '7411',
    name: 'Lambandia',
  },
  {
    id: '7411030',
    regencyId: '7411',
    name: 'Poli-Polia',
  },
  {
    id: '7411040',
    regencyId: '7411',
    name: 'Dangia',
  },
  {
    id: '7411050',
    regencyId: '7411',
    name: 'Ladongi',
  },
  {
    id: '7411060',
    regencyId: '7411',
    name: 'Loea',
  },
  {
    id: '7411070',
    regencyId: '7411',
    name: 'Tirawuta',
  },
  {
    id: '7411080',
    regencyId: '7411',
    name: 'Lalolae',
  },
  {
    id: '7411090',
    regencyId: '7411',
    name: 'Mowewe',
  },
  {
    id: '7411100',
    regencyId: '7411',
    name: 'Tinondo',
  },
  {
    id: '7411110',
    regencyId: '7411',
    name: 'Uluiwoi',
  },
  {
    id: '7411120',
    regencyId: '7411',
    name: 'Ueesi',
  },
  {
    id: '7412010',
    regencyId: '7412',
    name: 'Wawonii Tenggara',
  },
  {
    id: '7412020',
    regencyId: '7412',
    name: 'Wawonii Timur',
  },
  {
    id: '7412030',
    regencyId: '7412',
    name: 'Wawonii Timur Laut',
  },
  {
    id: '7412040',
    regencyId: '7412',
    name: 'Wawonii Utara',
  },
  {
    id: '7412050',
    regencyId: '7412',
    name: 'Wawonii Selatan',
  },
  {
    id: '7412060',
    regencyId: '7412',
    name: 'Wawonii Tengah',
  },
  {
    id: '7412070',
    regencyId: '7412',
    name: 'Wawonii Barat',
  },
  {
    id: '7413010',
    regencyId: '7413',
    name: 'Tiworo Kepulauan',
  },
  {
    id: '7413020',
    regencyId: '7413',
    name: 'Maginti',
  },
  {
    id: '7413030',
    regencyId: '7413',
    name: 'Tiworo Tengah',
  },
  {
    id: '7413040',
    regencyId: '7413',
    name: 'Tiworo Selatan',
  },
  {
    id: '7413050',
    regencyId: '7413',
    name: 'Tiworo Utara',
  },
  {
    id: '7413060',
    regencyId: '7413',
    name: 'Lawa',
  },
  {
    id: '7413070',
    regencyId: '7413',
    name: 'Sawerigadi',
  },
  {
    id: '7413080',
    regencyId: '7413',
    name: 'Barangka',
  },
  {
    id: '7413090',
    regencyId: '7413',
    name: 'Wa Daga',
  },
  {
    id: '7413100',
    regencyId: '7413',
    name: 'Kusambi',
  },
  {
    id: '7413110',
    regencyId: '7413',
    name: 'Napano Kusambi',
  },
  {
    id: '7414010',
    regencyId: '7414',
    name: 'Talaga Raya',
  },
  {
    id: '7414020',
    regencyId: '7414',
    name: 'Mawasangka',
  },
  {
    id: '7414030',
    regencyId: '7414',
    name: 'Mawasangka Tengah',
  },
  {
    id: '7414040',
    regencyId: '7414',
    name: 'Mawasangka Timur',
  },
  {
    id: '7414050',
    regencyId: '7414',
    name: 'Lakudo',
  },
  {
    id: '7414060',
    regencyId: '7414',
    name: 'Gu',
  },
  {
    id: '7414070',
    regencyId: '7414',
    name: 'Sangia Wambulu',
  },
  {
    id: '7415010',
    regencyId: '7415',
    name: 'Batu Atas',
  },
  {
    id: '7415020',
    regencyId: '7415',
    name: 'Lapandewa',
  },
  {
    id: '7415030',
    regencyId: '7415',
    name: 'Sampolawa',
  },
  {
    id: '7415040',
    regencyId: '7415',
    name: 'Batauga',
  },
  {
    id: '7415050',
    regencyId: '7415',
    name: 'Siompu Barat',
  },
  {
    id: '7415060',
    regencyId: '7415',
    name: 'Siompu',
  },
  {
    id: '7415070',
    regencyId: '7415',
    name: 'Kadatua',
  },
  {
    id: '7471010',
    regencyId: '7471',
    name: 'Mandonga',
  },
  {
    id: '7471011',
    regencyId: '7471',
    name: 'Baruga',
  },
  {
    id: '7471012',
    regencyId: '7471',
    name: 'Puuwatu',
  },
  {
    id: '7471013',
    regencyId: '7471',
    name: 'Kadia',
  },
  {
    id: '7471014',
    regencyId: '7471',
    name: 'Wua-Wua',
  },
  {
    id: '7471020',
    regencyId: '7471',
    name: 'Poasia',
  },
  {
    id: '7471021',
    regencyId: '7471',
    name: 'Abeli',
  },
  {
    id: '7471022',
    regencyId: '7471',
    name: 'Kambu',
  },
  {
    id: '7471023',
    regencyId: '7471',
    name: 'Nambo',
  },
  {
    id: '7471030',
    regencyId: '7471',
    name: 'Kendari',
  },
  {
    id: '7471031',
    regencyId: '7471',
    name: 'Kendari Barat',
  },
  {
    id: '7472010',
    regencyId: '7472',
    name: 'Betoambari',
  },
  {
    id: '7472011',
    regencyId: '7472',
    name: 'Murhum',
  },
  {
    id: '7472012',
    regencyId: '7472',
    name: 'Batupoaro',
  },
  {
    id: '7472020',
    regencyId: '7472',
    name: 'Wolio',
  },
  {
    id: '7472021',
    regencyId: '7472',
    name: 'Kokalukuna',
  },
  {
    id: '7472030',
    regencyId: '7472',
    name: 'Sorawolio',
  },
  {
    id: '7472040',
    regencyId: '7472',
    name: 'Bungi',
  },
  {
    id: '7472041',
    regencyId: '7472',
    name: 'Lea-Lea',
  },
  {
    id: '7501031',
    regencyId: '7501',
    name: 'Mananggu',
  },
  {
    id: '7501040',
    regencyId: '7501',
    name: 'Tilamuta',
  },
  {
    id: '7501041',
    regencyId: '7501',
    name: 'Dulupi',
  },
  {
    id: '7501042',
    regencyId: '7501',
    name: 'Botumoito',
  },
  {
    id: '7501050',
    regencyId: '7501',
    name: 'Paguyaman',
  },
  {
    id: '7501051',
    regencyId: '7501',
    name: 'Wonosari',
  },
  {
    id: '7501052',
    regencyId: '7501',
    name: 'Paguyaman Pantai',
  },
  {
    id: '7502010',
    regencyId: '7502',
    name: 'Batudaa Pantai',
  },
  {
    id: '7502011',
    regencyId: '7502',
    name: 'Biluhu',
  },
  {
    id: '7502020',
    regencyId: '7502',
    name: 'Batudaa',
  },
  {
    id: '7502021',
    regencyId: '7502',
    name: 'Bongomeme',
  },
  {
    id: '7502022',
    regencyId: '7502',
    name: 'Tabongo',
  },
  {
    id: '7502023',
    regencyId: '7502',
    name: 'Dungaliyo',
  },
  {
    id: '7502030',
    regencyId: '7502',
    name: 'Tibawa',
  },
  {
    id: '7502031',
    regencyId: '7502',
    name: 'Pulubala',
  },
  {
    id: '7502040',
    regencyId: '7502',
    name: 'Boliyohuto',
  },
  {
    id: '7502041',
    regencyId: '7502',
    name: 'Mootilango',
  },
  {
    id: '7502042',
    regencyId: '7502',
    name: 'Tolangohula',
  },
  {
    id: '7502043',
    regencyId: '7502',
    name: 'Asparaga',
  },
  {
    id: '7502044',
    regencyId: '7502',
    name: 'Bilato',
  },
  {
    id: '7502070',
    regencyId: '7502',
    name: 'Limboto',
  },
  {
    id: '7502071',
    regencyId: '7502',
    name: 'Limboto Barat',
  },
  {
    id: '7502080',
    regencyId: '7502',
    name: 'Telaga',
  },
  {
    id: '7502081',
    regencyId: '7502',
    name: 'Telaga Biru',
  },
  {
    id: '7502082',
    regencyId: '7502',
    name: 'Tilango',
  },
  {
    id: '7502083',
    regencyId: '7502',
    name: 'Telaga Jaya',
  },
  {
    id: '7503010',
    regencyId: '7503',
    name: 'Popayato',
  },
  {
    id: '7503011',
    regencyId: '7503',
    name: 'Popayato Barat',
  },
  {
    id: '7503012',
    regencyId: '7503',
    name: 'Popayato Timur',
  },
  {
    id: '7503020',
    regencyId: '7503',
    name: 'Lemito',
  },
  {
    id: '7503021',
    regencyId: '7503',
    name: 'Wanggarasi',
  },
  {
    id: '7503030',
    regencyId: '7503',
    name: 'Marisa',
  },
  {
    id: '7503031',
    regencyId: '7503',
    name: 'Patilanggio',
  },
  {
    id: '7503032',
    regencyId: '7503',
    name: 'Buntulia',
  },
  {
    id: '7503033',
    regencyId: '7503',
    name: 'Duhiadaa',
  },
  {
    id: '7503040',
    regencyId: '7503',
    name: 'Randangan',
  },
  {
    id: '7503041',
    regencyId: '7503',
    name: 'Taluditi',
  },
  {
    id: '7503050',
    regencyId: '7503',
    name: 'Paguat',
  },
  {
    id: '7503051',
    regencyId: '7503',
    name: 'Dengilo',
  },
  {
    id: '7504010',
    regencyId: '7504',
    name: 'Tapa',
  },
  {
    id: '7504011',
    regencyId: '7504',
    name: 'Bulango Utara',
  },
  {
    id: '7504012',
    regencyId: '7504',
    name: 'Bulango Selatan',
  },
  {
    id: '7504013',
    regencyId: '7504',
    name: 'Bulango Timur',
  },
  {
    id: '7504014',
    regencyId: '7504',
    name: 'Bulango Ulu',
  },
  {
    id: '7504020',
    regencyId: '7504',
    name: 'Kabila',
  },
  {
    id: '7504021',
    regencyId: '7504',
    name: 'Botu Pingge',
  },
  {
    id: '7504022',
    regencyId: '7504',
    name: 'Tilongkabila',
  },
  {
    id: '7504030',
    regencyId: '7504',
    name: 'Suwawa',
  },
  {
    id: '7504031',
    regencyId: '7504',
    name: 'Suwawa Selatan',
  },
  {
    id: '7504032',
    regencyId: '7504',
    name: 'Suwawa Timur',
  },
  {
    id: '7504033',
    regencyId: '7504',
    name: 'Suwawa Tengah',
  },
  {
    id: '7504034',
    regencyId: '7504',
    name: 'Pinogu',
  },
  {
    id: '7504040',
    regencyId: '7504',
    name: 'Bonepantai',
  },
  {
    id: '7504041',
    regencyId: '7504',
    name: 'Kabila Bone',
  },
  {
    id: '7504042',
    regencyId: '7504',
    name: 'Bone Raya',
  },
  {
    id: '7504043',
    regencyId: '7504',
    name: 'Bone',
  },
  {
    id: '7504044',
    regencyId: '7504',
    name: 'Bulawa',
  },
  {
    id: '7505010',
    regencyId: '7505',
    name: 'Atinggola',
  },
  {
    id: '7505011',
    regencyId: '7505',
    name: 'Gentuma Raya',
  },
  {
    id: '7505020',
    regencyId: '7505',
    name: 'Kwandang',
  },
  {
    id: '7505021',
    regencyId: '7505',
    name: 'Tomilito',
  },
  {
    id: '7505022',
    regencyId: '7505',
    name: 'Ponelo Kepulauan',
  },
  {
    id: '7505030',
    regencyId: '7505',
    name: 'Anggrek',
  },
  {
    id: '7505031',
    regencyId: '7505',
    name: 'Monano',
  },
  {
    id: '7505040',
    regencyId: '7505',
    name: 'Sumalata',
  },
  {
    id: '7505041',
    regencyId: '7505',
    name: 'Sumalata Timur',
  },
  {
    id: '7505050',
    regencyId: '7505',
    name: 'Tolinggula',
  },
  {
    id: '7505051',
    regencyId: '7505',
    name: 'Biau',
  },
  {
    id: '7571010',
    regencyId: '7571',
    name: 'Kota Barat',
  },
  {
    id: '7571011',
    regencyId: '7571',
    name: 'Dungingi',
  },
  {
    id: '7571020',
    regencyId: '7571',
    name: 'Kota Selatan',
  },
  {
    id: '7571021',
    regencyId: '7571',
    name: 'Kota Timur',
  },
  {
    id: '7571022',
    regencyId: '7571',
    name: 'Hulonthalangi',
  },
  {
    id: '7571023',
    regencyId: '7571',
    name: 'Dumbo Raya',
  },
  {
    id: '7571030',
    regencyId: '7571',
    name: 'Kota Utara',
  },
  {
    id: '7571031',
    regencyId: '7571',
    name: 'Kota Tengah',
  },
  {
    id: '7571032',
    regencyId: '7571',
    name: 'Sipatana',
  },
  {
    id: '7601010',
    regencyId: '7601',
    name: 'Banggae',
  },
  {
    id: '7601011',
    regencyId: '7601',
    name: 'Banggae Timur',
  },
  {
    id: '7601020',
    regencyId: '7601',
    name: 'Pamboang',
  },
  {
    id: '7601030',
    regencyId: '7601',
    name: 'Sendana',
  },
  {
    id: '7601031',
    regencyId: '7601',
    name: 'Tammerodo',
  },
  {
    id: '7601033',
    regencyId: '7601',
    name: 'Tubo Sendana',
  },
  {
    id: '7601040',
    regencyId: '7601',
    name: 'Malunda',
  },
  {
    id: '7601041',
    regencyId: '7601',
    name: 'Ulumanda',
  },
  {
    id: '7602010',
    regencyId: '7602',
    name: 'Tinambung',
  },
  {
    id: '7602011',
    regencyId: '7602',
    name: 'Balanipa',
  },
  {
    id: '7602012',
    regencyId: '7602',
    name: 'Limboro',
  },
  {
    id: '7602020',
    regencyId: '7602',
    name: 'Tubbi Taramanu',
  },
  {
    id: '7602021',
    regencyId: '7602',
    name: 'Alu',
  },
  {
    id: '7602030',
    regencyId: '7602',
    name: 'Campalagian',
  },
  {
    id: '7602031',
    regencyId: '7602',
    name: 'Luyo',
  },
  {
    id: '7602040',
    regencyId: '7602',
    name: 'Wonomulyo',
  },
  {
    id: '7602041',
    regencyId: '7602',
    name: 'Mapilli',
  },
  {
    id: '7602042',
    regencyId: '7602',
    name: 'Tapango',
  },
  {
    id: '7602043',
    regencyId: '7602',
    name: 'Matakali',
  },
  {
    id: '7602044',
    regencyId: '7602',
    name: 'B U L O',
  },
  {
    id: '7602050',
    regencyId: '7602',
    name: 'Polewali',
  },
  {
    id: '7602051',
    regencyId: '7602',
    name: 'Binuang',
  },
  {
    id: '7602052',
    regencyId: '7602',
    name: 'Anreapi',
  },
  {
    id: '7602061',
    regencyId: '7602',
    name: 'Matangnga',
  },
  {
    id: '7603010',
    regencyId: '7603',
    name: 'Sumarorong',
  },
  {
    id: '7603020',
    regencyId: '7603',
    name: 'Messawa',
  },
  {
    id: '7603030',
    regencyId: '7603',
    name: 'Pana',
  },
  {
    id: '7603031',
    regencyId: '7603',
    name: 'Nosu',
  },
  {
    id: '7603040',
    regencyId: '7603',
    name: 'Tabang',
  },
  {
    id: '7603050',
    regencyId: '7603',
    name: 'Mamasa',
  },
  {
    id: '7603060',
    regencyId: '7603',
    name: 'Tanduk Kalua',
  },
  {
    id: '7603061',
    regencyId: '7603',
    name: 'Balla',
  },
  {
    id: '7603070',
    regencyId: '7603',
    name: 'Sesenapadang',
  },
  {
    id: '7603071',
    regencyId: '7603',
    name: 'Tawalian',
  },
  {
    id: '7603080',
    regencyId: '7603',
    name: 'Mambi',
  },
  {
    id: '7603081',
    regencyId: '7603',
    name: 'Bambang',
  },
  {
    id: '7603082',
    regencyId: '7603',
    name: 'Rantebulahan Timur',
  },
  {
    id: '7603083',
    regencyId: '7603',
    name: 'Mehalaan',
  },
  {
    id: '7603090',
    regencyId: '7603',
    name: 'Aralle',
  },
  {
    id: '7603091',
    regencyId: '7603',
    name: 'Buntu Malangka',
  },
  {
    id: '7603100',
    regencyId: '7603',
    name: 'Tabulahan',
  },
  {
    id: '7604010',
    regencyId: '7604',
    name: 'Tapalang',
  },
  {
    id: '7604011',
    regencyId: '7604',
    name: 'Tapalang Barat',
  },
  {
    id: '7604020',
    regencyId: '7604',
    name: 'Mamuju',
  },
  {
    id: '7604022',
    regencyId: '7604',
    name: 'Simboro',
  },
  {
    id: '7604023',
    regencyId: '7604',
    name: 'Balabalakang',
  },
  {
    id: '7604030',
    regencyId: '7604',
    name: 'Kalukku',
  },
  {
    id: '7604031',
    regencyId: '7604',
    name: 'Papalang',
  },
  {
    id: '7604032',
    regencyId: '7604',
    name: 'Sampaga',
  },
  {
    id: '7604033',
    regencyId: '7604',
    name: 'Tommo',
  },
  {
    id: '7604040',
    regencyId: '7604',
    name: 'Kalumpang',
  },
  {
    id: '7604041',
    regencyId: '7604',
    name: 'Bonehau',
  },
  {
    id: '7605010',
    regencyId: '7605',
    name: 'Sarudu',
  },
  {
    id: '7605011',
    regencyId: '7605',
    name: 'Dapurang',
  },
  {
    id: '7605012',
    regencyId: '7605',
    name: 'Duripoku',
  },
  {
    id: '7605020',
    regencyId: '7605',
    name: 'Baras',
  },
  {
    id: '7605021',
    regencyId: '7605',
    name: 'Bulu Taba',
  },
  {
    id: '7605022',
    regencyId: '7605',
    name: 'Lariang',
  },
  {
    id: '7605030',
    regencyId: '7605',
    name: 'Pasangkayu',
  },
  {
    id: '7605031',
    regencyId: '7605',
    name: 'Tikke Raya',
  },
  {
    id: '7605032',
    regencyId: '7605',
    name: 'Pedongga',
  },
  {
    id: '7605040',
    regencyId: '7605',
    name: 'Bambalamotu',
  },
  {
    id: '7605041',
    regencyId: '7605',
    name: 'Bambaira',
  },
  {
    id: '7605042',
    regencyId: '7605',
    name: 'Sarjo',
  },
  {
    id: '7606010',
    regencyId: '7606',
    name: 'Pangale',
  },
  {
    id: '7606020',
    regencyId: '7606',
    name: 'Budong-Budong',
  },
  {
    id: '7606030',
    regencyId: '7606',
    name: 'Tobadak',
  },
  {
    id: '7606040',
    regencyId: '7606',
    name: 'Topoyo',
  },
  {
    id: '7606050',
    regencyId: '7606',
    name: 'Karossa',
  },
  {
    id: '8101040',
    regencyId: '8101',
    name: 'Tanimbar Selatan',
  },
  {
    id: '8101041',
    regencyId: '8101',
    name: 'Wer Tamrian',
  },
  {
    id: '8101042',
    regencyId: '8101',
    name: 'Wer Maktian',
  },
  {
    id: '8101043',
    regencyId: '8101',
    name: 'Selaru',
  },
  {
    id: '8101050',
    regencyId: '8101',
    name: 'Tanimbar Utara',
  },
  {
    id: '8101051',
    regencyId: '8101',
    name: 'Yaru',
  },
  {
    id: '8101052',
    regencyId: '8101',
    name: 'Wuar Labobar',
  },
  {
    id: '8101053',
    regencyId: '8101',
    name: 'Nirunmas',
  },
  {
    id: '8101054',
    regencyId: '8101',
    name: 'Kormomolin',
  },
  {
    id: '8101055',
    regencyId: '8101',
    name: 'Molu Maru',
  },
  {
    id: '8102010',
    regencyId: '8102',
    name: 'Kei Kecil',
  },
  {
    id: '8102012',
    regencyId: '8102',
    name: 'Kei Kecil Barat',
  },
  {
    id: '8102013',
    regencyId: '8102',
    name: 'Kei Kecil Timur',
  },
  {
    id: '8102014',
    regencyId: '8102',
    name: 'Hoat Sorbay',
  },
  {
    id: '8102015',
    regencyId: '8102',
    name: 'Manyeuw',
  },
  {
    id: '8102016',
    regencyId: '8102',
    name: 'Kei Kecil Timur Selatan',
  },
  {
    id: '8102020',
    regencyId: '8102',
    name: 'Kei Besar',
  },
  {
    id: '8102021',
    regencyId: '8102',
    name: 'Kei Besar Utara Timur',
  },
  {
    id: '8102022',
    regencyId: '8102',
    name: 'Kei Besar Selatan',
  },
  {
    id: '8102023',
    regencyId: '8102',
    name: 'Kei Besar Utara Barat',
  },
  {
    id: '8102024',
    regencyId: '8102',
    name: 'Kei Besar Selatan Barat',
  },
  {
    id: '8103010',
    regencyId: '8103',
    name: 'Banda',
  },
  {
    id: '8103040',
    regencyId: '8103',
    name: 'Tehoru',
  },
  {
    id: '8103041',
    regencyId: '8103',
    name: 'Telutih',
  },
  {
    id: '8103050',
    regencyId: '8103',
    name: 'Amahai',
  },
  {
    id: '8103051',
    regencyId: '8103',
    name: 'Kota Masohi',
  },
  {
    id: '8103052',
    regencyId: '8103',
    name: 'Teluk Elpaputih',
  },
  {
    id: '8103060',
    regencyId: '8103',
    name: 'Teon Nila Serua',
  },
  {
    id: '8103080',
    regencyId: '8103',
    name: 'Saparua',
  },
  {
    id: '8103081',
    regencyId: '8103',
    name: 'Nusalaut',
  },
  {
    id: '8103082',
    regencyId: '8103',
    name: 'Saparua Timur',
  },
  {
    id: '8103090',
    regencyId: '8103',
    name: 'P. Haruku',
  },
  {
    id: '8103100',
    regencyId: '8103',
    name: 'Salahutu',
  },
  {
    id: '8103110',
    regencyId: '8103',
    name: 'Leihitu',
  },
  {
    id: '8103111',
    regencyId: '8103',
    name: 'Leihitu Barat',
  },
  {
    id: '8103140',
    regencyId: '8103',
    name: 'Seram Utara',
  },
  {
    id: '8103141',
    regencyId: '8103',
    name: 'Seram Utara Barat',
  },
  {
    id: '8103142',
    regencyId: '8103',
    name: 'Seram Utara Timur Kobi',
  },
  {
    id: '8103143',
    regencyId: '8103',
    name: 'Seram Utara Timur Seti',
  },
  {
    id: '8104020',
    regencyId: '8104',
    name: 'Namlea',
  },
  {
    id: '8104021',
    regencyId: '8104',
    name: 'Waeapo',
  },
  {
    id: '8104022',
    regencyId: '8104',
    name: 'Waplau',
  },
  {
    id: '8104023',
    regencyId: '8104',
    name: 'Bata Bual',
  },
  {
    id: '8104024',
    regencyId: '8104',
    name: 'Teluk Kaiely',
  },
  {
    id: '8104025',
    regencyId: '8104',
    name: 'Waelata',
  },
  {
    id: '8104026',
    regencyId: '8104',
    name: 'Lolong Guba',
  },
  {
    id: '8104027',
    regencyId: '8104',
    name: 'Lilialy',
  },
  {
    id: '8104030',
    regencyId: '8104',
    name: 'Air Buaya',
  },
  {
    id: '8104031',
    regencyId: '8104',
    name: 'Fena Leisela',
  },
  {
    id: '8105010',
    regencyId: '8105',
    name: 'Aru Selatan',
  },
  {
    id: '8105011',
    regencyId: '8105',
    name: 'Aru Selatan Timur',
  },
  {
    id: '8105012',
    regencyId: '8105',
    name: 'Aru Selatan Utara',
  },
  {
    id: '8105020',
    regencyId: '8105',
    name: 'Aru Tengah',
  },
  {
    id: '8105021',
    regencyId: '8105',
    name: 'Aru Tengah Timur',
  },
  {
    id: '8105022',
    regencyId: '8105',
    name: 'Aru Tengah Selatan',
  },
  {
    id: '8105030',
    regencyId: '8105',
    name: 'Pulau-Pulau Aru',
  },
  {
    id: '8105031',
    regencyId: '8105',
    name: 'Aru Utara',
  },
  {
    id: '8105032',
    regencyId: '8105',
    name: 'Aru Utara Timur Batuley',
  },
  {
    id: '8105033',
    regencyId: '8105',
    name: 'Sir-Sir',
  },
  {
    id: '8106010',
    regencyId: '8106',
    name: 'Huamual Belakang',
  },
  {
    id: '8106011',
    regencyId: '8106',
    name: 'Kepulauan Manipa',
  },
  {
    id: '8106020',
    regencyId: '8106',
    name: 'Seram Barat',
  },
  {
    id: '8106021',
    regencyId: '8106',
    name: 'Huamual',
  },
  {
    id: '8106030',
    regencyId: '8106',
    name: 'Kairatu',
  },
  {
    id: '8106031',
    regencyId: '8106',
    name: 'Kairatu Barat',
  },
  {
    id: '8106032',
    regencyId: '8106',
    name: 'Inamosol',
  },
  {
    id: '8106033',
    regencyId: '8106',
    name: 'Amalatu',
  },
  {
    id: '8106034',
    regencyId: '8106',
    name: 'Elpaputih',
  },
  {
    id: '8106040',
    regencyId: '8106',
    name: 'Taniwel',
  },
  {
    id: '8106041',
    regencyId: '8106',
    name: 'Taniwel Timur',
  },
  {
    id: '8107010',
    regencyId: '8107',
    name: 'Pulau Gorom',
  },
  {
    id: '8107011',
    regencyId: '8107',
    name: 'Wakate',
  },
  {
    id: '8107012',
    regencyId: '8107',
    name: 'Teor',
  },
  {
    id: '8107013',
    regencyId: '8107',
    name: 'Gorom Timur',
  },
  {
    id: '8107014',
    regencyId: '8107',
    name: 'Pulau Panjang',
  },
  {
    id: '8107020',
    regencyId: '8107',
    name: 'Seram Timur',
  },
  {
    id: '8107021',
    regencyId: '8107',
    name: 'Tutuk Tolu',
  },
  {
    id: '8107022',
    regencyId: '8107',
    name: 'Kilmury',
  },
  {
    id: '8107023',
    regencyId: '8107',
    name: 'Lian Vitu',
  },
  {
    id: '8107024',
    regencyId: '8107',
    name: 'Kian Darat',
  },
  {
    id: '8107030',
    regencyId: '8107',
    name: 'Werinama',
  },
  {
    id: '8107031',
    regencyId: '8107',
    name: 'Siwalalat',
  },
  {
    id: '8107040',
    regencyId: '8107',
    name: 'Bula',
  },
  {
    id: '8107041',
    regencyId: '8107',
    name: 'Bula Barat',
  },
  {
    id: '8107042',
    regencyId: '8107',
    name: 'Teluk Waru',
  },
  {
    id: '8108010',
    regencyId: '8108',
    name: 'Wetar',
  },
  {
    id: '8108011',
    regencyId: '8108',
    name: 'Wetar Barat',
  },
  {
    id: '8108012',
    regencyId: '8108',
    name: 'Wetar Utara',
  },
  {
    id: '8108013',
    regencyId: '8108',
    name: 'Wetar Timur',
  },
  {
    id: '8108020',
    regencyId: '8108',
    name: 'Pp. Terselatan',
  },
  {
    id: '8108021',
    regencyId: '8108',
    name: 'Kisar Utara',
  },
  {
    id: '8108022',
    regencyId: '8108',
    name: 'Kepulauan Romang',
  },
  {
    id: '8108030',
    regencyId: '8108',
    name: 'Letti',
  },
  {
    id: '8108041',
    regencyId: '8108',
    name: 'Moa',
  },
  {
    id: '8108042',
    regencyId: '8108',
    name: 'Lakor',
  },
  {
    id: '8108050',
    regencyId: '8108',
    name: 'Damer',
  },
  {
    id: '8108060',
    regencyId: '8108',
    name: 'Mdona Hiera',
  },
  {
    id: '8108070',
    regencyId: '8108',
    name: 'Pp. Babar',
  },
  {
    id: '8108071',
    regencyId: '8108',
    name: 'Pulau Wetang',
  },
  {
    id: '8108080',
    regencyId: '8108',
    name: 'Babar Timur',
  },
  {
    id: '8108081',
    regencyId: '8108',
    name: 'Pulau Masela',
  },
  {
    id: '8108082',
    regencyId: '8108',
    name: 'Dawelor Dawera',
  },
  {
    id: '8109010',
    regencyId: '8109',
    name: 'Kepala Madan',
  },
  {
    id: '8109020',
    regencyId: '8109',
    name: 'Leksula',
  },
  {
    id: '8109021',
    regencyId: '8109',
    name: 'Fena Fafan',
  },
  {
    id: '8109030',
    regencyId: '8109',
    name: 'Namrole',
  },
  {
    id: '8109040',
    regencyId: '8109',
    name: 'Waisama',
  },
  {
    id: '8109050',
    regencyId: '8109',
    name: 'Ambalau',
  },
  {
    id: '8171010',
    regencyId: '8171',
    name: 'Nusaniwe',
  },
  {
    id: '8171020',
    regencyId: '8171',
    name: 'Sirimau',
  },
  {
    id: '8171021',
    regencyId: '8171',
    name: 'Leitimur Selatan',
  },
  {
    id: '8171030',
    regencyId: '8171',
    name: 'Teluk Ambon Baguala',
  },
  {
    id: '8171031',
    regencyId: '8171',
    name: 'Teluk Ambon',
  },
  {
    id: '8172010',
    regencyId: '8172',
    name: 'Pp. Kur',
  },
  {
    id: '8172011',
    regencyId: '8172',
    name: 'Kur Selatan',
  },
  {
    id: '8172020',
    regencyId: '8172',
    name: 'Tayando Tam',
  },
  {
    id: '8172030',
    regencyId: '8172',
    name: 'Pulau Dullah Utara',
  },
  {
    id: '8172040',
    regencyId: '8172',
    name: 'Pulau Dullah Selatan',
  },
  {
    id: '8201090',
    regencyId: '8201',
    name: 'Jailolo',
  },
  {
    id: '8201091',
    regencyId: '8201',
    name: 'Jailolo Selatan',
  },
  {
    id: '8201100',
    regencyId: '8201',
    name: 'Sahu',
  },
  {
    id: '8201101',
    regencyId: '8201',
    name: 'Sahu Timur',
  },
  {
    id: '8201130',
    regencyId: '8201',
    name: 'Ibu',
  },
  {
    id: '8201131',
    regencyId: '8201',
    name: 'Ibu Selatan',
  },
  {
    id: '8201132',
    regencyId: '8201',
    name: 'Tabaru',
  },
  {
    id: '8201140',
    regencyId: '8201',
    name: 'Loloda',
  },
  {
    id: '8202030',
    regencyId: '8202',
    name: 'Weda',
  },
  {
    id: '8202031',
    regencyId: '8202',
    name: 'Weda Selatan',
  },
  {
    id: '8202032',
    regencyId: '8202',
    name: 'Weda Utara',
  },
  {
    id: '8202033',
    regencyId: '8202',
    name: 'Weda Tengah',
  },
  {
    id: '8202034',
    regencyId: '8202',
    name: 'Weda Timur',
  },
  {
    id: '8202041',
    regencyId: '8202',
    name: 'Pulau Gebe',
  },
  {
    id: '8202042',
    regencyId: '8202',
    name: 'Patani',
  },
  {
    id: '8202043',
    regencyId: '8202',
    name: 'Patani Utara',
  },
  {
    id: '8202044',
    regencyId: '8202',
    name: 'Patani Barat',
  },
  {
    id: '8202045',
    regencyId: '8202',
    name: 'Patani Timur',
  },
  {
    id: '8203010',
    regencyId: '8203',
    name: 'Sula Besi Barat',
  },
  {
    id: '8203011',
    regencyId: '8203',
    name: 'Sulabesi Selatan',
  },
  {
    id: '8203020',
    regencyId: '8203',
    name: 'Sanana',
  },
  {
    id: '8203021',
    regencyId: '8203',
    name: 'Sula Besi Tengah',
  },
  {
    id: '8203022',
    regencyId: '8203',
    name: 'Sulabesi Timur',
  },
  {
    id: '8203023',
    regencyId: '8203',
    name: 'Sanana Utara',
  },
  {
    id: '8203030',
    regencyId: '8203',
    name: 'Mangoli Timur',
  },
  {
    id: '8203031',
    regencyId: '8203',
    name: 'Mangoli Tengah',
  },
  {
    id: '8203032',
    regencyId: '8203',
    name: 'Mangoli Utara Timur',
  },
  {
    id: '8203040',
    regencyId: '8203',
    name: 'Mangoli Barat',
  },
  {
    id: '8203041',
    regencyId: '8203',
    name: 'Mangoli Utara',
  },
  {
    id: '8203042',
    regencyId: '8203',
    name: 'Mangoli Selatan',
  },
  {
    id: '8204010',
    regencyId: '8204',
    name: 'Obi Selatan',
  },
  {
    id: '8204020',
    regencyId: '8204',
    name: 'Obi',
  },
  {
    id: '8204021',
    regencyId: '8204',
    name: 'Obi Barat',
  },
  {
    id: '8204022',
    regencyId: '8204',
    name: 'Obi Timur',
  },
  {
    id: '8204023',
    regencyId: '8204',
    name: 'Obi Utara',
  },
  {
    id: '8204030',
    regencyId: '8204',
    name: 'Bacan',
  },
  {
    id: '8204031',
    regencyId: '8204',
    name: 'Mandioli Selatan',
  },
  {
    id: '8204032',
    regencyId: '8204',
    name: 'Mandioli Utara',
  },
  {
    id: '8204033',
    regencyId: '8204',
    name: 'Bacan Selatan',
  },
  {
    id: '8204034',
    regencyId: '8204',
    name: 'Batang Lomang',
  },
  {
    id: '8204040',
    regencyId: '8204',
    name: 'Bacan Timur',
  },
  {
    id: '8204041',
    regencyId: '8204',
    name: 'Bacan Timur Selatan',
  },
  {
    id: '8204042',
    regencyId: '8204',
    name: 'Bacan Timur Tengah',
  },
  {
    id: '8204050',
    regencyId: '8204',
    name: 'Bacan Barat',
  },
  {
    id: '8204051',
    regencyId: '8204',
    name: 'Kasiruta Barat',
  },
  {
    id: '8204052',
    regencyId: '8204',
    name: 'Kasiruta Timur',
  },
  {
    id: '8204053',
    regencyId: '8204',
    name: 'Bacan Barat Utara',
  },
  {
    id: '8204060',
    regencyId: '8204',
    name: 'Kayoa',
  },
  {
    id: '8204061',
    regencyId: '8204',
    name: 'Kayoa Barat',
  },
  {
    id: '8204062',
    regencyId: '8204',
    name: 'Kayoa Selatan',
  },
  {
    id: '8204063',
    regencyId: '8204',
    name: 'Kayoa Utara',
  },
  {
    id: '8204070',
    regencyId: '8204',
    name: 'Pulau Makian',
  },
  {
    id: '8204071',
    regencyId: '8204',
    name: 'Makian Barat',
  },
  {
    id: '8204080',
    regencyId: '8204',
    name: 'Gane Barat',
  },
  {
    id: '8204081',
    regencyId: '8204',
    name: 'Gane Barat Selatan',
  },
  {
    id: '8204082',
    regencyId: '8204',
    name: 'Gane Barat Utara',
  },
  {
    id: '8204083',
    regencyId: '8204',
    name: 'Kepulauan Joronga',
  },
  {
    id: '8204090',
    regencyId: '8204',
    name: 'Gane Timur',
  },
  {
    id: '8204091',
    regencyId: '8204',
    name: 'Gane Timur Tengah',
  },
  {
    id: '8204092',
    regencyId: '8204',
    name: 'Gane Timur Selatan',
  },
  {
    id: '8205010',
    regencyId: '8205',
    name: 'Malifut',
  },
  {
    id: '8205011',
    regencyId: '8205',
    name: 'Kao Teluk',
  },
  {
    id: '8205020',
    regencyId: '8205',
    name: 'Kao',
  },
  {
    id: '8205021',
    regencyId: '8205',
    name: 'Kao Barat',
  },
  {
    id: '8205022',
    regencyId: '8205',
    name: 'Kao Utara',
  },
  {
    id: '8205030',
    regencyId: '8205',
    name: 'Tobelo Selatan',
  },
  {
    id: '8205031',
    regencyId: '8205',
    name: 'Tobelo Barat',
  },
  {
    id: '8205032',
    regencyId: '8205',
    name: 'Tobelo Timur',
  },
  {
    id: '8205040',
    regencyId: '8205',
    name: 'Tobelo',
  },
  {
    id: '8205041',
    regencyId: '8205',
    name: 'Tobelo Tengah',
  },
  {
    id: '8205042',
    regencyId: '8205',
    name: 'Tobelo Utara',
  },
  {
    id: '8205050',
    regencyId: '8205',
    name: 'Galela',
  },
  {
    id: '8205051',
    regencyId: '8205',
    name: 'Galela Selatan',
  },
  {
    id: '8205052',
    regencyId: '8205',
    name: 'Galela Barat',
  },
  {
    id: '8205053',
    regencyId: '8205',
    name: 'Galela Utara',
  },
  {
    id: '8205060',
    regencyId: '8205',
    name: 'Loloda Utara',
  },
  {
    id: '8205061',
    regencyId: '8205',
    name: 'Loloda Kepulauan',
  },
  {
    id: '8206010',
    regencyId: '8206',
    name: 'Maba Selatan',
  },
  {
    id: '8206011',
    regencyId: '8206',
    name: 'Kota Maba',
  },
  {
    id: '8206020',
    regencyId: '8206',
    name: 'Wasile Selatan',
  },
  {
    id: '8206030',
    regencyId: '8206',
    name: 'Wasile',
  },
  {
    id: '8206031',
    regencyId: '8206',
    name: 'Wasile Timur',
  },
  {
    id: '8206032',
    regencyId: '8206',
    name: 'Wasile Tengah',
  },
  {
    id: '8206033',
    regencyId: '8206',
    name: 'Wasile Utara',
  },
  {
    id: '8206040',
    regencyId: '8206',
    name: 'Maba',
  },
  {
    id: '8206041',
    regencyId: '8206',
    name: 'Maba Tengah',
  },
  {
    id: '8206042',
    regencyId: '8206',
    name: 'Maba Utara',
  },
  {
    id: '8207010',
    regencyId: '8207',
    name: 'Morotai Selatan',
  },
  {
    id: '8207020',
    regencyId: '8207',
    name: 'Morotai Timur',
  },
  {
    id: '8207030',
    regencyId: '8207',
    name: 'Morotai Selatan Barat',
  },
  {
    id: '8207040',
    regencyId: '8207',
    name: 'Morotai Jaya',
  },
  {
    id: '8207050',
    regencyId: '8207',
    name: 'Morotai Utara',
  },
  {
    id: '8208010',
    regencyId: '8208',
    name: 'Taliabu Barat',
  },
  {
    id: '8208020',
    regencyId: '8208',
    name: 'Taliabu Selatan',
  },
  {
    id: '8208030',
    regencyId: '8208',
    name: 'Tabona',
  },
  {
    id: '8208040',
    regencyId: '8208',
    name: 'Taliabu Timur Selatan',
  },
  {
    id: '8208050',
    regencyId: '8208',
    name: 'Taliabu Timur',
  },
  {
    id: '8208060',
    regencyId: '8208',
    name: 'Taliabu Utara',
  },
  {
    id: '8208070',
    regencyId: '8208',
    name: 'Lede',
  },
  {
    id: '8208080',
    regencyId: '8208',
    name: 'Taliabu Barat Laut',
  },
  {
    id: '8271010',
    regencyId: '8271',
    name: 'Pulau Ternate',
  },
  {
    id: '8271011',
    regencyId: '8271',
    name: 'Moti',
  },
  {
    id: '8271012',
    regencyId: '8271',
    name: 'Pulau Batang Dua',
  },
  {
    id: '8271013',
    regencyId: '8271',
    name: 'Pulau Hiri',
  },
  {
    id: '8271014',
    regencyId: '8271',
    name: 'Ternate Barat',
  },
  {
    id: '8271020',
    regencyId: '8271',
    name: 'Ternate Selatan',
  },
  {
    id: '8271021',
    regencyId: '8271',
    name: 'Ternate Tengah',
  },
  {
    id: '8271030',
    regencyId: '8271',
    name: 'Ternate Utara',
  },
  {
    id: '8272010',
    regencyId: '8272',
    name: 'Tidore Selatan',
  },
  {
    id: '8272020',
    regencyId: '8272',
    name: 'Tidore Utara',
  },
  {
    id: '8272030',
    regencyId: '8272',
    name: 'Tidore',
  },
  {
    id: '8272031',
    regencyId: '8272',
    name: 'Tidore Timur',
  },
  {
    id: '8272040',
    regencyId: '8272',
    name: 'Oba',
  },
  {
    id: '8272041',
    regencyId: '8272',
    name: 'Oba Selatan',
  },
  {
    id: '8272050',
    regencyId: '8272',
    name: 'Oba Utara',
  },
  {
    id: '8272051',
    regencyId: '8272',
    name: 'Oba Tengah',
  },
  {
    id: '9101050',
    regencyId: '9101',
    name: 'Fakfak Timur',
  },
  {
    id: '9101051',
    regencyId: '9101',
    name: 'Karas',
  },
  {
    id: '9101052',
    regencyId: '9101',
    name: 'Fakfak Timur Tengah',
  },
  {
    id: '9101060',
    regencyId: '9101',
    name: 'Fakfak',
  },
  {
    id: '9101061',
    regencyId: '9101',
    name: 'Fakfak Tengah',
  },
  {
    id: '9101062',
    regencyId: '9101',
    name: 'Pariwari',
  },
  {
    id: '9101070',
    regencyId: '9101',
    name: 'Fakfak Barat',
  },
  {
    id: '9101071',
    regencyId: '9101',
    name: 'Wartutin',
  },
  {
    id: '9101080',
    regencyId: '9101',
    name: 'Kokas',
  },
  {
    id: '9101081',
    regencyId: '9101',
    name: 'Teluk Patipi',
  },
  {
    id: '9101082',
    regencyId: '9101',
    name: 'Kramongmongga',
  },
  {
    id: '9101083',
    regencyId: '9101',
    name: 'Bomberay',
  },
  {
    id: '9101084',
    regencyId: '9101',
    name: 'Arguni',
  },
  {
    id: '9101085',
    regencyId: '9101',
    name: 'Mbahamdandara',
  },
  {
    id: '9101086',
    regencyId: '9101',
    name: 'Furwagi',
  },
  {
    id: '9101087',
    regencyId: '9101',
    name: 'Kayauni',
  },
  {
    id: '9101088',
    regencyId: '9101',
    name: 'Tomage',
  },
  {
    id: '9102010',
    regencyId: '9102',
    name: 'Buruway',
  },
  {
    id: '9102020',
    regencyId: '9102',
    name: 'Teluk Arguni',
  },
  {
    id: '9102021',
    regencyId: '9102',
    name: 'Teluk Arguni Bawah',
  },
  {
    id: '9102030',
    regencyId: '9102',
    name: 'Kaimana',
  },
  {
    id: '9102031',
    regencyId: '9102',
    name: 'Kambrau',
  },
  {
    id: '9102040',
    regencyId: '9102',
    name: 'Teluk Etna',
  },
  {
    id: '9102041',
    regencyId: '9102',
    name: 'Yamor',
  },
  {
    id: '9103010',
    regencyId: '9103',
    name: 'Naikere',
  },
  {
    id: '9103020',
    regencyId: '9103',
    name: 'Wondiboy',
  },
  {
    id: '9103021',
    regencyId: '9103',
    name: 'Rasiey',
  },
  {
    id: '9103022',
    regencyId: '9103',
    name: 'Kuri Wamesa',
  },
  {
    id: '9103030',
    regencyId: '9103',
    name: 'Wasior',
  },
  {
    id: '9103040',
    regencyId: '9103',
    name: 'Duairi',
  },
  {
    id: '9103041',
    regencyId: '9103',
    name: 'Roon',
  },
  {
    id: '9103050',
    regencyId: '9103',
    name: 'Windesi',
  },
  {
    id: '9103051',
    regencyId: '9103',
    name: 'Nikiwar',
  },
  {
    id: '9103060',
    regencyId: '9103',
    name: 'Wamesa',
  },
  {
    id: '9103061',
    regencyId: '9103',
    name: 'Roswar',
  },
  {
    id: '9103070',
    regencyId: '9103',
    name: 'Rumberpon',
  },
  {
    id: '9103071',
    regencyId: '9103',
    name: 'Soug Jaya',
  },
  {
    id: '9104010',
    regencyId: '9104',
    name: 'Fafurwar',
  },
  {
    id: '9104020',
    regencyId: '9104',
    name: 'Babo',
  },
  {
    id: '9104021',
    regencyId: '9104',
    name: 'Sumuri',
  },
  {
    id: '9104022',
    regencyId: '9104',
    name: 'Aroba',
  },
  {
    id: '9104023',
    regencyId: '9104',
    name: 'Kaitaro',
  },
  {
    id: '9104030',
    regencyId: '9104',
    name: 'Kuri',
  },
  {
    id: '9104040',
    regencyId: '9104',
    name: 'Wamesa',
  },
  {
    id: '9104050',
    regencyId: '9104',
    name: 'Bintuni',
  },
  {
    id: '9104051',
    regencyId: '9104',
    name: 'Manimeri',
  },
  {
    id: '9104052',
    regencyId: '9104',
    name: 'Tuhiba',
  },
  {
    id: '9104053',
    regencyId: '9104',
    name: 'Dataran Beimes',
  },
  {
    id: '9104060',
    regencyId: '9104',
    name: 'Tembuni',
  },
  {
    id: '9104070',
    regencyId: '9104',
    name: 'Aranday',
  },
  {
    id: '9104071',
    regencyId: '9104',
    name: 'Kamundan',
  },
  {
    id: '9104072',
    regencyId: '9104',
    name: 'Tomu',
  },
  {
    id: '9104073',
    regencyId: '9104',
    name: 'Weriagar',
  },
  {
    id: '9104080',
    regencyId: '9104',
    name: 'Moskona Selatan',
  },
  {
    id: '9104081',
    regencyId: '9104',
    name: 'Meyado',
  },
  {
    id: '9104082',
    regencyId: '9104',
    name: 'Moskona Barat',
  },
  {
    id: '9104090',
    regencyId: '9104',
    name: 'Merdey',
  },
  {
    id: '9104091',
    regencyId: '9104',
    name: 'Biscoop',
  },
  {
    id: '9104092',
    regencyId: '9104',
    name: 'Masyeta',
  },
  {
    id: '9104100',
    regencyId: '9104',
    name: 'Moskona Utara',
  },
  {
    id: '9104101',
    regencyId: '9104',
    name: 'Moskona Timur',
  },
  {
    id: '9105110',
    regencyId: '9105',
    name: 'Warmare',
  },
  {
    id: '9105120',
    regencyId: '9105',
    name: 'Prafi',
  },
  {
    id: '9105141',
    regencyId: '9105',
    name: 'Manokwari Barat',
  },
  {
    id: '9105142',
    regencyId: '9105',
    name: 'Manokwari Timur',
  },
  {
    id: '9105143',
    regencyId: '9105',
    name: 'Manokwari Utara',
  },
  {
    id: '9105144',
    regencyId: '9105',
    name: 'Manokwari Selatan',
  },
  {
    id: '9105146',
    regencyId: '9105',
    name: 'Tanah Rubu',
  },
  {
    id: '9105170',
    regencyId: '9105',
    name: 'Masni',
  },
  {
    id: '9105171',
    regencyId: '9105',
    name: 'Sidey',
  },
  {
    id: '9106010',
    regencyId: '9106',
    name: 'Inanwatan',
  },
  {
    id: '9106011',
    regencyId: '9106',
    name: 'Metemani',
  },
  {
    id: '9106020',
    regencyId: '9106',
    name: 'Kokoda',
  },
  {
    id: '9106021',
    regencyId: '9106',
    name: 'Kais',
  },
  {
    id: '9106022',
    regencyId: '9106',
    name: 'Kokoda Utara',
  },
  {
    id: '9106023',
    regencyId: '9106',
    name: 'Kais Darat',
  },
  {
    id: '9106060',
    regencyId: '9106',
    name: 'Moswaren',
  },
  {
    id: '9106070',
    regencyId: '9106',
    name: 'Teminabuan',
  },
  {
    id: '9106071',
    regencyId: '9106',
    name: 'Seremuk',
  },
  {
    id: '9106072',
    regencyId: '9106',
    name: 'Wayer',
  },
  {
    id: '9106073',
    regencyId: '9106',
    name: 'Konda',
  },
  {
    id: '9106074',
    regencyId: '9106',
    name: 'Saifi',
  },
  {
    id: '9106080',
    regencyId: '9106',
    name: 'Sawiat',
  },
  {
    id: '9106081',
    regencyId: '9106',
    name: 'Fokour',
  },
  {
    id: '9106082',
    regencyId: '9106',
    name: 'Salkma',
  },
  {
    id: '9107061',
    regencyId: '9107',
    name: 'Klaso',
  },
  {
    id: '9107062',
    regencyId: '9107',
    name: 'Saengkeduk',
  },
  {
    id: '9107100',
    regencyId: '9107',
    name: 'Makbon',
  },
  {
    id: '9107101',
    regencyId: '9107',
    name: 'Klayili',
  },
  {
    id: '9107110',
    regencyId: '9107',
    name: 'Beraur',
  },
  {
    id: '9107111',
    regencyId: '9107',
    name: 'Klamono',
  },
  {
    id: '9107112',
    regencyId: '9107',
    name: 'Klabot',
  },
  {
    id: '9107113',
    regencyId: '9107',
    name: 'Klawak',
  },
  {
    id: '9107114',
    regencyId: '9107',
    name: 'Bagun',
  },
  {
    id: '9107115',
    regencyId: '9107',
    name: 'Klasafet',
  },
  {
    id: '9107116',
    regencyId: '9107',
    name: 'Malabotom',
  },
  {
    id: '9107118',
    regencyId: '9107',
    name: 'Botain',
  },
  {
    id: '9107119',
    regencyId: '9107',
    name: 'Konhir',
  },
  {
    id: '9107120',
    regencyId: '9107',
    name: 'Salawati',
  },
  {
    id: '9107121',
    regencyId: '9107',
    name: 'Mayamuk',
  },
  {
    id: '9107122',
    regencyId: '9107',
    name: 'Salawati Timur',
  },
  {
    id: '9107123',
    regencyId: '9107',
    name: 'Hobard',
  },
  {
    id: '9107124',
    regencyId: '9107',
    name: 'Buk',
  },
  {
    id: '9107130',
    regencyId: '9107',
    name: 'Seget',
  },
  {
    id: '9107131',
    regencyId: '9107',
    name: 'Segun',
  },
  {
    id: '9107132',
    regencyId: '9107',
    name: 'Salawati Selatan',
  },
  {
    id: '9107133',
    regencyId: '9107',
    name: 'Salawati Tengah',
  },
  {
    id: '9107170',
    regencyId: '9107',
    name: 'Aimas',
  },
  {
    id: '9107171',
    regencyId: '9107',
    name: 'Mariat',
  },
  {
    id: '9107172',
    regencyId: '9107',
    name: 'Sorong',
  },
  {
    id: '9107180',
    regencyId: '9107',
    name: 'Sayosa',
  },
  {
    id: '9107181',
    regencyId: '9107',
    name: 'Maudus',
  },
  {
    id: '9107182',
    regencyId: '9107',
    name: 'Wemak',
  },
  {
    id: '9107183',
    regencyId: '9107',
    name: 'Sayosa Timur',
  },
  {
    id: '9107184',
    regencyId: '9107',
    name: 'Sunook',
  },
  {
    id: '9108011',
    regencyId: '9108',
    name: 'Misool Selatan',
  },
  {
    id: '9108012',
    regencyId: '9108',
    name: 'Misool Barat',
  },
  {
    id: '9108020',
    regencyId: '9108',
    name: 'Misool',
  },
  {
    id: '9108021',
    regencyId: '9108',
    name: 'Kofiau',
  },
  {
    id: '9108022',
    regencyId: '9108',
    name: 'Misool Timur',
  },
  {
    id: '9108023',
    regencyId: '9108',
    name: 'Kepulauan Sembilan',
  },
  {
    id: '9108031',
    regencyId: '9108',
    name: 'Salawati Utara',
  },
  {
    id: '9108033',
    regencyId: '9108',
    name: 'Salawati Tengah',
  },
  {
    id: '9108034',
    regencyId: '9108',
    name: 'Salawati Barat',
  },
  {
    id: '9108035',
    regencyId: '9108',
    name: 'Batanta Selatan',
  },
  {
    id: '9108036',
    regencyId: '9108',
    name: 'Batanta Utara',
  },
  {
    id: '9108040',
    regencyId: '9108',
    name: 'Waigeo Selatan',
  },
  {
    id: '9108041',
    regencyId: '9108',
    name: 'Teluk Mayalibit',
  },
  {
    id: '9108042',
    regencyId: '9108',
    name: 'Meos Mansar',
  },
  {
    id: '9108043',
    regencyId: '9108',
    name: 'Kota Waisai',
  },
  {
    id: '9108044',
    regencyId: '9108',
    name: 'Tiplol Mayalibit',
  },
  {
    id: '9108050',
    regencyId: '9108',
    name: 'Waigeo Barat',
  },
  {
    id: '9108051',
    regencyId: '9108',
    name: 'Waigeo Barat Kepulauan',
  },
  {
    id: '9108060',
    regencyId: '9108',
    name: 'Waigeo Utara',
  },
  {
    id: '9108061',
    regencyId: '9108',
    name: 'Warwarbomi',
  },
  {
    id: '9108062',
    regencyId: '9108',
    name: 'Supnin',
  },
  {
    id: '9108070',
    regencyId: '9108',
    name: 'Kepulauan Ayau',
  },
  {
    id: '9108071',
    regencyId: '9108',
    name: 'Ayau',
  },
  {
    id: '9108080',
    regencyId: '9108',
    name: 'Waigeo Timur',
  },
  {
    id: '9109010',
    regencyId: '9109',
    name: 'Fef',
  },
  {
    id: '9109011',
    regencyId: '9109',
    name: 'Syujak',
  },
  {
    id: '9109012',
    regencyId: '9109',
    name: 'Ases',
  },
  {
    id: '9109013',
    regencyId: '9109',
    name: 'Tinggouw',
  },
  {
    id: '9109020',
    regencyId: '9109',
    name: 'Miyah',
  },
  {
    id: '9109021',
    regencyId: '9109',
    name: 'Miyah Selatan',
  },
  {
    id: '9109022',
    regencyId: '9109',
    name: 'Ireres',
  },
  {
    id: '9109023',
    regencyId: '9109',
    name: 'Wilhem Roumbouts',
  },
  {
    id: '9109030',
    regencyId: '9109',
    name: 'Abun',
  },
  {
    id: '9109040',
    regencyId: '9109',
    name: 'Kwoor',
  },
  {
    id: '9109041',
    regencyId: '9109',
    name: 'Tobouw',
  },
  {
    id: '9109042',
    regencyId: '9109',
    name: 'Kwesefo',
  },
  {
    id: '9109050',
    regencyId: '9109',
    name: 'Sausapor',
  },
  {
    id: '9109051',
    regencyId: '9109',
    name: 'Bikar',
  },
  {
    id: '9109060',
    regencyId: '9109',
    name: 'Yembun',
  },
  {
    id: '9109061',
    regencyId: '9109',
    name: 'Bamusbama',
  },
  {
    id: '9109070',
    regencyId: '9109',
    name: 'Kebar',
  },
  {
    id: '9109071',
    regencyId: '9109',
    name: 'Kebar Timur',
  },
  {
    id: '9109072',
    regencyId: '9109',
    name: 'Kebar Selatan',
  },
  {
    id: '9109073',
    regencyId: '9109',
    name: 'Manekar',
  },
  {
    id: '9109080',
    regencyId: '9109',
    name: 'Senopi',
  },
  {
    id: '9109081',
    regencyId: '9109',
    name: 'Mawabuan',
  },
  {
    id: '9109090',
    regencyId: '9109',
    name: 'Amberbaken',
  },
  {
    id: '9109091',
    regencyId: '9109',
    name: 'Mpur',
  },
  {
    id: '9109092',
    regencyId: '9109',
    name: 'Amberbaken Barat',
  },
  {
    id: '9109100',
    regencyId: '9109',
    name: 'Mubarni / Arfu',
  },
  {
    id: '9109110',
    regencyId: '9109',
    name: 'Moraid',
  },
  {
    id: '9109111',
    regencyId: '9109',
    name: 'Selemkai',
  },
  {
    id: '9110010',
    regencyId: '9110',
    name: 'Aitinyo Barat/Athabu',
  },
  {
    id: '9110011',
    regencyId: '9110',
    name: 'Ayamaru Selatan Jaya',
  },
  {
    id: '9110020',
    regencyId: '9110',
    name: 'Aitinyo',
  },
  {
    id: '9110021',
    regencyId: '9110',
    name: 'Aitinyo Tengah',
  },
  {
    id: '9110030',
    regencyId: '9110',
    name: 'Aifat Selatan',
  },
  {
    id: '9110031',
    regencyId: '9110',
    name: 'Aifat Timur Selatan',
  },
  {
    id: '9110040',
    regencyId: '9110',
    name: 'Aifat',
  },
  {
    id: '9110050',
    regencyId: '9110',
    name: 'Aitinyo Utara',
  },
  {
    id: '9110051',
    regencyId: '9110',
    name: 'Aitinyo Raya',
  },
  {
    id: '9110060',
    regencyId: '9110',
    name: 'Ayamaru Timur',
  },
  {
    id: '9110061',
    regencyId: '9110',
    name: 'Ayamaru Timur Selatan',
  },
  {
    id: '9110070',
    regencyId: '9110',
    name: 'Ayamaru',
  },
  {
    id: '9110071',
    regencyId: '9110',
    name: 'Ayamaru Selatan',
  },
  {
    id: '9110072',
    regencyId: '9110',
    name: 'Ayamaru Jaya',
  },
  {
    id: '9110073',
    regencyId: '9110',
    name: 'Ayamaru Tengah',
  },
  {
    id: '9110074',
    regencyId: '9110',
    name: 'Ayamaru Barat',
  },
  {
    id: '9110080',
    regencyId: '9110',
    name: 'Ayamaru Utara',
  },
  {
    id: '9110081',
    regencyId: '9110',
    name: 'Ayamaru Utara Timur',
  },
  {
    id: '9110090',
    regencyId: '9110',
    name: 'Mare',
  },
  {
    id: '9110091',
    regencyId: '9110',
    name: 'Mare Selatan',
  },
  {
    id: '9110100',
    regencyId: '9110',
    name: 'Aifat Utara',
  },
  {
    id: '9110110',
    regencyId: '9110',
    name: 'Aifat Timur',
  },
  {
    id: '9110111',
    regencyId: '9110',
    name: 'Aifat Timur Tengah',
  },
  {
    id: '9110112',
    regencyId: '9110',
    name: 'Aifat Timur Jauh',
  },
  {
    id: '9111010',
    regencyId: '9111',
    name: 'Tahota',
  },
  {
    id: '9111020',
    regencyId: '9111',
    name: 'Dataran Isim',
  },
  {
    id: '9111030',
    regencyId: '9111',
    name: 'Nenei',
  },
  {
    id: '9111040',
    regencyId: '9111',
    name: 'Momi Waren',
  },
  {
    id: '9111050',
    regencyId: '9111',
    name: 'Ransiki',
  },
  {
    id: '9111060',
    regencyId: '9111',
    name: 'Oransbari',
  },
  {
    id: '9112010',
    regencyId: '9112',
    name: 'Didohu',
  },
  {
    id: '9112020',
    regencyId: '9112',
    name: 'Sururey',
  },
  {
    id: '9112030',
    regencyId: '9112',
    name: 'Anggi Gida',
  },
  {
    id: '9112040',
    regencyId: '9112',
    name: 'Membey',
  },
  {
    id: '9112050',
    regencyId: '9112',
    name: 'Anggi',
  },
  {
    id: '9112060',
    regencyId: '9112',
    name: 'Taige',
  },
  {
    id: '9112070',
    regencyId: '9112',
    name: 'Hingk',
  },
  {
    id: '9112080',
    regencyId: '9112',
    name: 'Menyambouw',
  },
  {
    id: '9112090',
    regencyId: '9112',
    name: 'Catubouw',
  },
  {
    id: '9112100',
    regencyId: '9112',
    name: 'Testega',
  },
  {
    id: '9171010',
    regencyId: '9171',
    name: 'Sorong Barat',
  },
  {
    id: '9171011',
    regencyId: '9171',
    name: 'Sorong Kepulauan',
  },
  {
    id: '9171012',
    regencyId: '9171',
    name: 'Maladum Mes',
  },
  {
    id: '9171020',
    regencyId: '9171',
    name: 'Sorong Timur',
  },
  {
    id: '9171021',
    regencyId: '9171',
    name: 'Sorong Utara',
  },
  {
    id: '9171022',
    regencyId: '9171',
    name: 'Sorong',
  },
  {
    id: '9171023',
    regencyId: '9171',
    name: 'Sorong Manoi',
  },
  {
    id: '9171024',
    regencyId: '9171',
    name: 'Klaurung',
  },
  {
    id: '9171025',
    regencyId: '9171',
    name: 'Malaimsimsa',
  },
  {
    id: '9171026',
    regencyId: '9171',
    name: 'Sorong Kota',
  },
  {
    id: '9401010',
    regencyId: '9401',
    name: 'Kimaam',
  },
  {
    id: '9401011',
    regencyId: '9401',
    name: 'Waan',
  },
  {
    id: '9401012',
    regencyId: '9401',
    name: 'Tabonji',
  },
  {
    id: '9401013',
    regencyId: '9401',
    name: 'Ilwayab',
  },
  {
    id: '9401020',
    regencyId: '9401',
    name: 'Okaba',
  },
  {
    id: '9401021',
    regencyId: '9401',
    name: 'Tubang',
  },
  {
    id: '9401022',
    regencyId: '9401',
    name: 'Ngguti',
  },
  {
    id: '9401023',
    regencyId: '9401',
    name: 'Kaptel',
  },
  {
    id: '9401030',
    regencyId: '9401',
    name: 'Kurik',
  },
  {
    id: '9401031',
    regencyId: '9401',
    name: 'Malind',
  },
  {
    id: '9401032',
    regencyId: '9401',
    name: 'Animha',
  },
  {
    id: '9401040',
    regencyId: '9401',
    name: 'Merauke',
  },
  {
    id: '9401041',
    regencyId: '9401',
    name: 'Semangga',
  },
  {
    id: '9401042',
    regencyId: '9401',
    name: 'Tanah Miring',
  },
  {
    id: '9401043',
    regencyId: '9401',
    name: 'Jagebob',
  },
  {
    id: '9401044',
    regencyId: '9401',
    name: 'Sota',
  },
  {
    id: '9401045',
    regencyId: '9401',
    name: 'Naukenjerai',
  },
  {
    id: '9401050',
    regencyId: '9401',
    name: 'Muting',
  },
  {
    id: '9401051',
    regencyId: '9401',
    name: 'Eligobel',
  },
  {
    id: '9401052',
    regencyId: '9401',
    name: 'Ulilin',
  },
  {
    id: '9402110',
    regencyId: '9402',
    name: 'Wamena',
  },
  {
    id: '9402111',
    regencyId: '9402',
    name: 'Asolokobal',
  },
  {
    id: '9402112',
    regencyId: '9402',
    name: 'Walelagama',
  },
  {
    id: '9402113',
    regencyId: '9402',
    name: 'Trikora',
  },
  {
    id: '9402114',
    regencyId: '9402',
    name: 'Napua',
  },
  {
    id: '9402115',
    regencyId: '9402',
    name: 'Walaik',
  },
  {
    id: '9402116',
    regencyId: '9402',
    name: 'Wouma',
  },
  {
    id: '9402117',
    regencyId: '9402',
    name: 'Walesi',
  },
  {
    id: '9402118',
    regencyId: '9402',
    name: 'Asotipo',
  },
  {
    id: '9402119',
    regencyId: '9402',
    name: 'Maima',
  },
  {
    id: '9402120',
    regencyId: '9402',
    name: 'Hubikosi',
  },
  {
    id: '9402121',
    regencyId: '9402',
    name: 'Pelebaga',
  },
  {
    id: '9402122',
    regencyId: '9402',
    name: 'Ibele',
  },
  {
    id: '9402123',
    regencyId: '9402',
    name: 'Tailarek',
  },
  {
    id: '9402124',
    regencyId: '9402',
    name: 'Hubikiak',
  },
  {
    id: '9402180',
    regencyId: '9402',
    name: 'Asologaima',
  },
  {
    id: '9402181',
    regencyId: '9402',
    name: 'Musatfak',
  },
  {
    id: '9402182',
    regencyId: '9402',
    name: 'Silo Karno Doga',
  },
  {
    id: '9402183',
    regencyId: '9402',
    name: 'Pyramid',
  },
  {
    id: '9402184',
    regencyId: '9402',
    name: 'Muliama',
  },
  {
    id: '9402185',
    regencyId: '9402',
    name: 'Wame',
  },
  {
    id: '9402190',
    regencyId: '9402',
    name: 'Kurulu',
  },
  {
    id: '9402191',
    regencyId: '9402',
    name: 'Usilimo',
  },
  {
    id: '9402192',
    regencyId: '9402',
    name: 'Wita Waya',
  },
  {
    id: '9402193',
    regencyId: '9402',
    name: 'Libarek',
  },
  {
    id: '9402194',
    regencyId: '9402',
    name: 'Wadangku',
  },
  {
    id: '9402195',
    regencyId: '9402',
    name: 'Pisugi',
  },
  {
    id: '9402220',
    regencyId: '9402',
    name: 'Bolakme',
  },
  {
    id: '9402221',
    regencyId: '9402',
    name: 'Wollo',
  },
  {
    id: '9402222',
    regencyId: '9402',
    name: 'Yalengga',
  },
  {
    id: '9402223',
    regencyId: '9402',
    name: 'Tagime',
  },
  {
    id: '9402224',
    regencyId: '9402',
    name: 'Molagalome',
  },
  {
    id: '9402225',
    regencyId: '9402',
    name: 'Tagineri',
  },
  {
    id: '9402226',
    regencyId: '9402',
    name: 'Bugi',
  },
  {
    id: '9402227',
    regencyId: '9402',
    name: 'Bpiri',
  },
  {
    id: '9402228',
    regencyId: '9402',
    name: 'Koragi',
  },
  {
    id: '9402611',
    regencyId: '9402',
    name: 'Itlay Hasige',
  },
  {
    id: '9402612',
    regencyId: '9402',
    name: 'Siepkosi',
  },
  {
    id: '9402614',
    regencyId: '9402',
    name: 'Popugoba',
  },
  {
    id: '9403080',
    regencyId: '9403',
    name: 'Kaureh',
  },
  {
    id: '9403081',
    regencyId: '9403',
    name: 'Airu',
  },
  {
    id: '9403082',
    regencyId: '9403',
    name: 'Yapsi',
  },
  {
    id: '9403140',
    regencyId: '9403',
    name: 'Kemtuk',
  },
  {
    id: '9403150',
    regencyId: '9403',
    name: 'Kemtuk Gresi',
  },
  {
    id: '9403151',
    regencyId: '9403',
    name: 'Gresi Selatan',
  },
  {
    id: '9403160',
    regencyId: '9403',
    name: 'Nimboran',
  },
  {
    id: '9403161',
    regencyId: '9403',
    name: 'Nimboran Timur / Namblong',
  },
  {
    id: '9403170',
    regencyId: '9403',
    name: 'Nimbokrang',
  },
  {
    id: '9403180',
    regencyId: '9403',
    name: 'Unurum Guay',
  },
  {
    id: '9403200',
    regencyId: '9403',
    name: 'Demta',
  },
  {
    id: '9403201',
    regencyId: '9403',
    name: 'Yokari',
  },
  {
    id: '9403210',
    regencyId: '9403',
    name: 'Depapre',
  },
  {
    id: '9403211',
    regencyId: '9403',
    name: 'Ravenirara',
  },
  {
    id: '9403220',
    regencyId: '9403',
    name: 'Sentani Barat',
  },
  {
    id: '9403221',
    regencyId: '9403',
    name: 'Waibu',
  },
  {
    id: '9403230',
    regencyId: '9403',
    name: 'Sentani',
  },
  {
    id: '9403231',
    regencyId: '9403',
    name: 'Ebungfau',
  },
  {
    id: '9403240',
    regencyId: '9403',
    name: 'Sentani Timur',
  },
  {
    id: '9404050',
    regencyId: '9404',
    name: 'Uwapa',
  },
  {
    id: '9404051',
    regencyId: '9404',
    name: 'Menou',
  },
  {
    id: '9404052',
    regencyId: '9404',
    name: 'Dipa',
  },
  {
    id: '9404060',
    regencyId: '9404',
    name: 'Yaur',
  },
  {
    id: '9404061',
    regencyId: '9404',
    name: 'Teluk Umar',
  },
  {
    id: '9404070',
    regencyId: '9404',
    name: 'Wanggar',
  },
  {
    id: '9404071',
    regencyId: '9404',
    name: 'Nabire Barat',
  },
  {
    id: '9404080',
    regencyId: '9404',
    name: 'Nabire',
  },
  {
    id: '9404081',
    regencyId: '9404',
    name: 'Teluk Kimi',
  },
  {
    id: '9404090',
    regencyId: '9404',
    name: 'Napan',
  },
  {
    id: '9404091',
    regencyId: '9404',
    name: 'Makimi',
  },
  {
    id: '9404092',
    regencyId: '9404',
    name: 'Wapoga',
  },
  {
    id: '9404093',
    regencyId: '9404',
    name: 'Kepulauan Moora',
  },
  {
    id: '9404100',
    regencyId: '9404',
    name: 'Siriwo',
  },
  {
    id: '9404110',
    regencyId: '9404',
    name: 'Yaro',
  },
  {
    id: '9408040',
    regencyId: '9408',
    name: 'Yapen Timur',
  },
  {
    id: '9408041',
    regencyId: '9408',
    name: 'Pantura Yapen',
  },
  {
    id: '9408042',
    regencyId: '9408',
    name: 'Teluk Ampimoi',
  },
  {
    id: '9408043',
    regencyId: '9408',
    name: 'Raimbawi',
  },
  {
    id: '9408044',
    regencyId: '9408',
    name: 'Pulau Kurudu',
  },
  {
    id: '9408050',
    regencyId: '9408',
    name: 'Angkaisera',
  },
  {
    id: '9408051',
    regencyId: '9408',
    name: 'KEP. Ambai',
  },
  {
    id: '9408052',
    regencyId: '9408',
    name: 'Yawakukat',
  },
  {
    id: '9408060',
    regencyId: '9408',
    name: 'Yapen Selatan',
  },
  {
    id: '9408061',
    regencyId: '9408',
    name: 'Kosiwo',
  },
  {
    id: '9408062',
    regencyId: '9408',
    name: 'Anataurei',
  },
  {
    id: '9408070',
    regencyId: '9408',
    name: 'Yapen Barat',
  },
  {
    id: '9408071',
    regencyId: '9408',
    name: 'Wonawa',
  },
  {
    id: '9408072',
    regencyId: '9408',
    name: 'Pulau Yerui',
  },
  {
    id: '9408080',
    regencyId: '9408',
    name: 'Poom',
  },
  {
    id: '9408081',
    regencyId: '9408',
    name: 'Windesi',
  },
  {
    id: '9409010',
    regencyId: '9409',
    name: 'Numfor Barat',
  },
  {
    id: '9409011',
    regencyId: '9409',
    name: 'Orkeri',
  },
  {
    id: '9409020',
    regencyId: '9409',
    name: 'Numfor Timur',
  },
  {
    id: '9409021',
    regencyId: '9409',
    name: 'Bruyadori',
  },
  {
    id: '9409022',
    regencyId: '9409',
    name: 'Poiru',
  },
  {
    id: '9409030',
    regencyId: '9409',
    name: 'Padaido',
  },
  {
    id: '9409031',
    regencyId: '9409',
    name: 'Aimando Padaido',
  },
  {
    id: '9409040',
    regencyId: '9409',
    name: 'Biak Timur',
  },
  {
    id: '9409041',
    regencyId: '9409',
    name: 'Oridek',
  },
  {
    id: '9409050',
    regencyId: '9409',
    name: 'Biak Kota',
  },
  {
    id: '9409060',
    regencyId: '9409',
    name: 'Samofa',
  },
  {
    id: '9409070',
    regencyId: '9409',
    name: 'Yendidori',
  },
  {
    id: '9409080',
    regencyId: '9409',
    name: 'Biak Utara',
  },
  {
    id: '9409081',
    regencyId: '9409',
    name: 'Andey',
  },
  {
    id: '9409090',
    regencyId: '9409',
    name: 'Warsa',
  },
  {
    id: '9409091',
    regencyId: '9409',
    name: 'Yawosi',
  },
  {
    id: '9409092',
    regencyId: '9409',
    name: 'Bondifuar',
  },
  {
    id: '9409100',
    regencyId: '9409',
    name: 'Biak Barat',
  },
  {
    id: '9409101',
    regencyId: '9409',
    name: 'Swandiwe',
  },
  {
    id: '9410030',
    regencyId: '9410',
    name: 'Paniai Timur',
  },
  {
    id: '9410031',
    regencyId: '9410',
    name: 'Yatamo',
  },
  {
    id: '9410032',
    regencyId: '9410',
    name: 'Kebo',
  },
  {
    id: '9410033',
    regencyId: '9410',
    name: 'Pugo Dagi',
  },
  {
    id: '9410034',
    regencyId: '9410',
    name: 'Wege Muka',
  },
  {
    id: '9410035',
    regencyId: '9410',
    name: 'Wegee Bino',
  },
  {
    id: '9410036',
    regencyId: '9410',
    name: 'Yagai',
  },
  {
    id: '9410040',
    regencyId: '9410',
    name: 'Bibida',
  },
  {
    id: '9410041',
    regencyId: '9410',
    name: 'Dumadama',
  },
  {
    id: '9410070',
    regencyId: '9410',
    name: 'Aradide',
  },
  {
    id: '9410071',
    regencyId: '9410',
    name: 'Ekadide',
  },
  {
    id: '9410072',
    regencyId: '9410',
    name: 'Aweida',
  },
  {
    id: '9410073',
    regencyId: '9410',
    name: 'Fajar Timur',
  },
  {
    id: '9410074',
    regencyId: '9410',
    name: 'Topiyai',
  },
  {
    id: '9410080',
    regencyId: '9410',
    name: 'Paniai Barat',
  },
  {
    id: '9410081',
    regencyId: '9410',
    name: 'Siriwo',
  },
  {
    id: '9410082',
    regencyId: '9410',
    name: 'Muye',
  },
  {
    id: '9410083',
    regencyId: '9410',
    name: 'Nakama',
  },
  {
    id: '9410084',
    regencyId: '9410',
    name: 'Teluk Deya',
  },
  {
    id: '9410090',
    regencyId: '9410',
    name: 'Bogobaida',
  },
  {
    id: '9411040',
    regencyId: '9411',
    name: 'Fawi',
  },
  {
    id: '9411041',
    regencyId: '9411',
    name: 'Dagai',
  },
  {
    id: '9411042',
    regencyId: '9411',
    name: 'Kiyage',
  },
  {
    id: '9411050',
    regencyId: '9411',
    name: 'Mulia',
  },
  {
    id: '9411053',
    regencyId: '9411',
    name: 'Yambi',
  },
  {
    id: '9411054',
    regencyId: '9411',
    name: 'Ilamburawi',
  },
  {
    id: '9411055',
    regencyId: '9411',
    name: 'Muara',
  },
  {
    id: '9411056',
    regencyId: '9411',
    name: 'Pagaleme',
  },
  {
    id: '9411057',
    regencyId: '9411',
    name: 'Gurage',
  },
  {
    id: '9411058',
    regencyId: '9411',
    name: 'Irimuli',
  },
  {
    id: '9411060',
    regencyId: '9411',
    name: 'Ilu',
  },
  {
    id: '9411061',
    regencyId: '9411',
    name: 'Torere',
  },
  {
    id: '9411063',
    regencyId: '9411',
    name: 'Yamoneri',
  },
  {
    id: '9411064',
    regencyId: '9411',
    name: 'Waegi',
  },
  {
    id: '9411065',
    regencyId: '9411',
    name: 'Nume',
  },
  {
    id: '9411066',
    regencyId: '9411',
    name: 'Nioga',
  },
  {
    id: '9411067',
    regencyId: '9411',
    name: 'Gubume',
  },
  {
    id: '9411068',
    regencyId: '9411',
    name: 'Taganombak',
  },
  {
    id: '9411070',
    regencyId: '9411',
    name: 'Tingginambut',
  },
  {
    id: '9411071',
    regencyId: '9411',
    name: 'Kalome',
  },
  {
    id: '9411072',
    regencyId: '9411',
    name: 'Wanwi',
  },
  {
    id: '9411080',
    regencyId: '9411',
    name: 'Mewoluk',
  },
  {
    id: '9411081',
    regencyId: '9411',
    name: 'Lumo',
  },
  {
    id: '9411082',
    regencyId: '9411',
    name: 'Molanikime',
  },
  {
    id: '9411090',
    regencyId: '9411',
    name: 'Yamo',
  },
  {
    id: '9411091',
    regencyId: '9411',
    name: 'Dokome',
  },
  {
    id: '9412010',
    regencyId: '9412',
    name: 'Mimika Barat',
  },
  {
    id: '9412011',
    regencyId: '9412',
    name: 'Mimika Barat Jauh',
  },
  {
    id: '9412012',
    regencyId: '9412',
    name: 'Mimika Barat Tengah',
  },
  {
    id: '9412013',
    regencyId: '9412',
    name: 'Amar',
  },
  {
    id: '9412020',
    regencyId: '9412',
    name: 'Mimika Timur',
  },
  {
    id: '9412021',
    regencyId: '9412',
    name: 'Mimika Tengah',
  },
  {
    id: '9412022',
    regencyId: '9412',
    name: 'Mimika Timur Jauh',
  },
  {
    id: '9412030',
    regencyId: '9412',
    name: 'Mimika Baru',
  },
  {
    id: '9412031',
    regencyId: '9412',
    name: 'Kuala Kencana',
  },
  {
    id: '9412032',
    regencyId: '9412',
    name: 'Tembagapura',
  },
  {
    id: '9412033',
    regencyId: '9412',
    name: 'Wania',
  },
  {
    id: '9412034',
    regencyId: '9412',
    name: 'Iwaka',
  },
  {
    id: '9412035',
    regencyId: '9412',
    name: 'Kwamki Narama',
  },
  {
    id: '9412040',
    regencyId: '9412',
    name: 'Agimuga',
  },
  {
    id: '9412041',
    regencyId: '9412',
    name: 'Jila',
  },
  {
    id: '9412042',
    regencyId: '9412',
    name: 'Jita',
  },
  {
    id: '9412043',
    regencyId: '9412',
    name: 'Alama',
  },
  {
    id: '9412044',
    regencyId: '9412',
    name: 'Hoya',
  },
  {
    id: '9413010',
    regencyId: '9413',
    name: 'Jair',
  },
  {
    id: '9413011',
    regencyId: '9413',
    name: 'Subur',
  },
  {
    id: '9413013',
    regencyId: '9413',
    name: 'Kia',
  },
  {
    id: '9413020',
    regencyId: '9413',
    name: 'Mindiptana',
  },
  {
    id: '9413021',
    regencyId: '9413',
    name: 'Iniyandit',
  },
  {
    id: '9413022',
    regencyId: '9413',
    name: 'Kombut',
  },
  {
    id: '9413023',
    regencyId: '9413',
    name: 'Sesnuk',
  },
  {
    id: '9413030',
    regencyId: '9413',
    name: 'Mandobo',
  },
  {
    id: '9413031',
    regencyId: '9413',
    name: 'Fofi',
  },
  {
    id: '9413032',
    regencyId: '9413',
    name: 'Arimop',
  },
  {
    id: '9413040',
    regencyId: '9413',
    name: 'Kouh',
  },
  {
    id: '9413041',
    regencyId: '9413',
    name: 'Bomakia',
  },
  {
    id: '9413042',
    regencyId: '9413',
    name: 'Firiwage',
  },
  {
    id: '9413043',
    regencyId: '9413',
    name: 'Manggelum',
  },
  {
    id: '9413044',
    regencyId: '9413',
    name: 'Yaniruma',
  },
  {
    id: '9413045',
    regencyId: '9413',
    name: 'Kawagit',
  },
  {
    id: '9413046',
    regencyId: '9413',
    name: 'Kombay',
  },
  {
    id: '9413050',
    regencyId: '9413',
    name: 'Waropko',
  },
  {
    id: '9413051',
    regencyId: '9413',
    name: 'Ambatkwi',
  },
  {
    id: '9413052',
    regencyId: '9413',
    name: 'Ninati',
  },
  {
    id: '9414010',
    regencyId: '9414',
    name: 'Nambioman Bapai',
  },
  {
    id: '9414011',
    regencyId: '9414',
    name: 'Minyamur',
  },
  {
    id: '9414020',
    regencyId: '9414',
    name: 'Edera',
  },
  {
    id: '9414021',
    regencyId: '9414',
    name: 'Venaha',
  },
  {
    id: '9414022',
    regencyId: '9414',
    name: 'Syahcame',
  },
  {
    id: '9414023',
    regencyId: '9414',
    name: 'Bamgi',
  },
  {
    id: '9414024',
    regencyId: '9414',
    name: 'Yakomi',
  },
  {
    id: '9414030',
    regencyId: '9414',
    name: 'Obaa',
  },
  {
    id: '9414031',
    regencyId: '9414',
    name: 'Passue',
  },
  {
    id: '9414040',
    regencyId: '9414',
    name: 'Haju',
  },
  {
    id: '9414050',
    regencyId: '9414',
    name: 'Assue',
  },
  {
    id: '9414060',
    regencyId: '9414',
    name: 'Citakmitak',
  },
  {
    id: '9414061',
    regencyId: '9414',
    name: 'Kaibar',
  },
  {
    id: '9414062',
    regencyId: '9414',
    name: 'Passue Bawah',
  },
  {
    id: '9414063',
    regencyId: '9414',
    name: 'Ti-Zain',
  },
  {
    id: '9415010',
    regencyId: '9415',
    name: 'Pantai Kasuari',
  },
  {
    id: '9415011',
    regencyId: '9415',
    name: 'Kopay',
  },
  {
    id: '9415012',
    regencyId: '9415',
    name: 'Der Koumur',
  },
  {
    id: '9415013',
    regencyId: '9415',
    name: 'Safan',
  },
  {
    id: '9415014',
    regencyId: '9415',
    name: 'Awyu',
  },
  {
    id: '9415020',
    regencyId: '9415',
    name: 'Fayit',
  },
  {
    id: '9415021',
    regencyId: '9415',
    name: 'Aswi',
  },
  {
    id: '9415030',
    regencyId: '9415',
    name: 'Atsy',
  },
  {
    id: '9415031',
    regencyId: '9415',
    name: 'Sirets',
  },
  {
    id: '9415032',
    regencyId: '9415',
    name: 'Ayip',
  },
  {
    id: '9415033',
    regencyId: '9415',
    name: 'Bectbamu',
  },
  {
    id: '9415040',
    regencyId: '9415',
    name: 'Suator',
  },
  {
    id: '9415041',
    regencyId: '9415',
    name: 'Kolf Braza',
  },
  {
    id: '9415042',
    regencyId: '9415',
    name: 'Joutu',
  },
  {
    id: '9415043',
    regencyId: '9415',
    name: 'Koroway Buluanop',
  },
  {
    id: '9415050',
    regencyId: '9415',
    name: 'Akat',
  },
  {
    id: '9415051',
    regencyId: '9415',
    name: 'Jetsy',
  },
  {
    id: '9415060',
    regencyId: '9415',
    name: 'Agats',
  },
  {
    id: '9415070',
    regencyId: '9415',
    name: 'Sawa Erma',
  },
  {
    id: '9415071',
    regencyId: '9415',
    name: 'Suru-Suru',
  },
  {
    id: '9415072',
    regencyId: '9415',
    name: 'Unir Sirau',
  },
  {
    id: '9415073',
    regencyId: '9415',
    name: 'Joerat',
  },
  {
    id: '9415074',
    regencyId: '9415',
    name: 'Pulau Tiga',
  },
  {
    id: '9416010',
    regencyId: '9416',
    name: 'Kurima',
  },
  {
    id: '9416011',
    regencyId: '9416',
    name: 'Musaik',
  },
  {
    id: '9416013',
    regencyId: '9416',
    name: 'Dekai',
  },
  {
    id: '9416014',
    regencyId: '9416',
    name: 'Obio',
  },
  {
    id: '9416015',
    regencyId: '9416',
    name: 'Pasema',
  },
  {
    id: '9416016',
    regencyId: '9416',
    name: 'Amuma',
  },
  {
    id: '9416017',
    regencyId: '9416',
    name: 'Suru-Suru',
  },
  {
    id: '9416018',
    regencyId: '9416',
    name: 'Wusama',
  },
  {
    id: '9416019',
    regencyId: '9416',
    name: 'Silimo',
  },
  {
    id: '9416020',
    regencyId: '9416',
    name: 'Ninia',
  },
  {
    id: '9416021',
    regencyId: '9416',
    name: 'Holuwon',
  },
  {
    id: '9416022',
    regencyId: '9416',
    name: 'Lolat',
  },
  {
    id: '9416023',
    regencyId: '9416',
    name: 'Langda',
  },
  {
    id: '9416024',
    regencyId: '9416',
    name: 'Bomela',
  },
  {
    id: '9416025',
    regencyId: '9416',
    name: 'Suntamon',
  },
  {
    id: '9416026',
    regencyId: '9416',
    name: 'Sobaham',
  },
  {
    id: '9416027',
    regencyId: '9416',
    name: 'Korupun',
  },
  {
    id: '9416028',
    regencyId: '9416',
    name: 'Sela',
  },
  {
    id: '9416029',
    regencyId: '9416',
    name: 'Kwelamdua',
  },
  {
    id: '9416030',
    regencyId: '9416',
    name: 'Anggruk',
  },
  {
    id: '9416031',
    regencyId: '9416',
    name: 'Panggema',
  },
  {
    id: '9416032',
    regencyId: '9416',
    name: 'Walma',
  },
  {
    id: '9416033',
    regencyId: '9416',
    name: 'Kosarek',
  },
  {
    id: '9416034',
    regencyId: '9416',
    name: 'Ubahak',
  },
  {
    id: '9416035',
    regencyId: '9416',
    name: 'Nalca',
  },
  {
    id: '9416036',
    regencyId: '9416',
    name: 'Puldama',
  },
  {
    id: '9416037',
    regencyId: '9416',
    name: 'Nipsan',
  },
  {
    id: '9416041',
    regencyId: '9416',
    name: 'Samenage',
  },
  {
    id: '9416042',
    regencyId: '9416',
    name: 'Tangma',
  },
  {
    id: '9416043',
    regencyId: '9416',
    name: 'Soba',
  },
  {
    id: '9416044',
    regencyId: '9416',
    name: 'Mugi',
  },
  {
    id: '9416045',
    regencyId: '9416',
    name: 'Yogosem',
  },
  {
    id: '9416046',
    regencyId: '9416',
    name: 'Kayo',
  },
  {
    id: '9416047',
    regencyId: '9416',
    name: 'Sumo',
  },
  {
    id: '9416048',
    regencyId: '9416',
    name: 'Hogio',
  },
  {
    id: '9416049',
    regencyId: '9416',
    name: 'Ukha',
  },
  {
    id: '9416051',
    regencyId: '9416',
    name: 'Werima',
  },
  {
    id: '9416052',
    regencyId: '9416',
    name: 'Soloikma',
  },
  {
    id: '9416053',
    regencyId: '9416',
    name: 'Seradala',
  },
  {
    id: '9416054',
    regencyId: '9416',
    name: 'Kabianggama',
  },
  {
    id: '9416055',
    regencyId: '9416',
    name: 'Kwikma',
  },
  {
    id: '9416056',
    regencyId: '9416',
    name: 'Hilipuk',
  },
  {
    id: '9416057',
    regencyId: '9416',
    name: 'Yahuliambut',
  },
  {
    id: '9416058',
    regencyId: '9416',
    name: 'Hereapini',
  },
  {
    id: '9416059',
    regencyId: '9416',
    name: 'Ubalihi',
  },
  {
    id: '9416061',
    regencyId: '9416',
    name: 'Talambo',
  },
  {
    id: '9416062',
    regencyId: '9416',
    name: 'Pronggoli',
  },
  {
    id: '9416063',
    regencyId: '9416',
    name: 'Endomen',
  },
  {
    id: '9416065',
    regencyId: '9416',
    name: 'Kona',
  },
  {
    id: '9416066',
    regencyId: '9416',
    name: 'Duram',
  },
  {
    id: '9416067',
    regencyId: '9416',
    name: 'Dirwemna',
  },
  {
    id: '9417010',
    regencyId: '9417',
    name: 'Iwur',
  },
  {
    id: '9417011',
    regencyId: '9417',
    name: 'Kawor',
  },
  {
    id: '9417012',
    regencyId: '9417',
    name: 'Tarup',
  },
  {
    id: '9417013',
    regencyId: '9417',
    name: 'Awinbon',
  },
  {
    id: '9417020',
    regencyId: '9417',
    name: 'Oksibil',
  },
  {
    id: '9417021',
    regencyId: '9417',
    name: 'Pepera',
  },
  {
    id: '9417022',
    regencyId: '9417',
    name: 'Alemsom',
  },
  {
    id: '9417023',
    regencyId: '9417',
    name: 'Serambakon',
  },
  {
    id: '9417024',
    regencyId: '9417',
    name: 'Kolomdol',
  },
  {
    id: '9417025',
    regencyId: '9417',
    name: 'Oksop',
  },
  {
    id: '9417026',
    regencyId: '9417',
    name: 'Ok Bape',
  },
  {
    id: '9417027',
    regencyId: '9417',
    name: 'Ok Aon',
  },
  {
    id: '9417030',
    regencyId: '9417',
    name: 'Borme',
  },
  {
    id: '9417031',
    regencyId: '9417',
    name: 'Bime',
  },
  {
    id: '9417032',
    regencyId: '9417',
    name: 'Epumek',
  },
  {
    id: '9417033',
    regencyId: '9417',
    name: 'Weime',
  },
  {
    id: '9417034',
    regencyId: '9417',
    name: 'Pamek',
  },
  {
    id: '9417035',
    regencyId: '9417',
    name: 'Nongme',
  },
  {
    id: '9417036',
    regencyId: '9417',
    name: 'Batani',
  },
  {
    id: '9417040',
    regencyId: '9417',
    name: 'Okbi',
  },
  {
    id: '9417041',
    regencyId: '9417',
    name: 'Aboy',
  },
  {
    id: '9417042',
    regencyId: '9417',
    name: 'Okbab',
  },
  {
    id: '9417043',
    regencyId: '9417',
    name: 'Teiraplu',
  },
  {
    id: '9417044',
    regencyId: '9417',
    name: 'Yefta',
  },
  {
    id: '9417050',
    regencyId: '9417',
    name: 'Kiwirok',
  },
  {
    id: '9417051',
    regencyId: '9417',
    name: 'Kiwirok Timur',
  },
  {
    id: '9417052',
    regencyId: '9417',
    name: 'Oksebang',
  },
  {
    id: '9417053',
    regencyId: '9417',
    name: 'Okhika',
  },
  {
    id: '9417054',
    regencyId: '9417',
    name: 'Oklip',
  },
  {
    id: '9417055',
    regencyId: '9417',
    name: 'Oksamol',
  },
  {
    id: '9417056',
    regencyId: '9417',
    name: 'Okbemta',
  },
  {
    id: '9417060',
    regencyId: '9417',
    name: 'Batom',
  },
  {
    id: '9417061',
    regencyId: '9417',
    name: 'Murkim',
  },
  {
    id: '9417062',
    regencyId: '9417',
    name: 'Mofinop',
  },
  {
    id: '9418010',
    regencyId: '9418',
    name: 'Kanggime',
  },
  {
    id: '9418011',
    regencyId: '9418',
    name: 'Woniki',
  },
  {
    id: '9418012',
    regencyId: '9418',
    name: 'Nabunage',
  },
  {
    id: '9418013',
    regencyId: '9418',
    name: 'Gilubandu',
  },
  {
    id: '9418014',
    regencyId: '9418',
    name: 'Wakuo',
  },
  {
    id: '9418015',
    regencyId: '9418',
    name: 'Aweku',
  },
  {
    id: '9418016',
    regencyId: '9418',
    name: 'Bogonuk',
  },
  {
    id: '9418020',
    regencyId: '9418',
    name: 'Karubaga',
  },
  {
    id: '9418021',
    regencyId: '9418',
    name: 'Goyage',
  },
  {
    id: '9418022',
    regencyId: '9418',
    name: 'Wunin',
  },
  {
    id: '9418023',
    regencyId: '9418',
    name: 'Kondaga',
  },
  {
    id: '9418024',
    regencyId: '9418',
    name: 'Nelawi',
  },
  {
    id: '9418025',
    regencyId: '9418',
    name: 'Kuari',
  },
  {
    id: '9418026',
    regencyId: '9418',
    name: 'Lianogoma',
  },
  {
    id: '9418027',
    regencyId: '9418',
    name: 'Biuk',
  },
  {
    id: '9418030',
    regencyId: '9418',
    name: 'Bokondini',
  },
  {
    id: '9418031',
    regencyId: '9418',
    name: 'Bokoneri',
  },
  {
    id: '9418032',
    regencyId: '9418',
    name: 'Bewani',
  },
  {
    id: '9418040',
    regencyId: '9418',
    name: 'Kembu',
  },
  {
    id: '9418041',
    regencyId: '9418',
    name: 'Wina',
  },
  {
    id: '9418042',
    regencyId: '9418',
    name: 'Umagi',
  },
  {
    id: '9418043',
    regencyId: '9418',
    name: 'Panaga',
  },
  {
    id: '9418044',
    regencyId: '9418',
    name: 'Poganeri',
  },
  {
    id: '9418045',
    regencyId: '9418',
    name: 'Kamboneri',
  },
  {
    id: '9418046',
    regencyId: '9418',
    name: 'Air Garam',
  },
  {
    id: '9418047',
    regencyId: '9418',
    name: 'Dow',
  },
  {
    id: '9418048',
    regencyId: '9418',
    name: 'Wari / Taiyeve',
  },
  {
    id: '9418049',
    regencyId: '9418',
    name: 'Egiam',
  },
  {
    id: '9418051',
    regencyId: '9418',
    name: 'Nunggawi',
  },
  {
    id: '9418060',
    regencyId: '9418',
    name: 'Kubu',
  },
  {
    id: '9418061',
    regencyId: '9418',
    name: 'Anawi',
  },
  {
    id: '9418062',
    regencyId: '9418',
    name: 'Wugi',
  },
  {
    id: '9418070',
    regencyId: '9418',
    name: 'Geya',
  },
  {
    id: '9418071',
    regencyId: '9418',
    name: 'Wenam',
  },
  {
    id: '9418080',
    regencyId: '9418',
    name: 'Numba',
  },
  {
    id: '9418081',
    regencyId: '9418',
    name: 'Kai',
  },
  {
    id: '9418090',
    regencyId: '9418',
    name: 'Dundu',
  },
  {
    id: '9418100',
    regencyId: '9418',
    name: 'Gundagi',
  },
  {
    id: '9418110',
    regencyId: '9418',
    name: 'Timori',
  },
  {
    id: '9418121',
    regencyId: '9418',
    name: 'Yuneri',
  },
  {
    id: '9418125',
    regencyId: '9418',
    name: 'Tagime',
  },
  {
    id: '9418126',
    regencyId: '9418',
    name: 'Danime',
  },
  {
    id: '9418127',
    regencyId: '9418',
    name: 'Yuko',
  },
  {
    id: '9418541',
    regencyId: '9418',
    name: 'Telenggeme',
  },
  {
    id: '9418542',
    regencyId: '9418',
    name: 'Gika',
  },
  {
    id: '9418543',
    regencyId: '9418',
    name: 'Tagineri',
  },
  {
    id: '9419021',
    regencyId: '9419',
    name: 'Pantai Timur Bagian Barat',
  },
  {
    id: '9419022',
    regencyId: '9419',
    name: 'Pantai Timur',
  },
  {
    id: '9419024',
    regencyId: '9419',
    name: 'Sungai Biri',
  },
  {
    id: '9419025',
    regencyId: '9419',
    name: 'Veen',
  },
  {
    id: '9419031',
    regencyId: '9419',
    name: 'Bonggo',
  },
  {
    id: '9419032',
    regencyId: '9419',
    name: 'Bonggo Timur',
  },
  {
    id: '9419033',
    regencyId: '9419',
    name: 'Bonggo Barat',
  },
  {
    id: '9419040',
    regencyId: '9419',
    name: 'Tor Atas',
  },
  {
    id: '9419041',
    regencyId: '9419',
    name: 'Ismari',
  },
  {
    id: '9419050',
    regencyId: '9419',
    name: 'Sarmi',
  },
  {
    id: '9419051',
    regencyId: '9419',
    name: 'Sarmi Timur',
  },
  {
    id: '9419052',
    regencyId: '9419',
    name: 'Sarmi Selatan',
  },
  {
    id: '9419053',
    regencyId: '9419',
    name: 'Sobey',
  },
  {
    id: '9419054',
    regencyId: '9419',
    name: 'Muara Tor',
  },
  {
    id: '9419055',
    regencyId: '9419',
    name: 'Verkam',
  },
  {
    id: '9419060',
    regencyId: '9419',
    name: 'Pantai Barat',
  },
  {
    id: '9419061',
    regencyId: '9419',
    name: 'Apawer Hulu',
  },
  {
    id: '9419062',
    regencyId: '9419',
    name: 'Apawer Hilir',
  },
  {
    id: '9419063',
    regencyId: '9419',
    name: 'Apawer Tengah',
  },
  {
    id: '9420010',
    regencyId: '9420',
    name: 'Web',
  },
  {
    id: '9420011',
    regencyId: '9420',
    name: 'Towe',
  },
  {
    id: '9420012',
    regencyId: '9420',
    name: 'Yaffi',
  },
  {
    id: '9420020',
    regencyId: '9420',
    name: 'Senggi',
  },
  {
    id: '9420021',
    regencyId: '9420',
    name: 'Kaisenar',
  },
  {
    id: '9420030',
    regencyId: '9420',
    name: 'Waris',
  },
  {
    id: '9420040',
    regencyId: '9420',
    name: 'Arso',
  },
  {
    id: '9420041',
    regencyId: '9420',
    name: 'Arso Timur',
  },
  {
    id: '9420042',
    regencyId: '9420',
    name: 'Arso Barat',
  },
  {
    id: '9420043',
    regencyId: '9420',
    name: 'Mannem',
  },
  {
    id: '9420050',
    regencyId: '9420',
    name: 'Skanto',
  },
  {
    id: '9426010',
    regencyId: '9426',
    name: 'Waropen Bawah',
  },
  {
    id: '9426011',
    regencyId: '9426',
    name: 'Inggerus',
  },
  {
    id: '9426012',
    regencyId: '9426',
    name: 'Urei Faisei',
  },
  {
    id: '9426013',
    regencyId: '9426',
    name: 'Oudate',
  },
  {
    id: '9426014',
    regencyId: '9426',
    name: 'Wapoga',
  },
  {
    id: '9426020',
    regencyId: '9426',
    name: 'Masirei',
  },
  {
    id: '9426021',
    regencyId: '9426',
    name: 'Risei Sayati',
  },
  {
    id: '9426022',
    regencyId: '9426',
    name: 'Demba',
  },
  {
    id: '9426023',
    regencyId: '9426',
    name: 'Soyoi Mambai',
  },
  {
    id: '9426024',
    regencyId: '9426',
    name: 'Wonti',
  },
  {
    id: '9426030',
    regencyId: '9426',
    name: 'Walani',
  },
  {
    id: '9426040',
    regencyId: '9426',
    name: 'Kirihi',
  },
  {
    id: '9427010',
    regencyId: '9427',
    name: 'Supiori Selatan',
  },
  {
    id: '9427011',
    regencyId: '9427',
    name: 'Kepulauan Aruri',
  },
  {
    id: '9427020',
    regencyId: '9427',
    name: 'Supiori Utara',
  },
  {
    id: '9427021',
    regencyId: '9427',
    name: 'Supiori Barat',
  },
  {
    id: '9427030',
    regencyId: '9427',
    name: 'Supiori Timur',
  },
  {
    id: '9428030',
    regencyId: '9428',
    name: 'Waropen Atas',
  },
  {
    id: '9428031',
    regencyId: '9428',
    name: 'Benuki',
  },
  {
    id: '9428032',
    regencyId: '9428',
    name: 'Sawai',
  },
  {
    id: '9428040',
    regencyId: '9428',
    name: 'Mamberamo Ilir',
  },
  {
    id: '9428050',
    regencyId: '9428',
    name: 'Mamberamo Tengah',
  },
  {
    id: '9428051',
    regencyId: '9428',
    name: 'Iwaso',
  },
  {
    id: '9428060',
    regencyId: '9428',
    name: 'Mamberamo Tengah Timur',
  },
  {
    id: '9428070',
    regencyId: '9428',
    name: 'Rofaer',
  },
  {
    id: '9428080',
    regencyId: '9428',
    name: 'Mamberamo Ulu',
  },
  {
    id: '9429010',
    regencyId: '9429',
    name: 'Wosak',
  },
  {
    id: '9429011',
    regencyId: '9429',
    name: 'Moba',
  },
  {
    id: '9429012',
    regencyId: '9429',
    name: 'Pija',
  },
  {
    id: '9429013',
    regencyId: '9429',
    name: 'Kora',
  },
  {
    id: '9429020',
    regencyId: '9429',
    name: 'Kenyam',
  },
  {
    id: '9429021',
    regencyId: '9429',
    name: 'Mbuwa Tengah',
  },
  {
    id: '9429022',
    regencyId: '9429',
    name: 'Krepkuri',
  },
  {
    id: '9429023',
    regencyId: '9429',
    name: 'Embetpem',
  },
  {
    id: '9429030',
    regencyId: '9429',
    name: 'Geselma',
  },
  {
    id: '9429031',
    regencyId: '9429',
    name: 'Kilmid',
  },
  {
    id: '9429032',
    regencyId: '9429',
    name: 'Yenggelo',
  },
  {
    id: '9429033',
    regencyId: '9429',
    name: 'Alama',
  },
  {
    id: '9429034',
    regencyId: '9429',
    name: 'Meborok',
  },
  {
    id: '9429040',
    regencyId: '9429',
    name: 'Mapenduma',
  },
  {
    id: '9429041',
    regencyId: '9429',
    name: 'Kroptak',
  },
  {
    id: '9429042',
    regencyId: '9429',
    name: 'Paro',
  },
  {
    id: '9429043',
    regencyId: '9429',
    name: 'Kegayem',
  },
  {
    id: '9429050',
    regencyId: '9429',
    name: 'Mugi',
  },
  {
    id: '9429051',
    regencyId: '9429',
    name: 'Yal',
  },
  {
    id: '9429052',
    regencyId: '9429',
    name: 'Mam',
  },
  {
    id: '9429060',
    regencyId: '9429',
    name: 'Yigi',
  },
  {
    id: '9429061',
    regencyId: '9429',
    name: 'Dal',
  },
  {
    id: '9429062',
    regencyId: '9429',
    name: 'Nirkuri',
  },
  {
    id: '9429063',
    regencyId: '9429',
    name: 'Inikgal',
  },
  {
    id: '9429070',
    regencyId: '9429',
    name: 'Mbuwa',
  },
  {
    id: '9429071',
    regencyId: '9429',
    name: 'Iniye',
  },
  {
    id: '9429072',
    regencyId: '9429',
    name: 'Wutpaga',
  },
  {
    id: '9429073',
    regencyId: '9429',
    name: 'Nenggeangin',
  },
  {
    id: '9429074',
    regencyId: '9429',
    name: 'Mbulmu Yalma',
  },
  {
    id: '9429080',
    regencyId: '9429',
    name: 'Gearek',
  },
  {
    id: '9429081',
    regencyId: '9429',
    name: 'Pasir Putih',
  },
  {
    id: '9429082',
    regencyId: '9429',
    name: 'Wusi',
  },
  {
    id: '9430010',
    regencyId: '9430',
    name: 'Makki',
  },
  {
    id: '9430011',
    regencyId: '9430',
    name: 'Gupura',
  },
  {
    id: '9430012',
    regencyId: '9430',
    name: 'Kolawa',
  },
  {
    id: '9430013',
    regencyId: '9430',
    name: 'Gelok Beam',
  },
  {
    id: '9430014',
    regencyId: '9430',
    name: 'Awina',
  },
  {
    id: '9430020',
    regencyId: '9430',
    name: 'Pirime',
  },
  {
    id: '9430021',
    regencyId: '9430',
    name: 'Buguk Gona',
  },
  {
    id: '9430022',
    regencyId: '9430',
    name: 'Milimbo',
  },
  {
    id: '9430023',
    regencyId: '9430',
    name: 'Gollo',
  },
  {
    id: '9430024',
    regencyId: '9430',
    name: 'Wiringgabut',
  },
  {
    id: '9430030',
    regencyId: '9430',
    name: 'Tiom',
  },
  {
    id: '9430031',
    regencyId: '9430',
    name: 'Nogi',
  },
  {
    id: '9430032',
    regencyId: '9430',
    name: 'Mokoni',
  },
  {
    id: '9430033',
    regencyId: '9430',
    name: 'Niname',
  },
  {
    id: '9430034',
    regencyId: '9430',
    name: 'Yiginua',
  },
  {
    id: '9430035',
    regencyId: '9430',
    name: 'Tiom Ollo',
  },
  {
    id: '9430036',
    regencyId: '9430',
    name: 'Yugunwi',
  },
  {
    id: '9430037',
    regencyId: '9430',
    name: 'Lannyna',
  },
  {
    id: '9430040',
    regencyId: '9430',
    name: 'Balingga',
  },
  {
    id: '9430041',
    regencyId: '9430',
    name: 'Balingga Barat',
  },
  {
    id: '9430042',
    regencyId: '9430',
    name: 'Bruwa',
  },
  {
    id: '9430043',
    regencyId: '9430',
    name: 'Ayumnati',
  },
  {
    id: '9430050',
    regencyId: '9430',
    name: 'Kuyawage',
  },
  {
    id: '9430051',
    regencyId: '9430',
    name: 'Wano Barat',
  },
  {
    id: '9430060',
    regencyId: '9430',
    name: 'Malagaineri',
  },
  {
    id: '9430061',
    regencyId: '9430',
    name: 'Melagai',
  },
  {
    id: '9430070',
    regencyId: '9430',
    name: 'Tiomneri',
  },
  {
    id: '9430071',
    regencyId: '9430',
    name: 'Wereka',
  },
  {
    id: '9430080',
    regencyId: '9430',
    name: 'Dimba',
  },
  {
    id: '9430081',
    regencyId: '9430',
    name: 'Kelulome',
  },
  {
    id: '9430082',
    regencyId: '9430',
    name: 'Nikogwe',
  },
  {
    id: '9430090',
    regencyId: '9430',
    name: 'Gamelia',
  },
  {
    id: '9430091',
    regencyId: '9430',
    name: 'Karu',
  },
  {
    id: '9430092',
    regencyId: '9430',
    name: 'Yiluk',
  },
  {
    id: '9430093',
    regencyId: '9430',
    name: 'Guna',
  },
  {
    id: '9430100',
    regencyId: '9430',
    name: 'Poga',
  },
  {
    id: '9430101',
    regencyId: '9430',
    name: 'Muara',
  },
  {
    id: '9431010',
    regencyId: '9431',
    name: 'Kobakma',
  },
  {
    id: '9431020',
    regencyId: '9431',
    name: 'Ilugwa',
  },
  {
    id: '9431030',
    regencyId: '9431',
    name: 'Kelila',
  },
  {
    id: '9431040',
    regencyId: '9431',
    name: 'Eragayam',
  },
  {
    id: '9431050',
    regencyId: '9431',
    name: 'Megambilis',
  },
  {
    id: '9432010',
    regencyId: '9432',
    name: 'Welarek',
  },
  {
    id: '9432020',
    regencyId: '9432',
    name: 'Apalapsili',
  },
  {
    id: '9432030',
    regencyId: '9432',
    name: 'Abenaho',
  },
  {
    id: '9432040',
    regencyId: '9432',
    name: 'Elelim',
  },
  {
    id: '9432050',
    regencyId: '9432',
    name: 'Benawa',
  },
  {
    id: '9433010',
    regencyId: '9433',
    name: 'Agadugume',
  },
  {
    id: '9433011',
    regencyId: '9433',
    name: 'Lambewi',
  },
  {
    id: '9433012',
    regencyId: '9433',
    name: 'Oneri',
  },
  {
    id: '9433020',
    regencyId: '9433',
    name: 'Gome',
  },
  {
    id: '9433021',
    regencyId: '9433',
    name: 'Amungkalpia',
  },
  {
    id: '9433022',
    regencyId: '9433',
    name: 'Gome Utara',
  },
  {
    id: '9433023',
    regencyId: '9433',
    name: 'Erelmakawia',
  },
  {
    id: '9433030',
    regencyId: '9433',
    name: 'Ilaga',
  },
  {
    id: '9433031',
    regencyId: '9433',
    name: 'Ilaga Utara',
  },
  {
    id: '9433032',
    regencyId: '9433',
    name: 'Mabugi',
  },
  {
    id: '9433033',
    regencyId: '9433',
    name: 'Omukia',
  },
  {
    id: '9433040',
    regencyId: '9433',
    name: 'Sinak',
  },
  {
    id: '9433041',
    regencyId: '9433',
    name: 'Sinak Barat',
  },
  {
    id: '9433042',
    regencyId: '9433',
    name: 'MageáBume',
  },
  {
    id: '9433043',
    regencyId: '9433',
    name: 'Yugumuak',
  },
  {
    id: '9433050',
    regencyId: '9433',
    name: 'Pogoma',
  },
  {
    id: '9433051',
    regencyId: '9433',
    name: 'Kembru',
  },
  {
    id: '9433052',
    regencyId: '9433',
    name: 'Bina',
  },
  {
    id: '9433060',
    regencyId: '9433',
    name: 'Wangbe',
  },
  {
    id: '9433061',
    regencyId: '9433',
    name: 'Ogamanim',
  },
  {
    id: '9433070',
    regencyId: '9433',
    name: 'Beoga',
  },
  {
    id: '9433071',
    regencyId: '9433',
    name: 'Beoga Barat',
  },
  {
    id: '9433072',
    regencyId: '9433',
    name: 'Beoga Timur',
  },
  {
    id: '9433080',
    regencyId: '9433',
    name: 'Doufo',
  },
  {
    id: '9433081',
    regencyId: '9433',
    name: 'Dervos',
  },
  {
    id: '9434010',
    regencyId: '9434',
    name: 'Sukikai Selatan',
  },
  {
    id: '9434020',
    regencyId: '9434',
    name: 'Piyaiye',
  },
  {
    id: '9434030',
    regencyId: '9434',
    name: 'Mapia Barat',
  },
  {
    id: '9434040',
    regencyId: '9434',
    name: 'Mapia Tengah',
  },
  {
    id: '9434050',
    regencyId: '9434',
    name: 'Mapia',
  },
  {
    id: '9434060',
    regencyId: '9434',
    name: 'Dogiyai',
  },
  {
    id: '9434070',
    regencyId: '9434',
    name: 'Kamu Selatan',
  },
  {
    id: '9434080',
    regencyId: '9434',
    name: 'Kamu',
  },
  {
    id: '9434090',
    regencyId: '9434',
    name: 'Kamu Timur',
  },
  {
    id: '9434100',
    regencyId: '9434',
    name: 'Kamu Utara',
  },
  {
    id: '9435010',
    regencyId: '9435',
    name: 'Homeyo',
  },
  {
    id: '9435020',
    regencyId: '9435',
    name: 'Sugapa',
  },
  {
    id: '9435030',
    regencyId: '9435',
    name: 'Hitadipa',
  },
  {
    id: '9435040',
    regencyId: '9435',
    name: 'Agisiga',
  },
  {
    id: '9435050',
    regencyId: '9435',
    name: 'Biandoga',
  },
  {
    id: '9435060',
    regencyId: '9435',
    name: 'Wandai',
  },
  {
    id: '9436010',
    regencyId: '9436',
    name: 'Kapiraya',
  },
  {
    id: '9436020',
    regencyId: '9436',
    name: 'Tigi Barat',
  },
  {
    id: '9436030',
    regencyId: '9436',
    name: 'Tigi',
  },
  {
    id: '9436040',
    regencyId: '9436',
    name: 'Tigi Timur',
  },
  {
    id: '9436050',
    regencyId: '9436',
    name: 'Bowobado',
  },
  {
    id: '9471010',
    regencyId: '9471',
    name: 'Muara Tami',
  },
  {
    id: '9471020',
    regencyId: '9471',
    name: 'Abepura',
  },
  {
    id: '9471021',
    regencyId: '9471',
    name: 'Heram',
  },
  {
    id: '9471030',
    regencyId: '9471',
    name: 'Jayapura Selatan',
  },
  {
    id: '9471040',
    regencyId: '9471',
    name: 'Jayapura Utara',
  },
]
